var _defs, _g, _g2, _g3, _polygon, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigaAppTestataReCa2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 983.73 447.53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #dacead;\n      }\n\n      .st2 {\n        fill: #cabfa1;\n      }\n\n      .st3 {\n        fill: #b6ad92;\n      }\n\n      .st4 {\n        fill: #c2b89c;\n      }\n\n      .st5 {\n        fill: #a69e86;\n      }\n\n      .st6 {\n        fill: #f0d6a9;\n      }\n\n      .st7 {\n        fill: #8f8974;\n      }\n\n      .st8 {\n        fill: #b0a78e;\n      }\n\n      .st9 {\n        fill: #b7ad93;\n      }\n\n      .st10 {\n        fill: #a29a83;\n      }\n\n      .st11 {\n        fill: #d2c6a7;\n      }\n\n      .st12 {\n        fill: #b4ab91;\n      }\n\n      .st13 {\n        fill: #e2d5b2;\n      }\n\n      .st14 {\n        fill: #9b4a28;\n      }\n\n      .st15 {\n        fill: #d6caaa;\n      }\n\n      .st16 {\n        fill: #938c77;\n      }\n\n      .st17 {\n        fill: #bbb196;\n      }\n\n      .st18 {\n        fill: #c97331;\n      }\n\n      .st19 {\n        fill: #a9562a;\n      }\n\n      .st20 {\n        fill: #b9af95;\n      }\n\n      .st21 {\n        fill: #86806d;\n      }\n\n      .st22 {\n        fill: #b5ac92;\n      }\n\n      .st23 {\n        fill: #d7cbab;\n      }\n\n      .st24 {\n        fill: #bab095;\n      }\n\n      .st25 {\n        fill: #9c957f;\n      }\n\n      .st26 {\n        fill: #e4d7b4;\n      }\n\n      .st27 {\n        fill: #8d8672;\n      }\n\n      .st28 {\n        fill: #928c77;\n      }\n\n      .st29 {\n        fill: #e7dab6;\n      }\n\n      .st30 {\n        fill: #e00d1d;\n      }\n\n      .st31 {\n        fill: #bd4e27;\n      }\n\n      .st32 {\n        fill: #9c947e;\n      }\n\n      .st33 {\n        fill: #aea58c;\n      }\n\n      .st34 {\n        fill: #9d6836;\n      }\n\n      .st35 {\n        fill: #b1a88e;\n      }\n\n      .st36 {\n        fill: #bdb398;\n      }\n\n      .st37 {\n        fill: #d5c9a9;\n      }\n\n      .st38 {\n        fill: #ecdeba;\n      }\n\n      .st39 {\n        fill: #eadcb8;\n      }\n\n      .st40 {\n        fill: #89836f;\n      }\n\n      .st41 {\n        fill: #908975;\n      }\n\n      .st42 {\n        fill: #ddd1af;\n      }\n\n      .st43 {\n        fill: #ecca99;\n      }\n\n      .st44 {\n        fill: #a79f87;\n      }\n\n      .st45 {\n        fill: #2b2118;\n      }\n\n      .st46 {\n        fill: #ccc1a3;\n      }\n\n      .st47 {\n        fill: #dc7323;\n      }\n\n      .st48 {\n        fill: #c0b69a;\n      }\n\n      .st49 {\n        fill: #d0c5a6;\n      }\n\n      .st50 {\n        fill: #8a8370;\n      }\n\n      .st51 {\n        fill: #dfd2b0;\n      }\n\n      .st52 {\n        fill: #9f9780;\n      }\n\n      .st53 {\n        fill: #b1a98f;\n      }\n\n      .st54 {\n        fill: #87816e;\n      }\n\n      .st55 {\n        fill: #e1d4b2;\n      }\n\n      .st56 {\n        fill: #98917b;\n      }\n\n      .st57 {\n        fill: url(#c);\n      }\n\n      .st58 {\n        fill: url(#d);\n      }\n\n      .st59 {\n        fill: #8e8773;\n      }\n\n      .st60 {\n        fill: #c46627;\n      }\n\n      .st61 {\n        fill: #b8af94;\n      }\n\n      .st62 {\n        fill: #928b76;\n      }\n\n      .st63 {\n        fill: #e38627;\n      }\n\n      .st64 {\n        fill: #ebddb9;\n      }\n\n      .st65 {\n        fill: #a49c85;\n      }\n\n      .st66 {\n        fill: #bab196;\n      }\n\n      .st67 {\n        fill: #c8bea0;\n      }\n\n      .st68 {\n        fill: #cdc2a4;\n      }\n\n      .st69 {\n        fill: #b7ae93;\n      }\n\n      .st70 {\n        fill: #cbc0a2;\n      }\n\n      .st71 {\n        fill: #cac0a1;\n      }\n\n      .st72 {\n        fill: #d4c9a9;\n      }\n\n      .st73 {\n        fill: #c3b99c;\n      }\n\n      .st74 {\n        fill: #d2c7a7;\n      }\n\n      .st75 {\n        fill: #eddfba;\n      }\n\n      .st76 {\n        fill: #d3c7a8;\n      }\n\n      .st77 {\n        fill: #968e79;\n      }\n\n      .st78 {\n        fill: #8c8672;\n      }\n\n      .st79 {\n        fill: #e5d7b4;\n      }\n\n      .st80 {\n        fill: #c9bea0;\n      }\n\n      .st81 {\n        fill: #aaa289;\n      }\n\n      .st82 {\n        fill: #968f7a;\n      }\n\n      .st83 {\n        fill: #dcd0ae;\n      }\n\n      .st84 {\n        fill: #cfc3a5;\n      }\n\n      .st85 {\n        fill: #aca38a;\n      }\n\n      .st86 {\n        fill: #c8bd9f;\n      }\n\n      .st87 {\n        fill: #bcb297;\n      }\n\n      .st88 {\n        fill: #88826f;\n      }\n\n      .st89 {\n        fill: #e3d6b3;\n      }\n\n      .st90 {\n        fill: #d7cbaa;\n      }\n\n      .st91 {\n        fill: #452b1f;\n      }\n\n      .st92 {\n        fill: #e0d3b1;\n      }\n\n      .st93 {\n        fill: #efe1bc;\n      }\n\n      .st94 {\n        fill: #958e79;\n      }\n\n      .st95 {\n        fill: #9a937d;\n      }\n\n      .st96 {\n        fill: #eee0bb;\n      }\n\n      .st97 {\n        fill: #aba28a;\n      }\n\n      .st98 {\n        fill: #784a2c;\n      }\n\n      .st99 {\n        fill: #99917c;\n      }\n\n      .st100 {\n        fill: #c5ba9d;\n      }\n\n      .st101 {\n        fill: #9b937e;\n      }\n\n      .st102 {\n        fill: #c7bc9f;\n      }\n\n      .st103 {\n        fill: #948d78;\n      }\n\n      .st104 {\n        fill: #a39b83;\n      }\n\n      .st105 {\n        fill: #ac4227;\n      }\n\n      .st106 {\n        fill: #b3aa90;\n      }\n\n      .st107 {\n        fill: #7c3928;\n      }\n\n      .st108 {\n        fill: #bdb397;\n      }\n\n      .st109 {\n        fill: #cec3a4;\n      }\n\n      .st110 {\n        fill: #99927c;\n      }\n\n      .st111 {\n        fill: #c5bb9e;\n      }\n\n      .st112 {\n        fill: #a59d85;\n      }\n\n      .st113 {\n        fill: #dccfae;\n      }\n\n      .st114 {\n        fill: #a39b84;\n      }\n\n      .st115 {\n        fill: #e6d9b5;\n      }\n\n      .st116 {\n        fill: #c2b89b;\n      }\n\n      .st117 {\n        fill: #e7d9b6;\n      }\n\n      .st118 {\n        fill: #9d967f;\n      }\n\n      .st119 {\n        fill: #ada48c;\n      }\n\n      .st120 {\n        fill: #c1b79b;\n      }\n\n      .st121 {\n        fill: #914029;\n      }\n\n      .st122 {\n        fill: #bfb599;\n      }\n\n      .st123 {\n        fill: #e49843;\n      }\n\n      .st124 {\n        fill: #ecdeb9;\n      }\n\n      .st125 {\n        fill: #efb962;\n      }\n\n      .st126 {\n        fill: #d4c8a8;\n      }\n\n      .st127 {\n        fill: #edc686;\n      }\n\n      .st128 {\n        fill: #d9cdac;\n      }\n\n      .st129 {\n        fill: #a09882;\n      }\n\n      .st130 {\n        fill: #afa78d;\n      }\n\n      .st131 {\n        fill: #eaa650;\n      }\n\n      .st132 {\n        fill: #c0b699;\n      }\n\n      .st133 {\n        fill: #aca48b;\n      }\n\n      .st134 {\n        fill: #a69d86;\n      }\n\n      .st135 {\n        fill: #9e9680;\n      }\n\n      .st136 {\n        fill: #eab473;\n      }\n\n      .st137 {\n        fill: #97907a;\n      }\n\n      .st138 {\n        fill: #a19982;\n      }\n\n      .st139 {\n        fill: #beb498;\n      }\n\n      .st140 {\n        fill: #efdbbe;\n      }\n\n      .st141 {\n        fill: #8f8874;\n      }\n\n      .st142 {\n        fill: #a9a088;\n      }\n\n      .st143 {\n        fill: #c4ba9d;\n      }\n\n      .st144 {\n        fill: #9f9881;\n      }\n\n      .st145 {\n        fill: #ea9d33;\n      }\n\n      .st146 {\n        fill: #87806d;\n      }\n\n      .st147 {\n        fill: #ded1af;\n      }\n\n      .st148 {\n        fill: #4569ac;\n      }\n\n      .st149 {\n        fill: #ded2b0;\n      }\n\n      .st150 {\n        fill: #c6bc9e;\n      }\n\n      .st151 {\n        fill: #e5d8b5;\n      }\n\n      .st152 {\n        fill: #583123;\n      }\n\n      .st153 {\n        fill: #d1c5a6;\n      }\n\n      .st154 {\n        fill: #a8a088;\n      }\n\n      .st155 {\n        fill: url(#e);\n      }\n\n      .st156 {\n        fill: url(#a);\n      }\n\n      .st157 {\n        fill: #a9a189;\n      }\n\n      .st158 {\n        fill: #e9dbb7;\n      }\n\n      .st159 {\n        fill: #e8dbb7;\n      }\n\n      .st160 {\n        fill: #693424;\n      }\n\n      .st161 {\n        fill: #afa68d;\n      }\n\n      .st162 {\n        fill: #d56623;\n      }\n\n      .st163 {\n        clip-path: url(#b);\n      }\n\n      .st164 {\n        fill: #cfc4a5;\n      }\n\n      .st165 {\n        fill: #d8ccab;\n      }\n\n      .st166 {\n        fill: #b2a990;\n      }\n\n      .st167 {\n        fill: #dbcfad;\n      }\n\n      .st168 {\n        fill: #d38d49;\n      }\n\n      .st169 {\n        fill: #918a76;\n      }\n\n      .st170 {\n        fill: #8b8571;\n      }\n\n      .st171 {\n        fill: #e18639;\n      }\n\n      .st172 {\n        fill: #cdc2a3;\n      }\n\n      .st173 {\n        fill: #e1d4b1;\n      }\n\n      .st174 {\n        fill: #8b8471;\n      }\n\n      .st175 {\n        fill: #ce5625;\n      }"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m36.17 502.98h38.86c3.03 0 6.06 0.5 8.75 1.51s5.22 2.36 7.23 4.04 3.7 3.7 4.71 5.89c1.18 2.19 1.68 4.71 1.68 7.23v13.29h-27.09v-9.25h-29.11v56.36h29.11v-9.25h27.42v13.29c0 2.52-0.5 5.05-1.68 7.23-1.18 2.19-2.69 4.21-4.71 5.89s-4.37 3.03-7.23 4.04-5.72 1.51-8.75 1.51h-39.2c-6.23 0-11.44-1.85-15.98-5.55-4.37-3.7-6.56-8.08-6.56-13.29v-64.44c0-5.22 2.19-9.59 6.56-13.29 4.54-3.36 9.93-5.22 15.98-5.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 584.69,
    x2: 886.75,
    y1: 975.92,
    y2: 1099.2,
    "data-name": "Sfumatura senza nome 4",
    gradientTransform: "rotate(-1.26 -17190 1844.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464648",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111112",
    offset: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58585a",
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151516",
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404043",
    offset: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d2d2f",
    offset: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69696b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 98.04,
    x2: 346.27,
    y1: 1137.8,
    y2: 1239.2,
    "data-name": "Sfumatura senza nome 4",
    gradientTransform: "rotate(1.17 26882 257.38)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 117.42,
    x2: 921.97,
    y1: 554.76,
    y2: 883.21,
    "data-name": "Sfumatura senza nome 3",
    gradientTransform: "rotate(-3.44 -5135.9 343.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a80b17",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d05333",
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2001a",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2001a",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8542f",
    offset: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf0418",
    offset: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f0d0d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 276.33,
    x2: 744.7,
    y1: 799.34,
    y2: 990.54,
    "data-name": "Sfumatura senza nome 4",
    gradientTransform: "rotate(-1.61 -14373 394.22)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 584.69,
    x2: 886.75,
    y1: 975.92,
    y2: 1099.2,
    gradientTransform: "rotate(-1.26 -17190 1844.2)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.003736 -262.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m35.67 502.98h38.19c3.03 0 5.89 0.5 8.58 1.51s5.05 2.36 7.07 4.04 3.53 3.7 4.71 5.89 1.68 4.71 1.68 7.23v13.29h-26.92v-9.25h-28.6v56.36h28.6v-9.25h26.92v13.29c0 2.52-0.5 5.05-1.68 7.23s-2.69 4.21-4.71 5.89-4.37 3.03-7.07 4.04c-2.69 1.01-5.55 1.51-8.58 1.51h-38.19c-6.06 0-11.27-1.85-15.65-5.55s-6.56-8.08-6.56-13.29v-64.44c0-5.22 2.19-9.59 6.56-13.29 4.37-3.36 9.59-5.22 15.65-5.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m147.05 525.86v17.33h29.78v19.01h-29.78v20.02h41.39v22.88h-68.31v-101.96h68.31v22.88h-41.39v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m294.93 550.76c0 6.06-1.85 11.61-5.55 16.49s-8.58 8.58-14.47 11.27l18 26.58h-29.61l-15.65-22.88h-8.41v22.88h-26.92v-101.96h45.43c5.22 0 9.93 0.84 14.47 2.52s8.41 3.87 11.78 6.73 6.06 6.23 7.91 9.93c1.85 3.87 2.86 7.91 2.86 12.28v16.15h0.17zm-26.92-16.32c0-2.36-1.01-4.37-3.03-6.06s-4.37-2.52-7.07-2.52h-18.51v33.31h18.51c2.69 0 5.05-0.84 7.07-2.52s3.03-3.53 3.03-5.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m383.94 502.98v22.88h-21.37v79.24h-26.92v-79.24h-21.37v-22.88h69.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m434.91 525.86v17.33h29.78v19.01h-29.78v20.02h41.39v22.88h-68.31v-101.96h68.31v22.88h-41.39v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m638.49 502.98v101.96h-27.26l-28.43-52.16v52.16h-26.92v-101.96h27.26l28.43 52.16v-52.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m722.95 502.98c3.03 0 5.89 0.5 8.58 1.51s5.05 2.36 7.07 4.04 3.53 3.7 4.71 5.89 1.68 4.71 1.68 7.23v64.44c0 2.52-0.5 5.05-1.68 7.23s-2.69 4.21-4.71 5.89-4.37 3.03-7.07 4.04c-2.69 1.01-5.55 1.51-8.58 1.51h-38.19c-3.03 0-5.89-0.5-8.58-1.51s-5.05-2.36-7.07-4.04-3.53-3.7-4.71-5.89-1.68-4.71-1.68-7.23v-64.44c0-2.52 0.5-5.05 1.68-7.23s2.69-4.21 4.71-5.89 4.37-3.03 7.07-4.04c2.69-1.01 5.55-1.51 8.58-1.51zm-4.88 22.88h-28.6v56.36h28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m838.87 502.98v22.88h-21.37v79.24h-26.92v-79.24h-21.37v-22.88h69.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m932.75 502.98v22.88h-21.37v79.24h-26.92v-79.24h-21.37v-22.88h69.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m983.73 502.98v101.96h-26.92v-101.96z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st163",
    transform: "translate(-.003736 -262.89)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m12.11 520.14c-2.36-7.57 12.95-18.17 34.49-23.55s40.88-4.04 43.24 3.53-12.95 18.17-34.49 23.55-40.88 3.87-43.24-3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "m12.11 519.97c-2.36-7.4 13.12-18 34.49-23.55s40.88-4.04 43.24 3.53c2.36 7.4-13.12 18-34.49 23.55s-40.88 4.04-43.24-3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "m11.95 519.97c-2.36-7.4 13.12-18 34.49-23.55s40.88-4.04 43.24 3.36-13.12 18-34.49 23.55-40.72 4.04-43.24-3.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "m11.95 519.8c-2.36-7.4 13.12-17.83 34.49-23.39 21.37-5.55 40.88-4.04 43.24 3.36s-13.12 17.83-34.49 23.39c-21.37 5.55-40.88 4.04-43.24-3.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "m11.95 519.8c-2.36-7.4 13.12-17.83 34.66-23.39 21.54-5.55 40.72-4.04 43.24 3.2 2.36 7.4-13.12 17.83-34.66 23.39-21.54 5.72-40.88 4.21-43.24-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "m11.95 519.8c-2.36-7.23 13.12-17.67 34.66-23.22s40.72-4.04 43.07 3.2-13.12 17.67-34.66 23.22c-21.37 5.55-40.72 4.04-43.07-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "m11.95 519.63c-2.36-7.23 13.12-17.67 34.66-23.22s40.72-4.21 43.07 3.2c2.36 7.23-13.12 17.67-34.66 23.22s-40.72 4.21-43.07-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "m11.95 519.63c-2.36-7.23 13.12-17.67 34.66-23.22s40.72-4.21 43.07 3.03c2.36 7.23-13.12 17.67-34.66 23.22s-40.72 4.21-43.07-3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "m11.95 519.46c-2.36-7.23 13.12-17.5 34.66-23.05s40.72-4.21 43.07 3.03c2.36 7.23-13.12 17.5-34.66 23.05s-40.88 4.21-43.07-3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "m11.78 519.46c-2.36-7.23 13.29-17.5 34.66-23.05s40.72-4.21 43.07 2.86c2.36 7.23-13.29 17.5-34.66 23.05s-40.72 4.37-43.07-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "m11.78 519.46c-2.36-7.07 13.29-17.33 34.66-22.88s40.72-4.21 43.07 2.86c2.36 7.07-13.29 17.33-34.66 22.88s-40.72 4.21-43.07-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "m11.78 519.3c-2.36-7.07 13.29-17.33 34.66-22.88s40.72-4.37 43.07 2.86c2.36 7.07-13.29 17.33-34.66 22.88-21.54 5.55-40.72 4.21-43.07-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "m11.78 519.3c-2.36-7.07 13.29-17.33 34.83-22.88s40.72-4.37 43.07 2.69c2.36 7.07-13.29 17.33-34.83 22.88s-40.72 4.37-43.07-2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "m11.78 519.13c-2.19-7.07 13.29-17.16 34.83-22.71s40.72-4.37 42.9 2.69c2.19 7.07-13.29 17.16-34.83 22.71s-40.72 4.37-42.9-2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "m11.78 519.13c-2.19-6.9 13.29-17.16 34.83-22.71s40.72-4.37 42.9 2.52-13.29 17.16-34.83 22.71-40.72 4.37-42.9-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "m11.78 519.13c-2.19-6.9 13.29-16.99 34.83-22.54s40.72-4.37 42.9 2.52c2.19 6.9-13.29 16.99-34.83 22.54s-40.72 4.37-42.9-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "m11.78 518.96c-2.19-6.9 13.29-16.99 34.83-22.54s40.72-4.37 42.9 2.52-13.29 16.99-34.83 22.54-40.72 4.37-42.9-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "m11.61 518.96c-2.19-6.9 13.46-16.99 34.83-22.54s40.72-4.54 42.9 2.36c2.19 6.9-13.46 16.99-34.83 22.54s-40.55 4.54-42.9-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "m11.61 518.79c-2.19-6.9 13.46-16.82 34.83-22.38 21.37-5.55 40.72-4.54 42.9 2.36 2.19 6.9-13.46 16.82-34.83 22.38-21.54 5.55-40.72 4.54-42.9-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m11.61 518.79c-2.19-6.73 13.46-16.82 34.83-22.38 21.37-5.55 40.72-4.54 42.9 2.19 2.19 6.73-13.46 16.82-34.83 22.38s-40.72 4.54-42.9-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "m11.61 518.79c-2.19-6.73 13.46-16.66 35-22.21s40.72-4.54 42.73 2.19c2.02 6.73-13.46 16.66-35 22.21s-40.55 4.54-42.73-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "m11.61 518.62c-2.19-6.73 13.46-16.66 35-22.21s40.55-4.54 42.73 2.19-13.46 16.66-35 22.21-40.55 4.54-42.73-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "m11.61 518.62c-2.19-6.73 13.46-16.66 35-22.21s40.55-4.71 42.73 2.02c2.19 6.73-13.46 16.66-35 22.21s-40.55 4.54-42.73-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "m11.61 518.45c-2.19-6.56 13.46-16.49 35-22.04s40.55-4.71 42.73 2.02c2.19 6.56-13.46 16.49-35 22.04s-40.72 4.71-42.73-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "m11.44 518.45c-2.19-6.56 13.63-16.49 35-22.04s40.72-4.71 42.9 2.02c2.19 6.73-13.63 16.49-35 22.04-21.54 5.38-40.72 4.54-42.9-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "m11.44 518.45c-2.19-6.56 13.63-16.32 35-21.87s40.55-4.71 42.73 1.85c2.19 6.56-13.63 16.32-35 21.87s-40.55 4.71-42.73-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "m11.44 518.29c-2.19-6.56 13.63-16.32 35-21.87s40.55-4.71 42.73 1.85c2.19 6.56-13.63 16.32-35 21.87s-40.55 4.71-42.73-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "m11.44 518.29c-2.02-6.56 13.63-16.32 35.16-21.7 21.54-5.38 40.55-4.71 42.73 1.68 2.19 6.39-13.63 16.32-35.16 21.7s-40.55 4.71-42.73-1.68z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st113",
    transform: "rotate(-14.14 50.316 508.22)",
    cx: 50.31,
    cy: 508.2,
    rx: 40.21,
    ry: 12.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st167",
    transform: "rotate(-14.15 50.276 507.87)",
    cx: 50.31,
    cy: 508.03,
    rx: 40.21,
    ry: 12.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "rotate(-14.15 50.276 507.87)",
    cx: 50.31,
    cy: 508.03,
    rx: 40.21,
    ry: 12.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st128",
    transform: "rotate(-14.15 50.347 507.96)",
    cx: 50.31,
    cy: 507.84,
    rx: 40.21,
    ry: 11.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st128",
    transform: "rotate(-14.16 50.122 507.8)",
    cx: 50.13,
    cy: 507.85,
    rx: 40.21,
    ry: 11.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st165",
    transform: "rotate(-14.16 50.177 508.01)",
    cx: 50.14,
    cy: 507.86,
    rx: 40.21,
    ry: 11.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    transform: "rotate(-14.16 50.157 507.84)",
    cx: 50.13,
    cy: 507.68,
    rx: 40.21,
    ry: 11.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st90",
    transform: "rotate(-14.17 50.133 507.7)",
    cx: 50.14,
    cy: 507.7,
    rx: 40.21,
    ry: 11.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    transform: "rotate(-14.18 50.093 507.36)",
    cx: 50.14,
    cy: 507.53,
    rx: 40.21,
    ry: 11.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    transform: "rotate(-14.18 50.088 507.4)",
    cx: 50.14,
    cy: 507.51,
    rx: 40.21,
    ry: 11.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st72",
    transform: "rotate(-14.18 50.144 507.61)",
    cx: 50.14,
    cy: 507.52,
    rx: 40.21,
    ry: 11.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st126",
    transform: "rotate(-14.19 50.105 507.26)",
    cx: 50.14,
    cy: 507.35,
    rx: 40.21,
    ry: 11.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st76",
    transform: "rotate(-14.19 49.939 507.28)",
    cx: 49.96,
    cy: 507.35,
    rx: 40.21,
    ry: 11.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st74",
    transform: "rotate(-14.19 49.979 507.29)",
    cx: 49.97,
    cy: 507.19,
    rx: 40.21,
    ry: 11.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    transform: "rotate(-14.2 49.955 507.14)",
    cx: 49.97,
    cy: 507.2,
    rx: 40.21,
    ry: 11.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st153",
    transform: "rotate(-14.21 49.951 506.84)",
    cx: 49.97,
    cy: 507.01,
    rx: 40.21,
    ry: 11.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st49",
    transform: "rotate(-14.21 49.951 506.84)",
    cx: 49.97,
    cy: 507.01,
    rx: 40.21,
    ry: 11.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st164",
    transform: "rotate(-14.21 49.966 507.05)",
    cx: 49.97,
    cy: 507.02,
    rx: 40.21,
    ry: 11.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st84",
    transform: "rotate(-14.22 49.962 506.75)",
    cx: 49.97,
    cy: 506.85,
    rx: 40.21,
    ry: 10.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st109",
    transform: "rotate(-14.22 49.962 506.75)",
    cx: 49.97,
    cy: 506.85,
    rx: 40.21,
    ry: 10.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st68",
    transform: "rotate(-14.22 49.832 506.81)",
    cx: 49.79,
    cy: 506.66,
    rx: 40.21,
    ry: 10.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st172",
    transform: "rotate(-14.22 49.832 506.81)",
    cx: 49.79,
    cy: 506.66,
    rx: 40.21,
    ry: 10.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st46",
    transform: "rotate(-14.23 49.808 506.67)",
    cx: 49.8,
    cy: 506.68,
    rx: 40.21,
    ry: 10.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    transform: "rotate(-14.23 49.848 506.68)",
    cx: 49.8,
    cy: 506.51,
    rx: 40.21,
    ry: 10.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st71",
    transform: "rotate(-14.23 49.848 506.68)",
    cx: 49.8,
    cy: 506.51,
    rx: 40.21,
    ry: 10.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    transform: "rotate(-14.24 49.804 506.38)",
    cx: 49.8,
    cy: 506.34,
    rx: 40.21,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st80",
    transform: "rotate(-14.25 49.78 506.24)",
    cx: 49.8,
    cy: 506.33,
    rx: 40.21,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st67",
    transform: "rotate(-14.25 49.615 506.26)",
    cx: 49.63,
    cy: 506.33,
    rx: 40.21,
    ry: 10.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st86",
    transform: "rotate(-14.25 49.655 506.26)",
    cx: 49.63,
    cy: 506.17,
    rx: 40.21,
    ry: 10.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st102",
    transform: "rotate(-14.25 49.655 506.26)",
    cx: 49.63,
    cy: 506.17,
    rx: 40.21,
    ry: 10.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st150",
    transform: "rotate(-14.26 49.611 505.96)",
    cx: 49.63,
    cy: 506,
    rx: 40.21,
    ry: 10.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st111",
    transform: "rotate(-14.26 49.666 506.17)",
    cx: 49.64,
    cy: 506.01,
    rx: 40.21,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st100",
    transform: "rotate(-14.26 49.666 506.17)",
    cx: 49.64,
    cy: 506.01,
    rx: 40.21,
    ry: 9.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st143",
    transform: "rotate(-14.27 49.623 505.86)",
    cx: 49.63,
    cy: 505.82,
    rx: 40.21,
    ry: 9.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st73",
    transform: "rotate(-14.27 49.663 505.87)",
    cx: 49.63,
    cy: 505.83,
    rx: 40.21,
    ry: 9.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    transform: "rotate(-14.28 49.419 505.54)",
    cx: 49.46,
    cy: 505.66,
    rx: 40.21,
    ry: 9.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st116",
    transform: "rotate(-14.28 49.419 505.54)",
    cx: 49.46,
    cy: 505.66,
    rx: 40.21,
    ry: 9.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st120",
    transform: "rotate(-14.28 49.474 505.75)",
    cx: 49.46,
    cy: 505.67,
    rx: 40.21,
    ry: 9.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st48",
    transform: "rotate(-14.29 49.43 505.45)",
    cx: 49.47,
    cy: 505.51,
    rx: 40.21,
    ry: 9.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st132",
    transform: "rotate(-14.29 49.43 505.45)",
    cx: 49.47,
    cy: 505.51,
    rx: 40.21,
    ry: 9.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st122",
    transform: "rotate(-14.29 49.505 505.5)",
    cx: 49.46,
    cy: 505.32,
    rx: 40.21,
    ry: 9.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st139",
    transform: "rotate(-14.29 49.505 505.5)",
    cx: 49.47,
    cy: 505.32,
    rx: 40.21,
    ry: 9.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st36",
    transform: "rotate(-14.3 49.302 505.17)",
    cx: 49.29,
    cy: 505.16,
    rx: 40.21,
    ry: 9.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st108",
    transform: "rotate(-14.3 49.302 505.17)",
    cx: 49.29,
    cy: 505.16,
    rx: 40.21,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st87",
    transform: "rotate(-14.31 49.278 505.04)",
    cx: 49.3,
    cy: 505.17,
    rx: 40.21,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    transform: "rotate(-14.31 49.263 504.83)",
    cx: 49.29,
    cy: 504.99,
    rx: 40.21,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st66",
    transform: "rotate(-14.31 49.318 505.04)",
    cx: 49.3,
    cy: 505.01,
    rx: 40.21,
    ry: 8.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    transform: "rotate(-14.31 49.298 504.88)",
    cx: 49.3,
    cy: 504.83,
    rx: 40.21,
    ry: 8.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    transform: "rotate(-14.32 49.275 504.74)",
    cx: 49.3,
    cy: 504.82,
    rx: 40.21,
    ry: 8.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st61",
    transform: "rotate(-14.32 49.275 504.74)",
    cx: 49.3,
    cy: 504.82,
    rx: 40.21,
    ry: 8.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st69",
    transform: "rotate(-14.32 49.145 504.8)",
    cx: 49.12,
    cy: 504.66,
    rx: 40.21,
    ry: 8.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    transform: "rotate(-14.32 49.145 504.8)",
    cx: 49.12,
    cy: 504.66,
    rx: 40.21,
    ry: 8.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    transform: "rotate(-14.33 49.107 504.46)",
    cx: 49.13,
    cy: 504.49,
    rx: 40.21,
    ry: 8.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    transform: "rotate(-14.33 49.107 504.46)",
    cx: 49.13,
    cy: 504.49,
    rx: 40.21,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    transform: "rotate(-14.34 49.083 504.33)",
    cx: 49.13,
    cy: 504.5,
    rx: 40.21,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    transform: "rotate(-14.34 49.103 504.17)",
    cx: 49.13,
    cy: 504.33,
    rx: 40.21,
    ry: 8.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st106",
    transform: "rotate(-14.34 49.158 504.38)",
    cx: 49.13,
    cy: 504.32,
    rx: 40.21,
    ry: 8.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st166",
    transform: "rotate(-14.34 49.138 504.21)",
    cx: 49.13,
    cy: 504.14,
    rx: 40.21,
    ry: 8.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st53",
    transform: "rotate(-14.34 48.974 504.23)",
    cx: 48.95,
    cy: 504.14,
    rx: 40.21,
    ry: 8.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st35",
    transform: "rotate(-14.35 48.956 504.06)",
    cx: 48.96,
    cy: 504.16,
    rx: 40.21,
    ry: 8.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    transform: "rotate(-14.35 48.936 503.89)",
    cx: 48.96,
    cy: 503.98,
    rx: 40.21,
    ry: 7.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st130",
    transform: "rotate(-14.35 48.99 504.1)",
    cx: 48.96,
    cy: 503.99,
    rx: 40.21,
    ry: 7.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st161",
    transform: "rotate(-14.35 48.971 503.94)",
    cx: 48.96,
    cy: 503.82,
    rx: 40.21,
    ry: 7.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    transform: "rotate(-14.36 48.952 503.76)",
    cx: 48.97,
    cy: 503.83,
    rx: 40.21,
    ry: 7.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st119",
    transform: "rotate(-14.36 48.947 503.8)",
    cx: 48.97,
    cy: 503.83,
    rx: 40.21,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st133",
    transform: "rotate(-14.36 48.769 503.62)",
    cx: 48.79,
    cy: 503.66,
    rx: 40.21,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st85",
    transform: "rotate(-14.37 48.745 503.48)",
    cx: 48.79,
    cy: 503.65,
    rx: 40.21,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st97",
    transform: "rotate(-14.37 48.765 503.32)",
    cx: 48.79,
    cy: 503.47,
    rx: 40.21,
    ry: 7.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st81",
    transform: "rotate(-14.37 48.78 503.52)",
    cx: 48.79,
    cy: 503.48,
    rx: 40.21,
    ry: 7.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st157",
    transform: "rotate(-14.37 48.805 503.33)",
    cx: 48.79,
    cy: 503.3,
    rx: 40.21,
    ry: 7.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st142",
    transform: "rotate(-14.38 48.782 503.19)",
    cx: 48.8,
    cy: 503.32,
    rx: 40.21,
    ry: 7.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st154",
    transform: "rotate(-14.38 48.782 503.19)",
    cx: 48.8,
    cy: 503.32,
    rx: 40.21,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st44",
    transform: "rotate(-14.38 48.762 503.03)",
    cx: 48.79,
    cy: 503.14,
    rx: 40.21,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    transform: "rotate(-14.38 48.653 503.26)",
    cx: 48.62,
    cy: 503.16,
    rx: 40.21,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st134",
    transform: "rotate(-14.38 48.638 503.05)",
    cx: 48.62,
    cy: 502.98,
    rx: 40.21,
    ry: 6.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st112",
    transform: "rotate(-14.38 48.638 503.05)",
    cx: 48.62,
    cy: 502.98,
    rx: 40.21,
    ry: 6.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st65",
    transform: "rotate(-14.39 48.61 502.96)",
    cx: 48.62,
    cy: 502.97,
    rx: 40.21,
    ry: 6.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st114",
    transform: "rotate(-14.39 48.635 502.76)",
    cx: 48.62,
    cy: 502.8,
    rx: 40.21,
    ry: 6.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st104",
    transform: "rotate(-14.39 48.649 502.96)",
    cx: 48.63,
    cy: 502.81,
    rx: 40.21,
    ry: 6.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    transform: "rotate(-14.39 48.669 502.8)",
    cx: 48.63,
    cy: 502.63,
    rx: 40.21,
    ry: 6.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st138",
    transform: "rotate(-14.39 48.466 502.82)",
    cx: 48.45,
    cy: 502.64,
    rx: 40.21,
    ry: 6.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st129",
    transform: "rotate(-14.4 48.448 502.64)",
    cx: 48.45,
    cy: 502.65,
    rx: 40.21,
    ry: 6.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st144",
    transform: "rotate(-14.4 48.468 502.48)",
    cx: 48.45,
    cy: 502.47,
    rx: 40.21,
    ry: 6.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st52",
    transform: "rotate(-14.4 48.468 502.48)",
    cx: 48.45,
    cy: 502.48,
    rx: 40.21,
    ry: 6.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st135",
    transform: "rotate(-14.41 48.425 502.19)",
    cx: 48.46,
    cy: 502.31,
    rx: 40.21,
    ry: 6.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st118",
    transform: "rotate(-14.41 48.425 502.19)",
    cx: 48.46,
    cy: 502.31,
    rx: 40.21,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    transform: "rotate(-14.41 48.425 502.19)",
    cx: 48.46,
    cy: 502.32,
    rx: 40.21,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st32",
    transform: "rotate(-14.41 48.46 502.23)",
    cx: 48.46,
    cy: 502.13,
    rx: 40.21,
    ry: 6.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st101",
    transform: "rotate(-14.41 48.302 502.21)",
    cx: 48.28,
    cy: 502.13,
    rx: 40.21,
    ry: 5.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st95",
    transform: "rotate(-14.41 48.322 502.05)",
    cx: 48.28,
    cy: 501.96,
    rx: 40.21,
    ry: 5.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st110",
    transform: "rotate(-14.42 48.259 501.91)",
    cx: 48.29,
    cy: 501.97,
    rx: 40.21,
    ry: 5.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st99",
    transform: "rotate(-14.42 48.259 501.91)",
    cx: 48.29,
    cy: 501.97,
    rx: 40.21,
    ry: 5.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st56",
    transform: "rotate(-14.42 48.279 501.75)",
    cx: 48.29,
    cy: 501.8,
    rx: 40.21,
    ry: 5.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st137",
    transform: "rotate(-14.42 48.279 501.75)",
    cx: 48.29,
    cy: 501.8,
    rx: 40.21,
    ry: 5.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st82",
    transform: "rotate(-14.42 48.319 501.76)",
    cx: 48.29,
    cy: 501.63,
    rx: 40.21,
    ry: 5.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st77",
    transform: "rotate(-14.42 48.319 501.76)",
    cx: 48.29,
    cy: 501.63,
    rx: 40.21,
    ry: 5.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st94",
    transform: "rotate(-14.42 48.141 501.58)",
    cx: 48.11,
    cy: 501.46,
    rx: 40.21,
    ry: 5.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st103",
    transform: "rotate(-14.43 48.118 501.44)",
    cx: 48.12,
    cy: 501.47,
    rx: 40.21,
    ry: 5.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    transform: "rotate(-14.43 48.118 501.44)",
    cx: 48.12,
    cy: 501.48,
    rx: 40.21,
    ry: 5.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st28",
    transform: "rotate(-14.43 48.133 501.32)",
    cx: 48.11,
    cy: 501.28,
    rx: 40.21,
    ry: 5.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st62",
    transform: "rotate(-14.43 48.133 501.32)",
    cx: 48.12,
    cy: 501.28,
    rx: 40.21,
    ry: 5.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st169",
    transform: "rotate(-14.44 48.096 500.99)",
    cx: 48.12,
    cy: 501.12,
    rx: 40.21,
    ry: 5.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st41",
    transform: "rotate(-14.44 48.096 500.99)",
    cx: 48.12,
    cy: 501.12,
    rx: 40.21,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    transform: "rotate(-14.44 47.933 501.01)",
    cx: 47.94,
    cy: 501.12,
    rx: 40.21,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st141",
    transform: "rotate(-14.44 47.913 500.84)",
    cx: 47.94,
    cy: 500.95,
    rx: 40.21,
    ry: 4.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st59",
    transform: "rotate(-14.44 47.972 501.01)",
    cx: 47.95,
    cy: 500.96,
    rx: 40.21,
    ry: 4.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    transform: "rotate(-14.44 47.953 500.85)",
    cx: 47.95,
    cy: 500.78,
    rx: 40.21,
    ry: 4.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st78",
    transform: "rotate(-14.44 47.953 500.85)",
    cx: 47.95,
    cy: 500.79,
    rx: 40.21,
    ry: 4.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st170",
    transform: "rotate(-14.44 47.953 500.85)",
    cx: 47.95,
    cy: 500.79,
    rx: 40.21,
    ry: 4.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st174",
    transform: "rotate(-14.45 47.95 500.56)",
    cx: 47.95,
    cy: 500.63,
    rx: 40.21,
    ry: 4.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st50",
    transform: "rotate(-14.45 47.95 500.56)",
    cx: 47.96,
    cy: 500.63,
    rx: 40.21,
    ry: 4.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st40",
    transform: "rotate(-14.45 47.773 500.38)",
    cx: 47.78,
    cy: 500.45,
    rx: 40.21,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st88",
    transform: "rotate(-14.45 47.773 500.38)",
    cx: 47.78,
    cy: 500.46,
    rx: 40.21,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st54",
    transform: "rotate(-14.45 47.827 500.58)",
    cx: 47.79,
    cy: 500.47,
    rx: 40.21,
    ry: 4.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st146",
    transform: "rotate(-14.45 47.807 500.42)",
    cx: 47.78,
    cy: 500.3,
    rx: 40.21,
    ry: 4.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    transform: "rotate(-14.45 47.807 500.42)",
    cx: 47.78,
    cy: 500.27,
    rx: 40.21,
    ry: 4.04
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.003736 -262.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m11.44 514.92c0 0.34 0.17 0.67 0.17 0.84h0.17c0.17-0.17 0.34-0.5 0.34-0.67-0.17-0.5 0.67-0.84 0.34-1.51 0.17-0.17 0.5-0.34 0.67-0.5 0.17 0 0.17-0.17 0.17-0.34s0.17-0.17 0.17-0.34c0.17 0 0.17-0.17 0.34-0.17s0.34 0 0.34-0.17c0.17-0.34 0.5-0.5 0.84-0.5 0.5 0 0.17-0.34 0.34-0.5v-0.17c0-0.17 0.17-0.5 0.17-0.5 0.34 0 0.67 0 0.84 0.17s0.5 0.17 0.67 0.34c0.34 0 0.67 0.17 1.01 0.34v0.84c-0.34 0-0.67 0-0.84 0.34 0 0.17-0.17 0.17-0.17 0.34 0 0 0.17 0.17 0.34 0.17 0.34 0 0.67 0 1.18 0.17v-0.5c0.17-0.17 0.5-0.34 0.67-0.5 0.17-0.17 0.5-0.34 0.67-0.67 0.17-0.34 0.17-0.67 0.34-1.01 0.17-0.17 0.34-0.17 0.34-0.34v-0.67h0.5q0.84 0 0.84 0.67c0 0.17 0.17 0.34 0.17 0.34 0.17 0 0.5 0 0.67-0.17 0.5-0.5 1.18-0.34 1.85-0.34-0.17 0.17-0.34 0.34-0.34 0.5 0.17 0 0.34 0 0.67 0.17v0.84c-0.5 0.17-1.01 0.34-1.51 0.67h-1.01c-0.17 0-0.17 0.17-0.34 0.34-0.5 0-0.84 0.17-1.01 0.67 0 0.17-0.17 0.34-0.17 0.34-0.34 0.17-0.67 0.34-1.01 0.67l0.34 0.34c-0.17 0.17-0.5 0.34-0.67 0.67h-0.84c-0.17 0-0.34 0.17-0.34 0.34l-0.17-0.17q0-0.5-1.01-0.34v0.67h-0.34c-0.5 0-0.67-0.17-0.5-0.67v-1.01c0-0.17-0.17-0.17-0.34-0.34q0-0.17-0.17-0.34c-0.5-0.34-0.34-0.5 0-0.67l-0.5-0.5-0.67 0.67c0 0.17-0.34 0.34-0.17 0.5 0.17 0.34 0 0.84 0.5 1.01h0.34c0.17 0.34 0.17 0.5 0.34 0.84 0 0.34 0.17 0.67 0.17 0.84s-0.17 0.34-0.17 0.5v0.34c-0.34 0.34-0.84 0.67-1.18 0.84h-0.17l-0.34-0.34c-0.17 0.17-0.5 0.34-0.5 0.5 0 0.84-0.5 0.67-1.01 0.67h-0.17c-0.17-0.5-0.34-1.01-0.5-1.68s-0.34-1.35-0.67-2.02c-0.17 0.34 0 0.17 0.34 0.17zm1.85 0.34c0-0.17-0.17-0.17-0.34-0.17s-0.34 0.17-0.34 0.34 0.17 0.17 0.17 0.34h0.17q0.34-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m87.32 501.97c0 0.67 0 1.35-0.17 2.02 0 0.17-0.17 0.17-0.17 0.34h-0.34c-0.34 0.17-0.5 0.34-0.84 0.5 0 0.17-0.17 0.5-0.17 0.67-0.17 0-0.34 0-0.5-0.17-0.67-0.17-1.18-0.34-1.85-0.67 0.17-0.17 0.34-0.17 0.67-0.34v-0.67c0.34-0.34 1.01-0.17 0.84-0.84 0.17 0 0.34-0.17 0.5-0.17 0.34-0.17 0.5-0.17 0.67-0.34 0 0-0.17-0.34-0.34-0.5-0.17-0.17-0.5-0.34-0.67-0.5-0.17-0.17-0.34-0.5-0.5-0.67 0-0.17 0.17-0.5 0.17-0.84-0.17 0.17-0.34 0.17-0.34 0.17-0.17 0.5-0.67 0.5-1.18 0.5-0.17 0-0.34 0.17-0.5 0.17h-0.67v-1.51h-1.18c-0.17 0-0.17 0.17-0.34 0.34s-0.5 0.17-0.67 0.34q-0.17-0.17-0.34-0.34-0.17 0.17-0.34 0.34c-0.17-0.17-0.17-0.34-0.34-0.5q-0.17-0.17-0.34-0.34s0-0.17-0.17-0.17l0.17-0.17h0.34c0.17 0 0.17-0.17 0.34-0.17-0.17 0-0.17-0.17-0.34-0.17h-0.34c-0.17-0.17-0.17-0.34-0.34-0.5 0.34-0.17 0.5-0.5 0-0.84-0.17-0.17-0.17-0.5 0.17-0.5q0.17-0.17 0.34-0.34-0.17-0.17-0.34-0.34c-0.17 0-0.67 0.17-0.67-0.34v-0.84c0.17-0.17 0.34-0.17 0.34-0.34v-1.01h0.5c0.17 0.17 0.17 0.5 0.34 0.67 0 0.17 0 0.34 0.17 0.5v0.5c-0.5 0-0.34 0.34-0.17 0.5h0.17v-0.5c0.17 0.17 0.34 0.17 0.34 0.34 0.17 0.17 0.34 0.17 0.5 0.34v0.5c0.5 0 1.18 0 1.01 0.84h0.67v1.01c0.34 0 0.84-0.17 1.18-0.17v0.17c-0.17 0.17-0.34 0.34-0.67 0.5 0.17 0.17 0.34 0.17 0.5 0.34 0.34-0.17 0.67-0.84 1.51-0.67 0 0 0.17-0.17 0.17-0.34 0.17-0.17 0.34-0.17 0.5-0.34 0.34 0 0.5 0 0.5-0.34 0-0.17 0.17-0.5-0.34-0.5h-0.34c0-0.17-0.17-0.34-0.17-0.5 0-0.34 0-0.67-0.17-1.01 0-0.17 0-0.5-0.34-0.5v-0.17h0.34q0.17-0.17 0.34-0.34t0.34-0.34l0.17 0.17c0.34 0.67 0.5 1.51 0.84 2.19 0.5 1.01 0.67 2.02 0.84 3.03 0 0.34-0.17 0.67 0.17 1.01v0.67c0.5 0.5 0.5 0.84 0.5 1.18zm-7.24-3.54c0.17 0.17 0.34 0.17 0.5 0.17s0.5 0.17 0.5-0.17c0-0.17-0.34-0.17-0.5-0.34-0.34 0.17-0.5 0.34-0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m8.92 486.32c0.17 1.18 0.34 2.36 0.5 3.53 0 0.34 0 0.67-0.17 1.01 0 0.34-0.17 0.67-0.34 1.01 0 0.17-0.17 0.17-0.34 0.34-0.17 0-0.17-0.17-0.34-0.17l-0.67-0.67c0 0.17-0.17 0.17-0.17 0.34s-0.17 0.34-0.17 0.5 0 0.17 0.17 0.34c0.67 0.17 1.01 0.5 0.84 1.18 0.34 0.34 0.67 0.5 0.67 1.01 0.17 0.5 0.5 1.01 0.67 1.51 0 0 0 0.17 0.17 0.17 0.17 0.34 0.67 0.5 0.34 0.84v0.34c0.17 0.5 0.84 0.67 0.67 1.35v1.51c0.34 0 0.5 0.17 1.01 0.17 0-0.5-0.17-1.01 0-1.35s0.67-0.5 1.18-0.67h0.34v-0.5c-0.17 0-0.17-0.17-0.34-0.17s-0.34 0-0.5-0.17h-0.5v-0.84c0-0.17 0.17-0.17 0.34-0.34h0.34c0-0.17 0.17-0.17 0.17-0.34v-0.17c-0.17-0.17-0.17-0.34-0.34-0.5-0.34 0-0.84 0.17-0.84-0.34q-0.84 0-1.01-0.67h-0.17l-0.5-0.5c-0.34-0.17-0.5-0.34-0.84-0.67-0.34 0-0.34-0.17-0.34-0.34s-0.17-0.5 0.34-0.5c0.17 0 0.17-0.17 0.34-0.17 0.17-0.84 1.35-1.35 2.19-0.84v0.17l0.17 0.17h0.17l0.17-0.17c0.17-0.17 0.34-0.17 0.5-0.34 0-0.34-0.17-0.34-0.5-0.34-0.17 0-0.5 0-0.34-0.34q-0.17 0-0.34-0.17c0.5-0.34 0.5-0.5 0.17-0.84v-0.17c0-0.17 0-0.34-0.17-0.5-0.34-0.17-0.17-0.5-0.17-0.84 0-0.17 0.17-0.5 0.34-0.67v-0.67h-0.34c-0.17 0-0.34-0.17-0.34-0.34s0-0.5 0.5-0.5l0.17-0.17s-0.17 0-0.17-0.17c-0.17-0.5-0.34-0.5-0.67-0.17-0.17 0.17-0.34 0.17-0.67 0.17-0.17 0-0.17-0.17-0.17-0.17 0-0.17 0.17-0.34 0.17-0.34h0.67v-0.5c-0.17-0.17-0.17-0.34-0.34-0.5-0.17 0-0.17-0.17-0.34-0.17 0.17 0 0.17-0.17 0.34-0.17q0.17-0.17 0.34-0.34l0.34 0.17c0 0.67 0.5 0.67 1.01 0.67 0.17-0.17 0.34-0.34 0.67-0.5 0-0.17 0-0.34-0.17-0.34h-0.5c-0.17 0-0.34-0.17-0.34-0.34s-0.17-0.67 0.34-0.67v-0.34c-0.17-0.17-0.5-0.17-0.67-0.34 0 0.17-0.17 0.17-0.17 0.34-0.17 0.17-0.34 0.34-0.5 0.34-0.34 0-0.84 0-1.01-0.34 0 0-0.17 0-0.17-0.17 0 0.5-0.17 0.84-0.17 1.35 0 0.34 0 0.5 0.34 0.67s0.34 0.5 0 0.84c-0.34 0.84-0.67 1.18-0.84 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m82.61 486.32c-0.34-0.84-0.5-1.68-0.84-2.69-0.17-0.67-0.5-1.35-0.67-1.85-0.34-1.01-0.5-1.85-0.67-2.86-0.17-0.67-0.17-1.18-0.34-1.85-0.34-1.01-0.17-2.19-0.17-3.2-0.17-0.67-0.17-1.51-0.34-2.19-0.17-0.34-0.34-0.67-0.17-1.18 0-0.17 0.17-0.34 0.17-0.5 0 0 0-0.17-0.17-0.34-0.17 0.17-0.34 0.17-0.5 0.34s-0.34 0.5-0.5 0.67v0.34h0.67v2.02c0 0.34-0.17 0.84 0.17 1.18s0.17 0.67 0.17 1.01c0 0.17 0 0.34 0.17 0.5 0.17 0.17 0.34 0.17 0.34 0.34v1.51c0 0.34 0.17 0.67-0.34 0.84 0.34 0.5 0.17 1.01 0.17 1.35 0.17 0.34 0.17 0.5 0.34 0.84 0.17 0 0.34 0.17 0.34 0.17 0 0.34 0 0.5 0.34 0.67 0.17 0.17 0.17 0.5-0.34 0.5v1.68c0.17 0.17 0.34 0.34 0.5 0.34 0.17 0.34 0.17 0.67 0.34 1.18l0.17 0.17c0.17 0.17 0.34 0.17 0.34 0.34v1.18c0.17-0.17 0.5-0.34 0.84-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m37.35 483.29c0-0.5-0.17-0.84-0.5-1.01-0.34-0.34-0.67-0.84-1.01-1.35-0.34-0.34-0.67-0.84-1.01-1.18-0.34-0.5-0.67-1.01-1.18-1.51l-1.01-1.01c-0.5-0.67-1.01-1.35-1.51-1.85l-0.17-0.17c-0.5 0-0.34-0.34-0.34-0.5h-0.5v0.5l-0.17-0.17h-0.34c-0.34 0-0.84 0.17-1.18 0.17h-1.01c-0.5 0-0.67 0.17-0.5 0.5h1.18c0.17 0 0.17 0.17 0.34 0.34l0.34 0.34c0.17 0 0.17-0.17 0.34-0.17 0.17-0.17 0.34-0.34 0.67-0.34 0.67-0.17 0.84 0.17 0.84 0.84 0 0.17 0.17 0.17 0.17 0.34 0.17 0.17 0.34 0.17 0.34 0.34l0.84 0.84c0.17 0.17 0.17 0.34 0.34 0.5s0.17 0.17 0.34 0.34c0.34 0 0.67 0.17 0.67 0.67l0.5 0.5c0.17 0.17 0.34 0.17 0.5 0.34 0.34 0 0.34 0.34 0.34 0.5s0.17 0.17 0.17 0.34c0.34 0.34 0.84 0.67 1.18 0.84 0.34 0.34 0.67 0.5 1.01 0.84l-0.17 0.17c0-0.34 0.34-0.17 0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m25.57 495.4c-0.34 0.34-0.67 0.34-1.01 0.17-0.5-0.17-1.01-0.5-1.68-0.67 0.34-1.18 0.34-2.36-0.17-3.53-0.34-0.67-1.01-1.18-1.68-1.85-0.17-0.17-0.34-0.5-0.5-0.84l-1.51-1.51c-0.34-0.5-0.67-0.84-1.01-1.35l-0.84-0.84h-0.34v0.84c0.17 0.17 0.5 0.34 0.67 0.67 0.17 0.34 0.34 0.5 0.67 0.84s0.5 0.67 0.84 1.18c0.17 0.17 0.5 0.34 0.67 0.67 0.17 0.17 0.34 0.17 0.5 0.34 0.17 0.34 0.34 0.5 0.5 0.84 0.17 0.17 0.5 0.34 0.67 0.34 0.5 0.17 0.67 0.34 0.5 0.67 0.17 0.34 0.17 0.5 0.34 0.84 0.34 0 0.5 0 0.5 0.34v1.51c0 0.17-0.17 0.17-0.34 0.34l-0.17 0.17v0.17c0.17 0.17 0.17 0.34 0.34 0.67v0.17c0.17 0.17 0.34 0.17 0.5 0.34 0.34 0.17 0.5 0.34 0.84 0.5h0.5c0.34 0.34 0.67 0.17 1.01 0.17 0.5 0 0.84-0.34 0.5-0.67-0.17-0.34-0.34-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m77.22 467.64c-0.34 0.34-0.84 0.67-1.18 1.01-0.17 0.17-0.17 0.5-0.17 0.67-0.17 1.01-0.34 2.02-0.5 3.03v3.36c0 0.17 0.17 0.34 0.17 0.34v1.18c0 0.17 0.17 0.17 0.34 0.34 0-0.17 0.17-0.5 0.17-0.67v-0.5c0-0.17-0.17-0.17-0.17-0.34v-3.7c0-0.17 0-0.34 0.34-0.34 0.17-0.17 0.17-0.34 0.34-0.67 0-0.17 0.17-0.17 0.17-0.34s0.17-0.34 0.17-0.5c0-0.34 0.17-0.67 0.67-0.67l0.17-0.17v-1.01h-0.5v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m0.84 492.21c0.17 0.5 0.34 0.84 0.5 1.35 0.34 0.67 0.84 1.51 1.18 2.19 0.17 0.34 0.34 0.5 0.5 0.84 0.67 0.17 1.35 0.5 2.19 0.5 0-0.5 0.34-0.17 0.5-0.34 0.17 0 0.34-0.17 0.34-0.17q-0.17-0.17-0.34-0.34h-0.34c-0.17 0.67-0.67 0.17-1.01 0.34 0 0 0-0.17-0.17-0.17l0.5-0.5q0.17-0.17 0.34-0.34h0.17q0.17-0.17 0.34-0.34-0.17-0.17-0.34-0.34h-0.5q-0.17 0.17-0.34 0.34c0 0.34-0.34 0.34-0.5 0.34l-0.17-0.17c-0.17-0.17-0.17-0.34-0.34-0.5q0-0.17-0.17-0.34c-0.17 0-0.17-0.34-0.17-0.67v-0.34h-0.34c-0.17-0.17-0.34-0.17-0.34-0.34v-0.67c-0.34 0-0.67-0.17-0.84-0.17 0 0 0-0.17-0.17-0.17h-0.5q0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m8.58 507.52c0 0.17 0.17 0.34 0.17 0.5 0.17 0.67 0.5 1.35 0.67 2.02 0.17 0.34 0 0.67 0.17 1.01 0.17 0.84 0.34 1.68 0.5 2.52 0 0.34 0.17 0.67 0.34 1.01h0.67v-1.18c0-0.17 0.17-0.17 0.34-0.34 0 0 0.17 0 0.17-0.17l0.17-0.17v-0.34q-1.35 0-1.35-1.01v-0.17c0.17 0 0.17-0.17 0.34-0.17 0-0.17 0.17-0.17 0.17-0.34-0.17-0.17-0.17-0.34-0.34-0.5-0.34-0.17-0.34-0.34-0.17-0.67 0-0.17 0.17-0.17 0.17-0.34v-0.67c-0.34 0.17-0.34 0.34-0.5 0.34h-0.34c-0.17-0.5-0.34-0.84-0.67-1.35q-0.17-0.17-0.34-0.34c0.17 0.34 0 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m47.11 468.49c-1.18 0-1.85 1.18-1.35 1.85 0.17 0.17 0 0.34 0 0.5v1.85c0 0.34 0.17 0.67 0.17 1.01h0.34c0.34-0.34 0.34-0.84 0.34-1.35 0-0.17 0-0.34 0.34-0.34v-0.5c0.34-0.17 0.84-0.17 1.18-0.34 0.17 0 0.5-0.17 0.67-0.17h0.34c0.17-0.17 0.34-0.17 0.5-0.34 0-0.34-0.17-0.5-0.17-0.84h-0.84c0 0.17-0.17 0.17-0.17 0.34 0 0.5-0.34 0.34-0.67 0.5-0.17 0.17-0.34 0.17-0.67 0.34 0 0-0.17 0.17-0.17 0.34-0.34-0.34-0.34-1.01 0-1.35 0-0.67 0-1.01 0.17-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m84.12 490.69c-0.17-0.5-0.34-1.01-0.5-1.68-0.17-0.34-0.17-0.5-0.34-0.84s-0.34-0.84-0.5-1.18c-0.17 0-0.34 0-0.67 0.17-0.17 0-0.34 0.17-0.67 0.17v1.18c0.17 0 0.17 0.17 0.34 0.17 0.34 0.17 0.67 0.5 0.5 0.84v2.02h1.01c0-0.17 0.17-0.17 0.17-0.34 0.34 0 0.5-0.34 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m8.58 507.52h0.34v-1.68c-0.67-0.17-0.17-0.5-0.34-0.84 0.34-0.17 0.5-0.17 0.67-0.34l-0.17-0.17c-0.17 0-0.5-0.17-0.67-0.17h-0.34c-0.17-0.17-0.34-0.17-0.34-0.34s0.17-0.17 0.34-0.34v-0.34h-0.34c-0.17 0-0.34-0.17-0.34-0.17 0-0.17 0-0.34 0.17-0.34h0.5c0.17 0 0.5 0.17 0.67 0.17q0.17-0.17 0.34-0.34c0-0.5-0.34-0.34-0.67-0.34h-0.17c-0.34 0-0.5 0-0.84 0.17-0.5 0-0.84 0-1.35 0.17 1.01 1.68 1.85 3.36 2.52 4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m25.57 477.74c0.17 0.34 0.34 0.67 0.5 0.84 0 0.17 0.17 0.34 0 0.5-0.34 1.01-0.34 2.02-0.34 3.03v0.84c0 0.34 0 0.67 0.17 1.01 0.17 0.17-0.17 0.5 0.34 0.67v-3.87c0-0.17 0-0.34 0.34-0.34 0.17-0.34 0.5-0.67 0.67-0.84 0-0.5-0.34-1.18 0.34-1.51v-0.34s-0.17 0-0.17-0.17h-0.17c-0.5-0.5-1.01-0.17-1.51-0.17 0-0.34-0.17 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m16.82 484.81c-0.17-0.17-0.17-0.34-0.34-0.67-0.34-0.67-0.84-1.18-1.51-1.68-0.34-0.34-0.67-0.84-0.84-1.18-0.17-0.17-0.5-0.34-0.67-0.67l-0.5 0.5s-0.17-0.17-0.34-0.17c-0.17 0.17-0.34 0.17-0.5 0.34 0 0.34-0.17 0.67-0.17 1.01q0.34-0.17 0.5-0.34h0.67c0.17 0 0.17 0.17 0.34 0.34s0.34 0.17 0.5 0.34c0.17 0 0.34 0.17 0.34 0.17 0.67 0 0.84 0.17 0.5 0.67 0.17 0.17 0.17 0.34 0.34 0.5 0.17 0.17 0.34 0.17 0.5 0.34 0.34 0.34 0.67 0.34 1.18 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m11.95 479.93c0-0.17-0.17-0.17-0.17-0.34-0.17 0-0.34 0-0.5-0.17h-1.85c-0.34 0.34-0.84 0.5-1.18 1.01s-0.5 1.18-0.17 1.68c0.17 0 0.67 0 0.67-0.17 0.34-0.34 0.34-0.17 0.67 0 0.5 0 0.84 0 1.35-0.17 0-0.17 0.17-0.34 0.17-0.67l-0.17-0.17c0-0.17-0.17-0.17-0.17-0.34h-0.17c-0.34 0-0.67-0.17-0.67-0.5s0.17-0.5 0.67-0.5c0.5 0.34 1.01 0.34 1.51 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m0.34 488.51c-0.5 0.34-0.34 0.67-0.17 1.01 0 0.34 0.17 0.67 0.17 1.01h1.18c0-0.17 0-0.34 0.17-0.67 0.17 0 0.5 0 0.5 0.17 0.34 0.5-0.5 0.5-0.67 0.84 0.34 0 0.67 0.17 0.84 0.17s0.34 0.17 0.5 0.17h0.17c0.17-0.17 0.34-0.17 0.34-0.34v-1.01l-0.17-0.17c-0.17 0-0.34-0.17-0.5-0.17-0.17-0.34-0.5-0.5-0.67-0.84h-0.17c-0.34 0.34-0.84 0.17-1.18 0.17v-0.34c0 0.17-0.17 0-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m37.35 483.29c-0.17-0.17-0.5-0.34-0.67-0.5-0.5-0.17-0.84-0.34-0.84-0.84-0.34-0.34-0.84-0.67-1.18-0.84q-0.17 0.17-0.34 0.34v0.67h0.67v0.67c0.34 0 0.84 0 0.67 0.5 0.5-0.17 0.5 0.17 0.5 0.67 0.17 0 0.67-0.17 0.67 0.34s-0.34 0.17-0.67 0.34c0 0 0 0.17-0.17 0.17v0.34h0.67v0.5h1.35c0.17 0 0.34 0 0.34-0.17v-0.17c-0.5-0.34-1.01-0.84-0.84-1.51q0-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m75.37 484.3v0.5s-0.17 0-0.17 0.17c-0.5-0.34-0.84-0.67-1.35-1.01-0.67 0.34-0.67 0.84-0.84 1.35 0 0.17 0.17 0.17 0.17 0.34 0.17 0 0.34 0.17 0.5 0.17 0.34 0.17 0.84 0.34 1.18 0.67h0.34c0.17-0.34-0.17-0.67 0.17-0.84-0.17-0.5 0.17-0.67 0.67-0.84v-0.34c-0.67-0.17-0.17-0.5-0.34-0.84 0.17 0 0.34 0 0.5 0.17l0.17-0.17v-0.5c-0.34-0.17-0.5-0.17-0.67-0.34h-0.34v1.51c0.17-0.34 0.17-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m25.74 473.87c-0.67 0.34-1.18 0.84-1.68 1.51-0.17 0.34 0.17 1.18 0.5 1.35 0.17 0 0.17 0.17 0.34 0.34 0.34-0.17 0.5-0.5 0.84-0.67v-0.17c0.17 0 0.34 0 0.5 0.17l0.17-0.17v-0.34c0.34-0.17 0.17-0.34 0.17-0.5-0.34-0.17-0.84-0.34-0.84-0.5 0-0.34 0.34-0.5 0.5-0.84-0.17 0-0.34 0-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m23.22 514.58c0.67 0 1.18-0.5 1.85-0.67 0.17 0 0.34-0.34 0.5-0.5 0-0.5 0.34-0.67 0.67-0.67 0.17 0 0.17-0.17 0.34-0.17 0.34 0 0.67 0 1.01-0.34v-0.17c-0.34 0-0.67 0-1.18-0.17-0.34 0.17-0.67 0.17-0.84 0.34-0.34 0.17-0.67 0.5-1.01 0.84q-0.17 0.17-0.34 0.34c-0.17 0.17-0.17 0.34-0.34 0.34h-0.84c-0.17 0.17 0 0.5 0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m9.59 482.11c-0.17-0.17-0.34-0.34-0.67 0-0.17 0.17-0.5 0-0.67 0.17 0 0.67-0.17 1.51 0.34 2.19 0.17 0.34 0.17 1.01 0.17 1.35 0 0.17 0.17 0.34 0.17 0.5 0.34-0.34 0.5-0.67 0.84-0.84 0.34-0.34 0.34-0.5 0-0.84-0.34-0.17-0.34-0.34-0.34-0.67 0-0.5 0-0.84 0.17-1.35-0.17-0.17-0.17-0.34 0-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m4.71 499.78c0.17 0.5 0.5 0.84 0.67 1.35q0-0.17 0.17-0.34h0.17c0.17 0.34 0.34 0.5 0.5 0.84 0 0 0.17-0.17 0.17-0.34 0.34-0.5 0.34-0.84 0.34-1.35v-1.35h-1.35c0.17 0.17 0.17 0.34 0.34 0.5-0.17 0-0.34 0.17-0.5 0.17l0.17 0.17c-0.17 0-0.34 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m25.24 489.85v1.68c0 0.34 0.17 0.67 0.5 1.01 0.5 0.34 0.84 0.84 1.35 1.35 0 0.17 0.17 0.34 0.17 0.67h0.34c0.17-0.34 0.17-0.67 0.34-0.84v-0.67h-0.84c-0.17 0-0.17-0.17-0.34-0.34-0.17-0.34-0.5-0.5-0.67-0.84-0.34-0.17-0.5-0.34-0.34-0.84 0-0.17 0.17-0.34 0.17-0.34l-0.5-0.5v-0.34c0 0.17-0.17 0.17-0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m13.96 517.95-0.34-0.34c-0.17 0.17-0.5 0.34-0.5 0.5 0 0.84-0.5 0.67-1.01 0.67h-0.17c0 0.84 0.5 1.35 1.01 1.85 0.34 0.17 0.67 0.5 1.01 0.67s0.5 0.17 0.67-0.17c-0.17-0.34-0.34-0.5-0.5-0.84-0.17 0-0.5-0.17-0.67-0.17s-0.17 0-0.34-0.17c-0.5 0-0.34-0.34-0.34-0.5s0-0.5 0.34-0.34c0 0 0.17 0 0.17-0.17q0.17-0.17 0.34-0.34c0-0.34 0.17-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m73.69 502.64c0.5 0 1.18 0.17 1.68 0.17s1.01 0 1.51-0.17c0.17 0 0.17-0.17 0.34-0.17v-0.17c0.34-0.17 0.34-0.5 0.17-0.5-0.17-0.17-0.67-0.17-0.84 0-0.34 0.34-0.5 0.17-0.84 0.17h-1.35l-0.17 0.17c-0.17 0-0.34 0.17-0.5 0.17v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m36.34 508.86c0.34-0.17 0.67-0.34 1.18-0.5 0-0.34-0.5-0.5-0.84-0.34-0.17 0.17-0.34 0.17-0.5 0.17 0-0.17 0-0.34-0.17-0.5h-1.68c-0.17 0.17-0.34 0.17-0.5 0.34 0 0.34 0.17 0.5 0.17 0.84h0.84c0.5-0.17 1.01-0.17 1.51 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m36.34 508.86c-0.5 0-1.01 0-1.51-0.17h-0.84c-0.34 0.17-0.67 0.17-0.84 0.34s-0.17 0.34-0.34 0.34h-1.01v0.67c0.34 0 0.84 0 1.18 0.17 0.34 0 0.84 0 1.01-0.5 0-0.17 0.34-0.17 0.5-0.17 0.5-0.34 1.18-0.5 1.85-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m27.42 512.06v0.5c0.17 0 0.5-0.17 0.67-0.17v-0.67c0.5 0 0.84 0.17 1.18 0.17 0.67-0.34 1.35-0.67 2.02-1.01v-0.34h-1.35l-0.5 0.5h-1.35c-0.34 0.17-0.5 0.34-0.84 0.34 0 0.17 0.17 0.34 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m25.74 473.87c0.17 0 0.34 0.17 0.34 0.17-0.17 0.34-0.5 0.67-0.5 0.84s0.5 0.34 0.84 0.5c0.17 0.17 0.17 0.34-0.17 0.5v0.34h0.67c0-0.34 0.34-0.34 0.5-0.34v-0.34h-0.5c-0.17-0.5 0-0.67 0.5-0.5h1.01v-0.34h-0.34c-0.34 0-0.5 0-0.84-0.17-0.17-0.17-0.5-0.34-0.67-0.34 0.17-0.34 0.17-0.5 0.34-0.67-0.5 0.17-0.84 0.17-1.18 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m53.33 503.65c0.34-0.17 0.84-0.17 1.18-0.34-0.34 0-0.67-0.17-1.01-0.17v-0.5h0.67q0-0.17 0.17-0.34v-1.85h-0.67v1.68h-0.5c0.17 0.5-0.34 0.5-0.67 0.5h-0.67v0.5c0.5 0.5 1.01 0.5 1.51 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m59.73 502.47c0.84 0 1.68-0.17 2.52-0.17-0.17-0.17-0.17-0.5-0.34-0.67h-2.19c-0.34 0.5-1.01 0.17-1.51 0.34-0.17 0-0.34 0.17-0.34 0.17v0.67c0.5-0.17 0.84-0.34 1.18-0.34h0.34c0.17-0.17 0.17 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m65.28 467.31c-0.5 1.18-0.34 2.36-0.17 3.53q0.17 0 0.34-0.17l0.5-1.01v-1.68s0-0.17-0.17-0.17l-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m23.22 514.58c-0.17-0.34-0.34-0.67-0.5-1.01h-0.67l-0.5 0.5c-0.16 0.16-0.34 0.17-0.5 0.17s-0.34 0-0.34 0.17 0 0.17 0.17 0.34 0.34 0.34 0.5 0.67h0.84c0.5-0.34 0.67-0.67 1.01-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m44.58 484.47c0 0.17-0.17 0.34-0.17 0.5 0.34 0.34 0.67 0.5 0.34 1.01-0.17 0.17-0.17 0.5 0.34 0.67 0.17 0.17 0.34 0.17 0.5 0.34-0.17-0.5 0.17-0.67 0.67-0.5 0 0 0-0.17 0.17-0.17-0.17-0.17-0.34-0.5-0.5-0.67-0.5-0.17-0.5-0.34-0.17-0.84-0.34 0-0.67-0.17-1.18-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m45.09 482.11c-0.34 0.5-0.34 1.01-0.34 1.51 0.17 0 0.67 0.17 0.67 0.17 0 0.5 0.34 0.34 0.67 0.34-0.17-0.5 0.17-0.67 0.67-0.67v-0.5h-0.67v-0.5c-0.34 0.17-0.84 0.34-1.01-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m5.22 488.51-1.51-1.51c-0.17-0.17-0.34-0.34-0.67-0.34v0.67c0 0.17-0.17 0.17-0.34 0.34l-0.17 0.17c-0.17 0.17-0.17 0.34-0.34 0.5 0.17 0 0.34 0 0.5 0.17 0.5-0.17 1.01-0.34 1.35 0 0.17-0.17 0.34-0.17 0.5 0.17 0.17-0.17 0.34 0.34 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m65.45 470.84q-0.17 0-0.34 0.17c0 0.17 0 0.34 0.17 0.67 0 0.17 0 0.5 0.17 0.67 0 0.34-0.17 0.34-0.34 0.34v0.34c0.17 0.34 0.34 0.84-0.17 1.18v0.17h0.5c0.34-0.5 0.5-0.17 0.67 0q0.17-0.17 0.34-0.34v-0.67c-0.5 0-0.67-0.17-0.67-0.67v-1.01c-0.17-0.34-0.34-0.67-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m6.39 501.29c0 0.17-0.17 0.17-0.17 0.34-0.17-0.34-0.34-0.67-0.5-0.84h-0.17q0 0.17-0.17 0.34c0.17 0.5 0.34 0.84 0.5 1.35 0.5 0 1.01-0.17 1.68-0.17v0.5c0.34 0 0.5 0 0.84-0.17-0.17-0.17-0.17-0.34-0.34-0.5s-0.34-0.34-0.34-0.5c-0.34-0.34-0.84-0.34-1.35-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m44.58 506c0.84-0.17 1.51-0.5 2.36-0.67 0.34-0.17 0.84-0.17 1.18-0.34v-0.34h-1.18c-0.17 0.17-0.17 0.34-0.34 0.34h-1.01c-0.17 0.17-0.17 0.34-0.34 0.34h-0.84c-0.17 0.17-0.17 0.34-0.34 0.5 0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m36 507.69c0 0.17 0 0.34 0.17 0.5 0.17 0 0.34-0.17 0.5-0.17 0.34-0.17 0.84 0 0.84 0.34 0.67 0.17 1.18-0.34 1.85-0.67v-0.67h-1.18v0.67h-2.02q-0.17-0.17-0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m85.3 493.55c-0.17-0.5-0.5-1.01-0.67-1.68-0.17 0.17-0.5 0.17-0.67 0.34h-0.34l-0.5 0.5c0.17 0.17 0.17 0.34 0.34 0.5h0.17c0.17 0 0.34-0.17 0.67-0.17v0.84c0.17-0.17 0.34-0.17 0.5-0.17 0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m5.22 488.51c-0.34 0.5-0.5 0-0.67-0.17-0.17-0.34-0.34-0.17-0.5-0.17 0 0.17 0.17 0.17 0.17 0.34 0.84 0 1.01 0.84 1.35 1.18 0 0.17 0.17 0.17 0.17 0.34 0.17 0 0.17 0.17 0.34 0.17s0.17 0 0.34 0.17 0.34 0.34 0.5 0.67c0-0.17 0.17-0.34 0.17-0.5-0.17-0.17-0.17-0.34-0.34-0.5l-1.51-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m2.69 491.2c-0.34 0-0.5-0.17-0.84-0.17 0.17-0.34 0.84-0.34 0.67-0.84 0-0.17-0.34 0-0.5-0.17 0 0.17 0 0.34-0.17 0.67h-1.18c0.17 0.5 0.34 1.18 0.5 1.68h0.17c0-0.67 0.34-1.01 0.84-0.84 0-0.17 0.17-0.34 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m5.22 497.09c-0.84 0-1.51-0.34-2.19-0.5 0.17 0.5 0.5 1.01 0.67 1.51 0 0.17 0.17 0.34 0.17 0.5s0.17 0.17 0.34 0.17c0.17-0.5 0.34-0.84 0.5-1.35 0.17 0.17 0.34 0.17 0.5 0.34v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m5.22 497.59c-0.17-0.17-0.34-0.17-0.5-0.34-0.17 0.5-0.34 0.84-0.5 1.35 0.17 0.34 0.34 0.67 0.5 1.01 0.17-0.17 0.34-0.34 0.67-0.5l-0.17-0.17c0.17 0 0.34-0.17 0.5-0.17-0.17-0.17-0.17-0.34-0.34-0.5v-0.67q0 0.17-0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m45.59 487.16c-0.17-0.17-0.34-0.17-0.5-0.34-0.17 0-0.5 0.17-0.67 0.17 0.34 0.34 0.67 0.67 1.01 1.18 0.17 0.17 0.17 0.34 0.34 0.5h0.67c0-0.17 0.17-0.34 0.17-0.5 0-0.34-0.17-0.67-0.17-0.84l-0.17-0.17h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m54.01 476.39c-0.17-0.34-0.5-0.67-0.67-0.84-0.34-0.34-0.5-0.84-0.84-1.18 0 0 0 0.17-0.17 0.17v1.35c0 0.17 0.17 0.17 0.17 0.34s0.17 0.34 0.17 0.5c0.67 0 1.01 0.17 1.35-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m49.46 470.5c-0.17 0.17-0.34 0.17-0.5 0.34 0 0.34 0.17 0.5 0.17 0.84v1.18c-0.17 0.5 0.17 0.67 0.67 0.67v-0.67c-0.34 0-0.34-0.17-0.34-0.34s-0.34-0.67 0.34-0.67c0-0.17-0.17-0.5 0.34-0.67 0-0.17 0.17-0.34 0.17-0.34-0.17-0.17-0.17-0.34-0.34-0.34 0-0.17-0.17-0.17-0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m59.22 484.3c0.17-0.84-0.34-1.68-0.67-2.36-0.17-0.34-0.5-0.67-0.67-1.18h-0.17v0.34c0.17 0.5 0.34 1.01 0.5 1.35l0.17 0.17q0.34 0 0.34 0.34v1.35h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m73.69 483.29c0-0.17-0.17-0.17-0.17-0.34h-0.67c-0.17 0-0.34-0.17-0.67-0.17h-0.17c-0.17 0-0.17 0.17-0.34 0l-0.5-0.5h-0.17s0 0.17-0.17 0.17v1.01c0.17 0 0.67-0.17 0.67 0.34 0.17-0.17 0.5-0.17 0.67-0.34h0.67c0.5 0.17 0.67 0 0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m38.53 485.14v0.17l0.17 0.17c0.5 0 0.67 0.17 0.67 0.67v0.34c0.34 0 0.34 0.17 0.34 0.34v2.19c0.34 0 0.34-0.17 0.34-0.34v-1.68c0.34 0.17 0.34 0.34 0.5 0.5 0-0.5-0.17-0.84-0.5-1.18-0.34-0.34-0.5-0.67-0.84-1.01s-0.5-0.34-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m56.19 479.08c-0.17-0.17-0.17-0.5-0.34-0.67-0.34-0.34-0.67-0.84-1.01-1.18 0 0-0.17 0-0.34-0.17l-0.17 0.17v0.5h0.67v1.01c0.5 0 0.34 0.34 0.34 0.67h0.34v-0.67c0.17 0.34 0.34 0.34 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m51.65 473.2c-0.17-0.34-0.5-0.84-0.67-1.18-0.17-0.17-0.5-0.17-0.67-0.34h-0.34v1.01h0.67v0.5h0.34c0.17 0 0.34 0.17 0.5 0.17 0 0.17 0 0 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m63.26 483.12v0.17c0.17 0 0.34 0.17 0.5 0.17l0.5 0.5c0.17-0.17 0.34-0.17 0.5-0.34v-0.17c0-0.17 0-0.34-0.17-0.67-0.5-0.34-0.5-0.84 0.17-1.35-0.17 0-0.17-0.17-0.34-0.17s-0.34 0.17-0.67 0.17v0.84c0.17 0.17 0.17 0.34 0.34 0.5-0.34 0.34-0.5 0.34-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m26.08 484.47c-0.5 0-0.17-0.34-0.34-0.67h-0.34c0 1.18-0.17 2.19-0.17 3.36 0 0.17 0 0.34 0.17 0.67 0 0.17 0.17 0.34 0.17 0.5l0.17-0.17v-3.2c0-0.17 0.17-0.17 0.34-0.34v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m25.57 495.4c0.17 0.17 0.34 0.17 0.34 0.34 0.17 0.5 0 0.67-0.5 0.67-0.34 0-0.84 0.17-1.01-0.17h-0.5v0.17q0.17 0.17 0.34 0.34h2.19v-0.84c0-0.17 0.17-0.17 0.34-0.34 0 0 0.17 0 0.17-0.17 0.17-0.17 0.17-0.34 0.34-0.34 0-0.17-0.17-0.34-0.17-0.5q-0.17 0-0.34 0.17c-0.67 0.34-1.01 0.5-1.18 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m40.55 486.99q-0.17-0.17-0.5-0.5v1.68c0 0.17 0 0.34-0.34 0.34v0.34c0.17 0.17 0.17 0.5 0.34 0.67h0.5l0.17-0.17c-0.34-0.5 0-1.01 0-1.35-0.17-0.17-0.17-0.5-0.17-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m79.41 503.65c0.17 0 0.34 0.17 0.5 0.17q0.17-0.17 0.34-0.34h0.67c0.34-0.17 0.67-0.17 1.01-0.34v-0.34h-0.67c-0.17 0-0.17 0.17-0.34 0.17-0.34 0.17-0.84 0.17-1.01-0.17-0.5 0-0.67-0.17-0.5-0.5h-0.67v0.84c0.34 0.17 0.84 0 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m60.23 486.82c-0.34-0.34-0.84-0.5-1.18-0.84h-1.01v1.01l0.17 0.17h0.5v-0.5h0.5c0 0.17 0.17 0.34 0.17 0.5h0.84v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m71.84 476.56c-0.34-0.67-0.5-1.35-0.84-2.02 0 0-0.17 0-0.17 0.17v1.51l0.17 0.17c0 0.34 0 0.67-0.17 0.84h0.5v-0.84c0 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m69.82 472.19c0-0.17-0.17-0.34-0.17-0.67-0.5 0-0.17-0.34-0.34-0.67-0.17-0.17-0.34-0.17-0.34-0.34v-1.35c0-0.17 0.17-0.17 0.34-0.34v-0.34h-0.5v3.53l0.17 0.17h0.5c0 0.17 0.17 0.17 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m17.67 518.62c0.34-0.17 0.5-0.34 0.84-0.5 0 0 0.17-0.17 0.17-0.34h-0.5v-0.5l-0.17-0.17-0.17 0.17c0 0.5-0.5 0.5-1.01 0.5l-0.17 0.17c0 0.17-0.17 0.17-0.17 0.34s0.17 0.34 0.17 0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m51.82 503.65v-0.5h-0.5c0.17 0.5-0.17 0.67-0.67 0.5h-0.67v0.5c0.34 0 0.67 0.17 0.84 0.17 0.34 0 0.67-0.17 1.01-0.17v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m49.3 468.15h-0.17c-0.17 0-0.34 0-0.5 0.17-0.17 0-0.5 0.17-0.67 0.17v0.34h-0.67v0.5h1.18c0.17-0.17 0.17-0.67 0.67-0.5 0.17-0.34 0.17-0.5 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m11.1 514.25v0.5h-0.67c0 0.17 0.17 0.34 0.17 0.34 0.17 0 0.5 0 0.67-0.17 0 0.34 0.17 0.67 0.17 0.84h0.17c0.17-0.17 0.34-0.5 0.34-0.67-0.17-0.5 0.67-0.84 0.34-1.51 0 0-0.17 0-0.17 0.17 0 0.34-0.34 0.34-0.5 0.34-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m59.73 502.47c-0.17 0-0.17-0.17-0.34-0.17s-0.17-0.17-0.34 0c-0.34 0.17-0.67 0.17-1.18 0.34v-0.67h-0.17c-0.34 0.17-0.67 0.17-1.01 0.34q-0.17 0.17-0.34 0.34v0.5c0.84-0.17 1.68-0.34 2.69-0.5 0.17 0 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m66.63 466.13c-0.17 0-0.17 0.17-0.34 0.17 0 0.5 0.17 0.84 0.17 1.35 0.34 0.17 1.01-0.17 1.18-0.34-0.17-0.17-0.17-0.34-0.34-0.67-0.17 0-0.67 0-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m86.98 504.15h-0.34c-0.34 0.17-0.5 0.34-0.84 0.5 0 0.17-0.17 0.5-0.17 0.67 0.34 0.17 0.5 0.34 0.84 0.5 0 0 0.34-0.17 0.34-0.34 0-0.34 0-0.84 0.17-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m46.27 484.3c-0.34 0-0.67 0.17-0.67-0.34 0 0-0.5-0.17-0.67-0.17 0 0.34-0.17 0.67-0.17 0.84 0.34 0.17 0.84 0.17 1.18 0.34h0.5c-0.17-0.34-0.17-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m67.13 502.13h1.35c0.17-0.34 0.34-0.67 0.84-0.67 0-0.34-0.34-0.34-0.5-0.34s-0.5 0.17-0.67 0.17h-1.18v0.34q0 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m26.08 476.39c-0.17 0-0.34 0-0.5-0.17v0.17c-0.34 0.17-0.5 0.5-0.84 0.67 0.17 0.17 0.34 0.5 0.67 0.67 0-0.17 0.17-0.67 0.17-0.67 0.5 0 1.01-0.34 1.51 0.17h0.17v-0.5s-0.17 0-0.17-0.17h-0.67c-0.17 0.17-0.34 0-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m54.34 477.4c0-0.34-0.17-0.67-0.34-0.84-0.34 0.34-0.67 0.34-1.18 0.34q-0.17 0.17-0.34 0.34v0.34c0.67-0.17 1.18-0.17 1.85-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m83.11 504.66c0.17-0.17 0.34-0.17 0.67-0.34v-0.67h-1.01c0.17 0.5-0.17 0.67-0.67 0.67v0.34c0.34-0.17 0.67 0 1.01 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m11.95 479.93h-1.51c-0.34 0-0.67 0.17-0.67 0.5s0.34 0.5 0.67 0.5h0.17q0-0.84 0.84-0.84c0.17 0 0.34 0 0.5-0.17 0.17 0.17 0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m15.14 520.47c0.34-0.17 1.01-0.17 1.01-0.84h-0.67v-0.5q-0.17 0.17-0.34 0.34t-0.34 0.34v0.67c0.17-0.17 0.34-0.17 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m28.1 474.71h0.34c0.17-0.5 0.34-0.67 1.01-0.67l0.17-0.17c-0.17-0.17-0.5-0.17-0.67-0.34-0.34 0.17-0.84 0.17-1.18 0.34-0.17 0-0.17 0.17-0.34 0.17 0.17 0.17 0.17 0.34 0.34 0.34 0.34-0.17 0.34 0 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m18.68 517.95c0.5 0 0.67-0.17 0.84-0.5 0 0-0.17 0-0.17-0.17-0.34-0.17-0.5-0.5-0.34-0.67 0.17-0.17 0.17-0.5 0.34-0.67v-0.34c-0.34 0-0.5 0-0.84 0.17 0.17 0.17 0.67 0.5 0.17 0.84v0.84 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m12.11 480.09c-0.17 0-0.34 0.17-0.5 0.17q-0.84 0-0.84 0.84c0 0.17 0.17 0.17 0.17 0.34 0.17-0.67 0.67-0.67 1.18-0.5h0.34v-0.34c0-0.34-0.17-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m44.92 489.85q-0.17 0.17-0.34 0.34h-0.5c-0.5 0.17-1.01 0.17-1.51 0.34-0.17 0-0.17 0.17-0.34 0.34 0.17 0 0.17 0.17 0.34 0.17s0.34 0 0.5-0.17c0.17 0 0.34-0.17 0.5-0.17h1.68c-0.5-0.17-0.34-0.5-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m70.83 474.21c-0.17-0.34-0.5-0.84-0.67-1.18l-0.5 0.5c0 0.34-0.17 0.5-0.17 0.84 0.34-0.17 0.84-0.17 1.35-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m63.76 477.4c-0.34 0.34-0.34 0.84-0.5 1.18 0 0.5-0.17 1.18-0.34 1.68h0.34c0-0.5 0.17-0.84 0.17-1.35 0.34-0.5 0.34-1.01 0.34-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m57.71 480.77c-0.5-0.5-1.01-1.18-1.51-1.68-0.34 0.17-0.5 0.34 0 0.67 0.34 0.17 0.84 0.5 0.67 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m75.71 482.62h1.35q0.17-0.17 0.34-0.34h0.5v-0.34h-1.18c0 0.5-0.34 0.34-0.67 0.17v-1.18c-0.17 0.17-0.17 0.34-0.34 0.67v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m39.37 507.01v0.67c0.34-0.17 0.67-0.17 1.01-0.34s0.67-0.34 1.01-0.34v-0.5h-0.67v0.5h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m3.03 486.49v-0.17c-0.5-0.17-1.01-0.5-1.51-0.34-0.17 0-0.34 0.34-0.5 0.5q0.17 0 0.34 0.17h0.67c0.17 0 0.34 0.17 0.67 0.17h0.34q-0.17-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m64.27 484.13-0.5-0.5c-0.16-0.16-0.34-0.17-0.5-0.17-0.17 0.5 0.34 1.01 0.5 1.35 0 0 0 0.17 0.17 0.34h0.34v-0.34c0.17-0.34 0.17-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m69.32 501.63c-0.5 0-0.67 0.17-0.84 0.67 0.17 0 0.34 0 0.5 0.17 0-0.67 0.5-0.34 0.84-0.34s0.5 0 0.5 0.34h0.84c0-0.17 0-0.34-0.17-0.34-0.5-0.17-0.84-0.34-1.35-0.34 0-0.17-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m82.1 504.49v-0.34h-0.34v-0.17c0.17-0.17 0.5-0.17 0.67-0.34l-0.5-0.5c-0.34 0.17-0.67 0.17-1.01 0.34 0 0.17 0 0.34-0.17 0.34v0.17c0.5 0.34 1.01 0.34 1.35 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m73.02 480.6c-0.17-0.5-0.17-1.01-0.34-1.35 0-0.17-0.34-0.17-0.34-0.34h-0.17v1.51c0.5 0 0.34 0.34 0.34 0.5 0.17-0.17 0.34-0.34 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m68.98 466.3c0-0.34-0.34-0.34-0.67-0.5v0.17c-0.17 0.17-0.17 0.5-0.34 0.67v0.34c0 0.17 0.17 0.5 0.17 0.67h0.67v-0.34h-0.67c0.5-0.34 0.67-0.67 0.84-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m20.19 516.94c0.67-0.34 1.18-0.84 1.85-1.18-0.34 0-0.84 0-1.18-0.17 0 0.34-0.17 0.5-0.5 0.67-0.17 0.17-0.17 0.34-0.34 0.5l0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m25.74 488.34c0-0.17-0.17-0.34-0.17-0.5s-0.17-0.34-0.17-0.67c-0.34 0.34-0.17 0.84-0.17 1.35 0.17 0.17 0.34 0.17 0.34 0.34v1.35h0.34v-0.34c-0.17-0.5-0.17-1.01-0.17-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m45.09 481.78v0.17h1.01v-1.18h-0.67c-0.17 0.17 0.17 0.5-0.34 0.67 0.17 0 0.17 0.17 0 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m59.22 484.3h-0.5c-0.17 0.17-0.17 0.5-0.34 0.67v0.17c0.17 0.34 0.5 0.5 0.67 0.84 0-0.17 0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m38.53 485.14c0.17 0 0.34-0.17 0.5-0.17-0.5-0.17-0.67-0.67-1.01-1.01-0.17-0.17-0.34-0.17-0.5-0.34 0 0.5 0.5 1.01 1.01 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m47.45 469.33v-0.5h0.67v-0.34h-0.67q-0.17 0-0.34 0.17c-0.17 0.5-0.17 0.84-0.34 1.35l0.17 0.17h0.17c0-0.34-0.17-0.84 0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m40.38 489.68h-0.5v0.84h0.5v0.5h0.67c0.17 0 0.17-0.17 0.34-0.17v-0.17c-0.17-0.17-0.17-0.34-0.34-0.34-0.34 0-0.5-0.17-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m50.81 504.32c-0.34 0-0.5-0.17-0.84-0.17v-0.5h-0.67v1.01c0.5-0.17 1.01-0.17 1.51-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m15.14 520.47c-0.17-0.17-0.34-0.17-0.34-0.34v-0.67h-0.34l-0.67 0.67c0.17 0.34 0.34 0.5 0.5 0.84 0.34-0.17 0.67-0.34 0.84-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m63.09 486.99c-0.5 0-0.84-0.17-1.35-0.17-0.17 0-0.34 0.17-0.5 0.17s-0.5 0-0.67 0.17l0.17 0.17h2.52q-0.17-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m72.18 477.4c-0.17-0.17-0.17-0.34-0.34-0.34-0.34 0.17 0 0.67-0.5 0.67v0.84h-0.5c0.17 0 0.5 0.17 0.67 0.17s0.17-0.17 0.34-0.17c0-0.34 0.17-0.67 0.34-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m44.25 486.99c0.17 0 0.5-0.17 0.67-0.17-0.34-0.17-0.5-0.5-0.34-0.67 0.34-0.5 0-0.84-0.34-1.01 0 0.17-0.17 0.34-0.17 0.5v1.35c0.17-0.17 0.17 0 0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m69.32 469.16c-0.17 0.17-0.34 0.17-0.34 0.34v1.35c0 0.17 0.17 0.17 0.34 0.34 0-0.34 0.17-0.5 0.17-0.84s0-0.67 0.17-0.84c0-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m49.46 470.5c0.17 0 0.5-0.17 0.67-0.17 0.5-0.34 0.5-0.5 0.17-0.84h-0.34c0 0.5-0.5 0.17-0.67 0.34 0 0.17 0.17 0.34 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m54.17 502.81h-0.67v0.5c0.34 0 0.67 0.17 1.01 0.17s0.84 0.17 1.01-0.34c0 0-0.17 0-0.17-0.17-0.34 0-0.67-0.17-1.18-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m67.13 502.13-0.17-0.17h-2.69v0.34c0.84 0 1.85 0 2.86-0.17q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m68.98 466.3c-0.17 0.34-0.5 0.67-0.67 1.01h0.67c0.17 0 0.34 0 0.5-0.17 0-0.17-0.17-0.5-0.5-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m73.69 502.64v-0.5h-1.51c-0.17 0-0.17 0.17-0.34 0.34 0.67 0 1.35 0.17 1.85 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m75.88 478.92c0 0.17-0.17 0.34-0.17 0.34v1.01c0 0.34 0 0.5 0.34 0.67h0.17c0-0.17 0.17-0.17 0.17-0.34v-0.5c-0.17-0.17-0.34-0.17-0.34-0.34-0.17-0.17-0.17-0.5-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m73.69 483.29c-0.17 0.17-0.34 0.17-0.5 0.34-0.34 0.34-0.34 0.67-0.34 1.18v0.34s0.17 0 0.17 0.17h0.17c0-0.5 0.17-1.18 0.84-1.35-0.17-0.34-0.17-0.5-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m64.1 502.13v-0.84h-0.17c-0.34 0-0.67 0.17-1.01 0.17v0.67h1.18q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m83.79 492.21c0.17-0.17 0.5-0.17 0.67-0.34-0.17-0.34-0.34-0.84-0.34-1.18l-0.5 0.5c0 0.17-0.17 0.17-0.17 0.34 0.5 0.17 0.34 0.5 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m7.57 502.64v-0.5c-0.5 0-1.18 0.17-1.68 0.17 0.17 0.17 0.17 0.34 0.34 0.5 0.5 0 1.01 0 1.35-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m69.65 467.31c-0.17 0-0.34 0-0.5 0.17v0.34c0.17 0.17 0.34 0.17 0.34 0.34v1.18q0.17 0.17 0.34 0.34c-0.17-1.01-0.17-1.68-0.17-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m63.43 480.26h-0.34v0.17c0 0.17 0.17 0.34 0.17 0.5v1.51h0.34c-0.17-0.67-0.17-1.51-0.17-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m77.9 467.48h-0.34c0 0.5 0.17 0.84 0.17 1.35h0.67c0.17 0 0.17-0.17 0.34-0.17-0.5 0.17-0.67-0.17-0.67-0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m67.97 466.97v-0.34c-0.17-0.17-0.5-0.34-0.67-0.67-0.17 0-0.34 0-0.5-0.17q-0.17 0-0.34 0.17c0 0.5 0.5 0.5 0.67 0.5 0.17 0.17 0.34 0.34 0.34 0.67 0.34 0 0.5 0 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m52.49 474.54v0c0-0.34-0.17-0.5-0.34-0.67-0.34 0-0.67 0-1.01 0.17 0 0.17 0.17 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m78.74 503.31v-0.84c-0.17 0-0.34 0.17-0.34 0.17-0.17 0-0.34 0-0.67-0.17h-0.17c0 0.17 0.17 0.5 0.17 0.67q0.17 0 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m45.76 475.05v1.51l0.34 0.34 0.17-0.17v-1.68h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m29.61 473.7-0.17 0.17c0 0.17 0 0.5-0.17 0.67 0.17 0 0.17 0.17 0.34 0.17h0.34l0.17-0.17v-0.67c-0.17 0.17-0.34 0-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m64.1 476.73c-0.17 0.17-0.17 0.34-0.34 0.67 0.17 0.34 0.17 0.5 0.34 0.84 0 0.17 0 0.5 0.34 0.34v-1.18c0-0.17-0.17-0.5-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m63.09 482.62v-1.51c0-0.17 0-0.34-0.17-0.5 0 0.17-0.17 0.34-0.17 0.67v0.84c0.17 0.34 0.17 0.67 0.34 0.84v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m27.42 474.04c0.17 0 0.17-0.17 0.34-0.17v-0.34c-0.34 0-0.5 0-0.84 0.17 0 0.17-0.17 0.5-0.34 0.67 0.17 0 0.34 0.17 0.67 0.34 0-0.34-0.34-0.67 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m71.84 502.47q0.17-0.17 0.34-0.34h0.67v-0.34h-1.01c-0.17 0-0.67 0.17-0.67-0.34h-0.17v0.34c0 0.17 0 0.34 0.17 0.34 0.17 0.17 0.5 0.34 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m81.6 487.33c0.17 0 0.34-0.17 0.67-0.17 0.17 0 0.34 0 0.67-0.17 0-0.17-0.17-0.5-0.17-0.67-0.34 0.17-0.67 0.34-1.01 0.5-0.17 0.17-0.17 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m75.88 477.74c-0.17-0.17-0.34-0.17-0.34-0.34v-1.18c0-0.17-0.17-0.34-0.17-0.34 0 0.84 0 1.68 0.17 2.52 0.17 0 0.5 0 0.5-0.34-0.17-0.17-0.17-0.34-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m71.17 477.74c0.5 0 0.34-0.5 0.5-0.67v-0.5h-0.5v0.84h-0.5c0 0.17 0.17 0.34 0.17 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m45.59 479.08c0 0.17 0.17 0.34 0.17 0.5s-0.17 0.5-0.17 0.67h0.67v-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m46.1 488.67h-0.67c-0.17 0.34-0.17 0.5-0.34 0.84 0 0 0.17 0 0.17 0.17h0.67c0-0.34 0.17-0.67 0.17-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m64.1 476.73h1.51c0.17-0.5-0.34-0.5-0.67-0.5h-0.5q-0.17 0.17-0.34 0.34v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m44.58 506c-0.17 0-0.34 0-0.5-0.17h-1.01v0.5c0.67 0.17 1.01 0 1.51-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m16.15 519.63c0.17-0.17 0.5-0.34 0.67-0.5 0-0.17-0.17-0.34-0.17-0.34h-1.18v0.34h0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m64.77 474.21c-0.17 0.34-0.34 0.67-0.34 0.84s0 0.34 0.17 0.5h0.5v-1.18c-0.17 0.17-0.34 0-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m69.65 473.53 0.5-0.5c0-0.34-0.17-0.5-0.17-0.84-0.17 0-0.34 0.17-0.5 0.17v1.01l0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m63.76 485.98c-0.17 0.17-0.17 0.5-0.34 0.67q0.17 0.17 0.34 0.34h0.67c0-0.34-0.17-0.5-0.17-0.84-0.17 0-0.34 0-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m45.59 479.08h0.67v-1.18h-0.34l-0.34 0.34v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m41.22 506.51v0.5c0.67-0.17 1.18-0.34 1.85-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m51.82 503.65v0.5c0.5-0.17 1.01-0.34 1.51-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m78.74 468.65c-0.17 0-0.17 0.17-0.34 0.17v0.67h0.34c0.17-0.17 0.34-0.17 0.67-0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m7.07 490.69c0 0.17-0.17 0.34-0.17 0.5v0.84s0.17 0 0.17 0.17c0-0.17 0.17-0.34 0.17-0.5s0.17-0.17 0.17-0.34c0.17-0.34 0.17-0.67-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m46.27 481.95h-1.01v0.17c0.17 0.5 0.67 0.34 1.01 0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m51.15 474.04c0.34 0 0.67 0 1.01-0.17-0.17-0.17-0.34-0.5-0.5-0.67 0 0.17-0.17 0.34-0.17 0.5-0.17 0-0.34-0.17-0.5-0.17 0 0 0 0.17 0.17 0.5q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m0.34 488.51c0.17 0.17 0.34 0.17 0.5 0.34v-1.35h-0.5c0.17 0.17 0 0.5 0 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m75.88 478.92c0 0.34 0 0.67 0.17 1.01 0 0.17 0.17 0.17 0.34 0.34v-1.85q-0.34 0.17-0.5 0.5 0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m79.41 469.16c-0.17 0.17-0.34 0.17-0.67 0.34 0 0.17 0.17 0.5 0.17 0.67 0.17-0.17 0.34-0.17 0.5-0.34 0.34-0.34 0.17-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m70.83 474.21h-1.51v0.34l0.17 0.17h1.18s0.17 0 0.17-0.17v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m72.18 477.4c-0.17 0.34-0.17 0.67-0.34 1.01 0.17 0 0.34 0.17 0.34 0.17h0.17c0.34-0.34-0.17-0.67-0.17-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m65.28 467.31c0.17 0.17 0.34 0.34 0.5 0.34l0.17-0.17c0-0.34-0.17-0.67-0.17-1.01-0.17 0-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m73.69 482.62c-0.17-0.34-0.34-0.84-0.34-1.18h-0.17v0.17c0 0.34-0.17 0.67-0.17 0.84 0.17 0.17 0.34 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m45.76 475.05h0.5s0.17 0 0.17-0.17v-0.34c-0.5-0.17-0.17-0.67-0.17-1.01h-0.34v0.34c0 0.5-0.17 0.84-0.17 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m63.76 485.98c0.17 0 0.34 0.17 0.34 0.17 0-0.34 0.17-0.67 0.17-0.84v-0.34h-0.34c0 0.34 0 0.67-0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m75.71 482.62v-0.84c0 0.84-0.17 1.68-0.17 2.52 0-0.17 0.17-0.34 0.17-0.34v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m48.12 504.66v0.34c0.34 0 0.5-0.17 0.84-0.17 0-0.17-0.17-0.34-0.17-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m49.3 468.15v1.01c0.34 0 0.5-0.17 0.84-0.17-0.34-0.34-0.5-0.67-0.84-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m55.35 502.98s0.17 0 0.17 0.17h0.84v-0.5c-0.34 0-0.5 0-0.84-0.17 0 0.17 0 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m78.74 468.65h0.67c0-0.34 0-0.67-0.17-0.84h-0.5v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m26.25 512.73c-0.34 0.17-0.67 0.34-0.67 0.67 0.5 0 1.01-0.17 1.18-0.67h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m45.59 478.24 0.34-0.34c0-0.34 0.17-0.67 0.17-1.01v-0.17l-0.34-0.34c0 0.17-0.17 0.17-0.17 0.34v1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m50.31 471.68c0.17 0.17 0.5 0.17 0.67 0.34-0.17-0.5-0.34-0.84-0.5-1.35 0 0.17-0.17 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m29.27 511.72c-0.34 0-0.67-0.17-1.18-0.17v0.67c0.34-0.17 0.67-0.34 1.18-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m32.98 510.04c-0.34 0-0.84 0-1.18-0.17v0.67c0.34-0.17 0.84-0.34 1.18-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m70.33 502.3c0-0.34-0.17-0.5-0.5-0.34-0.34 0-0.84-0.34-0.84 0.34h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m9.59 479.59h1.85c-0.5-0.34-1.51-0.34-1.85 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m77.73 503.14c0-0.17-0.17-0.5-0.17-0.67h-0.34c-0.17 0-0.17 0.17-0.34 0.17v0.34c0.34 0.17 0.67 0.5 0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m63.76 486.99q-0.17-0.17-0.34-0.34-0.17 0.17-0.34 0.34v0.67h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m73.69 482.62h-0.84c-0.17 0-0.17 0.17-0.34 0.17l-0.17 0.17c0.17 0 0.34 0.17 0.67 0.17h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m59.05 485.81c-0.17-0.34-0.5-0.5-0.67-0.84q-0.17 0.17-0.34 0.34v0.5c0.34 0.17 0.67 0.17 1.01 0v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m41.56 490.69q0 0.17 0 0v0.5h1.01v-0.34c-0.17 0-0.17-0.17-0.34-0.17-0.34 0.17-0.5 0.17-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m12.62 480.43v0.34c0 0.17 0 0.34-0.17 0.34 0.17 0 0.34 0.17 0.34 0.17l0.5-0.5c-0.17-0.17-0.5-0.34-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m20.86 515.59c0.34 0 0.84 0 1.18 0.17 0.17-0.17 0.17-0.34 0.34-0.34h-0.84c-0.34 0-0.67-0.34-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m62.76 502.3v-0.67h-0.84c0.17 0.17 0.17 0.5 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m16.82 484.81c-0.34 0-0.84-0.17-1.18-0.17q0 0.17 0.17 0.34c0.17 0.17 0.34 0.17 0.5 0.34 0.17 0 0.5 0 0.67-0.17h0.34c-0.17-0.34-0.34-0.5-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m63.09 482.62q0 0.17-0.17 0.34 0.17 0.17 0.34 0.34c0.34 0 0.5-0.17 0.84-0.17-0.17-0.17-0.34-0.34-0.34-0.5h-0.34q-0.17 0-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m65.78 466.63c0 0.34 0.17 0.67 0.17 1.01 0.17 0 0.34 0 0.5-0.17 0-0.5-0.17-0.84-0.17-1.35-0.17 0.34-0.34 0.34-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m64.44 475.72c0-0.17 0-0.34-0.17-0.5-0.34 0.5-0.5 0.84-0.17 1.35q0.17-0.17 0.34-0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m77.9 468.82c0-0.5-0.17-0.84-0.17-1.35h-0.34v1.18c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m31.8 510.55v-0.67h-0.5v0.84c0.17 0 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m69.65 470.34c0 0.34-0.17 0.5-0.17 0.84 0.17 0.17-0.17 0.5 0.34 0.67-0.17-0.67-0.17-1.18-0.17-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m25.57 490.02v-1.01c0-0.17-0.17-0.17-0.34-0.34v1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m76.89 503.14v-0.34c-0.5 0-1.01 0-1.51 0.17 0 0 0 0.17 0.17 0.17 0.5-0.17 1.01-0.17 1.35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m60.57 487.16c0.17 0 0.5 0 0.67-0.17 0.17 0 0.34-0.17 0.5-0.17-0.5 0-1.01 0-1.51-0.17v0.34c0.17 0 0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m20.19 516.94-0.17-0.17c-0.5-0.17-0.67 0.17-0.67 0.67 0 0 0.17 0 0.17 0.17 0.17-0.34 0.5-0.5 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m27.76 473.36v0.34c0.34-0.17 0.84-0.17 1.18-0.34-0.5 0.17-0.84-0.34-1.18 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m66.96 465.96c0.17 0 0.34 0 0.5 0.17 0.34 0 0.67 0 1.01-0.17v-0.17c-0.67-0.17-1.18-0.34-1.51 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m47.28 468.32h0.67c0.17 0 0.5-0.17 0.67-0.17-0.17 0-0.34-0.17-0.5-0.17-0.34 0-0.84-0.17-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m85.3 493.55c-0.17 0-0.34 0-0.5 0.17v0.84q0.17-0.17 0.34-0.34t0.34-0.34q-0.17-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m0.5 487.33h0.5v-0.34c0-0.17 0-0.34 0.17-0.5q-0.17 0-0.34-0.17c-0.17 0.5-0.34 0.67-0.34 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m45.59 480.26c0-0.17 0.17-0.5 0.17-0.67s0-0.34-0.17-0.5c-0.5 0.34-0.34 0.67-0.34 1.18h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m78.74 467.64h0.5v-0.34h-1.35l-0.17 0.17c0.17 0 0.17 0.17 0.34 0.17h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m64.77 474.21c0.34-0.34 0.17-0.84 0.17-1.18-0.5 0.34-0.5 0.67-0.17 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m44.25 486.82v-1.35c-0.34 0.34-0.34 1.01 0 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m64.94 472.52c0.34 0 0.5 0 0.34-0.34 0-0.17 0-0.5-0.17-0.67 0 0.34-0.17 0.67-0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m40.38 489.68c0 0.34 0.17 0.67 0.67 0.67 0.17-0.5-0.17-0.5-0.67-0.67q0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m45.26 489.68v0c-0.17 0-0.34 0.17-0.34 0.34 0 0.34-0.17 0.67 0.17 0.84 0.17-0.5 0.17-0.84 0.17-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m73.19 481.44v-0.84c-0.17 0-0.34 0.17-0.5 0.17l-0.17 0.17c0.17 0.17 0.34 0.34 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m26.75 494.73c0 0.17 0.17 0.34 0.17 0.5 0 0 0.17 0 0.17-0.17s0.17-0.34 0.17-0.5-0.17-0.34-0.17-0.67c0.17 0.34 0 0.67-0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m78.07 467.31h1.35l-0.34-0.34c-0.5 0.17-0.84-0.17-1.01 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m78.74 503.31h-0.67c0.34 0.5 0.84 0.17 1.35 0.34 0.17-0.5-0.34-0.34-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m45.59 480.26h-0.34v1.18c0.5 0 0.17-0.34 0.34-0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m26.25 512.73c0.17 0 0.34 0 0.5 0.17 0.17-0.17 0.5-0.17 0.67-0.34v-0.34c-0.17 0.34-0.5 0.34-1.18 0.5 0.17-0.17 0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m75.88 478.75c0.17 0 0.34-0.17 0.5-0.17v-0.5h-0.34c0 0.34-0.17 0.34-0.5 0.34 0.17 0 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m80.93 503.99c0-0.17 0-0.34 0.17-0.34h-0.67c-0.17 0-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m3.03 486.49-0.17 0.17v0.84c0.17-0.17 0.34-0.17 0.34-0.34-0.17 0-0.17-0.34-0.17-0.67v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m50.14 468.82c-0.34 0-0.5 0.17-0.84 0.17v0.34h1.01c0-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m25.57 483.96h0.34c0-0.34 0-0.67-0.17-1.01 0 0.34-0.17 0.67-0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m48.79 504.15c0 0.17 0.17 0.34 0.17 0.67q0.17 0 0.34-0.17v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m16.82 518.62c0 0.17 0.17 0.34 0.17 0.34 0.17-0.17 0.5-0.34 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m30.12 474.04v0.5h0.5c0-0.17-0.17-0.5-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m30.62 474.54c0 0.17-0.17 0.5 0.34 0.5-0.17-0.17 0-0.5-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m20.53 509.54h0.5q0.84 0 0.84 0.67c0 0.17 0.17 0.34 0.17 0.34 0.17 0 0.5 0 0.67-0.17 0.5-0.5 1.18-0.34 1.85-0.34-0.17 0.17-0.34 0.34-0.34 0.5 0.17 0 0.34 0 0.67 0.17v0.84q0.17-0.17 0.34-0.34c0-0.17 0.17-0.34 0.17-0.67 0-0.17-0.17-0.34-0.17-0.34 0.67-0.17 1.18-0.34 1.85-0.5v-1.18c0-0.34-0.17-0.5-0.5-0.5-0.17 0-0.5 0.17-0.5-0.34-0.5 0-1.01 0-1.51 0.34-0.17 0.34-0.17 0.5-0.34 0.84 0.5 0 0.34 0.34 0.34 0.67 0 0.5-0.34 0.17-0.67 0.34h-1.51c0-0.17 0-0.34-0.17-0.67h-1.51c-0.17 0.17-0.17 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m19.35 512.23c0.17-0.17 0.5-0.34 0.67-0.67 0.17-0.34 0.17-0.67 0.34-1.01-0.17-0.17-0.34-0.17-0.34-0.34s-0.17-0.34-0.17-0.5c-0.17 0-0.34 0-0.5-0.17v0.67h-0.17v-0.5h-0.67c0 0.17-0.17 0.17-0.17 0.34 0 0.34-0.34 0.34-0.5 0.34-0.34 0-0.84 0.34-1.18-0.17 0-0.17-0.17-0.34-0.17-0.67h-0.34v0.5l-0.17-0.17c-0.34 0.17-0.67 0.17-1.01 0.5q-0.5 0.34-0.84-0.17c0 0.17-0.17 0.34-0.17 0.34v0.84c0.17 0 0.34-0.17 0.5-0.17h0.67c0.17 0 0.17 0.17 0.34 0.17v-0.17c0-0.17 0.17-0.5 0.17-0.5 0.34 0 0.67 0 0.84 0.17s0.5 0.17 0.67 0.34c0.34 0 0.67 0.17 1.01 0.34q0.17-0.17 0.34-0.34l0.5 0.5h0.5c-0.17 0.17-0.17 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m25.07 511.39q-0.17 0.17-0.34 0.34c-0.5 0.17-1.01 0.34-1.51 0.67q-0.17 0.17-0.34 0.34v0.17c0.17 0 0.34 0.17 0.34 0.17h1.01c0.34-0.34 0.67-0.5 1.01-0.84 0.34-0.17 0.5-0.17 0.84-0.34s0.67-0.34 1.01-0.5 0.5-0.34 0.84-0.34v-0.5c-0.5 0.17-1.18 0.17-1.68 0.34-0.34 0-0.84 0.34-1.18 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m20.19 516.1c-0.34-0.17-0.67-0.17-1.01-0.34v-0.67c0.17-0.17 0.5-0.34 0.67-0.67 0.17 0.17 0.34 0.17 0.67 0.34v-1.35c0-0.17 0.17-0.34 0.17-0.34 0 0.34-0.17 0.67 0.34 0.5 0.17 0 0.17-0.34 0.34-0.5h0.34q0.17 0.17 0.34 0.34l-0.5 0.5c-0.16 0.16-0.34 0.17-0.5 0.17s-0.34 0-0.34 0.17 0 0.17 0.17 0.34 0.34 0.34 0.5 0.67c-0.17 0-0.67-0.17-0.67 0.34 0 0.34 0 0.5-0.5 0.5zm0.34-0.67c-0.34-0.17-0.67-0.17-0.84-0.17v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m13.29 512.9c0-0.17 0.17-0.17 0.17-0.34v-0.34c-0.34 0-0.34-0.17-0.34-0.34v-1.51c-0.34 0-0.5 0.17-0.84 0.17-0.17 0.17-0.34 0.34-0.5 0.67v0.5c0.67 0 0.5 0.34 0.5 0.67s0.17 0.5 0.5 0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m16.82 517.95c0.5 0 0.84 0 1.01-0.5l0.17-0.17c0-0.17 0-0.34 0.17-0.5v-1.01l-0.34-0.34c-0.34 0.17-0.67 0.17-1.01 0.34h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34l0.17 0.17q1.35 0 1.18 1.01l-0.17 0.17h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m19.35 512.23v-0.5h-0.5l-0.5-0.5q-0.17 0.17-0.34 0.34c0.5 0 0.34 0.34 0.34 0.5s0 0.5-0.34 0.34c-0.34 0-0.67 0-0.84 0.34 0 0.17-0.17 0.17-0.17 0.34 0 0 0.17 0.17 0.34 0.17 0.34 0 0.67 0 1.18 0.17v-0.5c0.34-0.5 0.5-0.5 0.84-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m16.49 518.29c0-0.17 0.17-0.17 0.17-0.34-0.34 0-0.67-0.17-1.18-0.17v-0.5q-0.17-0.17-0.34-0.34c-0.34 0.34-0.84 0.67-1.18 0.84 0 0.17 0.17 0.34 0.17 0.5h1.68c0.34 0.17 0.5 0 0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m15.31 516.94q0.17 0.17 0.34 0.34h1.68q0-0.17 0.17-0.17 0.17-1.01-1.18-1.01v0.5h-0.84c-0.17 0.17-0.17 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m13.29 512.9h-0.34c-0.34 0-0.5-0.17-0.5-0.5s0.17-0.67-0.5-0.67v-0.5h-0.34v0.84c0.17 0 0.34 0 0.67 0.17-0.17 0.34-0.17 0.5-0.34 0.67l-0.17 0.17c0.17 0.17 0.17 0.5 0.34 0.67 0 0 0.17 0 0.17-0.17 0.17-0.17 0.5-0.34 0.67-0.5 0.17 0.17 0.17 0 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.14 511.22c-0.17 0-0.17-0.17-0.34-0.17h-0.67c-0.17 0-0.34 0.17-0.5 0.17v1.18c0.17 0 0.34 0 0.34-0.17 0.17-0.34 0.5-0.5 0.84-0.5 0.67 0.17 0.34-0.17 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.48 513.58q0-0.17-0.17-0.34c-0.5-0.34-0.34-0.5 0-0.67l-0.5-0.5-0.67 0.67c0.17 0.17 0.34 0.17 0.34 0.34v1.18h0.34v-0.84c0.34 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m16.15 516.1c0.17-0.17 0.17-0.34 0.34-0.34-0.5 0-0.67-0.17-0.5-0.67v-1.01c0-0.17-0.17-0.17-0.34-0.34v1.35c0 0.17-0.17 0.17-0.34 0.34 0 0.34 0.17 0.67 0.17 0.84 0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m14.3 518.45c0-0.17-0.17-0.34-0.17-0.5h-0.17c-0.17 0.17-0.17 0.5-0.34 0.67 0 0.34 0.17 0.67 0.17 1.01 0 0.17 0.17 0.5 0.17 0.67l0.5-0.5c0-0.17-0.17-0.17-0.17-0.34-0.17-0.34 0-0.67 0-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m15.14 515.26c0.17-0.17 0.34-0.17 0.34-0.34v-1.35h-0.67v0.84c0.17 0.34 0.34 0.5 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m19.85 514.75c0.17 0.17 0.34 0.17 0.67 0.34v-1.35c-0.34 0.17-0.67 0.34-1.01 0.67 0.17 0 0.34 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m19.85 509.71c0 0.17 0 0.34 0.17 0.5 0 0.17 0.17 0.17 0.34 0.34 0.17-0.17 0.34-0.17 0.34-0.34v-1.01h-0.34l-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m14.64 514.42v-1.18c0-0.17-0.17-0.17-0.34-0.34 0 0.17-0.34 0.34-0.17 0.5 0 0.5-0.17 0.84 0.5 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m16.66 515.59c0.34-0.17 0.67-0.17 1.01-0.34q0-0.5-1.01-0.34c0.17 0.34 0.17 0.5 0 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m21.54 513.24h0.34v-0.67c-0.5 0-0.84 0.17-1.01 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m16.15 516.1c-0.17 0-0.5 0-0.67 0.17 0 0.17-0.17 0.34-0.17 0.5h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m21.7 512.57v0.34h0.5c0.17 0 0.34-0.17 0.5-0.17v-0.17h-1.01q0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m18 515.59c0.17 0.17 0.34 0.17 0.5 0.17 0.34 0 0.5 0 0.84-0.17v-0.34h-0.84c-0.34 0-0.34 0.17-0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m21.87 512.57h1.01q0.17-0.17 0.34-0.34h-1.01c-0.17 0-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m13.12 515.59c0-0.17 0.17-0.34 0.17-0.34 0-0.17-0.17-0.17-0.34-0.17s-0.34 0.17-0.34 0.34 0.17 0.17 0.17 0.34c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m13.63 512.57v-0.84h-0.34v1.18c0.17-0.34 0.34-0.34 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m18 512.23c0.34 0 0.34-0.17 0.34-0.34s0.17-0.5-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m79.41 499.95c-0.17-0.17-0.17-0.34-0.34-0.5q-0.17-0.17-0.34-0.34c-0.17 0.17-0.17 0.34-0.34 0.34h-1.18c-0.5 0.17-0.84 0.17-1.51-0.17 0.67 0 0.67-0.34 0.67-0.84-0.5-0.17-1.01-0.17-1.35 0.34 0.17 0.17 0.34 0.17 0.5 0.34 0 0-0.17 0.17-0.17 0.34v0.34c0 0.17 0.17 0.34 0.17 0.67h0.67c0.5-0.17 0.84-0.17 1.35-0.34h0.5c0.34 0.34 0.67 0.17 1.01 0.17l0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m81.94 497.09v1.01c0.34 0 0.84-0.17 1.18-0.17v0.17c-0.17 0.17-0.34 0.34-0.67 0.5 0.17 0.17 0.34 0.17 0.5 0.34 0.34-0.17 0.67-0.84 1.51-0.67 0 0 0.17-0.17 0.17-0.34h-0.5c-0.5-0.34-0.84-0.34-1.35-0.34l-0.17-0.17c0-0.17 0.17-0.17 0.34-0.34-0.17-0.17-0.17-0.34-0.34-0.34h-0.67v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m79.41 499.95c-0.17 0.17-0.17 0.34-0.34 0.34-0.34 0-0.84 0.17-1.01-0.17h-0.5v0.67c0.84 0.17 1.51 0.34 2.36 0v0.5h0.34c0.17-0.34 0.17-0.67 0.34-1.01 0 0 0.17-0.17 0.34-0.17v-0.34h-0.34c-0.17 0.17-0.5 0.17-0.67 0.34-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m84.12 497.93h0.5c0.17-0.17 0.34-0.17 0.5-0.34h-1.01c0.17-0.34 0.34-0.67 0.5-0.84-0.34-0.34-0.34-0.67-0.34-1.01v-1.18c0-0.34-0.34-0.34-0.5-0.34v1.18c0.34 0 0.34 0.17 0.34 0.5 0 0.17 0.17 0.5-0.34 0.5v1.01c0.5-0.17 0.34 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m78.74 498.26c-0.17-0.17-0.17-0.34-0.34-0.5 0.34-0.17 0.5-0.5 0-0.84-0.17-0.17-0.17-0.5 0.17-0.5-0.17-0.17-0.17-0.34-0.34-0.34-0.5 0-0.67-0.17-0.67-0.67h-0.17v0.84c0.17 0 0.17 0.17 0.34 0.17q0.17 0.17 0.17 0.34v1.18c0.5 0.34 0.67 0.34 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m81.94 497.09v-0.34c-0.17 0-0.17-0.17-0.34-0.17v-0.67h-0.67c-0.17 0-0.17-0.17-0.34-0.34q-0.17-0.17-0.34-0.34v0.84c0.5 0 1.18 0 1.01 0.84 0.34 0 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m85.13 501.29c-0.17-0.17-0.34-0.5-0.5-0.67 0-0.17 0.17-0.5 0.17-0.84-0.17 0.17-0.34 0.17-0.34 0.17-0.17 0.5-0.67 0.5-1.18 0.5-0.17 0-0.34 0.17-0.5 0.17h0.34q1.01 0 1.18 0.67h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m85.3 502.64c0.34-0.17 0.5-0.17 0.67-0.34 0 0-0.17-0.34-0.34-0.5-0.17-0.17-0.5-0.34-0.67-0.5v0.5c0.17 0.34 0.17 0.67 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m83.79 494.23c0.17 0 0.5-0.17 0.5 0.34h0.34v-0.84c-0.17 0-0.34 0.17-0.5 0.17v-0.84c-0.17 0.17-0.5 0.17-0.67 0.17 0.5 0.17 0.34 0.5 0.34 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m84.8 496.75c-0.17 0.34-0.34 0.5-0.5 0.84h1.01c0-0.34 0-0.67 0.17-0.84h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m84.8 496.75h0.34c0-0.17-0.17-0.34-0.17-0.5 0-0.34 0-0.67-0.17-1.01 0-0.17 0-0.5-0.34-0.5v1.01c0 0.34-0.17 0.67 0.34 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m78.74 498.26h-0.67c-0.17 0-0.5 0-0.67 0.17 0 0.17 0 0.5 0.17 0.67 0.34-0.34 0.67-0.17 1.18-0.17l0.17-0.17c-0.17-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m78.4 493.39h0.5c-0.17-0.34-0.34-0.5-0.5-0.84h-0.84v0.17c0 0.17 0.17 0.17 0.17 0.34q0.17 0.17 0.34 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m85.3 502.64c0-0.34-0.17-0.5-0.17-0.84-0.17-0.17-0.5-0.17-0.67-0.34 0.17 0.34 0.17 0.84 0.34 1.18 0.17 0.17 0.34 0.17 0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m78.74 498.77c-0.34 0-0.84-0.17-1.18 0.17h-0.34v0.34h1.18c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m80.25 495.57v-0.34c-0.17-0.34-0.17-0.5-0.34-0.84h-0.5v0.5c0.17 0.17 0.34 0.17 0.34 0.34 0.34 0.17 0.34 0.34 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m83.11 500.79h-1.01v0.34l0.5 0.5v0.17h0.5c-0.17-0.17-0.17-0.34-0.34-0.5 0.17-0.34 0.34-0.5 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m77.9 495.57c-0.17 0.5 0.17 0.67 0.67 0.67 0.17 0 0.17 0.17 0.34 0.34q0.17-0.17 0.34-0.34-0.17-0.17-0.34-0.34c-0.17 0-0.67 0.17-0.67-0.34h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m80.59 499.61h1.01c0.17 0 0.17 0.17 0.34 0.34h0.17v-0.67h-1.18l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m80.42 498.1c-0.17 0.17-0.34 0.34-0.5 0.34 0.17 0.17 0.34 0.17 0.5 0.17s0.5 0.17 0.5-0.17c0-0.17-0.17-0.17-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m78.4 493.39h-0.34v1.35c0.17-0.17 0.34-0.17 0.34-0.34 0.17-0.34 0-0.67 0-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m83.79 503.65c0.34-0.34 1.01-0.17 0.84-0.84h-0.34c-0.17 0.17-0.67 0.34-0.5 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m79.08 493.39c0.17 0.17 0.17 0.5 0.34 0.67 0.17 0 0.5 0 0.67-0.17v-0.34c-0.17 0-0.5 0.17-0.5-0.34q-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m79.92 493.89c-0.17 0-0.5 0-0.67 0.17 0 0.17 0 0.34 0.17 0.5h0.5c0.17-0.17 0-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m78.07 494.73v-0.17h-0.34v1.01h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m78.74 498.26v0.5h0.34c0.17 0 0.17-0.17 0.34-0.17-0.17 0-0.17-0.17-0.34-0.17 0-0.17-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m85.3 496.75c0 0.34 0 0.67-0.17 0.84 0.34 0 0.5 0 0.5-0.34 0-0.17 0.17-0.5-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m82.27 499.95c-0.17 0.17-0.17 0.34-0.17 0.5s0.17 0.34 0.17 0.5v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m79.41 495.07c-0.5 0-0.34 0.34-0.17 0.5h0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m79.41 499.95h0.5q-0.17-0.17-0.34-0.34 0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m13.29 498.26v0.5q0.84 0 0.84 0.67v0.67c0 0.17 0.17 0.17 0.34 0.34 0.17-0.34 0.34-0.5 0.5-0.84 0.17 0 0.34-0.17 0.5-0.17v-1.35c0-0.17 0.17-0.5 0.34-0.67v-0.67q-0.17 0-0.34-0.17-0.17 0-0.34 0.17c0 0.34-0.17 0.67-0.67 0.67-0.17 0-0.17 0.17-0.34 0.17v0.34c-0.17 0.17-0.17 0.34-0.34 0.34h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m12.95 498.77c-0.34 0.17-1.01 0.34-1.18 0.67-0.17 0.34 0 0.84 0 1.35-0.34 0-0.67-0.17-1.01-0.17v0.17c0.34 0 0.67 0 0.5 0.34 0.17 0.34 0.34 0.5 0.5 0.84 0.17 0.17 0.34 0.17 0.5 0.34h0.34c-0.17-0.34-0.34-0.67-0.67-1.18 0.5-0.5 1.35-0.5 2.02-0.5l-0.5-0.5h-0.17v-0.84c0-0.17-0.17-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m9.59 496.25c-0.34-0.5-0.67-1.01-0.67-1.51-0.17-0.5-0.34-0.84-0.67-1.01l-0.17 0.17c0.17 0.5-0.17 0.67-0.67 0.67h-0.17v0.17h0.17c0.5 0 0.84 0.34 0.84 0.84 0 0.34 0.17 0.84 0.17 1.18h0.34c0-0.17 0.17-0.34 0.17-0.67 0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m11.78 495.4c0 0.5 0.5 0.34 0.84 0.34l0.17-0.17v-1.51h1.01c-0.17 0.34-0.34 0.5-0.34 0.84 0.17 0.5 0.5 0.17 0.84 0.34v-0.34q0.17-0.17 0.34-0.34v-0.84h-2.19v0.67c0 0.34-0.17 0.34-0.5 0.17 0 0 0 0.17-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m11.78 484.81c-0.5 0-1.01 0-1.01-0.67 0 0-0.17-0.17-0.34-0.17s-0.17 0.17-0.34 0.34v0.34c0.17 0.17 0.17 0.34 0.34 0.5 0.5 0.17 1.01 0.67 1.01 1.18 0.5-0.17 0.5-0.5 0.5-0.84s0-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m12.28 491.87c0 0.17-0.17 0.17 0 0 0.17 0.17 0.5 0.17 0.84 0.34h1.18v-0.5h0.67v-0.34c-0.17-0.34-0.17-0.5-0.34-0.84-0.17 0-0.17 0.17-0.34 0.17v0.17c-0.5 0-0.5 0.34-0.5 0.67 0 0.17-0.17 0.17-0.34 0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m7.91 493.89 0.17-0.17c0.17-0.67-0.34-1.01-0.84-1.18 0.17 0.5 0 0.84-0.34 1.01-0.17-0.17-0.5-0.17-0.84-0.17v0.67c0.34 0 0.67 0.17 1.01 0.17 0.34-0.17 0.67-0.17 0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m11.1 481.44c0 0.17-0.17 0.34-0.17 0.67 0.17 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.5 0.17 0.67 0.34h0.34l0.17-0.17v-0.34c-0.17 0-0.34 0.17-0.5 0.34 0.17-0.34 0.17-0.67 0.17-1.01-0.34-0.17-0.67-0.17-1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m11.44 486.32c0-0.5-0.5-1.01-1.01-1.18v0.5h-0.67c-0.17 0-0.17 0.17-0.17 0.34l0.17 0.17c0.17 0 0.5 0 0.67-0.17 0.34-0.34 0.5-0.34 0.67 0.17q0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m11.44 486.32q-0.17 0.17-0.34 0.34c0.17 0.34 0.17 0.5 0.34 0.84v0.34h0.84c0-0.17-0.17-0.17-0.17-0.34-0.34-0.17-0.5-0.5-0.17-0.84q0.17-0.17 0.34-0.34v-0.84h-0.34c0 0.17 0.17 0.67-0.5 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m6.06 493.39c0.34 0 0.5 0.17 0.84 0.17 0.5-0.17 0.67-0.5 0.34-1.01q0-0.17-0.17-0.34s-0.17 0-0.17-0.17c-0.17 0.17-0.17 0.5-0.34 0.67h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m12.62 495.57q0 0.17 0 0c0 0.34 0.17 0.5 0.17 0.67h1.35c0.17-0.17 0.17-0.34 0.34-0.34h0.67v-0.34h-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m11.44 489.85v0.17c0.5 0.34 0.34 0.5-0.17 0.84 0.17 0 0.34 0 0.34 0.17h0.84v-1.01c-0.17 0-0.34 0-0.5-0.17h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m10.77 498.94c0.17-0.67-0.5-0.84-0.67-1.35q-0.17 0.17-0.34 0.34v1.01c0.17 0 0.5 0.17 0.67 0.17s0.34 0 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m11.1 482.45c-0.17-0.17-0.17-0.34-0.34-0.34-0.5 0-0.84 0-1.35 0.17 0 0.17 0 0.34-0.17 0.5 0 0 0.17 0 0.17 0.17h1.35q0.34-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m12.45 487.67h-0.84v0.34q1.01 0 0.84 0.5c-0.17 0.17-0.34 0.17-0.5 0.34h0.5c0.17 0 0.5-0.17 0.67-0.17v-0.34c0-0.17 0-0.34-0.17-0.5-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m11.78 488.67c0.17-0.17 0.34-0.17 0.5-0.34q0.17-0.5-0.84-0.5c-0.17 0.17-0.17 0.5-0.34 0.67 0 0.34-0.34 0.67 0.17 0.84 0-0.17 0-0.34 0.17-0.34 0.17-0.17 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m9.59 492.54c-0.17 0-0.17 0.17-0.34 0.17v0.5h0.84v0.17l0.5 0.5h0.34c-0.17-0.34-0.34-0.5-0.5-0.84h-0.5v-0.5q-0.17 0-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m9.59 492.54c0.34-0.17 0.5-0.34 0.67-0.5 0.17 0 0.34-0.17 0.5-0.17h1.01v-0.17c-0.84-0.5-2.02 0-2.19 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m9.59 496.25h-0.84c-0.17 0.17-0.17 0.34-0.17 0.67 0 0 0 0.17 0.17 0.17 0.17 0.17 0.5 0.17 0.67 0.34 0-0.34-0.17-0.84 0.5-0.84-0.17-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m11.78 495.4v-0.34h-0.67v-0.67h-1.01l0.5 0.5h0.17q0.17 0.34 1.01 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m12.45 483.96c0 0.17 0 0.34 0.17 0.34 0.34 0 0.5 0.17 0.84 0.17 0-0.34-0.17-0.67-0.17-0.84-0.17 0-0.34-0.17-0.5-0.17 0 0 0 0.17-0.17 0.17-0.34 0.17-0.17 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m12.95 498.77c0.17 0.17 0.17 0.34 0.34 0.67 0.34 0 0.5 0.34 0.84 0q0-0.5-0.84-0.67h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m9.76 496.41c-0.67 0.17-0.34 0.5-0.5 0.84h0.84c0.17-0.34-0.17-0.5-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m13.29 484.47c-0.34 0-0.5-0.17-0.84-0.17-0.17 0.17-0.34 0.34-0.67 0.5 0 0.17 0.17 0.34 0.17 0.5h0.34c-0.17-0.5 0.17-0.67 0.67-0.67q0.17 0 0.34-0.17 0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m10.26 494.23h0.34v-0.34l-0.5-0.5v-0.17h-0.84v0.34c0.34 0.34 0.67 0.5 1.01 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m11.78 488.67q-0.17 0.17-0.34 0.34c0 0.17 0 0.34-0.17 0.34 0 0.17 0 0.34 0.17 0.5 0.34 0 0.5 0 0.84-0.17-0.17-0.17-0.34-0.34-0.34-0.5-0.17 0-0.17-0.17-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m12.28 491.87h1.01v-0.67c0-0.17-0.17-0.17-0.34-0.34 0 0.17 0.17 0.5-0.34 0.5 0 0.34-0.17 0.5-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m12.62 497.93c0.17 0 0.34 0 0.5 0.17v-0.5c-0.17-0.17-0.34-0.17-0.34-0.34v-0.67h-0.34c0 0.5 0 1.01 0.17 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m10.77 498.94q-0.17 0-0.34 0.17v1.18c0 0.17 0.17 0.17 0.34 0.34v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m12.62 491.7c0.5 0 0.34-0.34 0.34-0.5h-1.18c0 0.34 0.17 0.34 0.34 0.34 0.34-0.17 0.67-0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m12.45 483.96v-0.34c-0.5 0.17-0.5-0.34-0.5-0.67-0.5 0-0.34 0.34-0.34 0.67 0 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m10.09 497.26h-0.84v0.67h0.5q0.17-0.17 0.34-0.34v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m11.78 491.87h-1.01c-0.17 0-0.34 0.17-0.5 0.17 0.5 0 0.84 0.17 1.35 0.17 0.17 0 0.17-0.17 0.17-0.34 0.17 0.17 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m11.95 492.04c0 0.17-0.17 0.17-0.17 0.34 0 0 0 0.17 0.17 0.17h0.84c0.17 0 0.17-0.17 0.34-0.34-0.34 0-0.5-0.17-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m12.62 497.93c0-0.34-0.17-0.84-0.17-1.18-0.17 0.17-0.34 0.17-0.34 0.34v0.84h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m11.78 483.12c0 0.34 0 0.67 0.5 0.67 0 0 0-0.17 0.17-0.17 0-0.17-0.17-0.5-0.17-0.67h-0.34c-0.17-0.17-0.17 0-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m11.1 482.79h-1.35c0.17 0.34 0.67 0.34 1.01 0.34l0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m11.44 487.33c-0.17-0.34-0.17-0.5-0.34-0.84-0.5 0-0.5 0.34-0.5 0.5s0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m14.3 496.25h-1.35v0.17h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m12.95 497.93q0.17 0.17 0.34 0.34h0.5c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m14.3 496.58h-1.35c0 0.17-0.17 0.17-0.17 0.34h1.51v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m9.25 493.55v-0.84c-0.5 0-0.34 0.34-0.34 0.5s0 0.5 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m10.09 484.47v-0.34c-0.17 0-0.17 0.17-0.34 0.17 0.17 0.17 0.34 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m81.6 487.33v-0.67q-0.17 0-0.34-0.17-0.17 0-0.34-0.17h-0.34v0.5c0 0.5-0.17 0.67-0.67 0.67h-0.5v2.19c0.67-0.17 0.5 0.34 0.5 0.67 0.17-0.17 0.5-0.34 0.67-0.5 0.17-0.17 0.34-0.17 0.34-0.17 0.17 0.17 0.34 0.5 0.5 0.67h0.5v-0.67c0-0.17-0.17-0.34-0.17-0.5-0.5 0.17-0.84-0.17-0.67-0.67h-0.5c-0.34 0.34-0.5 0.17-1.01 0.17 0.17-0.34 0.17-0.5 0.34-0.67q0.17-0.17 0.34-0.34h0.67s0.17 0 0.17-0.17c0.17 0.17 0.17-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m80.42 483.63v-0.34c-0.17 0-0.17-0.17-0.34-0.17-0.34-0.17-0.67-0.34-0.5-0.84-0.17 0.17-0.5 0.17-0.67 0.34v0.5h0.67v1.18h0.84c-0.17-0.34 0-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m79.75 479.76c0-0.5 0.17-1.01-0.17-1.35-0.17 0-0.5 0.17-0.67 0.17v1.85h0.67c0-0.34 0-0.5 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m79.75 479.76c0 0.17-0.17 0.34-0.17 0.5 0 0.34 0 0.84-0.17 1.18 0 0.17 0 0.34 0.17 0.5h0.5s0.17 0 0.17-0.17c0-0.5-0.17-0.84-0.17-1.35-0.17-0.17-0.34-0.34-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m77.9 469.83c-0.17 0.34-0.17 0.5-0.17 0.67h-0.67c0 0.17-0.17 0.34-0.17 0.5h1.51v-0.34c-0.5-0.17-0.17-0.67-0.5-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m78.74 478.58c0.17 0 0.5-0.17 0.67-0.17v-0.84h-0.67c0 0.17 0.17 0.67-0.34 0.67v0.67c0.17-0.34 0.34-0.34 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m79.41 475.22c0.17-0.34 0.17-0.67-0.17-1.01-0.17-0.34-0.17-0.67-0.17-1.18h-0.34c0 0.67 0.17 1.35 0.17 1.85 0.17 0.17 0.34 0.17 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m78.07 469.83c0.17 0.34-0.17 0.84 0.5 1.01 0.17-0.17 0.34-0.5 0.5-0.67 0-0.17-0.17-0.5-0.17-0.67h-0.34c-0.17 0-0.34 0.17-0.5 0.34v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m78.74 473.03h0.34v-2.02h-0.67c0 0.17 0.17 0.34 0.17 0.34 0.17 0.67 0.17 1.18 0.17 1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m81.26 485.14c-0.17-0.34-0.17-0.67-0.34-1.18l-0.17 0.17v0.34c-0.17 0-0.17 0.17-0.34 0.17v0.67h0.34s0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m81.26 485.14c-0.17 0-0.34 0.17-0.5 0.17 0.34 0.34 0.34 0.67 0.34 1.18q0.17 0 0.34 0.17v-1.35c-0.17 0-0.17-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m80.08 480.6c0 0.5 0.17 0.84 0.17 1.35 0 0 0.17 0 0.17 0.17 0.5 0 0.34-0.34 0.34-0.5-0.34-0.17-0.34-0.5-0.34-0.67-0.17-0.34-0.34-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m79.41 475.22c-0.17 0-0.17-0.17-0.34-0.17-0.34 0.34-0.34 0.84 0.17 1.01h0.34v-0.34c-0.17-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m79.41 477.4v0.84c0.34-0.17 0.34-0.5 0.34-0.84v-0.67h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m81.26 485.31v1.35q0.17 0 0.34 0.17v-1.01c0-0.34-0.17-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m80.42 481.95q-0.17 0 0 0h-0.34v1.01c0.17 0 0.17 0.17 0.34 0.17-0.17-0.34-0.17-0.67 0-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m79.41 476.73h0.34v-0.84c0-0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m80.59 484.3 0.17-0.17c-0.17-0.17-0.34-0.34-0.5-0.34v0.67c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m33.31 479.42c0-0.34-0.34-0.5-0.67-0.67l-0.17 0.17v1.85h1.35v-0.5h-0.84c0.17-0.34 0.17-0.5 0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m30.79 476.9c0-0.17-0.17-0.17-0.17-0.34h-0.34c-0.17 0-0.5 0.17-0.67 0.17 0.17 0.17 0.34 0.17 0.34 0.34v1.01c0.34 0 0.5 0 0.84 0.17 0.17 0 0.34-0.17 0.5-0.17-0.17-0.17-0.34-0.5-0.5-0.5-0.34-0.34-0.17-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m27.42 476.9v0.5s0.17 0 0.17 0.17c0.17 0 0.34 0 0.5-0.17 0.17 0 0.34 0 0.5 0.17 0.34-0.17 0.5-0.5 0.84-0.67v-0.17c-0.17 0-0.67 0.17-0.67-0.34l-0.17-0.17c0 0.17 0 0.34-0.17 0.34 0 0.17-0.17 0.17-0.34 0.34-0.34-0.17-0.5 0-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m28.77 476.22c0 0.5 0.34 0.17 0.67 0.34 0-0.34 0.34-0.34 0.5-0.34s0.17 0.17 0.34 0.34h0.34c0-0.84-0.17-1.01-0.84-0.84-0.17 0-0.34 0.34-0.67 0.34-0.17 0.17-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m32.47 479.08 0.17-0.17q-0.17-0.17-0.34-0.34c-0.17 0-0.34 0-0.5 0.17-0.34 0.17-0.67 0.17-0.84 0.34v0.17c0.17 0.17 0.34 0.34 0.5 0.67h0.34c-0.17-0.67 0-1.01 0.67-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m30.96 478.92c0.34-0.17 0.67-0.17 0.84-0.34 0.17 0 0.34 0 0.5-0.17-0.17-0.17-0.17-0.34-0.34-0.5h-0.67c-0.17 0-0.34 0.17-0.5 0.17 0 0.34 0 0.5 0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m31.29 477.91h0.67l-0.84-0.84c-0.17-0.17-0.34-0.17-0.34-0.34-0.34 0.17-0.34 0.34 0 0.5 0.17 0.34 0.34 0.5 0.5 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m28.1 476.73 0.34-0.34c0-0.17 0-0.34 0.17-0.34l-0.17-0.17h-1.01c-0.17 0-0.5 0-0.5 0.34h1.18v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m34.32 481.44q0.17-0.17 0.34-0.34c0-0.17-0.17-0.17-0.17-0.34h-0.67v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m33.82 480.77h0.67c0-0.17 0-0.5-0.34-0.5-0.17 0-0.34-0.17-0.5-0.34v0.34c0.17 0.17 0.17 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m29.61 474.88c-0.17 0-0.17-0.17-0.34-0.17h-0.84v0.34c0.34 0 0.67-0.17 1.18-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m33.82 480.26v-0.34l-0.5-0.5c-0.17 0.17-0.17 0.5-0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m35.84 481.95c0 0.5 0.34 0.67 0.84 0.84l0.17-0.17c-0.34-0.17-0.67-0.34-1.01-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m27.42 475.89h1.01c-0.17-0.17-0.17-0.34-0.34-0.34h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m30.12 474.71-0.17 0.17 0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m23.72 496.41v-0.17c-0.34-0.17-0.67-0.34-0.84-0.5s-0.34-0.17-0.5-0.34c-0.34 0-0.84 0.17-1.18 0.17v1.35h0.5c0.17-0.17 0.17-0.5 0.34-0.84 0.34 0 0.84-0.17 0.84 0 0.17 0.17 0.17 0.67 0.34 1.01h0.5v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m21.2 495.57c0.34 0 0.84-0.17 1.18-0.17v-0.17h-0.84v-0.5h0.5v-0.17c0-0.17-0.17-0.34-0.17-0.34h-0.67q-0.17 0-0.34 0.17c-0.17 0.17-0.17 0.34-0.34 0.5-0.17 0.17-0.5 0.17-0.67 0.34 0 0.34 0.17 0.5 0.67 0.5 0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m22.04 492.21c-0.17-0.34-0.17-0.5-0.34-0.84-0.17 0-0.34 0-0.5-0.17v0.84c-0.5 0.17-0.84 0.17-1.18 0.34v0.17h0.84c0.17 0 0.17 0.17 0.34 0.34 0.34 0 0.67 0 0.67-0.5l0.17-0.17q0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m17.5 486.49c-0.17-0.17-0.5-0.34-0.67-0.67h-1.18v0.67c0.17 0.17 0.34 0.34 0.5 0.34 0.17-0.17 0.34-0.5 0.84-0.34h0.5c-0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m19.52 489.18c-0.17-0.17-0.5-0.34-0.67-0.67-0.34-0.17-0.5-0.17-0.84-0.34 0 0.34 0 0.67-0.17 0.84 0 0 0 0.17 0.17 0.17h1.18c0.17 0.17 0.17 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m16.49 485.98h0.34v-0.84c-0.17 0-0.5 0-0.67 0.17 0 0.17 0.17 0.34 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m18 487.5c-0.17-0.34-0.34-0.5-0.67-0.84-0.17 0.5 0 0.67 0.67 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m19.52 489.18-0.17 0.17v0.67h0.67v-0.5c-0.17-0.17-0.34-0.34-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m22.04 494.73h-0.5v0.5h0.84c-0.17-0.17-0.34-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m19.85 489.52v1.01h0.34l0.17-0.17c0-0.34-0.17-0.67-0.5-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m18 488.17c0.34 0.17 0.5 0.17 0.84 0.34-0.34-0.34-0.5-0.67-0.84-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m22.21 494.56c0.17-0.17 0.34-0.17 0.34-0.34v-0.84h-0.34v0.34c-0.17 0.17 0 0.5 0 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m22.21 493.39h0.34v-0.67c0-0.34-0.17-0.34-0.5-0.34v0.17c0 0.17 0 0.5 0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m22.21 494.56v-0.84c-0.5 0-0.34 0.34-0.34 0.67 0 0 0 0.17 0.34 0.17q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m21.2 491.37c0.17 0 0.34 0 0.5 0.17 0.17-0.34 0-0.5-0.5-0.67v0.5q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m21.03 491.03v-0.34c-0.17-0.17-0.5-0.34-0.67-0.34l-0.17 0.17c0.17 0.17 0.17 0.34 0.34 0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m76.22 472.02c-0.34 0-0.34 0.17-0.34 0.34v3.7c0 0.17 0.17 0.17 0.17 0.34 0-0.17 0.17-0.34 0.17-0.5v-2.02-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m76.22 472.02v2.02h0.34q0.17-0.17 0.34-0.34v-1.85q-0.17-0.17-0.34-0.34s-0.17 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m76.22 477.91v0.5h0.67v-2.02h-0.67v1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m76.22 476.73h0.67v-0.5c-0.34 0-0.34-0.17-0.34-0.34v-1.85h-0.34v2.69q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m76.55 471.35q0.17 0.17 0.34 0.34h1.18c0-0.17 0.17-0.34 0.17-0.67h-1.51c0 0.17 0 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m78.07 469.83v0c0.17-0.34 0.17-0.67 0.17-1.01h-0.34v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m76.89 470.67h0.67v-0.5c-0.34-0.17-0.67 0-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m76.22 477.91c0-0.34 0-0.67-0.17-1.01 0 0.17-0.17 0.5-0.17 0.67v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m5.38 495.57q-0.34 0.17-0.5 0.34c0 0.34 0.34 0.34 0.5 0.34h0.34c0-0.34 0.34-0.34 0.5-0.34s0.5 0 0.5 0.34c0.17 0 0.67 0.17 0.67-0.34-0.5 0-0.34-0.34-0.34-0.67h-1.35c0 0.17-0.17 0.34-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m5.72 495.4h1.35v-1.18h-0.5c-0.17 0-0.5 0.17-0.67 0.17s-0.17 0.17-0.34 0.17v0.34c0 0.17 0.17 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m1.35 492.21s0 0.17 0.17 0.17c0.34 0.17 0.5 0.17 0.84 0.17 0.17 0.17 0.34 0.17 0.34 0.34v0.67h0.34c0-0.34 0.17-0.5 0.17-0.84-0.17 0-0.34-0.17-0.5-0.17s-0.17-0.17-0.34-0.34h-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m3.03 493.89c0 0.34 0 0.67 0.34 0.84 0 0 0.17 0.17 0.17 0.34 0.17 0.17 0.17 0.34 0.34 0.5 0-0.34 0-0.67 0.34-1.01-0.17-0.17-0.17-0.34-0.34-0.34-0.34 0-0.5 0-0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m3.03 493.89c0.17 0.17 0.5 0.34 0.84 0.34 0.17 0 0.17 0.17 0.34 0.34 0.17 0 0.5 0.17 0.67 0.17-0.17-0.34-0.17-0.5-0.34-0.84h-1.01c-0.17 0-0.34-0.17-0.5-0.17v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m4.88 494.73c-0.17 0-0.5-0.17-0.67-0.17-0.34 0.34-0.34 0.67-0.34 1.01l0.17 0.17c0.17-0.17 0.34-0.17 0.5-0.34q0.17-0.17 0.34-0.34h0.5v-0.34h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m6.73 496.25c0-0.34-0.17-0.34-0.5-0.34-0.17 0-0.5-0.17-0.5 0.34q0.17 0.17 0.34 0.34c0.34-0.17 0.67 0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2.02 491.37c-0.5-0.17-0.84 0-0.84 0.84h0.34q0.17-0.17 0.34-0.34c0-0.17 0-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m5.38 496.25c-0.17 0-0.5 0.17-0.5-0.34l-0.5 0.5s0 0.17 0.17 0.17c0.17-0.17 0.67 0.34 0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m2.69 493.55v-0.67c0-0.17-0.17-0.17-0.34-0.34v0.67c0 0.17 0.34 0.34 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m6.06 496.58c-0.17 0-0.34 0.17-0.34 0.17-0.17 0.17-0.5-0.17-0.5 0.34h0.5c0.17 0 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m4.54 495.24c-0.17 0.17-0.34 0.17-0.5 0.34 0.17 0 0.5 0.17 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m5.38 495.57q0.17-0.17 0.34-0.34c0 0.17-0.17 0.34-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m4.88 495.91q0.17-0.17 0.34-0.34c0 0.17-0.17 0.34-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m4.88 495.07q-0.17 0.17-0.34 0.34l0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m9.25 507.85c0.17 0.5 0.34 0.84 0.67 1.35h0.34c0.17 0 0.34-0.17 0.5-0.34v0.67c0.17-0.17 0.34-0.17 0.34-0.34v-1.35l0.5-0.5-0.17-0.17c-0.34 0-0.84-0.17-1.01 0.34-0.17 0.34-0.34 0.34-0.67 0.34v-0.5c0 0.17-0.17 0.17-0.17 0.34 0 0-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m11.1 507.85v1.35c0 0.17-0.17 0.17-0.34 0.34 0 0.17-0.17 0.17-0.17 0.34-0.17 0.17-0.17 0.5 0.17 0.67 0.17 0 0.17 0.34 0.34 0.5h0.5v-1.01c0-0.17 0.17-0.17 0.34-0.34v-0.34c-0.34 0-0.34-0.17-0.34-0.34s-0.34-0.67 0.34-0.67v-0.34c-0.34-0.17-0.5-0.17-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m11.78 512.9c0.17-0.17 0.17-0.5 0.34-0.67-0.34 0-0.5-0.17-0.67-0.17v-0.84c-0.17 0.17-0.34 0.17-0.34 0.34v0.84c0.17 0 0.5 0.17 0.67 0.17v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m11.78 512.73c-0.17 0-0.5-0.17-0.67-0.17-0.17-0.17-0.34-0.17-0.34-0.34v-0.84c-0.17 0-0.17 0.17-0.34 0.17v0.17q0 1.01 1.35 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m10.77 511.22v0.84c0 0.17 0.17 0.17 0.34 0.34v-0.84c0-0.17 0.17-0.17 0.34-0.34v-0.34h-0.5c0 0.17 0 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m12.11 513.91c-0.17-0.17-0.17-0.5-0.34-0.67 0 0-0.17 0-0.17 0.17v0.84c0.17 0 0.5 0 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m11.44 514.25v-0.84c-0.17 0.17-0.34 0.17-0.34 0.34v0.67c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m8.92 507.52q0.17 0.17 0.34 0.34l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m46.94 472.02c-0.34 0-0.34 0.17-0.34 0.34 0 0.5 0 1.01-0.34 1.35h0.67v-1.51-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m46.94 470-0.17-0.17c-0.34 0.34-0.34 1.01 0 1.35 0-0.17 0.17-0.34 0.17-0.34 0.17-0.17 0.5-0.17 0.67-0.34-0.17 0-0.34 0-0.34-0.17l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m46.94 472.02v0.34c0-0.17 0.17-0.17 0.17-0.34l0.34-0.34c0.17-0.17 0.5-0.17 0.67-0.34v-0.34c-0.34 0.17-0.84 0.17-1.18 0.34v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m49.97 469.33h-1.51v0.34h0.84c0.17 0 0.67 0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m48.12 471.01v0.34l0.34 0.34h0.34v-0.84c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m48.45 469.66v-0.34h-0.67c-0.17 0.17-0.17 0.34-0.34 0.5h0.84s0.17 0 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m48.29 470h-1.35l0.34 0.34q0.17 0 0.34 0.17c0.34-0.17 0.67 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m48.79 470.84v0.84h0.5c0-0.34-0.17-0.5-0.17-0.84h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m80.08 488.17c-0.17 0.17-0.17 0.5-0.34 0.67 0.5 0 0.84 0.17 1.01-0.17 0-0.17 0.34 0 0.5 0h0.67c-0.17 0-0.17-0.17-0.34-0.17s-0.34-0.17-0.34-0.17c0-0.17-0.17-0.34-0.17-0.5 0 0-0.17 0-0.17 0.17-0.17 0.17-0.17 0.34-0.34 0.34s-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m83.79 492.21c0-0.17 0.17-0.5-0.34-0.67h-1.01v-1.18h-0.34v1.18q0.17 0.17 0.34 0.34h0.67c0.17 0 0.17 0.17 0.34 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m82.27 490.53h0.34v-0.84c0-0.5-0.17-0.67-0.5-0.84v0.5c0 0.17 0.17 0.34 0.17 0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m81.26 487.83c0 0.17 0 0.34 0.17 0.5 0 0.17 0.17 0.17 0.34 0.17v-1.18c-0.5 0-0.5 0.34-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m8.58 504.49c0.17 0 0.5 0.17 0.67 0.17v-1.01c0.34 0 0.67-0.17 1.01-0.17s0.5 0.17 0.84 0.17h0.34v-0.5h-2.19q-0.17 0.17-0.34 0.34t-0.34 0.34v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m8.92 507.52q0.17 0.17 0.34 0.34 0.17-0.17 0.34-0.34t0.17-0.34h0.34q0.17-0.17 0.34-0.34t0.34-0.34c-0.17 0-0.5-0.17-0.67-0.17l-0.17 0.17-0.17-0.17c-0.17-0.34-0.34-0.67-0.84-0.67v1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m8.92 505.84c0.5-0.17 0.67 0.34 0.84 0.67h0.34c0.17-0.17 0.17-0.34 0.34-0.67h-0.67c0.17-0.34 0.17-0.67 0.34-0.84-0.17 0-0.5-0.17-0.67-0.17-0.17 0.17-0.5 0.17-0.67 0.34 0 0.17-0.34 0.67 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m9.42 504.83c0.17 0 0.5 0.17 0.67 0.17h0.17c0-0.17 0.17-0.17 0.17-0.34 0.17 0 0.5-0.17 0.67-0.17v-0.34h-1.85c0 0.17 0 0.34 0.17 0.67-0.17-0.17 0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m7.57 501.63c0.17 0.17 0.34 0.34 0.34 0.5 0.17 0.17 0.17 0.34 0.34 0.5h0.17c-0.17-0.5 0.34-0.34 0.67-0.34 0-0.34-0.17-0.34-0.5-0.34-0.17 0-0.5 0.17-0.5-0.34h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m9.25 502.13c-0.34 0-0.67-0.17-0.67 0.34 0.34 0 0.67 0 0.67 0.34h0.34c0-0.34 0.17-0.5 0.17-0.84l-0.17-0.17c0 0.34-0.17 0.34-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m8.58 503.65q0.17-0.17 0.34-0.34c-0.17 0-0.5-0.17-0.67-0.17h-0.5s-0.17 0.17-0.17 0.34 0.17 0.17 0.34 0.17h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m8.58 503.65h-0.34v1.01h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m8.24 504.49v-0.67c-0.17 0.17-0.34 0.17-0.34 0.34s0.34 0.34 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m8.92 503.31q0.17-0.17 0.34-0.34c0 0.17-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m27.26 479.42c-0.17 0.34-0.5 0.67-0.67 0.84v2.86s0.17 0 0.17 0.17c0.17-0.67 0.34-1.18 0.17-1.85 0-0.34 0-0.67 0.5-1.01 0.34 0 0.5 0 0.84-0.17v-0.34c-0.17-0.17-0.34-0.17-0.34-0.34v-0.67c-0.34 0.17-0.5 0.34-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m27.26 479.42c0.17-0.17 0.34-0.17 0.5-0.34v-0.5h0.67v0.5h0.34c0-0.17 0.17-0.34 0.17-0.5v-0.34c-0.5 0.17-0.84-0.17-0.67-0.67v-0.34c-0.17 0-0.34 0-0.5 0.17v0.34c-1.01 0.5-0.5 1.01-0.5 1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m26.41 483.12v-2.86c-0.34 0-0.34 0.17-0.34 0.34v2.36c0.17 0.17 0.34 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m26.41 483.12h-0.34v1.68h0.34c0-0.5 0.17-0.84 0.17-1.35v-0.17q0-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m13.29 484.47q0 0.17 0 0c0 0.17 0.17 0.34 0.17 0.34 0.34-0.17 0.67-0.17 1.18-0.34v0.67h1.01c0-0.17 0-0.34 0.17-0.5q0-0.17-0.17-0.34c-0.17-0.17-0.34-0.17-0.5-0.34q-1.01 0-0.67-0.84c0-0.17-0.17-0.34-0.17-0.34-0.17 0-0.34-0.17-0.34-0.17s0 0.17-0.17 0.17c0.17 0.5-0.17 0.67-0.67 0.67 0 0.5 0 0.84 0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m11.1 481.44h1.01c0.17-0.17 0.34-0.17 0.5-0.34 0-0.17 0-0.34 0.17-0.34h-0.34c-0.84 0-1.35 0-1.35 0.67q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m13.63 483.12s0-0.17 0.17-0.17c-0.17-0.17-0.34-0.17-0.5-0.34h-1.01l-0.17 0.17c0.17 0 0.34 0.17 0.67 0.17 0-0.17 0.17-0.17 0.17-0.34 0.34 0.34 0.5 0.34 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m14.3 483.46c-0.34 0.67-0.17 0.84 0.67 0.84-0.17-0.17-0.17-0.34-0.34-0.5 0-0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m14.3 483.46c0.17 0.17 0.34 0.17 0.5 0.34 0.34-0.67 0.17-0.67-0.5-0.67v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m12.45 482.62h1.01c-0.17-0.17-0.17-0.34-0.34-0.34h-0.67v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m4.21 488.67c0-0.17-0.17-0.17-0.17-0.34-0.5-0.34-1.01-0.17-1.35 0 0.17 0.34-0.17 0.34-0.5 0.5 0.17 0.34 0.5 0.5 0.67 0.84 0-0.34 0.17-0.5 0.17-0.84h0.5c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m2.36 488.84c0.17-0.17 0.5-0.17 0.5-0.5-0.17 0-0.34 0-0.5-0.17h-0.34q-0.84 0.17-0.84-0.67l-0.17-0.17v1.18c0.34 0.34 0.67 0.34 1.35 0.34q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m4.21 488.67h-0.67c0 0.34-0.17 0.67-0.17 1.18l0.17 0.17h0.17c0.17 0 0.34 0 0.5-0.17v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m2.02 491.37c0 0.17-0.17 0.34-0.17 0.5h1.35v-0.67c-0.17 0-0.34-0.17-0.5-0.17-0.34 0.17-0.5 0.34-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m3.03 491.37v0.67h-1.35q-0.17 0.17-0.34 0.34h1.85v-0.67q0-0.17-0.17-0.34 0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m3.2 491.37v0.34h0.34q0.17-0.17 0.34-0.34c0-0.5 0-0.84-0.17-1.35h-0.17v1.01c0 0.17-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m3.36 489.85c0-0.34 0.17-0.67 0.17-1.18h-0.5c0 0.34-0.17 0.67-0.17 0.84 0.17 0.17 0.34 0.17 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m2.19 488.84c-0.5 0-0.84 0-1.35-0.17v0.34c0.5 0 1.01 0.17 1.35-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m36 484.81v-0.34l-0.17-0.17h-1.01c0 0.5-0.34 0.5-0.67 0.5 0 0-0.17 0-0.17 0.17-0.17 0.17-0.5 0.17-0.67 0.34 0 0.17-0.17 0.34-0.17 0.67v0.17c0 0.17 0.17 0.17 0.17 0.34h0.67c0.17-0.17 0.5-0.34 0.67-0.5 0.34-0.34 0.84-0.67 1.35-0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m36.17 483.63c0-0.34 0-0.67-0.5-0.67h-0.67v0.67h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m35 482.62v-0.67h-0.67v0.5c-0.17 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m36 484.81v0.34s0 0.17 0.17 0.17h0.67v-0.5h-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m36.17 483.63h-1.18v0.34h0.5c0.34 0 0.5 0.17 0.5 0.34l0.17 0.17s0-0.17 0.17-0.17c-0.17-0.17-0.17-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m38.19 485.31h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m37.52 485.98v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m36.17 483.63v0.67c0.17 0 0.67 0.17 0.67-0.34s-0.5-0.34-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m38.19 485.31v0.5h0.5v-0.5l-0.17-0.17c-0.17 0.17-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m35 482.62v0.5h0.67c0-0.67-0.34-0.67-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m34.32 481.44h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m75.04 486.32c-0.34-0.17-0.67-0.34-1.18-0.67-0.17 0-0.34-0.17-0.5-0.17 0 0.17-0.17 0.34-0.17 0.5 0.17 0 0.34 0 0.5-0.17v1.18h0.67v-0.5c0.34 0 0.5 0 0.67-0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m75.71 485.31c-0.5 0.17-0.17 0.67-0.17 0.84h0.84c0.17-0.17 0.17-0.34 0.34-0.5v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m73.19 485.98c0-0.17 0.17-0.34 0.17-0.5s-0.17-0.17-0.17-0.34h-0.17c-0.17 0-0.34 0.17-0.5 0.17v1.18c0.5 0.17 0.84 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m76.55 483.29q0 0.17 0 0l-0.17 0.17 0.17 0.17h1.51c0.5 0.17 0.67-0.17 0.67-0.67h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34h-1.18-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m75.71 485.31h1.01v-0.67c-0.17 0-0.17-0.17-0.34-0.17-0.67 0.17-0.84 0.34-0.67 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m76.55 483.29h0.34q0.17-0.17 0.34-0.34c-0.17-0.17-0.17-0.34-0.34-0.5h-1.01c0.17 0.17 0.34 0.17 0.67 0.34v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m76.22 486.15h-1.18v0.34h0.5c0.34 0 0.84 0.34 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m76.22 484.47c0.17 0 0.17 0.17 0.34 0.17v-1.18l-0.17-0.17c0 0.17-0.17 0.5-0.17 0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m76.22 484.3c0-0.17 0.17-0.5 0.17-0.67v-0.17c-0.17 0-0.34 0-0.5-0.17 0.17 0.34-0.34 0.84 0.34 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m26.08 476.39c0 0.34 0.17 0.34 0.34 0.34h0.67c-0.17-0.17-0.17-0.34-0.34-0.5-0.17 0-0.34 0-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m22.38 513.07h-0.5v0.34q0.17 0.17 0.34 0.34h1.51c0.17 0 0.17-0.17 0.34-0.34h-1.35l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m22.38 513.07c0.17 0.17 0.17 0.34 0.34 0.34h1.35q0.17-0.17 0.34-0.34h-1.01c-0.17 0-0.34-0.17-0.34-0.17-0.34 0-0.5 0-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m27.26 511.39c-0.34 0.17-0.67 0.34-1.01 0.5 0.34 0 0.67 0 1.18 0.17 0-0.34-0.17-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m6.73 499.27v0.5c0.34 0 0.34 0.17 0.34 0.5 0 0.17 0 0.34 0.34 0.34v-0.67c0-0.34 0.17-0.5 0.5-0.5v-0.34c-0.17-0.17-0.34-0.17-0.5-0.34-0.17 0.17-0.34 0.34-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m7.4 500.62c-0.34 0-0.34-0.17-0.34-0.34s0-0.5-0.34-0.5c0 0.5 0 1.01-0.34 1.35 0.5 0 0.84-0.17 1.18 0.34v-0.67c0 0.17 0 0-0.17-0.17 0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m5.72 497.09h-0.5v0.67c0 0.17 0.17 0.17 0.17 0.34v0.67h0.34v-1.18c0.17-0.34 0-0.5 0-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m5.89 497.42v1.18h1.01v-0.34c-0.17-0.17-0.67 0.17-0.67-0.34-0.17-0.17-0.34-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m6.73 499.27c0.17-0.17 0.5-0.34 0.67-0.67-0.17 0-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m26.25 491.87c0.17 0.34 0.5 0.5 0.67 0.84h1.85c0.17-0.17 0.34-0.17 0.67-0.34v-0.5h-1.68c0.17 0.17 0.5 0.34 0.67 0.5h-1.35v-0.5h-0.84c0.17-0.34 0.34-0.67 0.5-0.84h-0.67c0.17 0.34 0.17 0.67 0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m26.25 491.03h1.01c0-0.17-0.17-0.34-0.17-0.34 0-0.17 0.17-0.34 0.17-0.34h-1.68l0.5 0.5s-0.17 0.17-0.17 0.34c0-0.17 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m28.77 492.71h-1.85c0.17 0.17 0.17 0.34 0.34 0.34h0.84v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m28.77 493.55h-0.67c-0.17 0.34-0.17 0.67-0.34 0.84h1.01c-0.17-0.17 0-0.5 0-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m28.6 494.56h-1.35c0 0.17-0.17 0.34-0.17 0.5h0.17c0.17 0 0.5 0 0.67-0.17 0.17 0 0.5 0 0.67 0.17v-0.34c0.17 0 0.17-0.17 0-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m26.25 491.03h-0.34c-0.17 0.5 0 0.84 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m13.96 520.14c-0.17-0.17-0.17-0.5-0.17-0.67 0-0.34-0.17-0.67-0.17-1.01q-0.17 0.17-0.34 0.34c0 0.34 0 0.67 0.17 1.01 0.17 0.17 0.34 0.34 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m13.29 519.97c0-0.34 0-0.67-0.17-1.01 0 0-0.17 0-0.17 0.17v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m12.95 519.8v-0.84c-0.34 0-0.34 0.17-0.34 0.34 0.17 0.34 0 0.67 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m80.08 500.96v-0.5c-0.84 0.5-1.51 0.34-2.36 0v0.84h-0.5c-0.17-0.34-0.5-0.17-0.67-0.17v0.67c-0.5-0.17-0.84-0.17-1.35-0.34h-0.34c0 0.17-0.17 0.34-0.17 0.5h1.35c0.34 0 0.67 0 0.84-0.17s0.67-0.17 0.84 0 0.17 0.5-0.17 0.5v0.17h0.5c0.34-0.34 0.67-0.67 1.01-0.84-0.17 0-0.67 0.17-0.67-0.34 0-0.17 0.17-0.34 0.34-0.34 0.5 0 0.17 0.34 0.34 0.5 0.17-0.17 0.5-0.17 0.67-0.34-0.17 0.17 0 0 0.34-0.17q-0.17 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m74.36 501.97c0-0.17 0.17-0.34 0.17-0.5 0 0-0.17 0-0.17-0.17h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34h-0.84c-0.17 0-0.17 0.17-0.34 0.34h0.34 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m74.36 501.97c-0.5 0-1.01 0-1.35-0.17v0.34h0.84s0.34 0 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m33.82 507.85c0.17-0.17 0.34-0.17 0.5-0.34 0.17-0.34 0.34-0.5 0.34-0.84h0.84c0 0.17 0 0.34 0.17 0.5h0.5c0.17-0.5 0.34-0.84 0.5-1.35-0.34 0-0.67 0-1.18-0.17h-0.67c-0.34 0-0.67 0-0.84-0.34h-0.34c-0.34 0.5-0.84 0.17-1.35 0.34-0.5 0-0.67 0.17-0.67 0.67q0.17 0.17 0.34 0.34c-0.17 0-0.17 0.17-0.34 0.17h-0.5c-0.17 0.17-0.34 0.17-0.34 0.34v0.67c0.5 0 0.34 0.34 0.34 0.67-0.17 0-0.5 0.17-0.67 0.17s-0.17 0.17-0.34 0.34c0.17 0.17 0.17 0.34 0.34 0.34h1.18c0-0.5 0.34-0.17 0.67-0.34 0.17-0.34 0.34-0.5 0.34-0.67 0.5-0.17 0.84-0.34 1.18-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m36.17 507.35h-0.5c0-0.17 0-0.34-0.17-0.5h-0.84c-0.17 0.34-0.34 0.67-0.34 0.84h1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m33.82 507.85c-0.34 0.17-0.5 0.17-0.84 0.34-0.17 0.17-0.34 0.5-0.34 0.67h0.67c0.34-0.17 0.67-0.17 0.84-0.34-0.17-0.17-0.34-0.34-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m31.8 509.37h-1.18c-0.17 0-0.17-0.17-0.34-0.34q0.17-0.17 0.34-0.34c0.17-0.17 0.34-0.17 0.67-0.17h-1.01c-0.17 0.34-0.34 0.67-0.84 0.84v0.34c0.17 0 0.34-0.17 0.5-0.17v1.01h1.35v-0.5h0.5v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m33.14 509.03h-0.67c-0.17 0-0.67-0.17-0.67 0.34h1.01c0-0.17 0.17-0.34 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m29.27 509.54v-0.34c-0.34 0-0.34-0.17-0.34-0.5 0-0.17 0-0.34-0.34-0.34v0.17c0 0.17 0.17 0.5-0.34 0.67 0 0.17 0.17 0.5-0.34 0.67v1.18h0.34v-0.5h0.67v-0.5c0.17-0.34 0.34-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m29.95 510.55v-1.01c-0.17 0-0.34 0.17-0.5 0.17v0.67c0 0.17-0.17 0.17-0.34 0.34 0.17 0.17 0.17 0.34 0.34 0.5 0.17-0.34 0.34-0.5 0.5-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m29.27 511.05c-0.17-0.17-0.17-0.34-0.34-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m27.42 474.04c-0.5 0-0.17 0.34-0.17 0.5 0.34 0 0.5 0 0.84 0.17 0-0.17 0-0.34-0.34-0.34l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m53.17 502.47h0.5v-1.68h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m54.34 501.63v0.84h0.34q0.17-0.17 0.34-0.34c0.17-0.34 0.17-0.67 0.34-0.84-0.34 0.17-0.67 0.17-1.01 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m53.17 500.79h1.18v-0.5h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m54.68 502.47h-0.34q0 0.17-0.17 0.34c0.34 0 0.67 0.17 1.01 0.17 0.17-0.17 0.17-0.34 0.34-0.5h-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m54.34 500.79v0.34h0.67c0.17 0 0.17 0.17 0.34 0.34h0.34c0-0.17 0.17-0.34 0.17-0.67h-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m55.35 501.29q-0.17-0.17-0.34-0.34h-0.67v0.67c0.34-0.17 0.67-0.17 1.01-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m51.82 502.98h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m52.49 502.47v0.5c0.34 0 0.84 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m57.71 501.97s0.17 0 0 0c0.17 0 0.34 0 0.5-0.17s0.34-0.17 0.5-0.34h1.01c-0.17-0.17-0.34-0.17-0.67-0.34h-2.86c-0.17 0.34-0.17 0.5-0.5 0.84h0.84c0.17-0.17 0.17-0.34 0.34-0.34 0.17 0.34 0.5 0.34 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m58.04 501.29h1.01c0.17 0 0.34 0.17 0.67 0.34h0.34v-1.01h-0.67v-0.5h-1.35v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m60.06 501.46v0c0.5 0.17 1.01 0.17 1.51 0.17v-0.34h-1.01c-0.17 0-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m59.73 501.63h-1.01c-0.17 0-0.34 0.17-0.5 0.34 0.5-0.17 1.18 0.17 1.51-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m61.58 501.29v0.34h1.18v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m66.46 467.64c-0.17 0-0.34 0-0.5 0.17l-0.17 0.17s0 0.17 0.17 0.17h1.18c0.17 0 0.17 0.17 0.34 0.34h0.34c0-0.5 0.34-0.17 0.67-0.34h0.34v-0.34h-0.5c0-0.17-0.17-0.5-0.17-0.67-0.17 0-0.17 0.17-0.34 0.17-0.17 0.17-0.84 0.34-1.35 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m65.45 470.84c0 0.34 0.17 0.67 0.17 0.84h0.67v-1.85c0-0.17-0.17-0.17-0.17-0.34h-0.17c-0.17 0.5-0.34 0.84-0.5 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m65.95 469.66s0.17 0 0 0c0.17-0.17 0.34-0.17 0.34-0.34s0.17-0.34 0.17-0.5-0.17-0.34-0.17-0.67v-0.34h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m45.93 485.65c0.17 0.17 0.34 0.5 0.5 0.67 0.34 0.34 1.51 0.34 2.02 0h0.17c0-0.17 0.17-0.17 0.17-0.34 0 0-0.17 0-0.17-0.17-0.5 0.34-1.18 0.34-2.02 0.17 0.17-0.34 0.17-0.5 0.34-0.84 0-0.17-0.17-0.17-0.17-0.34-0.34 0.5-0.67 0.67-0.84 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m45.59 487.16c0.17 0 0.34 0.17 0.5 0.17 0.34 0 0.67-0.17 0.84-0.17h1.18v-0.34h-1.51c-0.17 0-0.34-0.17-0.34-0.17-0.5-0.17-0.84 0-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m46.27 486.49c0.17 0 0.34 0.17 0.34 0.17h1.51c0.34 0 0.34-0.17 0.34-0.34-0.5 0.34-1.68 0.34-2.02 0-0.17 0-0.17 0.17-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m45.93 485.65c0.17-0.17 0.5-0.34 0.67-0.5-0.17 0-0.17-0.17-0.34-0.17h-0.5c-0.34 0.34-0.34 0.5 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m46.27 484.81c0.17 0 0.17 0.17 0.34 0.17q0.17-0.17 0.34-0.34v-1.01c-0.5 0-0.67 0.17-0.67 0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m46.27 482.62v0.5h0.67c0.17 0 0.17-0.17 0.34-0.17q0-0.17 0.17-0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m47.28 482.79c-0.17 0-0.17 0.17-0.34 0.17v0.5h0.5v-0.5s-0.17 0-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m1.01 487.67q0 0.67 0.84 0.67h0.34c0.17-0.17 0.17-0.34 0.34-0.5 0 0-0.17 0-0.17-0.17h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m2.36 487.67s0.17 0 0.17 0.17l0.17-0.17v-0.84h-0.34v0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m66.29 471.68h-0.67v1.01c0 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m66.29 474.04q-0.17 0.17-0.34 0.34v0.5h1.35c0.34-0.17 0.5-0.5 0.34-0.84h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m65.95 474.54v-0.34c-0.17-0.17-0.34-0.5-0.67 0h-0.5c0 0.17 0.17 0.17 0.17 0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m66.29 473.36v0.34h1.18v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m67.47 473.7h-1.18v0.34h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m43.07 506h1.01c0.17-0.17 0.17-0.34 0.34-0.5h-1.35l-0.17 0.17c0 0.17-0.17 0.17-0.17 0.34 0.17-0.17 0.34-0.17 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m45.59 504.99h1.01c0.17 0 0.34-0.17 0.34-0.34h-1.35q0 0.17 0 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m44.42 505.33h0.84c0.17 0 0.17-0.17 0.34-0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m48.12 504.66v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m47.45 504.66v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m36.17 507.35v0.34h0.67c0.34-0.34 0.67-0.67 1.35-0.67v-0.5h2.36v-0.5h-0.34c-0.5 0.17-0.67 0.17-0.84-0.34h-0.67c-0.17 0.17-0.17 0.34-0.34 0.34h-0.84c-0.34 0-0.5 0-0.84 0.17-0.17 0.34-0.34 0.67-0.5 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m40.04 506.51h-1.85v0.5h1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m38.19 507.01c-0.5 0-1.01 0.17-1.35 0.67h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m83.28 493.22c-0.17-0.17-0.17-0.34-0.34-0.5h-0.5c0 0.34-0.17 0.34-0.34 0.34s-0.5 0-0.5 0.34 0.34 0.34 0.5 0.34h0.34q0.17-0.17 0.34-0.34c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m82.44 492.71h0.5l0.5-0.5c-0.17-0.17-0.17-0.34-0.34-0.34h-0.67c0.17 0.34 0.17 0.5 0 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m83.28 493.22c-0.17 0-0.34 0-0.5 0.17-0.17 0-0.17 0.17-0.34 0.34h0.67c0.17 0 0.17 0.17 0.34 0.34 0.17 0 0.17 0.17 0.34 0.17 0-0.34 0.17-0.67-0.34-0.84q0-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m4.21 488.67v1.18h1.35c-0.34-0.34-0.5-1.01-1.35-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m6.06 490.36c-0.17 0-0.17-0.17-0.34-0.17q-0.17 0.17-0.34 0.34v0.5h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m5.38 490.53q0.17-0.17 0.34-0.34c0-0.17-0.17-0.17-0.17-0.34h-0.67v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m6.06 490.36v0.5c0.34 0.17 0.5 0.17 0.84 0.34v-0.17c-0.17-0.17-0.34-0.5-0.5-0.67 0 0.17-0.17 0.17-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m5.38 497.93c0-0.17-0.17-0.17-0.17-0.34q0.17 0.17 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m46.1 487.33c0 0.34 0.17 0.67 0.17 0.84 0.17 0 0.34 0 0.5-0.17v-0.34c-0.17 0-0.17-0.5-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m46.77 488.17c-0.17 0-0.34 0-0.5 0.17 0 0.17-0.17 0.34-0.17 0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m46.1 487.33c0.5-0.17 0.5 0.34 0.67 0.34l0.17-0.17v-0.67c-0.34 0.34-0.67 0.34-0.84 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m52.49 474.54h-1.85v0.5c0.5-0.17 0.67 0.17 0.67 0.67h1.18v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m52.49 477.07q0.17-0.17 0.34-0.34c0-0.17-0.17-0.34-0.17-0.5h-1.18v0.5c0.34 0.34 0.67 0.34 1.01 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m51.48 476.73v-0.5h1.18c0-0.17-0.17-0.17-0.17-0.34h-1.18c0 0.34 0 0.5 0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m51.31 476.06h1.18v-0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m49.97 473.36c-0.5 0-0.67-0.17-0.67-0.67h-0.5v1.35h1.18v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m49.97 473.36v1.18h0.34v-0.84c0-0.17 0.17-0.34 0.34-0.34v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m48.79 472.69h0.5v-1.18h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m49.97 472.69v-1.01c-0.5 0-0.34 0.5-0.34 0.67s0 0.5 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m50.31 471.68v-0.67c-0.5 0-0.34 0.34-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m58.38 482.62c-0.34-0.17-0.67-0.17-0.84-0.17h-0.67v0.5c0.5 0 0.84 0.17 1.01 0.67 0 0.17 0.17 0.5 0.17 0.67 0 0.34 0 0.5 0.34 0.5v-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m56.87 482.62h0.67v-0.5c0-0.34 0.17-0.5 0.17-0.84v-0.34h-0.84c0 0.5 0.34 1.01 0 1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m58.38 482.62v2.36c0.17-0.17 0.17-0.5 0.34-0.67v-1.35c0-0.17 0-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m57.71 481.1c0 0.34-0.17 0.5-0.17 0.84v0.5h0.67c-0.17-0.34-0.34-0.84-0.5-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m71.5 482.28 0.5 0.5h0.34v-0.84c0-0.17 0.17-0.17 0.34-0.34 0-0.5-0.34-0.17-0.67-0.34-0.34 0.5-0.34 0.67-0.5 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m71.17 483.63v-1.01h-1.18v0.17c0.34 0.34 0.84 0.34 0.67 0.84h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m69.99 482.62h1.18s0-0.17 0.17-0.17l-0.17-0.17c-0.17-0.17-0.34-0.17-0.5-0.34h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m71.34 482.28 0.17 0.17c0.17-0.34 0.34-0.67 0.5-1.01 0 0 0-0.17-0.17-0.17h-0.34l-0.17 0.17c-0.17 0.17-0.17 0.5 0 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m72.85 484.81c0-0.34 0-0.84 0.34-1.18h-0.67v0.67c0 0.17 0 0.5 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m72.51 481.61c-0.17 0.17-0.34 0.17-0.34 0.34v0.84h0.17l0.17-0.17v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m71.84 483.96c0-0.5-0.34-0.17-0.67-0.34v0.67h0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m71.84 483.96v0.34h0.67v-0.67c-0.17 0.17-0.34 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m39.71 489.01v-2.52c0-0.17 0-0.34-0.34-0.34v0.84c0 0.34-0.17 0.67-0.17 0.84 0 0.34 0.17 0.5 0.17 0.84v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m39.37 486.49v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m38.7 485.98h0.67c0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m54.34 477.4h-3.03v0.67h3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m56.87 480.77c0.17-0.5-0.34-0.67-0.67-1.01-0.5-0.34-0.17-0.5 0-0.67h-0.5v1.68h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m55.02 479.08v-1.01h-0.67v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m55.69 480.77v-1.01h-0.34v0.34c-0.17 0.34-0.17 0.67-0.34 0.84 0.17-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m55.35 479.59c0-0.17 0.17-0.5-0.34-0.67-0.17 0.17-0.17 0.34-0.34 0.5 0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m50.64 473.36c-0.17 0.17-0.34 0.17-0.34 0.34v0.5c0.17-0.17 0.5-0.17 0.67-0.34v-0.67q-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m64.77 481.78c-0.5 0.5-0.67 0.84-0.17 1.35h0.67c0.34 0 0.67 0.17 1.01 0.34h0.34l0.5-0.5h-0.5c0-0.5-0.34-0.5-0.67-0.5h-0.67c0-0.34-0.34-0.5-0.5-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m63.43 482.62h0.34v-1.68c0-0.67 0-1.18-0.17-1.85 0 0.5-0.17 0.84-0.17 1.35v2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m64.77 481.78c0.17 0.17 0.5 0.34 0.67 0.5 0.17-0.17 0.5-0.17 0.67-0.34s0.34-0.17 0.5-0.34h-1.01c-0.17 0-0.17-0.17-0.34-0.34h-0.34c0 0.17-0.17 0.34-0.17 0.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m63.76 480.77v0.84c0.17 0 0.34-0.17 0.67-0.17v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m64.27 484.13c0 0.17 0 0.5 0.17 0.67h0.5v-0.5c0-0.17-0.17-0.34-0.17-0.5-0.17 0-0.34 0.17-0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m66.29 483.29c-0.34-0.17-0.67-0.17-1.01-0.34h-0.67c0 0.17 0 0.34 0.17 0.67h0.17c0.17-0.17 0.34-0.17 0.5-0.17 0.17-0.17 0.5-0.17 0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m64.94 483.63q-0.17 0 0 0c-0.17 0-0.17 0.17 0 0 0 0.34 0 0.5 0.17 0.67h0.67v-0.5c-0.34-0.17-0.67-0.17-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m64.44 480.77v0.67c0.17 0 0.17 0.17 0.34 0.17 0-0.17 0.17-0.17 0.17-0.34v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m25.74 488.34c0 0.5 0 1.01 0.17 1.51h0.34v-1.01c0-0.17 0.17-0.34 0.17-0.34 0.17 0 0.34 0.17 0.34 0.17 0.17 0 0.17 0.17 0.34 0.34v-0.84c-0.5 0-0.34-0.34-0.34-0.67-0.17 0.17-0.34 0.17-0.67 0.34 0 0.17-0.17 0.34-0.34 0.5 0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m26.08 484.81c-0.17 0.17-0.34 0.17-0.34 0.34v1.51h0.34v-1.18c0.17-0.34 0.17-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m26.25 486.49h-0.34v1.68q0.17-0.17 0.34-0.34v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m26.08 496.75h-2.19c0.17 0.17 0.17 0.34 0.34 0.5h1.18c0.17 0 0.34-0.17 0.5-0.17q0.17-0.17 0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m27.42 495.07h-0.17s-0.17 0-0.17 0.17c-0.17 0.17-0.17 0.34-0.34 0.34 0 0.34 0 0.84 0.17 1.18h1.18v-0.5h-0.34q-0.67 0-0.5-0.67c0.17-0.17 0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m26.75 496.75c0-0.34 0-0.84-0.17-1.18 0 0-0.17 0-0.17 0.17v1.01h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m26.58 496.75v-1.01c-0.17 0.17-0.34 0.17-0.34 0.34v0.84c0-0.17 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m24.4 497.26c-0.17-0.17-0.17-0.34-0.34-0.5q-0.17-0.17-0.34-0.34v0.84h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m39.71 489.01h-0.34v0.34c0 0.17 0.17 0.34 0.17 0.34h0.5c-0.17-0.17-0.34-0.5-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m81.26 502.98h0.67c0-0.17 0.17-0.34 0.17-0.34 0.67 0 1.35-0.5 2.02 0v-0.5h-0.17c-0.17-0.17-0.34-0.34-0.5-0.34h-0.34c-0.34 0.17-0.67 0.17-1.01 0.34-0.17 0.67-0.67 0.17-1.18 0.34 0.17-0.34 0.34-0.67 0.5-1.01-0.34 0.17-0.84-0.34-0.84 0.34 0 0.34 0.17 0.67 0.5 0.84 0.17 0.17 0.17 0.34 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m84.12 502.64c-0.67-0.5-1.35 0-2.02 0 0 0-0.17 0.17-0.17 0.34v0.34l0.5 0.5c-0.17 0.17-0.5 0.17-0.67 0.34v0.17h0.34c0.5 0 0.84-0.17 0.67-0.67 0-0.17 0.17-0.5 0.17-0.5 0.5-0.17 0.34 0.34 0.34 0.5h0.34c-0.17-0.5 0.34-0.5 0.5-0.84q0.17 0 0-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m81.26 502.98c0-0.17-0.17-0.34-0.17-0.34-0.34-0.17-0.5-0.34-0.5-0.84h-0.67v1.18c0.17 0.34 0.67 0.5 1.01 0.17 0.17 0 0.34 0 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m78.74 501.63c-0.34 0.34-0.67 0.67-1.01 0.84 0.17 0 0.34 0.17 0.67 0.17q0.17 0 0.34-0.17h0.67v-1.18c-0.17 0.17-0.34 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m79.41 501.97v0.67c0 0.34 0.17 0.5 0.5 0.5v-1.18h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m60.57 487.16s-0.17 0-0.17-0.17h-0.84c0-0.17-0.17-0.34-0.17-0.5h-0.5v1.68h0.67v-0.67h1.18v-0.34c-0.17 0.17-0.17 0-0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m58.04 486.82v-0.34h-1.18v1.01c0.17 0 0.17 0.17 0.34 0.17 0-0.17 0.17-0.34 0.17-0.5 0.17-0.17 0.34-0.34 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m58.04 486.82c-0.34 0-0.5 0.17-0.67 0.5 0 0.17-0.17 0.34-0.17 0.5h0.84c0.17-0.34 0.17-0.5 0.34-0.84v-0.17q-0.17 0.17-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m56.87 486.49h1.18v-0.67h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m58.21 486.99q0 0.17 0 0c0 0.5 0 0.84 0.17 1.18h0.34v-1.18h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m70.66 477.4c0-0.34 0.17-0.5 0.17-0.84 0 0 0-0.17-0.17-0.17h-0.67c0.17 0.5-0.34 0.5-0.67 0.5h-0.5v2.19h0.5v-1.85c0.5 0.17 1.01 0.17 1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m69.99 476.22h0.67v-1.18h-1.35c0 0.34-0.34 0.34-0.5 0.34v0.34h0.5c0.5-0.17 0.84 0 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m69.32 475.05h1.35v-0.34h-1.18q0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m66.63 468.82c0 0.17-0.17 0.34-0.17 0.5h1.85c0-0.5 0.34-0.34 0.67-0.34v-0.34h-0.67c-0.5 0-0.34-0.34-0.34-0.5h-0.34c0 0.17-0.17 0.34-0.17 0.5-0.34 0.17-0.67 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m68.98 472.36s-0.17 0 0 0q-0.34-0.17-0.5-0.34c-0.34 0-0.5 0.17-0.84 0.17v0.5c0.5-0.17 0.67 0.17 0.67 0.67h0.67c-0.17-0.34 0-0.67 0-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m68.81 469.16c-0.17 0-0.67-0.17-0.67 0.34 0.34 0 0.34 0.17 0.34 0.34v1.68h0.34v-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m68.98 472.36c0 0.34 0 0.67-0.17 1.01v0.67c0-0.17 0.17-0.17 0.17-0.34q0.17-0.17 0.34-0.34v-1.01q-0.17 0-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m68.81 467.64v0.34c0.5 0.34 0.17 0.5 0 0.84h0.5v-0.84c0-0.17-0.17-0.17-0.5-0.34q0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m68.81 471.35h-0.34c0 0.17 0 0.34-0.17 0.34v0.34c0.17 0 0.34 0.17 0.5 0.17v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m16.82 517.28h-1.18v0.5c0.34 0 0.84 0.17 1.18 0.17l0.17-0.17c-0.17-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m18 516.6c0 0.17 0 0.34-0.17 0.5l0.17 0.17h0.5v-0.84c0 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m18.68 517.28h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m16.49 518.29c-0.17 0-0.34 0.17-0.67 0.17v0.17h0.84q0-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m49.97 503.65h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m50.64 502.98v0.5c0.5 0.17 0.84 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m51.82 502.98v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m48.62 469.33h0.67v-0.67c-0.5 0-0.5 0.5-0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m47.11 470h0.34c0.17-0.17 0.17-0.34 0.34-0.5h-0.34c-0.5-0.17-0.34 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m56.53 502.13h-0.84c0.17-0.34 0.34-0.67 0.5-0.84h-0.84c-0.17 0.34-0.17 0.67-0.34 0.84 0.17 0 0.67-0.17 0.67 0.34 0.34 0 0.5 0 0.84 0.17q0.17-0.17 0.34-0.34-0.17 0-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m56.53 502.13s0.17 0 0.17 0.17c0.34-0.17 0.67-0.17 1.01-0.34-0.34 0-0.67-0.17-1.01-0.17 0 0.17 0 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m69.32 501.63h0.34q0.17-0.17 0.34-0.34v-0.67c-0.17 0-0.5-0.17-0.67-0.17-0.17-0.17-0.34-0.17-0.5-0.34h-0.67v0.5c0.17 0.17 0.5 0.34 0.67 0.67 0.17 0 0.5-0.17 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m68.81 501.29c-0.17-0.17-0.5-0.34-0.67-0.67-0.34 0-0.5 0-0.84 0.17 0 0.34-0.17 0.5-0.5 0.5h-0.5v0.34h1.68c0.34-0.17 0.67-0.17 0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m66.79 501.63h-2.02c-0.17 0-0.34-0.17-0.5-0.17h-0.17v0.5h2.69v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m26.92 476.22c0.17 0.17 0.17 0.34 0.34 0.5 0 0 0.17 0 0.17 0.17 0.17 0 0.5 0 0.67-0.17v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m51.31 477.4h1.18v-0.34c-0.34 0-0.67 0-1.01-0.34h-0.17v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m83.45 503.65c0-0.34 0.17-0.67-0.34-0.5-0.17 0-0.17 0.34-0.17 0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m16.15 519.63v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m15.48 518.96v-0.34c-0.34 0-0.67-0.17-0.67 0.34v0.5q0.17-0.17 0.34-0.34c0.17 0 0.34 0 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m28.43 474.71h0.84c0-0.17 0-0.5 0.17-0.67-0.67 0-1.01 0.17-1.01 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m20.19 516.1c-0.34-0.17-0.67-0.17-1.01-0.34-0.17 0.17-0.17 0.5-0.34 0.67-0.17 0.34 0 0.67 0.34 0.67-0.17-0.5 0.17-0.67 0.67-0.67 0.17 0 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m18 516.6c0.17 0 0.34-0.17 0.5-0.17 0.5-0.34 0-0.5-0.17-0.84h-0.5c0.17 0.5 0.17 0.67 0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m45.26 490.69h-1.85c-0.17 0-0.34 0.17-0.5 0.17l0.17 0.17h1.85q0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m43.07 491.03h-0.5v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m69.32 473.36q-0.17 0.17-0.34 0.34t-0.17 0.34v0.34c0.17 0.17 0.34 0.17 0.5 0.34v-0.34c0-0.34 0.17-0.5 0-1.01q0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m63.76 480.77h0.67v-0.5h0.5v-0.34h-0.5v-1.35c-0.34 0-0.34-0.17-0.34-0.34 0-0.34-0.17-0.5-0.34-0.84 0 0.5 0 1.01-0.17 1.51 0.17 0.67 0.17 1.18 0.17 1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m76.55 481.95h1.18c0.34 0 0.5-0.17 0.84-0.17q0.17-0.17 0.34-0.34s-0.17 0-0.17-0.17h-2.52c0.17 0.34-0.17 0.67 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m78.74 481.78c-0.34 0-0.5 0.17-0.84 0.17v0.34c0 0.17 0.17 0.34 0.17 0.34 0.34-0.17 0.5-0.34 0.84-0.34 0.34-0.34-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m78.07 482.62c0-0.17-0.17-0.34-0.17-0.34h-0.5c-0.17 0-0.17 0.17-0.34 0.34 0.17 0.17 0.17 0.34 0.34 0.5 0.17 0 0.5 0 0.67-0.17q0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m76.55 481.95c-0.5 0-0.34-0.34-0.34-0.5s-0.17-0.17-0.17-0.34h-0.17v1.18c0.34 0 0.67 0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m40.55 506v0.5h2.02v-0.5h-0.67c-0.17 0.34-0.67 0.34-1.18 0.17 0-0.17-0.17-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m40.04 506.51v0.5h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m2.36 486.99v-0.34c-0.17 0-0.34-0.17-0.67-0.17h-0.67c0 0.17 0 0.34-0.17 0.5h1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m64.94 484.81h-0.5v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m69.99 501.29q-0.17 0.17-0.34 0.34c0.5-0.17 0.84 0.17 1.35 0.34v-0.34q-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m71.5 481.27h0.34c0.17 0 0.5-0.17 0.67-0.17l0.17-0.17c0-0.17 0.17-0.5-0.34-0.5l-0.67-0.67h-2.19v0.34c0.34 0.17 0.67 0.17 1.01 0.34h0.17c0.5 0 0.67 0 0.67 0.5-0.17 0 0 0.17 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m69.32 479.59h2.19l0.67 0.67v-1.51c-0.17 0-0.34-0.17-0.34-0.17-0.17 0-0.17 0.17-0.34 0.17 0 0.17-0.17 0.34-0.17 0.5-0.17 0-0.5 0.17-0.5 0-0.34-0.5-0.84-0.5-1.35-0.5v0.34c-0.17 0.17-0.17 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m68.31 465.96c-0.34 0-0.67 0-1.01 0.17 0.17 0.17 0.5 0.34 0.67 0.67 0.17-0.34 0.34-0.5 0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m26.25 489.85h-0.34v0.34h1.85v-0.34c-0.5 0.17-1.01 0.17-1.51 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m46.27 480.77v0.34h2.52v-0.34c-0.84-0.17-1.68 0.17-2.52 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m46.77 481.1h-0.5v1.51h0.34c0-0.5 0.17-1.01 0.17-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m45.59 480.26v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m58.38 484.97c-0.34-0.17-0.34-0.34-0.34-0.5s-0.17-0.5-0.17-0.67c0 0.34 0.17 0.67-0.5 0.5l-0.5 0.5h0.67v0.5h0.5c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m40.55 491.03v-0.5h-0.5v1.01h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m42.57 491.7v-0.34h-1.01v-0.5c-0.17 0-0.17 0.17-0.34 0.17v0.5c0.5 0.17 0.84 0.17 1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m40.04 489.68h-0.5l-0.17 0.17v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m41.22 491.7v-0.5h-0.67v0.67c0.17-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m51.31 502.47h0.5v-3.53h-0.5v-1.68h-1.35v0.5h-1.18v-0.5h-0.67c-0.5 0.17-0.84-0.17-0.67-0.5h-0.67c-0.34 0-0.5-0.17-0.5-0.5v-1.68h-1.85c0-0.17 0-0.34-0.17-0.67h-0.67v0.5h-1.18v-0.5h-0.67c0.17 0.5-0.17 0.67-0.67 0.5h-0.67v-0.17c-0.17-0.17-0.17-0.34-0.34-0.5l-0.5 0.5v0.17h-0.5v1.18c0.17 0.5-0.17 0.67-0.67 0.67v1.01h0.67v0.5h2.52v-1.18h2.52v1.01h0.5v1.01h1.35v-0.5h0.84c0.17 0 0.17 0.17 0.34 0.34-0.17 0-0.17 0.17-0.34 0.17h-0.84v0.67c0.5-0.17 0.67 0.17 0.67 0.67h0.5v1.01h0.5c0.17 0.17 0.5 0.17 0.67 0.34 0-0.17 0-0.5 0.17-0.67l0.17-0.17c0.17 0 0.17 0.17 0.34 0.17v0.34h0.84c0.5 0 0.5 0.17 0.5 0.5-0.17 0-0.34 0-0.5 0.17 0 0.17 0 0.34-0.17 0.5q-1.01 0.17-1.18 1.18h-0.5v0.67h1.18v-0.5c-0.17-0.5 0.17-0.67 0.67-0.67h0.67c0-0.34 0.34-0.34 0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m49.97 502.98c-0.5-0.17-0.84 0.17-0.67 0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m14.81 518.96c0-0.5 0.34-0.34 0.67-0.34h0.34v-0.17h-1.68v0.84c0 0.17 0.17 0.17 0.17 0.34l0.17-0.17c0.17-0.17-0.17-0.5 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m14.81 518.96c-0.5 0-0.34 0.34-0.34 0.67h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m60.57 487.33v0.34h2.52v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m69.32 478.75c0.5 0 1.01 0 1.35 0.5h0.5c0.17-0.17 0.17-0.34 0.17-0.5-0.17 0-0.5-0.17-0.67-0.17v-0.67h-0.34v0.67h-1.01v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m70.66 477.91v0.67h0.5v-0.84q-0.17 0-0.5 0.17 0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m76.22 479.59v1.18h0.67v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m76.89 480.77h-0.67c0 0.17-0.17 0.17-0.17 0.34s0.17 0.17 0.17 0.34h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m72.51 485.31c0.17 0 0.34-0.17 0.5-0.17 0 0-0.17 0-0.17-0.17-0.34 0-0.67 0-0.67-0.34 0 0-0.17 0-0.34-0.17v0.84h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m71.84 484.47c0.17 0 0.34 0 0.34 0.17 0 0.5 0.34 0.5 0.67 0.34v-0.34c-0.5 0-0.34-0.34-0.34-0.5h-0.67v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m64.1 501.46c0.17-0.17 0.17-0.5 0.34-0.67h-2.02v0.5h0.34c0.34 0 0.67 0 1.01 0.17h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m63.93 501.46c-0.34 0-0.67 0-1.01-0.17v0.34c0.17-0.17 0.67-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m78.74 467.64h-0.67v0.34c-0.17 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m78.07 468.82v0.84q0.17-0.17 0.34-0.34v-0.67c0 0.17-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m50.98 474.04c-0.17 0.17-0.5 0.17-0.67 0.34v0.34h1.01c-0.17-0.34-0.17-0.5-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m46.1 476.9v1.18h0.67v-0.84c0-0.17-0.17-0.17-0.34-0.34q0-0.17-0.34 0c0.17-0.17 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m46.27 476.73h0.34v-1.68l-0.17-0.17s-0.17 0-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m65.62 476.73h-1.35c0 0.17 0.17 0.34 0.17 0.5h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m65.62 477.4h-1.18v0.67h0.5c0-0.5 0.5-0.17 0.67-0.34v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m64.94 477.91h-0.5v1.01h0.17c0.17-0.34 0.17-0.5 0.34-0.84v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m72.51 501.97c0.17-0.17 0.17-0.34 0.34-0.34h0.84c0.17 0 0.17-0.17 0.34-0.34h-2.86v0.34c0.17 0.17 0.5 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m71.17 501.63v-0.84c0-0.17 0.17-0.34 0.17-0.5q-0.17 0-0.34 0.17l-0.17 0.17c-0.17 0-0.17 0.17-0.34 0.17v0.5q0.17 0.17 0.34 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m71.84 501.97c-0.17-0.17-0.5-0.17-0.67-0.34 0 0.5 0.5 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m70.66 477.91c0.17-0.34 0-0.5 0-0.5h-1.35v0.67h1.01c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m46.27 480.26v0.5c0.84 0.17 1.68-0.17 2.52 0 0-0.34 0.17-0.5 0.5-0.5v-0.5h-1.18c0 0.17 0.17 0.5-0.34 0.5-0.17 0-0.34-0.17-0.34-0.34 0-0.5 0.34-0.17 0.67-0.34 0.17-0.5-0.17-0.67-0.67-0.67h-1.18v1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m46.94 488.67h-0.67c-0.17 0.34-0.17 0.67-0.34 0.84 0.34 0.34 0.5 0.34 1.01 0.34v-0.5h0.5c0-0.17 0.17-0.34 0.17-0.34l-0.17-0.17c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m45.26 489.68v1.01c0.17 0 0.17-0.17 0.34-0.17-0.17-0.34 0-0.67 0.34-0.84h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m65.62 476.73v0.67h1.18v-1.68h-1.85v0.67c0.5-0.17 0.84-0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m64.94 476.22v-0.67h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m42.57 505.84v0.5h0.5v-0.5l-0.17-0.17c-0.17 0.17-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m64.94 475.72h1.35v-0.67c0-0.17-0.17-0.17-0.17-0.34h-0.17c-0.34 0.17-0.67 0.17-1.01 0.34v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m64.94 475.05c0.34-0.17 0.67-0.17 1.01-0.34v-0.17h-1.01v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m64.94 484.81v0.5h-0.5c0 0.34-0.17 0.67-0.17 0.84 0 0.34 0.17 0.5 0.17 0.84h0.5v-0.67c0-0.5 0.17-0.5 0.5-0.5h0.34c0-0.17 0.17-0.17 0.17-0.34-0.34-0.17-0.34-0.5-0.34-0.84-0.17 0.17-0.34 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m64.94 486.99h-1.18v0.5h2.52v-0.84h-0.5c-0.17 0.17-0.5 0.34-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m46.27 479.08h0.67v-0.5h0.5c0-0.17 0.17-0.34 0.17-0.5l-0.17-0.17h-1.18v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m46.27 477.91c0-0.34 0-0.67-0.17-1.01 0 0.34-0.17 0.67-0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m6.06 492.71h0.5c0.17-0.34 0.34-0.5 0.34-0.67v-0.34h-0.84v0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m6.06 491.7h0.84v-0.34c-0.34-0.17-0.5-0.17-0.84-0.34v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m2.36 486.99h-1.35v0.5l0.17 0.17h1.35c-0.17-0.17-0.17-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m76.22 479.59h0.67v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m69.32 474.54c-0.17-0.17-0.34-0.17-0.5-0.34v1.18c0.17 0 0.5 0.17 0.5-0.34q0.17-0.17 0-0.5c0.17 0.17 0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m72.35 480.94c-0.17 0-0.5 0.17-0.67 0.17 0 0 0 0.17 0.17 0.17s0.67-0.17 0.67 0.34h0.5v-0.17c-0.17-0.17-0.34-0.34-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m73.02 481.61h-0.5v1.01c0.17 0 0.17-0.17 0.34-0.17 0.17-0.17 0.17-0.5 0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m46.44 475.05s0.17 0 0 0c0.34 0.17 0.67 0.17 0.84 0.17 0-0.17 0-0.34 0.17-0.34-0.17-0.34-0.17-0.5-0.5-0.5-0.17 0.17-0.34 0.34-0.5 0.34v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m46.44 474.71c0.17-0.17 0.34-0.34 0.5-0.34v-0.67h-0.67c0.17 0.34-0.34 0.67 0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m63.09 487.67h-3.7v1.51c0 1.01 0.17 0.84-0.67 0.84h-0.67c0 0.5 0 0.84 0.34 1.18 0.17 0.17 0.34 0.67 0.34 0.84-0.34 0.5-0.67 1.01-1.01 1.51-0.17 0.17-0.17 0.34-0.17 0.34v0.84h1.85v-1.85h0.67c0-0.34 0.17-0.5 0.5-0.5v-0.67h1.85v-0.67h-0.67c-0.34 0-0.67-0.17-0.5-0.5v-0.5h-0.5c-0.17-0.17-0.17-0.5-0.34-0.5-0.34-0.17-0.34-0.34-0.34-0.5 0.17-0.17 0.5-0.17 0.5-0.34 0-0.34 0.34-0.34 0.5-0.34h2.69v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m58.04 485.31h-1.85v2.19h0.67v-1.68h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m15.65 484.81c0 0.17 0 0.34-0.17 0.5q0 0.17-0.17 0.34t0.17 0.34h0.84c-0.17-0.34-0.17-0.5-0.34-0.84 0-0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m28.1 510.21v-0.84h-0.17c-0.17-0.17-0.34-0.34-0.5-0.67l0.34-0.34v-0.67c-0.34-0.34-0.34-0.67-0.34-1.18 0-0.17-0.17-0.34-0.17-0.5s0-0.34-0.34-0.34c-0.34 0.17-0.67 0.17-1.01 0.34v0.84c0.34 0 0.34 0.34 0.34 0.5s0 0.5-0.34 0.34c0 0.34 0.34 0.34 0.5 0.34 0.34 0 0.5 0.17 0.5 0.5v1.18c-0.67 0.17-1.18 0.34-1.85 0.5 0 0.17 0.17 0.17 0.17 0.34h1.01c0.5-0.34 1.01-0.5 1.85-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m25.91 507.01v-0.34c-0.17 0-0.5-0.17-0.67-0.17v-0.17c0.17 0 0.34 0 0.67-0.17-0.17-0.5-0.67-0.17-0.84-0.34v1.51c0 0.17-0.17 0.17-0.34 0.34h-0.34c-0.17 0.17-0.34 0.17-0.5 0.34 0.17 0.17 0.34 0.17 0.5 0.34 0.5-0.34 1.01-0.34 1.51-0.34v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m24.4 508.19c-0.17-0.17-0.34-0.17-0.5-0.34q0 0.17-0.17 0.34c-0.34 0.17-0.5 0.34-0.84 0.5 0 0.17 0.17 0.34 0.17 0.67h0.67c0.17 0 0.17-0.17 0.34-0.34 0-0.34 0.17-0.5 0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m23.05 509.37c0-0.17-0.17-0.34-0.17-0.67h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34h-0.67v0.34h0.67c0 0.17 0 0.34 0.17 0.67h1.51q-0.17-0.17-0.34-0.34c-0.34-0.17-0.5-0.34-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m23.05 509.37q0.17 0.17 0.34 0.34t0.34 0.34c0.17 0 0.67 0.17 0.67-0.34 0-0.17 0.17-0.67-0.34-0.67q-0.17 0.17-0.34 0.34h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m26.25 510.72h-1.01c0 0.17-0.17 0.34-0.17 0.67 0.5-0.17 1.01-0.34 1.18-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m21.54 509.37v-0.34h-0.84c-0.17 0-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m13.96 510.04q0.34 0.5 0.84 0.17c0.34-0.17 0.67-0.34 1.01-0.5l0.17 0.17v-0.5h-0.5l-0.5-0.5c0.17 0 0.34-0.17 0.5-0.17v-0.17q-0.67-0.17-0.34-0.67c0.17 0.17 0.34 0.5 0.5 0.67h0.67c0-0.34 0.34-0.34 0.5-0.34 0-0.17-0.17-0.67 0.34-0.67 0.34 0 0.5 0 0.84 0.17l0.17-0.17c-0.17-0.17-0.34-0.17-0.67-0.34-0.17 0-0.34-0.17-0.34-0.34-0.34 0-0.67-0.17-1.01 0.17h-0.5c-0.17 0-0.5-0.17-0.67-0.34v-0.67c-0.5 0-1.01 0-1.18 0.5 0 0-0.17 0-0.34 0.17h-0.34v0.17c0.17 0.17 0.17 0.34 0.34 0.34h1.01c-0.17 0.34-0.17 0.5-0.34 0.67v0.67c0.17 0.17 0.17 0.5 0.34 0.67-0.34 0.17-0.5 0.17-0.5 0.17 0 0.34 0 0.5 0.17 0.67q-0.17-0.17-0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m16.82 507.85c-0.17 0-0.5-0.17-0.5 0.34 0.17 0 0.5-0.17 0.5 0.34 0.17 0.17 0.5 0.34 0.67 0.5 0.17 0 0.34 0 0.5 0.17 0.17-0.34 0.34-0.5 0.67-0.34 0.17 0 0.17 0.34 0.17 0.5v0.84h0.17v-1.51h0.67c0.17 0 0.17-0.17 0.34-0.17q0.17-0.17 0.17-0.34v-0.17h-1.18q-0.17 0.17-0.34 0.34h1.01c-0.5 0.34-0.84 0.34-1.01 0-0.34 0.17-0.5 0.17-0.84 0.34q-0.17-0.17-0.34-0.34c-0.17-0.34-0.5-0.34-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m18 509.03c-0.17 0-0.34 0-0.5-0.17 0.17 0.17 0.17 0.34 0.34 0.5-0.67 0.34-0.84 0.17-1.01-0.5h-0.5v0.34c0 0.17 0.17 0.34 0.17 0.67h1.68c0-0.17 0.17-0.17 0.17-0.34-0.17-0.17-0.34-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m18 509.03c0.17 0.17 0.17 0.34 0.34 0.5h0.67v-0.34c0-0.17-0.17-0.5-0.17-0.5-0.5-0.17-0.84 0-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m19.85 508.7h-0.67v0.84c0.17 0 0.34 0 0.5 0.17 0.17-0.17 0.34-0.34 0.5-0.34h-0.67c0.17-0.34 0.34-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m16.15 509.37v-0.34c-0.34 0-0.84 0-0.84-0.5-0.17 0-0.34 0.17-0.5 0.17l0.5 0.5h0.5c0.17 0.17 0.34 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m18 509.87h-1.68c0.17 0.5 0.67 0.17 1.18 0.17 0.34 0.17 0.5 0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m13.96 510.04v-0.34c-0.17-0.17-0.34-0.17-0.5-0.34 0 0.34 0 0.67-0.17 1.18h0.34c0.17-0.17 0.17-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m13.63 510.55h-0.34v1.01h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m26.25 510.72s0.17 0 0.17 0.17c0.5-0.17 1.18-0.17 1.68-0.34v-0.34c-0.84-0.17-1.35 0-1.85 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m21.54 513.24h-0.67c0 0.34-0.17 0.67 0.34 0.5 0.17 0 0.17-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m19.68 515.43h0.84v-0.17c-0.34 0.17-0.5 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m13.29 511.56v-1.01c0-0.34 0-0.67 0.17-1.18 0-0.17-0.17-0.34-0.17-0.34-0.34-0.34-0.84-0.34-1.35-0.34 0 0.17-0.17 0.34-0.17 0.5h0.5c0.17 0.17 0.5 0.34 0.5 0.5 0.17 0.34-0.34 0.34-0.5 0.34 0 0.17-0.17 0.17-0.17 0.34v0.17c0.17 0 0.5-0.17 0.84-0.17v1.51c0 0.17 0 0.34 0.34 0.34v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m12.28 510.72v-0.17h-0.67v0.84h0.34c0-0.34 0.17-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m75.37 499.27c0-0.17 0.17-0.34 0.17-0.34 0-0.17-0.34-0.17-0.5-0.34 0.34-0.5 0.84-0.5 1.35-0.34l0.17-0.17v-0.67h-1.01c-0.17 0-0.34 0-0.5 0.17s-0.34 0.17-0.5 0.34q-0.17 0.17-0.34 0.34c0.17 0.17 0.34 0.5 0.5 0.67q0.17 0.17 0.34 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m75.04 501.46c0.34 0.17 0.84 0.17 1.35 0.34v-1.18c-0.17 0-0.34 0-0.67 0.17v-0.5c0-0.17-0.17-0.34-0.17-0.67 0 0.5 0 1.01 0.17 1.68-0.34 0-0.5 0-0.67 0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m76.22 500.62c0.5 0 0.84 0 1.35-0.17v-0.67c-0.5 0.17-0.84 0.17-1.35 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m76.55 498.26c0 0.5-0.17 0.84-0.84 0.84 0.5 0.34 1.01 0.34 1.51 0.17v-0.34c-0.67 0-0.17-0.5-0.34-0.84 0 0.17-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m75.37 499.27h-1.68q-0.17 0.17-0.34 0.34h2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m76.22 500.62v-0.34h-0.67v0.5c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m81.6 496.58c0.17 0 0.17 0.17 0.34 0.17h0.67c0.17 0 0.17 0.17 0.34 0.34s0.17 0.34 0.34 0.34h0.67v-1.01h-1.85c-0.17-0.17-0.34 0-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m83.79 497.26h-0.67c-0.17 0-0.17-0.17-0.34-0.34-0.17 0.17-0.34 0.17-0.34 0.34l0.17 0.17c0.5 0 1.01 0 1.35 0.34 0.17 0 0.34-0.5-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m82.27 500.96c0-0.17-0.17-0.34-0.17-0.5v-0.5h-0.34c0 0.17 0.17 0.67-0.34 0.67s-0.17-0.34-0.34-0.5c-0.17 0-0.34 0-0.34 0.17-0.17 0.34-0.17 0.67-0.34 1.01h0.84c0.34 0 0.5 0.17 0.5 0.34h0.17c0-0.34 0.17-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m81.6 501.46c0-0.34-0.17-0.5-0.5-0.34h-1.18l-0.17 0.17c0 0.34 0 0.5 0.17 0.84h0.67c0.17-0.5 0.5-0.17 0.84-0.34l0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m81.6 499.95h0.34c-0.17-0.17-0.17-0.34-0.34-0.34h-0.67v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m83.79 494.06c-0.17 0-0.17-0.17-0.34-0.17h-1.01c-0.17 0-0.5 0-0.67 0.17 0 0.17 0 0.34 0.17 0.5h1.18c0.17 0 0.5-0.17 0.67-0.17v-0.34q0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m83.79 494.4c-0.17 0-0.5 0.17-0.67 0.17v0.84h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m83.79 496.25c0.34 0 0.34-0.34 0.34-0.5s0-0.5-0.34-0.5v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m77.73 495.57v-2.52h-0.17v1.51h-1.35v1.18c0.67 0 0.17 0.67 0.5 0.84h0.34c0-0.17 0-0.5 0.17-0.67 0-0.17 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m75.04 497.76c0.17 0 0.34 0 0.5-0.17s0.17-0.17 0.34-0.34h0.67c0.5-0.17 0.84 0.34 1.01 0.5 0.17-0.17 0.34-0.17 0.5-0.17v-0.5h-2.19c-0.17 0-0.17-0.17-0.34-0.34-0.17 0-0.5-0.17-0.5 0.34v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m78.07 497.59c-0.17 0-0.34 0.17-0.5 0.17-0.17-0.17-0.5-0.67-1.01-0.5v1.01h0.34c0.17 0 0.34 0 0.5 0.17 0.17 0 0.5 0 0.67-0.17v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m76.89 497.09h1.18c0-0.17-0.17-0.17-0.17-0.34-0.17 0-0.17-0.17-0.34-0.17h-0.5l-0.17 0.17v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m77.22 496.58h0.5v-0.84c-0.17 0.17-0.34 0.17-0.34 0.34-0.17 0-0.17 0.17-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m79.92 493.89v0.67c0.17 0.34 0.17 0.5 0.34 0.84q0.17 0.17 0.34 0.34h0.67v-1.01h-0.17l-0.84-0.84q-0.17-0.17-0.34-0.34v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m81.26 495.57h-0.67c0.17 0.17 0.17 0.34 0.34 0.34h0.67v0.67q0.17-0.17 0.34-0.34v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m83.11 501.97h0.34v-0.5h0.84c-0.17-0.5-0.34-0.67-1.18-0.67-0.17 0.17-0.17 0.34-0.34 0.5 0 0.17 0.17 0.34 0.34 0.67v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m84.46 501.63c0.17 0.17 0.5 0.17 0.67 0.34v-0.5h-0.67v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m77.56 498.26c-0.17 0-0.34 0-0.5-0.17 0.17 0.34-0.34 0.67 0.34 0.84h0.34c-0.17-0.17-0.17-0.34-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m79.08 493.39h0.34v-1.01h-1.01v0.34c0.34 0 0.5 0.34 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m78.4 492.54v-0.34h-0.5c-0.34-0.34-0.67-0.17-1.01-0.34v0.34c0.17 0.17 0.5 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m77.73 493.05v1.51h0.34v-1.18c0-0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m77.56 492.54c-0.17-0.17-0.5-0.17-0.67-0.34-0.5 0-0.34 0.34-0.34 0.5h1.01v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m77.56 493.05c0.17-0.17 0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m84.46 501.63v-0.34h-0.84v0.5c0.17 0.17 0.34 0.34 0.5 0.34h0.17v0.5s0.17 0 0.17 0.17h0.34c-0.17-0.34-0.34-0.84-0.34-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m83.11 501.97v-0.34h-0.5v-0.17l-0.5-0.5c-0.17 0.17-0.17 0.34-0.34 0.34 0.17 0.34 0.17 0.5 0.34 0.84 0.5 0 0.67-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m79.41 493.39c0 0.34 0.34 0.34 0.5 0.34v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.82 497.26c-0.17 0.17-0.17 0.5-0.34 0.67v1.18c0.17 0 0.34 0 0.5 0.17 0.17 0 0.5-0.17 0.67-0.17v-0.84h0.67l0.17-0.17c-0.34 0-0.5-0.17-0.84-0.17v-0.5c-0.17-0.17-0.5-0.17-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m14.3 496.58v0.17q0 0.17-0.17 0.17c-0.5 0-0.5 0.34-0.5 0.67h0.5c0.17 0 0.17-0.17 0.34-0.17 0.5 0 0.67-0.34 0.67-0.67 0-0.17-0.17-0.34-0.17-0.34-0.34 0-0.5 0-0.84-0.17 0.17 0 0.17 0.17 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m15.48 496.58q0.17 0 0.34 0.17h0.84c0-0.34 0.17-0.5 0.17-0.84h-0.17c-0.17 0-0.34-0.17-0.5-0.17-0.34 0.17-0.5 0.17-0.84 0.34 0.17 0.17 0.17 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m14.3 499.27c-0.34 0.34-0.5 0-0.84 0v0.84h0.17l0.5 0.5v0.84c0-0.17 0.17-0.17 0.17-0.34 0.17-0.34 0.17-0.5 0.34-0.84-0.17-0.17-0.34-0.17-0.34-0.34-0.17-0.17 0-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m15.48 496.58v-0.67c0.34-0.17 0.67-0.17 0.84-0.34-0.17-0.17-0.34-0.34-0.5-0.34-0.17 0.17-0.5 0.17-0.67 0.34v0.34c0 0.17 0 0.34-0.17 0.34 0 0.17 0.17 0.34 0.17 0.34 0.17 0.17 0.34 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.48 499.27c-0.17 0-0.34 0.17-0.5 0.17-0.17 0.34-0.34 0.67-0.5 0.84h0.34q0.17-0.17 0.34-0.34t0.34-0.34v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m16.15 496.75h-0.34v0.67h0.84v-0.34c-0.17-0.17-0.5 0-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m14.3 497.59h-1.18v0.34h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m15.48 499.27v0.34c0.34 0 0.5 0 0.5-0.34 0 0-0.17-0.17-0.5 0q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m13.96 501.29v-0.84c-0.67 0.17-1.51 0-2.02 0.5 0.17 0.5 0.5 0.84 0.67 1.18h0.67v-0.67c0-0.17 0.17-0.17 0.34-0.34 0.17 0.17 0.34 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m11.78 501.97c-0.17-0.34-0.34-0.5-0.5-0.84-0.34 0-1.01-0.17-0.84 0.5 0.17 0.17 0.34 0.17 0.34 0.34v0.84h1.01v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m10.77 500.45c-0.17-0.17-0.34-0.17-0.34-0.34v-0.67c-0.34 0-0.34 0.34-0.34 0.5s0 0.5-0.34 0.34h-0.17v0.34c0 0.17 0.17 0.34 0.17 0.34h0.34c-0.17-0.5 0.17-0.67 0.67-0.5q0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m10.77 500.62c-0.5 0-0.84 0.17-0.67 0.67v0.34h0.34c0-0.67 0.5-0.5 0.84-0.5 0.17-0.34-0.17-0.5-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m11.78 501.97v1.18h0.17q0.17-0.17 0.34-0.34c0.17 0 0.17-0.17 0.34-0.17q-0.17-0.17-0.34-0.34c-0.17-0.17-0.34-0.34-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m12.45 502.13q0.17 0.17 0.34 0.34h0.34q0.17-0.17 0.34-0.34h-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m8.24 496.75c0-0.34-0.17-0.84-0.17-1.18h-0.5v0.34c0.34 0.34 0.34 0.5 0 0.67-0.17 0-0.17 0.17-0.34 0.17 0.5 0 0.17 0.34 0.34 0.67h0.17c0.17-0.34 0.34-0.5 0.5-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m8.24 496.75-0.5 0.5c0.5-0.17 0.84 0.17 0.67 0.67v0.34q0.17 0.17 0.34 0.34v-1.51s0-0.17-0.17-0.17c-0.17-0.17-0.34-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m7.07 494.23v0.34h0.17c0.5 0.17 0.67-0.17 0.67-0.67-0.17 0.17-0.5 0.17-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m7.4 495.57h0.5c0-0.67-0.17-0.84-0.84-0.84 0.17 0.34 0.34 0.67 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m7.4 495.57c-0.17-0.34-0.17-0.5-0.34-0.84h-0.17v0.67c0 0.17-0.17 0.67 0.34 0.67q0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m11.95 494.9c0.34 0.17 0.5 0 0.5-0.17v-0.67h2.19l0.17-0.17v-0.34c-0.34 0-0.67 0-1.18-0.17-0.34 0-0.67 0.17-0.84 0-0.5-0.17-0.67 0-1.01 0.17 0 0.17 0.17 0.34 0.17 0.5h-0.5c0.17 0.17 0.34 0.5 0.5 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m11.95 494.9c-0.17-0.34-0.34-0.67-0.5-0.84h-1.01v0.34h0.67v0.67h0.67c0-0.17 0.17-0.17 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m14.3 495.57h1.01v-0.84h-0.67q-0.17 0.17-0.34 0.34v0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m13.29 495.07c0.17-0.17 0.17-0.5 0.34-0.84h-1.01v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m13.29 495.07h-0.67v0.67h1.51v-0.34c-0.17-0.17-0.67 0.17-0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m14.64 494.73h0.34v-0.17c0-0.17 0-0.5-0.17-0.67l-0.17 0.17v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m14.3 495.07q0.17-0.17 0.34-0.34c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m12.62 491.03h0.34c0.17 0 0.34 0.17 0.34 0.34v0.67c0.17-0.17 0.34-0.17 0.34-0.34 0-0.34 0-0.67 0.5-0.67v-0.17h-0.67c0.17-0.17 0.17-0.5 0.34-0.67-0.34 0-0.84 0-1.18-0.17v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m13.63 493.39c0.34 0 0.67 0 1.18 0.17l0.17-0.17v-0.5c-0.34-0.17-0.5-0.34-0.67-0.34v-0.34h-1.18c-0.17 0.17-0.17 0.34-0.34 0.34h-0.84c0.34 0.5 1.01 0.34 1.35 0.17 0.5-0.17 0.5 0 0.84 0.17-0.34 0.17-0.34 0.34-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m14.47 490.53c0.17 0.34 0.17 0.5 0.34 0.84h0.67c0-0.5 0.34-0.34 0.67-0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m15.48 491.37h-0.67v0.34c0 0.17 0.17 0.34 0.17 0.5s0 0.34 0.17 0.34h0.34v-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m13.96 490.02c-0.17 0.17-0.17 0.34-0.34 0.67h0.67c0.17 0 0.17-0.17 0.34-0.17v-0.34c-0.17 0-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.14 492.21c0-0.17-0.17-0.34-0.17-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m6.06 493.39v-0.67h-2.19c0.17 0.17 0.17 0.34 0.34 0.67 0.5-0.17 0.84 0.17 0.67 0.67h1.18v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m7.07 494.23c-0.34-0.17-0.67-0.17-1.01-0.34-0.17 0.17-0.17 0.34-0.34 0.67 0.17 0 0.5-0.17 0.67-0.17 0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m14.64 485.31v-0.67c-0.5 0.17-0.67 0.17-1.18 0.34 0 0-0.17-0.17-0.17-0.34 0 0-0.17 0-0.17 0.17v0.67c0 0.5-0.17 0.84-0.67 0.84q-0.17 0.17-0.34 0.34v0.5h1.01c0-0.5 0.34-0.17 0.67-0.34 0.17 0 0.34-0.17 0.5-0.17 0 0 0.17 0 0.17-0.17-0.34-0.5-0.34-1.01 0.17-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m12.95 486.99h-1.01v-0.5c-0.34 0.34-0.34 0.67 0.17 0.84 0.17 0 0.17 0.17 0.17 0.34 0.17 0 0.34 0 0.5 0.17l0.17-0.17v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m12.28 486.32c0.5-0.17 0.67-0.5 0.67-0.84h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m15.14 496.25c0-0.17 0-0.34 0.17-0.34h-0.67c-0.17 0-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m12.95 487.67v0.67h0.67q0.17 1.01-1.01 1.01h-0.84c0.17 0.17 0.34 0.34 0.34 0.5 0.17 0 0.34 0 0.5 0.17 0.34 0 0.84 0 1.18 0.17l0.17-0.17c0-0.17 0.17-0.34 0.17-0.67 0-0.17 0.17-0.34 0.17-0.34 0.5 0 0.84-0.17 1.18-0.34 0 0 0-0.17 0.17-0.17l-0.5-0.5c-0.17 0.17-0.17 0.5-0.34 0.67-0.17 0-0.5-0.17-0.5-0.17 0-0.34 0.17-0.67 0.17-1.01s-0.17-0.67-0.17-0.84c-0.17 0-0.34 0.17-0.5 0.17-0.17 0.84 0 0.84-0.84 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m9.76 500.45c0.34 0 0.34-0.17 0.34-0.34s-0.17-0.5 0.34-0.5v-0.5c-0.17 0-0.5-0.17-0.67-0.17h-0.5v1.01h0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m9.25 499.11h0.5v-1.01h-0.5c0 0.34 0 0.67-0.17 0.84q0.17 0 0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m12.62 489.35q1.18 0 1.01-1.01h-0.67v0.34q0.17 0.17 0.34 0.34c-0.17 0-0.17 0.17-0.34 0.17h-0.34v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m12.62 489.35v-0.34q-0.17-0.17-0.34-0.34h-0.5v0.5c0.34 0.17 0.67 0.17 0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m12.28 488.67q0.17 0.17 0.34 0.34h0.34c0.17 0 0.17-0.17 0.34-0.17q-0.17-0.17-0.34-0.34c-0.17 0.17-0.34 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m13.63 493.39c0.17-0.17 0.17-0.34 0.34-0.5-0.17-0.17-0.34-0.34-0.84-0.17-0.34 0.17-1.01 0.34-1.35-0.17 0 0 0-0.17-0.17-0.17-0.5 0-0.84-0.17-1.35-0.17l-0.5 0.5v0.5h0.5c0.17 0.34 0.34 0.67 0.5 0.84h1.18c0-0.17-0.17-0.34-0.17-0.5 0.34-0.17 0.5-0.34 1.01-0.17h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m8.58 497.09v0.84h0.67v-0.67c-0.17 0-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m13.63 483.12c-0.17 0-0.34-0.17-0.67-0.34 0 0-0.17 0.17-0.17 0.34-0.17-0.17-0.5-0.17-0.67-0.17 0 0.17 0.17 0.5 0.17 0.67 0.17 0 0.34 0.17 0.5 0.17 0.67 0 1.01-0.17 0.84-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m12.45 485.31h0.67v-0.67c-0.67 0-0.84 0.17-0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m12.95 496.75h-0.34v0.67c0 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m12.95 496.75v0.84h0.67c0-0.34 0-0.67 0.5-0.67 0 0 0-0.17 0.17-0.17h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m78.4 492.21h1.01c0-0.34 0-0.67 0.5-0.67v-1.18c0-0.34 0-0.67-0.5-0.67 0.17 0.5-0.17 0.67-0.67 0.67h-1.18v0.5h0.5v0.5c0.17 0.5 0.34 0.67 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m78.74 490.53c0.5 0.17 0.67-0.17 0.67-0.67v-1.18h-0.67c0.17 0.5-0.17 0.67-0.67 0.67v0.67c0.67-0.17 0.84 0.17 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m80.08 487.67c0.5 0.17 0.67-0.17 0.67-0.67v-0.5c0.17-0.5-0.17-0.67-0.67-0.67v1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m80.08 490.53v0.5h0.67v-0.5h1.01c-0.17-0.17-0.34-0.5-0.5-0.67l-0.34 0.17c-0.5 0.17-0.67 0.34-0.84 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m81.6 490.53h-1.01v0.5h0.67v0.5h0.84v-0.34c-0.17 0-0.5 0.17-0.5-0.34 0-0.34 0.34-0.34 0.5-0.34v-0.17c-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m80.08 487.67v-1.68c-0.17 0.17-0.34 0.17-0.5 0.34v1.51c0-0.17 0.17-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m78.74 488.67h0.67v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m80.08 485.98c0.5-0.17 0.67 0.17 0.67 0.67h0.34c0-0.5 0-0.84-0.34-1.18h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m81.94 489.35v-0.5h-0.67c0 0.34 0.17 0.5 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m80.08 488.17h0.67c0.17 0 0.17-0.17 0.34-0.34h-0.67l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m78.74 483.12c0 0.5-0.17 0.67-0.67 0.67v0.67h1.35v-1.18c-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m79.41 484.3h-0.67v0.5s0.17 0 0.17 0.17c0 0 0.17 0 0.17-0.17 0.17-0.34 0.5-0.17 0.84-0.17h0.67v-0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m78.74 481.78c0 0.17 0.5 0.17 0.17 0.5v0.34c0.17-0.17 0.5-0.17 0.67-0.34v-0.34c0-0.17 0-0.34-0.17-0.5h-0.34c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m79.41 481.95v0.34c0 0.34 0.17 0.67 0.5 0.84v-1.01c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m78.74 482.62v-0.34c-0.34 0.17-0.5 0.34-0.84 0.34v0.34c0.17 0 0.34 0 0.5 0.17h0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m78.74 480.26v-0.67c-0.34 0-0.5-0.17-0.84-0.17h-0.17s0 0.17-0.17 0.17v0.67h0.5v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m78.74 480.26v1.18s0.17 0 0.17 0.17h0.34c0-0.34 0-0.84 0.17-1.18-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m77.9 479.42c0.34 0 0.5 0.17 0.84 0.17v-1.18h-0.34c0 0.34 0.34 1.01-0.5 1.01 0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m78.4 471.01c0 0.17-0.17 0.34-0.17 0.67v4.54h0.67q0.17-0.17 0.34-0.34c-0.5-0.17-0.5-0.67-0.17-1.01 0-0.67-0.17-1.35-0.17-1.85h-0.17c-0.17-0.17 0-1.35 0.17-1.51-0.34-0.17-0.34-0.34-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m78.74 476.22h-0.67v1.85h0.34c0.5 0 0.34-0.34 0.34-0.67v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m78.74 476.22v1.01h0.67v-1.51h-0.34c0 0.34-0.17 0.5-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m78.4 477.91h-0.34c0 0.5 0 0.84-0.17 1.35 0.84 0 0.34-0.5 0.5-0.84v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m78.74 471.51c-0.17 0.17-0.34 1.35-0.17 1.51h0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m79.92 484.64c-0.34 0.17-0.67-0.17-0.84 0.17 0.5 0 0.17 0.34 0.34 0.67h0.84v-0.67c0-0.17-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m79.92 484.64c0.17 0 0.17 0.17 0.34 0.17s0.17-0.17 0.34-0.17c-0.17-0.17-0.34 0-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m32.81 480.77h-1.18v1.01h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m31.63 480.77h0.84v-0.5h-0.67v-0.5h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34 0 0.17 0 0.5 0.17 0.67h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m33.82 481.95v-1.18h-0.67c0 0.34 0.5 0.67-0.17 1.01 0 0 0 0.17 0.17 0.17h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m32.98 481.78c0.67-0.34 0.17-0.67 0.17-1.01h-0.34v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m32.47 479.08c-0.5-0.17-0.67 0.17-0.67 0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m32.47 479.59h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m30.96 478.92c0-0.17-0.17-0.5-0.17-0.67-0.34 0-0.5 0-0.84-0.17h-0.34c0 0.34-0.17 0.5-0.17 0.84 0.17 0 0.17 0.17 0.34 0.17 0.5 0 0.5 0.17 0.5 0.5 0.17 0 0.17 0.17 0.34 0.17 0.17-0.17 0.34-0.5 0.5-0.67l-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m29.61 478.08h0.34v-1.01c0-0.17-0.17-0.17-0.34-0.34h-0.17c-0.34 0.17-0.5 0.5-0.84 0.67 0 0.17 0 0.34 0.17 0.5 0.17 0.17 0.5 0.17 0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m29.44 476.73h0.17c0.17 0 0.5-0.17 0.67-0.17-0.17-0.17-0.17-0.34-0.34-0.34s-0.5 0-0.5 0.5c-0.17-0.17 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m28.77 477.91c0-0.17 0-0.34-0.17-0.5-0.17 0-0.34 0-0.5-0.17v0.34c-0.17 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m30.96 479.08c-0.17 0.17-0.34 0.5-0.5 0.67 0 0.17 0.17 0.17 0.17 0.34h0.5c0.17-0.17 0.17-0.34 0.34-0.34-0.17-0.34-0.34-0.5-0.5-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m23.72 497.26h-0.5c0-0.34 0-0.84-0.34-1.01-0.17-0.17-0.67 0-0.84 0-0.17 0.34-0.17 0.5-0.34 0.84 0.17 0.17 0.34 0.17 0.5 0.34 0.17-0.34 0.34-0.17 0.34 0v0.84c0.17 0.17 0.34 0.17 0.5 0.34-0.17-0.5 0.17-0.67 0.67-0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m21.2 495.57h-0.67c-0.5 0-0.67-0.17-0.67-0.5h-0.5v0.5s-0.17 0-0.17-0.17c-0.17 0.17-0.34 0.34-0.5 0.34h0.5q0.84 0 0.67 0.67c0.34 0 0.67 0.17 0.84 0.17s0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m22.04 497.26c-0.17-0.17-0.34-0.17-0.5-0.34h-0.5c0 0.34 0 0.67-0.34 0.84 0.17 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.17 0.34 0.34 0.5 0.17 0 0.34 0.17 0.5 0.17v-0.5c0-0.17 0.17-0.5 0.17-0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m19.35 495.07h0.5c0.17-0.17 0.5-0.17 0.67-0.34s0.17-0.34 0.34-0.5v-1.01c-0.34 0-0.5-0.17-0.84-0.17v0.84h-1.35c0 0.34 0 0.5-0.17 0.84 0.17 0.17 0.5 0.34 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m21.87 494.23c0-0.17-0.17-0.5 0.34-0.67v-0.34c-0.17 0-0.5 0-0.67 0.17 0 0.34-0.17 0.5-0.17 0.84h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m21.2 494.23c0-0.34 0.17-0.5 0.17-0.84l-0.17-0.17h-0.34v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m21.03 491.03h-0.5c-0.34 0-0.84 0-0.67-0.5v-0.5h-0.67c0.17 0.17 0.17 0.5 0.34 0.67s0 0.67-0.34 0.67v0.34c0.5 0 0.67 0 0.67 0.5v0.34c0.34-0.17 0.84-0.17 1.18-0.34v-0.84q0.17-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m19.85 492.54v-0.34c0.17-0.5-0.17-0.67-0.67-0.5v0.67c0 0.34 0 0.67-0.17 0.84 0.17 0 0.34 0.17 0.5 0.17l0.17-0.17c0-0.17 0-0.34 0.17-0.34 0.17-0.17 0.17-0.34 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m20.02 492.71c0 0.17 0 0.34-0.17 0.34h0.17c0.34 0 0.5 0.17 0.84 0.17h0.34v-0.34c-0.17-0.17-0.17-0.34-0.34-0.34-0.34 0.17-0.67 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m21.2 493.05v0.34l0.17 0.17c0.17 0 0.5 0 0.67-0.17 0-0.34 0-0.67-0.17-0.84l-0.17 0.17c0.17 0.34-0.17 0.34-0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m18 488.17v-0.84c-0.67 0-0.84-0.34-0.67-0.84h-0.67c0.17 0.34-0.34 0.5-0.5 0.67 0 0.17 0.17 0.34 0.17 0.34v0.34l0.17 0.17c0.67 0.17 1.18 0.17 1.51 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m16.49 487.67c0-0.17-0.17-0.34-0.17-0.34q-0.17-0.17-0.34-0.34c-0.17-0.17-0.34-0.34-0.5-0.34h-1.01c0 0.17 0.17 0.34 0.17 0.5v0.34l0.17 0.17c0.17 0 0.5 0.17 0.5 0.17 0.67 0 1.01-0.17 1.18-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m15.48 485.98q-0.34-0.17-0.17-0.34s0.17-0.17 0.17-0.34h-0.67c-0.17 0.34-0.17 0.67-0.34 0.84h1.01v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m15.98 486.99q0.17 0.17 0.34 0.34c0.17-0.17 0.5-0.34 0.5-0.67-0.5-0.17-0.67 0.17-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m15.48 486.32h-1.01l-0.17 0.17s0.17 0 0.17 0.17h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m18 488.17h-1.35c0 0.34-0.17 0.5-0.5 0.5q0 0.67 0.67 0.67h0.17c0.34-0.17 0.5-0.17 0.84-0.34 0.17-0.17 0.17-0.5 0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m18 489.18c-0.34 0.17-0.5 0.17-0.84 0.34v0.5h1.01v-0.5c-0.17-0.17-0.17-0.34-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m19.35 489.85v-0.67h-0.67v0.67s0.17 0 0.17 0.17c0.17 0 0.34 0 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m18.68 489.85v-0.67h-0.5v0.5c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m19.85 490.53c-0.17 0.5 0.34 0.5 0.67 0.5-0.17-0.17-0.17-0.34-0.34-0.5h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m78.07 473.36v-1.68h-0.5v0.5c0 0.5-0.17 0.67-0.67 0.5v1.18c0.5 0.17 0.67 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m76.89 474.04v-0.34q-0.17 0.17-0.34 0.34v1.85c0 0.17 0 0.34 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m76.89 472.69c0.5 0.17 0.67 0 0.67-0.5v-0.5h-0.67v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m77.56 480.26v-0.67c-0.17-0.17-0.34-0.17-0.34-0.34v-1.35h-0.34v2.36h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m76.89 476.22v1.18h0.67v-1.01c-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m77.56 477.4h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m7.07 496.75c0.17 0 0.17-0.17 0.34-0.17 0.34-0.17 0.34-0.34 0-0.67 0 0.5-0.34 0.17-0.67 0.34 0 0.5-0.34 0.17-0.67 0.34v0.34c0.34-0.17 0.67-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m5.72 494.56c0.17-0.17 0.17-0.34 0.34-0.67h-1.51c0.17 0.34 0.17 0.5 0.34 0.84h0.5c0.17 0 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m4.21 493.39c-0.17-0.17-0.17-0.34-0.34-0.67h-0.67c0 0.34-0.17 0.5-0.17 0.84 0.17 0 0.34 0.17 0.5 0.17h0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m3.2 492.71h0.67v-0.5h-1.51q0.17 0.17 0.34 0.34c0.17 0 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m4.21 493.39v0.5h0.67c0.17-0.5-0.17-0.67-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m7.07 496.75h-1.01c-0.17 0-0.17 0.17-0.34 0.17v0.34c0.17 0.17 0.17 0.34 0.34 0.5h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m10.09 507.35h-0.34v0.5c0.34 0 0.5 0.17 0.67-0.34s0.67-0.17 1.01-0.34c0.17-0.5 0.17-1.01 0.34-1.35v-0.5c-0.34-0.17-0.67-0.17-1.01-0.34 0 0.5-0.17 1.01 0.34 1.35 0.17 0.17 0 0.34-0.34 0.34q-0.17 0.17-0.34 0.34l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m11.78 505.84c-0.17 0.5-0.17 1.01-0.34 1.35l0.17 0.17-0.5 0.5h0.67c0-0.34 0.34-0.34 0.5-0.34 0.34 0 0.84-0.17 1.18-0.17 0.34-0.17 0.5-0.17 0.5 0.17 0.17-0.17 0.17-0.34 0.34-0.67h-1.01c-0.17 0-0.17-0.17-0.34-0.34-0.17 0-0.34 0.17-0.5 0.17s-0.34-0.17-0.5-0.34c0 0 0-0.17-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m12.45 507.69c-0.17 0-0.5-0.17-0.5 0.34v0.34c0 0.17 0.17 0.34 0.17 0.5 0.5-0.17 0.84 0 1.35 0.34q0.17-0.17 0.34-0.34v-0.5h-1.35v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m11.44 510.55h0.67c0-0.17 0.17-0.17 0.17-0.34v-0.5h-0.5c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m11.78 509.54h0.5v0.5c0.17 0 0.67 0 0.5-0.34 0-0.17-0.34-0.34-0.5-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m12.11 508.7c0-0.17-0.17-0.34-0.17-0.5-0.5 0-0.34 0.5-0.34 0.67s0 0.5 0.34 0.34c0-0.17 0-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m46.94 473.7v0.67c0.34 0 0.5 0.17 0.5 0.5 0.17 0 0.17-0.17 0.34-0.17v-1.18c0-0.17 0.17-0.17 0.34-0.34 0 0 0.17 0 0.17-0.17-0.34 0-0.5-0.17-0.84-0.17h-0.34c0.17 0.17 0.17 0.34 0.34 0.34-0.17 0-0.34 0.17-0.5 0.17q0 0.17 0 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m46.94 473.36c0.17 0 0.34-0.17 0.5-0.17 0-0.17-0.17-0.17-0.34-0.34h0.34v-1.01l-0.34 0.34q-0.17 0.17-0.17 0.34v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m47.45 471.68v1.01c0.34 0 0.5 0.17 0.84 0.17 0 0.17 0 0.34 0.17 0.34h0.34v-0.67c-0.17-0.17-0.34-0.17-0.34-0.34v-0.84l-0.34-0.34c-0.17 0.5-0.5 0.5-0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m48.45 471.68v0.84c0 0.17 0.17 0.17 0.34 0.34v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m82.27 491.7c-0.17 0.34-0.17 0.67-0.17 1.01h0.5v-0.84c-0.17 0-0.34-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m82.27 490.69c-0.17 0-0.5-0.17-0.5 0.34 0 0.34 0.34 0.17 0.5 0.34-0.17-0.17 0-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m9.25 504.15h1.85v-0.5c-0.34 0-0.5-0.17-0.84-0.17s-0.67 0.17-1.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m10.43 501.63h-0.34c-0.17 0.17 0.17 0.67-0.34 0.67 0 0.34-0.17 0.5-0.17 0.84h1.18v-0.34c-0.17-0.17-0.34-0.17-0.34-0.34v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m11.1 503.65v0.5h0.67v-0.5q-0.17 0-0.34-0.17c0 0.17-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m11.44 503.65q0.17 0 0.34 0.17h0.17v-0.67h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m11.44 502.98h0.34v-0.34h-1.01v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m10.77 506.68c0.34 0 0.5-0.17 0.34-0.34-0.5-0.34-0.17-0.84-0.34-1.35h-0.5c0 0.34 0.17 0.67 0.17 0.84-0.17 0.17-0.17 0.34-0.34 0.67 0.34 0 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m10.43 507.01q0.17-0.17 0.34-0.34c0 0.17-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m10.09 507.35q0.17-0.17 0.34-0.34l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m10.09 506.51h-0.34l0.17 0.17c0.17 0 0.17-0.17 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m10.43 505.84c0-0.34-0.17-0.67-0.17-0.84h-0.17c-0.17 0.17-0.17 0.5-0.34 0.84h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m12.11 503.65h-0.17v0.5h-0.67v0.34h0.84c0-0.5 0.34-0.17 0.67-0.34 0 0 0-0.17 0.17-0.17-0.17-0.17-0.34-0.17-0.5-0.34h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m10.26 504.99h0.5c0.34 0.17 0.67 0.17 1.01 0.34v-0.67h-1.35q0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m10.43 504.66h1.35v0.67h0.17v-0.84h-0.84c-0.17 0-0.34 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m9.76 501.29c0-0.17-0.17-0.34-0.17-0.34q-0.17 0-0.34 0.17c0 0.5-0.5 0.17-0.67 0.34q-0.17 0.17-0.34 0.34c0 0.34 0.34 0.34 0.5 0.34s0.5 0 0.5 0.34c0.17 0 0.34 0 0.5-0.17v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m7.74 500.96v0.67h0.67v-0.34q-0.17-0.17-0.34-0.34h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m9.76 501.29c0 0.34 0 0.5-0.17 0.84l0.17 0.17c0.5 0 0.17-0.34 0.34-0.67v-0.34h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m26.75 483.12v0.17c0.17 0.17 0.5 0.17 0.67 0.34v-0.34c0-0.17 0.17-0.34 0.17-0.34v-0.67c0-0.17-0.17-0.17-0.17-0.34v-0.67h-0.5c0.17 0.67 0 1.35-0.17 1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m28.1 480.26c-0.34 0-0.5 0-0.84 0.17 0 0 0 0.17 0.17 0.17s0.5 0.17 0.67 0.17h0.67v-0.84c-0.34 0.17-0.5 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m28.1 480.26c0.17-0.17 0.5-0.17 0.67-0.34v-0.84h-0.34c-0.17 0.17 0.17 0.67-0.34 0.67v0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m27.42 480.6s0-0.17-0.17-0.17c-0.34 0.17-0.5 0.5-0.5 1.01h0.5c0.17-0.34 0.17-0.67 0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m28.1 479.93v-0.34c0-0.17 0.17-0.5-0.34-0.67v0.67c0 0.17 0.17 0.34 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m28.77 477.91v0.67c0 0.17 0 0.34-0.17 0.5 0.17 0 0.5-0.17 0.67-0.17 0-0.34 0.17-0.5 0.17-0.84-0.17 0-0.5 0-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m27.76 479.08c0.5 0 0.34 0.34 0.34 0.67 0.5 0 0.34-0.34 0.34-0.67v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m27.42 483.63c-0.17-0.17-0.5-0.17-0.67-0.34 0 0.5-0.17 0.84-0.17 1.35 0.17 0.5 0.5 0.17 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m27.42 484.97c-0.34-0.17-0.84 0.34-0.84-0.34h-0.34v0.5q0.17 0.17 0.34 0.34c0.17 0.17 0.17 0.34 0.17 0.34 0.17-0.17 0.17-0.34 0.34-0.5 0.17 0.17 0.17 0 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m14.47 486.32c0.17-0.34 0.34-0.67 0.5-1.01h-0.34c-0.5 0.17-0.5 0.67-0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m3.87 490.02c0 0.5 0 0.84 0.17 1.35h0.34v-1.51q-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m3.2 492.21h0.67c-0.17-0.17-0.17-0.34-0.34-0.5h-0.34v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m3.53 491.7c0.17 0.17 0.17 0.34 0.34 0.5v0.34h0.34q0.17-0.17 0.34-0.34c-0.17-0.17-0.17-0.34-0.34-0.67v-0.34h-0.34c0 0.17-0.17 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m33.31 485.98v-0.17s-0.17 0-0.17-0.17c-0.17 0-0.34-0.17-0.34-0.34v-0.67h-0.34c0.17 0.5-0.17 0.67-0.67 0.67v1.68h0.67v-0.5c0-0.5 0.17-0.67 0.67-0.5t0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m33.31 485.98h-0.34c-0.5 0-0.67 0.17-0.67 0.5v0.5h0.67c0.17-0.34 0.17-0.5 0.34-0.84v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m36.17 485.31s0-0.17-0.17-0.17c-0.5 0-1.01 0.34-1.35 0.67l0.17 0.17h1.18c0.17-0.17 0.17-0.5 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m33.48 486.15c-0.17 0.34-0.17 0.5-0.34 0.84h1.18c0-0.34-0.17-0.5-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m33.99 486.32c0 0.34 0.17 0.5 0.17 0.84h0.67v-1.01l-0.17-0.17c-0.17 0-0.34 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m34.15 484.81s0.17 0 0 0c0.17-0.17 0.34-0.34 0.34-0.5 0 0-0.17 0-0.17-0.17h-1.18v0.5c0.34 0.17 0.67 0.17 1.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m34.15 484.81c-0.34 0-0.67 0-1.01-0.17v0.84s0.17 0 0.17 0.17c0-0.17 0.17-0.5 0.17-0.67 0.17 0 0.5 0 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m35.84 484.3c0-0.34-0.17-0.5-0.5-0.34h-0.5v0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m34.49 484.3c0 0.17-0.17 0.34-0.17 0.34 0.34 0 0.67 0 0.67-0.5-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m33.14 484.3h1.18c-0.17-0.5 0.17-0.67 0.67-0.67v-0.67c-0.5 0.17-0.67-0.17-0.67-0.67v-0.5h-1.18v0.67h0.67q0.17 1.01-1.01 1.01h-0.34v0.67c0.17 0.17 0.34 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m36.17 485.31v0.5h0.67v-0.67c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m35 483.63c-0.5-0.17-0.67 0.17-0.67 0.67 0 0 0.17 0 0.17 0.17 0.17 0 0.34-0.17 0.34-0.17v-0.34q0.17-0.17 0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m38.19 485.98h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m37.52 486.49v-0.67h-1.35v0.67c0.17 0 0.5 0.17 0.67 0.17-0.17 0.17-0.17 0.34-0.34 0.34 0.17 0.17 0.17 0.34 0.34 0.5h0.67v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m38.19 485.98v0.67h0.5v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m73.19 485.98c0.17 0.5-0.17 0.67-0.67 0.67h-1.85v0.17c0.17 0 0.5-0.17 0.5 0.34h0.67c0.5-0.17 0.67 0.17 0.67 0.5h1.85v-0.67h-0.67v-1.18c-0.17 0-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m75.04 486.49h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m76.22 486.15c0 0.5-0.5 0.17-0.67 0.34v0.5h1.35c0-0.34 0-0.67-0.17-1.18l-0.17-0.17c0 0.34-0.17 0.5-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m76.55 485.81 0.17 0.17h1.35v-0.67h-1.51v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m70.66 486.49h1.85v-1.18h-1.85v0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m78.23 484.3v-0.67h-1.18v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m78.4 483.12c-0.17 0-0.34 0-0.5-0.17-0.17 0-0.5 0-0.67 0.17q-0.17 0.17-0.34 0.34h1.18l0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m76.89 484.3v-0.67h-0.34v1.35s0.17 0 0.17-0.17c0.17-0.17 0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m76.89 484.81s-0.17 0-0.17 0.17v0.5h1.51v-0.67h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m75.71 486.99v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m8.58 498.6q-0.17-0.17-0.34-0.34h-0.67v-0.84h-0.17c0 0.17 0 0.5-0.17 0.67-0.17 0-0.34 0.17-0.5 0.17v0.34c0.17 0 0.5 0.17 0.67 0.17 0.17 0.17 0.34 0.17 0.5 0.34 0-0.5 0.5-0.17 0.67-0.34v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m7.4 500.62s0.17 0 0 0h0.5c0.17-0.34-0.34-0.67 0.34-0.84v-0.34s0-0.17-0.17-0.17h-0.17c-0.34 0-0.5 0.17-0.5 0.5v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m7.91 499.44q0.17 0 0.34-0.17t0.34-0.34c0.17-0.17 0.34-0.17 0.5-0.17-0.17 0-0.34 0-0.5-0.17-0.17 0.17-0.67-0.17-0.67 0.34v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m7.91 500.79h-0.5q0 0.17 0.17 0.34h1.68q0.17 0 0.34-0.17v-0.34h-0.34c-0.17 0-0.5 0.17-0.67 0.17h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m6.73 498.26c0.17 0 0.34-0.17 0.5-0.17 0 0-0.17 0-0.17-0.17h-1.01c0 0.5 0.5 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m27.09 491.03h-0.34c-0.17 0.34-0.34 0.5-0.5 0.84h0.84v-0.17c0.17 0.17 0.34 0.17 0.5 0.17v-0.34c0-0.17-0.17-0.34-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m27.76 491.87c-0.17 0-0.34-0.17-0.5-0.17v0.67h1.35c-0.5-0.17-0.67-0.34-0.84-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m29.27 491.87v0.5c-0.34 0.17-0.5 0.17-0.67 0.34h1.18v-0.84h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m27.76 491.7v0.34h1.68v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m27.76 491.7h1.68c0-0.17 0.17-0.17 0.17-0.34s0-0.17-0.17-0.34c0-0.17-0.17-0.17-0.17-0.34h-0.5c0-0.5-0.34-0.5-0.67-0.5h-0.84c0 0.17-0.17 0.34-0.17 0.34 0 0.17 0.17 0.17 0.17 0.34 0.17 0.34 0.34 0.5 0.5 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m29.11 492.71h-0.34v1.68c0.34 0 0.34-0.17 0.34-0.34v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m29.11 492.71v1.35c0 0.17 0 0.34-0.34 0.34v0.17c0.17 0.17 0.5 0.17 0.67 0.34h0.17v-0.67c0-0.5 0.17-0.67 0.67-0.84l0.17-0.17c0-0.17 0-0.34 0.17-0.34-0.17 0-0.5 0.17-0.5-0.34-0.5 0.17-0.84 0.17-1.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m27.42 495.07v0.5c-0.34 0.67-0.17 0.67 0.5 0.67h0.34v-1.35c-0.5 0-0.67 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m28.1 494.9v1.35h0.84v-0.17c-0.5-0.34-0.17-0.67-0.17-0.84l-0.17-0.17c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m28.77 495.07c0.34 0.17 0.5 0.34 0.67 0.34v-0.34c-0.17-0.17-0.5-0.17-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m75.04 501.46v0c0.17-0.5 0.17-0.84 0.17-1.18h-0.67v1.18s0.17 0 0.17 0.17c0-0.17 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m77.56 500.45c-0.5 0-0.84 0.17-1.35 0.17v0.34c0.34 0 0.5 0 0.67 0.17h0.5c0.17-0.17 0.17-0.34 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m78.74 501.63c0-0.17 0.17-0.67-0.34-0.5-0.17 0-0.34 0.17-0.34 0.34 0.17 0.34 0.5 0 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m80.08 501.97c0-0.34 0-0.5-0.17-0.84-0.17 0-0.34 0.17-0.5 0.17v0.5c0.17 0.17 0.34 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m74.36 501.29v-0.67h-2.52v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m33.82 505.67h0.34c0-0.17 0.17-0.17 0.17-0.34s0.17-0.67-0.34-0.67-1.18 0.17-1.35-0.5h-1.35c0.17 0.17 0.34 0.34 0.67 0.5l0.67 0.67h0.5c0.17 0 0.34 0.17 0.67 0.34q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m31.8 506.51c-0.17-0.5 0.17-0.67 0.67-0.67v-0.34l-0.17-0.17c-0.17 0-0.34-0.17-0.5-0.17-0.34-0.17-0.67-0.67-1.18-0.5 0.17 0.5 0.34 0.84 0.5 1.35 0 0.17-0.17 0.34-0.34 0.34 0.17 0 0.17 0.17 0.34 0.17 0.34 0.17 0.5 0 0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m31.29 506.68c-0.17 0-0.17-0.17-0.34-0.17h-0.34c-0.17 0.17-0.17 0.34-0.34 0.5q0.17 0.17 0.34 0.34c-0.17 0.17-0.17 0.34-0.34 0.67v0.34c0.17 0 0.67 0.17 0.67-0.34v-0.67c0-0.17 0.17-0.17 0.34-0.34q0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m36.68 506c0.34 0 0.5 0 0.84-0.17v-0.34h-1.85v0.34c0.34 0.17 0.67 0.17 1.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m35.67 505.84v-0.34h-1.51c0.17 0.34 0.5 0.34 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m30.96 507.85c0 0.5-0.34 0.34-0.67 0.34q0 0.17-0.17 0.34h1.01c0-0.34 0.34-0.67-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m31.29 506.68v0.34h0.5c0.17 0 0.17-0.17 0.34-0.17q-0.17-0.17-0.34-0.34c-0.17 0-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m32.47 505.67v0.34c0.5 0 1.01 0.17 1.35-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m30.12 508.53q0-0.17 0.17-0.34v-0.34h-0.5c-0.34 0.34-0.5 0.17-1.01 0.17 0.17-0.17 0.17-0.34 0.34-0.5 0.17-0.34 0.17-0.5-0.17-0.5-0.17 0-0.34-0.17-0.34-0.17-0.17-0.17-0.34-0.34-0.67-0.5 0 0.5-0.17 1.01 0.34 1.18 0.34 0.17 0.34 0.34 0.34 0.67 0 0.17 0.17 0.17 0.34 0.34 0.34 0 0.34 0.17 0.34 0.34s0 0.5 0.34 0.5c0.17-0.17 0.34-0.5 0.5-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m28.77 508.53c-0.17-0.17-0.34-0.17-0.34-0.34 0-0.34 0-0.5-0.34-0.67-0.5-0.34-0.34-0.84-0.34-1.18h-0.34v0.5c0 0.5 0 0.84 0.34 1.18 0.17 0.17 0.34 0.17 0.34 0.34 0 0.5 0.34 0.5 0.67 0.5v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m28.77 508.7c-0.34 0-0.67 0-0.67-0.5l-0.34-0.34v1.18s0.17 0 0.17-0.17l0.5 0.5c0.5-0.17 0.17-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m28.43 509.37-0.5-0.5s-0.17 0-0.17 0.17v-0.5l-0.34 0.34c0.17 0.17 0.34 0.34 0.5 0.67h0.17v0.5c0.5-0.17 0.17-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m29.11 510.55c0.17-0.17 0.34-0.17 0.34-0.34v-0.67c-0.17 0.17-0.34 0.17-0.34 0.34-0.17 0.17 0 0.5 0 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m52.49 502.47h0.67v-2.36h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m55.69 502.47c0-0.5-0.34-0.17-0.67-0.34q-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m54.34 500.79h1.51c0.17-0.17 0.17-0.34 0.34-0.5h-1.85v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m53.17 500.28h1.18v-0.5h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m55.69 501.29h2.36v-0.67h-2.19c0 0.34-0.17 0.5-0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m53.17 500.28v-0.67c-0.5 0.17-0.67-0.17-0.67-0.5h-0.67v3.53h0.67v-2.36h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m55.86 500.62h2.19v-0.5h-1.85c0 0.34-0.17 0.5-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m58.04 500.28h1.35v-0.67h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m60.06 501.46c0.17 0 0.34-0.17 0.5-0.17v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m59.39 500.28v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m60.57 500.79v0.5h1.85v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m68.81 468.82c0.17-0.34 0.5-0.5 0-0.84h-0.34c-0.17 0.34-0.17 0.5-0.34 0.84h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m68.14 468.82c0.17-0.34 0.17-0.5 0.34-0.84-0.17 0-0.67-0.17-0.67 0.34 0 0.17-0.17 0.5 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m66.29 467.98v0.34h1.18c-0.17-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m67.47 469.33h-1.18c0 0.17-0.17 0.17-0.17 0.34s0.17 0.17 0.17 0.34h1.18v-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m67.47 470h-1.18v0.67h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m66.29 471.68v1.01h0.34v-0.67c0-0.17 0.17-0.34 0.17-0.5v-0.5h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m66.29 471.01h1.18v-0.5h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m67.47 468.32h-1.18c0 0.17 0.17 0.34 0.17 0.67 0.17 0 0.5 0 0.67-0.17 0.34-0.17 0.34-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m46.77 485.48c-0.17 0.17-0.17 0.5-0.34 0.84 0.84 0.17 1.35 0.17 2.02-0.17 0.17-0.5-0.17-0.67-0.5-0.84-0.34 0-0.67 0.17-1.18 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m46.77 485.48c0.34 0.17 0.67-0.17 1.01-0.34l0.17-0.17v-0.17c-0.34 0-0.67 0-1.18-0.17q-0.17 0.17-0.34 0.34c0.17 0.34 0.34 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m48.45 486.32c0 0.17 0 0.34-0.34 0.34v1.01h0.67v-1.18q-0.17 0-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m47.95 484.97q0 0.17 0 0c0.34 0.34 0.67 0.5 0.5 0.84 0 0 0.17 0 0.17 0.17l0.17-0.17v-0.5c0-0.5-0.5-0.17-0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m48.79 485.98c-0.17 0.17-0.17 0.34-0.17 0.34l0.17 0.17h0.5v-0.67c-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m48.12 487.67v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m47.45 487.67v-0.67h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m47.45 483.12v0.5h-0.5v0.5h1.18v-1.18c-0.17 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m48.12 484.3h-1.18v0.5c0.34 0 0.67 0 1.18 0.17l0.17-0.17c-0.17-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m46.77 481.1c0 0.5-0.17 1.01-0.17 1.35h0.84q0-0.17 0.17-0.34c0.17-0.17 0.17-0.34 0.34-0.34 0.34 0 1.01-0.34 1.18 0.34 0.17-0.17 0.34-0.17 0.34-0.34v-0.67c0-0.34-0.34-0.34-0.5-0.34-0.84 0.34-1.51 0.34-2.19 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m47.45 483.12h1.35v-0.5h-1.35q0 0.17-0.17 0.34s0.17 0 0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m66.63 472.69h-0.34v0.67h1.18v-0.5c-0.17 0-0.5 0-0.84-0.17 0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m66.12 474.71c0 0.17 0.17 0.17 0.17 0.34h1.18v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m67.13 474.71h0.34c0.67-0.17 0.17-0.5 0.34-0.84h-0.34c0.17 0.5 0 0.67-0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m67.47 473.87h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m40.21 506h0.34c-0.17-0.67 0.84-0.17 0.84-0.84 0.34 0.34 0.67 0.5 1.18 0.34 0.17 0 0.34 0 0.5-0.17l0.17-0.17c0.17-0.17 0.17-0.34 0.34-0.34h1.01v-0.34c-0.34-0.17-0.5-0.34-0.84-0.5-0.17 0.17-0.34 0.34-0.5 0.34-0.34 0-0.67 0-0.84-0.17-0.17 0-0.34-0.17-0.34-0.34s0.17-0.34 0.17-0.34c0.17 0 0.34 0.17 0.67 0.17 0.5-0.34 0.5-0.67 0-1.01v-0.17q-0.17 0-0.34-0.17c-0.17 0-0.17 0.17-0.34 0.17 0 0.5-0.17 0.67-0.67 0.67l-0.5 0.5c-0.34 0.5-0.84 0.84-1.51 0.84v0.67c0.17 0.5 0.67 0.17 0.67 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m42.9 505.33c-0.17 0-0.34 0-0.5 0.17-0.5 0.17-0.84 0.17-1.18-0.34 0 0.5-0.84 0.17-0.84 0.84h0.17c0.34 0 0.67 0 1.18-0.17h0.67c0.17 0 0.17-0.17 0.34-0.17s0.17-0.17 0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m44.42 504.99h-1.01c-0.17 0-0.17 0.17-0.34 0.34h1.35q0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m46.94 504.66v-0.5c-0.34 0-0.67 0-0.84-0.5 0 0-0.17 0-0.17-0.17h-0.34v1.01c0.5 0.17 0.84 0.17 1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m44.42 504.66v0.34h1.18v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m48.12 504.15v-1.18c0-0.5-0.17-0.67-0.67-0.67v1.68c0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m47.45 504.15v-1.68h-0.5v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m37.52 505.67v0.34h0.84c0.17 0 0.17-0.17 0.34-0.34-0.5 0-0.34-0.34-0.34-0.5h-0.17c-0.17 0.17-0.5 0.17-0.67 0.34v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m38.36 504.99c0 0.17-0.17 0.5 0.34 0.5h0.67v-0.67c-0.34 0-0.5 0-0.84-0.17 0 0.34-0.17 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m40.21 506c0-0.67-0.5-0.34-0.84-0.34 0.17 0.5 0.34 0.5 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m82.44 492.71h-1.18v0.5c0 0.17 0.17 0.5 0.17 0.67h0.5c0.17 0 0.5 0 0.67-0.17v-0.34h-0.34c-0.17 0-0.5 0-0.5-0.34s0.17-0.34 0.5-0.34c0 0.34 0.34 0.34 0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m82.61 493.55v0.34h1.01c-0.17-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m4.21 489.85v0.67h0.67v-0.67c-0.17 0.17-0.34 0-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m4.88 490.53h-0.67v0.5h0.67v0.5h1.18v-0.67h-0.67v-0.5c-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m47.45 487.67h-0.5l-0.17 0.17v0.34c0 0.17 0.17 0.34 0.17 0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m51.31 476.06v-0.34c0-0.5-0.17-0.67-0.67-0.67v1.01c0.17-0.17 0.5-0.17 0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m50.64 474.54h-0.67v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m51.31 476.06h-0.67c0 0.17 0.17 0.34 0.17 0.67 0.17 0 0.34 0.17 0.34 0.17 0.17-0.34 0.17-0.67 0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m49.97 474.54v-0.5h-1.18v0.34c0 0.17 0 0.34-0.17 0.5q0 0.17 0.17 0.34h0.5c0.17-0.34 0.5-0.5 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m48.79 473.36h-0.34c0 0.17-0.17 0.5 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m57.88 483.63c-0.17-0.5-0.5-0.67-1.01-0.67h-0.34q-0.17 0.17-0.34 0.34c-0.17 0-0.34 0-0.5 0.17 0 0 0 0.17 0.17 0.17h1.01c0.17-0.17 0.5-0.34 0.67 0q0.17 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m56.53 483.12h0.34v-0.5h-0.67v0.5h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m56.19 482.62h0.67c0.34-0.5-0.17-1.18 0-1.68h-1.18c0 0.17 0 0.5-0.17 0.5-0.17 0.17-0.5 0-0.67-0.34-0.17 0-0.34 0-0.5 0.17v0.84h1.85v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m71.84 484.47v-0.34h-0.67v-0.67h-1.18v0.5c0.17 0 0.34 0 0.67 0.17v0.5h1.18v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m69.99 483.63h0.67c0.17-0.5-0.34-0.67-0.67-0.84-0.17 0.17-0.5 0.17-0.67 0.34v0.67c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m69.32 483.12c0.17-0.17 0.5-0.17 0.67-0.34v-0.84h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m69.32 481.95h1.35v-0.67c0-0.17 0.17-0.67-0.34-0.67-0.34 0-0.67-0.17-0.67 0.5 0 0-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m70.66 481.44v0.67c0.17 0.17 0.34 0.17 0.5 0.34v-0.84c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m70.66 481.44h0.5l0.17-0.17c0-0.17-0.17-0.34-0.17-0.34 0-0.5-0.17-0.67-0.67-0.5h-0.17v0.5c0.5-0.17 0.34 0.17 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m38.7 486.49h-0.5v0.5h1.18v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m39.37 488.67c0-0.34-0.17-0.5-0.17-0.84 0 0.17-0.17 0.17-0.17 0.34l-0.5 0.5h0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m39.03 488c0.17-0.34 0.17-0.67 0.34-0.84h-0.67c0.17 0.17 0.17 0.5 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m39.37 488.67h-0.34c-0.17 0.17-0.17 0.34-0.34 0.5h0.67v-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m47.45 478.58h-0.5v0.5h0.5c0.5 0 0.84 0.17 0.67 0.67h0.67v-0.34c0-0.17 0.17-0.17 0.34-0.34 0 0.17 0.17 0.17 0.17 0.34v0.34q1.35 0 1.35 1.01v0.5h1.18v-1.68h0.67c-0.17-0.5 0.17-0.67 0.67-0.5h1.18v-1.01h-3.03v-0.67h-0.67v0.5c0 0.5-0.17 0.67-0.67 0.67h-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m54.68 479.59c0.17-0.17 0.17-0.34 0.34-0.5h-0.67v0.67q0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m54.34 481.1c0.17 0 0.34 0 0.5-0.17l0.17-0.17c0.17-0.34 0.17-0.67 0.34-0.84h-1.18c-0.34 0-0.67 0-0.84 0.34-0.17 0.17-0.34 0.17-0.5 0.34v0.17c0.5 0.17 1.01 0.34 1.51 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m55.02 480.94-0.17 0.17c0.17 0.34 0.5 0.34 0.67 0.34s0.17-0.34 0.17-0.5c-0.17-0.17-0.5-0.17-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m54.17 479.93h1.18v-0.34h-1.01c0 0.17-0.17 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m66.63 483.29h-0.34v0.84h0.5v0.5q0.17 0.17 0.34 0.34h0.17c0.17-0.34 0.5-0.34 0.84-0.34v-0.5c-0.5 0.17-0.67-0.17-0.67-0.67-0.34 0.17-0.67 0.34-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m66.63 481.61c-0.17 0.17-0.34 0.17-0.5 0.34-0.17 0.17-0.5 0.17-0.67 0.34h0.67c0.34 0 0.67 0 0.67 0.5h0.5v-1.01c-0.34-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m66.63 483.29c0.17 0.34 0.5 0.34 0.84 0.34v-0.84h-0.34l-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m64.94 480.26h-0.5v0.5h0.5v0.5h0.67v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m65.62 481.27h-0.34q0.17 0.17 0.34 0.34h1.01c0-0.17 0.17-0.17 0.17-0.34v-0.67h-0.5v0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m64.94 484.81h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m66.29 483.46c-0.34 0-0.67-0.17-1.01 0-0.17 0-0.34 0.17-0.5 0.17h0.84c0.17 0 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m66.29 483.46c-0.17 0-0.5 0.17-0.67 0.17v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m26.25 489.85h2.19q0.17-0.17 0.34-0.34h0.67v-0.34c-0.17-0.17-0.17-0.34-0.34-0.34h-1.01c-0.34 0.5-0.5 0.17-0.84 0q-0.17-0.17-0.34-0.34c-0.17 0-0.34-0.17-0.34-0.17-0.17 0-0.17 0.17-0.17 0.34-0.34 0.5-0.17 0.84-0.17 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m27.09 489.01c0.34 0.17 0.5 0.5 0.84 0 0.17-0.17 0.17-0.34 0.34-0.34h0.67v-0.5c-0.5-0.17-1.01 0.17-1.01-0.5 0 0-0.17 0-0.17 0.17 0 0.34-0.34 0.34-0.5 0.34-0.17 0.34-0.17 0.67-0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m26.25 486.49v1.35c0.17-0.17 0.34-0.17 0.67-0.34 0.17-0.17-0.17-0.67 0.34-0.67 0-0.34 0.17-0.5 0.17-0.84h-0.5c0 0.67-0.5 0.5-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m27.09 486.99c-0.5 0-0.17 0.34-0.34 0.67 0 0.17-0.17 0.5 0.34 0.67 0.17 0 0.5 0.17 0.5-0.34h-0.5v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m26.25 486.49c0.17 0 0.67 0.17 0.67-0.34 0 0 0-0.17-0.17-0.17 0-0.17-0.17-0.34-0.17-0.34q-0.17-0.17-0.34-0.34v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m26.58 496.75h-0.34c0 0.17-0.17 0.34-0.17 0.34l0.17 0.17c0.5 0 0.67 0.17 0.5 0.67h0.5c0-0.17 0.17-0.5 0.17-0.5 0.5 0 0.5-0.34 0.5-0.67h-1.35c0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m26.92 497.93c0-0.34 0-0.67-0.5-0.67l-0.17-0.17c-0.17 0-0.34 0.17-0.5 0.17v0.67h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m25.57 497.59v-0.34h-1.18v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m28.94 496.25h-0.84v0.5h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m24.4 497.59v-0.34h-0.67v0.67h0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m39.37 489.35h-0.67v0.5h0.67l0.17-0.17s-0.17-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m82.27 502.13c-0.17-0.34-0.17-0.5-0.34-0.84h-0.17l-0.17 0.17c-0.17 0.34-0.17 0.5-0.5 1.01 0.5 0 1.01 0.34 1.18-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m59.39 489.01v-0.84h-1.01v0.5c0.34 0.17 0.67 0.34 1.01 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m56.87 487.67h-0.67v0.67h0.67q0.17-0.17 0.34-0.34c-0.17-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m58.38 488.17c0-0.34 0-0.67-0.17-1.01-0.17 0.17-0.17 0.5-0.34 0.84h-0.67c0 0.17 0.17 0.17 0.17 0.34 0.5-0.17 0.67-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m57.54 488.17c0-0.17-0.17-0.17-0.17-0.34h-0.17q-0.17 0.17-0.34 0.34c0 0.34 0 0.67 0.5 0.5h0.5c-0.17-0.17-0.17-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m66.79 475.72v1.68c0.17 0.17 0.84-0.34 0.5 0.34 0 0 0 0.17 0.17 0.17h0.34c0.17 0.17 0.34 0.17 0.34 0.34v0.84h0.67v-2.19h0.5v-0.5h-1.18c-0.5 0-0.84-0.17-0.67-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m69.32 479.59v-0.67h-0.5v1.18c0.17 0 0.5 0.17 0.5-0.34v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m70.33 477.91h-1.01v0.67h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m69.32 476.22v0.5c0.34 0 0.84 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m66.79 475.72h2.02v-0.67h-2.52v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m69.32 476.22h0.67c0.17-0.5-0.17-0.67-0.67-0.67h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m67.47 469.33v0.34c0.17 0.17 0.5 0.17 0.67 0.34v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m68.14 475.05h0.67v-1.85h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m66.79 472.69h0.67v-1.01h-0.34c0 0.17 0 0.34-0.17 0.5 0 0.17 0 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m67.47 471.68v0.5c0.34 0 0.5-0.17 0.84-0.17v-0.34h-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m67.47 473.36h0.67c0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m68.14 469.33v1.85q0.17 0.17 0.34 0.34v-1.68c0-0.34 0-0.5-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m68.48 471.35q-0.17-0.17-0.34-0.34h-0.67v0.67c0.34 0 0.5 0 0.84 0.17 0.17-0.17 0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m51.31 502.47c-0.34 0-0.84 0-0.67 0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m67.47 500.79c0.34 0 0.5 0 0.84-0.17v-0.5h-1.85c0 0.34-0.17 0.34-0.5 0.34-0.17 0-0.34 0.17-0.5 0.17 0.5 0.17 1.35-0.17 2.02 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m68.14 500.28h0.67v-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m70.66 501.29v-0.5h-0.67v0.67c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m68.81 499.95v0.34c0.17 0.17 0.34 0.17 0.5 0.34v-1.01c-0.17 0.17-0.34 0.17-0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m69.99 500.79h0.67c0.17 0 0.17-0.17 0.34-0.17h-1.68c0.34 0 0.5 0 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m67.47 500.79c-0.67-0.34-1.35 0-2.02-0.17-0.17 0.17-0.17 0.34-0.34 0.5h1.85c0.34 0.17 0.5 0 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m66.29 501.29h-1.35c0.17-0.34 0.34-0.5 0.34-0.5h-0.84c0 0.17 0 0.5-0.17 0.67 0.17 0 0.34 0.17 0.5 0.17h1.51q0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m50.64 477.4h0.67v-0.5c-0.17 0-0.34-0.17-0.34-0.17-0.17 0.17-0.34 0.34-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m45.59 490.53c-0.17 0-0.17 0.17-0.34 0.17q-0.17 0.17-0.34 0.34v1.18h0.67c0-0.17-0.17-0.34-0.17-0.67h2.69v-0.67h-1.18v-0.5c-0.5 0.17-0.84 0.17-1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m44.92 492.21v-1.18h-1.85v0.5h1.35v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m44.42 492.21v-0.67h-1.85v0.5c-0.5 0-1.01 0-1.18 0.17s-0.17 0.67-0.17 1.01h1.35v0.67h1.18c-0.17-0.5 0.17-0.67 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m64.61 479.08c-0.17 0.34-0.17 0.5-0.17 0.84h0.5c0-0.17 0.17-0.17 0.17-0.34l-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m65.28 479.76c0 0.17-0.17 0.17-0.17 0.34v0.34h0.67v-0.84c-0.34-0.17-0.5 0-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m78.74 481.27v-0.67h-1.18v0.5c0.5 0.17 0.84 0.17 1.18 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m77.56 481.27v-0.5h-0.67v0.67c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m41.89 505.84c-0.34 0-0.67 0-1.18 0.17 0.34 0.34 1.01 0.34 1.18-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m69.32 479.93c0 0.34-0.34 0.34-0.5 0.34v0.5c0 0.34 0 0.67 0.5 0.67 0.17 0 0.34-0.17 0.34-0.17 0-0.5 0.34-0.34 0.67-0.5v-0.5c-0.34-0.17-0.67-0.17-1.01-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m28.43 489.85h-0.67v0.34h0.34c0.34 0 0.67 0 0.67 0.5h0.5v-0.67c-0.34 0-0.67 0-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m48.79 481.1c0.17 0 0.5-0.17 0.5 0.34h0.34v-0.5h-0.84v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m57.54 483.63c-0.17-0.34-0.5-0.17-0.67 0 0 0.34-0.17 0.34-0.34 0.34s-0.5 0.17-0.5-0.34c0 0 0-0.17-0.17-0.17-0.5-0.17-0.5 0.34-0.67 0.5 0.34 0.17 0.5 0.5 0.84 0.67h1.01l0.5-0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m56.87 484.81h-1.18v0.5h1.85v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m57.54 483.63c0 0.17-0.17 0.34-0.17 0.67 0.67 0.17 0.5-0.34 0.5-0.5q-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m40.04 491.7v-0.5h-0.67c0 0.17-0.17 0.17-0.17 0.34s0.17 0.17 0.17 0.34c0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m40.55 491.7h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m39.37 491.03h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m40.55 491.7v1.85h0.67c0-0.34 0-0.84 0.17-1.01s0.67-0.17 1.18-0.17v-0.5h-1.35c-0.17-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m39.37 490.02h-4.37v1.01h1.18c-0.17-0.5 0.34-0.5 0.67-0.5h2.52v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m47.45 502.47c0.5-0.17 0.67 0.17 0.67 0.67v0.5h0.5q0.17-1.01 1.18-1.18c0-0.17 0-0.34 0.17-0.5 0.17 0 0.34 0 0.5-0.17 0.17-0.34 0-0.5-0.5-0.5h-0.84v-0.34c0-0.17-0.17-0.17-0.34-0.17l-0.17 0.17c0 0.17-0.17 0.5-0.17 0.67-0.17-0.17-0.5-0.34-0.67-0.34h-0.5c0.17 0.34 0.17 0.84 0.17 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m41.22 493.39h-3.03c-0.5 0-0.84 0.17-0.67 0.67h1.85v0.67h0.5v-0.17l0.5-0.5c0.17 0.17 0.17 0.34 0.34 0.5v0.17h0.67c-0.17-0.67-0.17-1.01-0.17-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m44.42 493.39c-0.5-0.17-0.84 0.17-0.67 0.67h0.67c0 0.17 0 0.34 0.17 0.67h1.85v-1.18c-0.84-0.17-1.51-0.17-2.02-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m41.89 497.93h-0.67c0 0.34 0 0.67-0.5 0.67s-0.67-0.17-0.67-0.67h-0.67v1.18h2.52v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m39.37 495.57v-0.67c-0.17 0-0.34-0.17-0.34-0.17 0-0.5-0.34-0.34-0.5-0.34-0.17 0.17-0.34 0.34-0.34 0.5v2.36h0.5v-1.01c-0.17-0.5 0.17-0.67 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m38.19 495.07c0.17-0.17 0.17-0.34 0.34-0.5 0.17 0 0.5-0.17 0.5 0.34 0 0 0.17 0.17 0.34 0.17v-1.18h-1.85v1.18h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m46.27 494.56v1.68c0 0.34 0.17 0.5 0.5 0.5h0.67v-0.5h-0.5v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m41.89 497.26v0.67h2.52v-0.5c-0.84-0.17-1.68-0.17-2.52-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m41.89 497.26h2.52v-0.5h-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m41.22 493.39v1.18c0.34 0 0.84 0 0.67-0.5h0.67v-0.67h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m45.59 499.11h-0.67c0 0.34-0.17 0.84-0.17 1.18 0 0 0.17 0 0.17 0.17 0.17 0 0.34 0 0.5 0.17l0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m51.31 497.26v1.68h0.5v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m45.59 499.11v1.18h0.67v-1.35c-0.34 0-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m48.79 497.26v0.5h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m40.04 497.93c0 0.5 0.17 0.67 0.67 0.67s0.67-0.17 0.5-0.67h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m46.27 498.94h0.84c0.17 0 0.17-0.17 0.34-0.17q-0.17-0.17-0.34-0.34h-0.84v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m44.92 498.94v-1.01h-0.5v1.18c0.17-0.17 0.34 0 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m47.45 501.29v-1.01h-0.5v1.18c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m46.27 499.61v0.67h0.67c0-0.5-0.17-0.84-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m39.37 497.93v-0.5h-0.67v0.67c0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m50.64 497.26h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m50.64 497.26v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m48.12 497.26h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m48.12 497.26v-0.5h-0.67c-0.17 0.5 0.17 0.67 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m39.37 495.57c-0.5-0.17-0.67 0.17-0.67 0.67 0.5 0 0.67-0.17 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m76.89 480.77h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m71.84 484.81h-1.18v0.67h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m60.57 500.79h2.52v-0.5h-1.51c-0.34 0-0.34-0.17-0.34-0.34v-1.35h-0.67v1.68 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m63.09 500.28v0.5h1.35v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m47.28 475.22h-0.84v1.68c0.17 0.17 0.34 0.17 0.34 0.34v0.84h0.17v-0.5c0-0.17 0.17-0.34 0.34-0.5l0.68-0.68h-0.67c-0.17 0-0.5 0-0.5-0.17-0.17-0.17 0-0.34 0.34-0.5 0 0 0-0.17 0.17-0.17v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m67.3 477.74c0.34-0.67-0.34-0.34-0.5-0.34h-1.18v0.34q0.17 0.17 0.34 0.34l0.17 0.17h0.5c0.34-0.34 0.5-0.34 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m65.95 477.91q-0.17-0.17-0.34-0.34c-0.17 0-0.67-0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m66.79 478.08h-0.5c-0.34 0-0.84 0.17-1.18 0.17-0.17 0.34-0.17 0.5-0.34 0.84 0.17 0.17 0.34 0.34 0.5 0.67 0.17-0.17 0.34-0.17 0.5-0.34 0-0.17-0.17-0.5 0.34-0.5 0.34 0 0.34 0.17 0.34 0.34h0.34c0.17 0 0.34 0 0.5-0.17 0-0.34-0.17-0.84-0.5-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m64.94 478.24c0.34 0 0.84-0.17 1.18-0.17l-0.17-0.17h-1.01v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m71.84 501.29v-0.67h2.52v-0.5h-2.86c-0.17 0.17-0.17 0.34-0.17 0.5v0.5c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m71.5 500.28q0.17 0 0 0c0.34-0.17 0.5-0.17 0.67-0.34 0.17 0 0.34-0.17 0.5-0.17-0.5 0-1.01-0.17-1.51-0.17-0.17-0.34-0.17-0.5-0.34-0.84h0.84c0 0.17 0.17 0.34 0.17 0.5 0.84-0.67 1.35-0.84 2.19-0.5 0.17 0 0.34 0.17 0.5 0.17-0.17-0.17-0.34-0.5-0.5-0.67-0.34 0-0.67 0.17-1.01 0.17h-1.68c-0.17 0-0.17-0.17-0.34-0.34h-0.34c-0.34 0.34 0.17 0.67-0.5 0.84h-0.34c-0.34 0.17-0.67 0.17-0.67 0.67h1.68v0.67s0.17 0 0.17 0.17c0.34-0.17 0.5-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m71.17 500.28s-0.17 0-0.17-0.17h-1.68v0.34c0.5 0 1.18 0 1.85-0.17q0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m50.64 480.77q0-1.18-1.35-1.01v0.5h0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m49.97 480.77v-0.5h-0.67c-0.5 0-0.67 0.17-0.5 0.5h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m48.12 479.59c-0.17 0-0.67-0.17-0.67 0.34 0 0.17 0.17 0.34 0.34 0.34 0.5 0 0.17-0.34 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m49.3 479.59v-0.34c0-0.17-0.17-0.17-0.17-0.34q-0.17 0.17-0.34 0.34v0.34h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m45.59 490.53h1.35v-0.5c-0.34 0-0.67 0-1.01-0.34-0.34 0.17-0.5 0.5-0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m47.45 487.67v1.01l0.17 0.17s0.17 0 0.17-0.17 0.17-0.34 0.17-0.34v-0.84c0 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m47.95 488.84s-0.17 0-0.17 0.17-0.17 0.34-0.17 0.34v0.67h0.34c-0.17-0.5-0.17-0.84 0-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m47.45 490.02v-0.67h-0.5v0.5c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m64.94 486.99c0.34 0 0.5-0.17 0.84-0.17v-0.84h-0.34c-0.5 0-0.67 0-0.5 0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m65.78 485.98v0.84h0.84c-0.17-0.34-0.34-0.84-0.5-1.18h-0.17q0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m65.95 485.65c0.17 0 0.34-0.17 0.34-0.17v-0.67h-0.67c0 0.34 0 0.67 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m63.09 500.28h1.35v-1.01c0-0.17 0.17-0.17 0.17-0.17 0.17 0 0.17 0.17 0.34 0.17v0.34h1.85c-0.17-0.5 0.17-0.67 0.67-0.67v-1.18c-0.5 0.17-0.67-0.17-0.67-0.67v-1.01h-0.5v-0.5h-0.67v-1.18h-0.67v-2.36h0.67v-0.5h0.67v-1.85c0-0.34-0.17-0.5-0.5-0.34h-0.34c-0.17 0-0.5 0-0.5-0.34 0-0.17 0.34-0.34 0.5-0.34h2.69v-0.5h-1.35v-0.5h-1.85v0.34c0 0.17-0.17 0.17-0.17 0.34q-0.17-0.17-0.34-0.34v-0.34h-0.67v0.67h-2.69c-0.17 0-0.5 0-0.5 0.34 0 0.17-0.34 0.17-0.5 0.34 0 0.17 0 0.34 0.34 0.5 0.17 0 0.17 0.34 0.34 0.5h0.5v0.5c-0.17 0.34 0 0.5 0.5 0.5h0.67v0.67c0.5-0.17 0.67 0.17 0.67 0.67h0.67v1.68h-0.67v3.36c-0.34 0-0.5 0-0.67 0.17 0 0.17 0 0.34-0.17 0.5h-1.18v1.85c0 0.34 0.17 0.34 0.34 0.34h1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m66.29 487.67h1.18v-0.67c-0.17 0-0.5-0.17-0.67-0.17h-0.5v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m64.44 487.67v0.34c0 0.17 0.17 0.17 0.34 0.34 0-0.17 0.17-0.17 0.17-0.34v-0.34h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m47.45 478.58h1.85v-0.67h-0.84c-0.17 0-0.5 0.17-0.67 0.17-0.17 0.17-0.17 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m47.61 478.08c0.17 0 0.5-0.17 0.67-0.17v-0.34h-1.01v0.34c0.17 0.17 0.34 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m47.45 477.91v-1.01c-0.17 0.17-0.34 0.34-0.34 0.5v0.5q0.17 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m6.06 491.7h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m6.06 492.21h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m47.28 475.22v0.34h0.17c0.5 0 1.01-0.17 1.01-0.67-0.17 0-0.17-0.17-0.34-0.17h-0.34c-0.17 0-0.17 0.17-0.34 0.17 0 0 0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m56.19 488.17v-1.18h-0.5v-1.01h-1.35v-1.18h-0.67c0 0.17 0 0.34-0.17 0.5h-1.18v0.67c0 0.5-0.17 0.5-0.67 0.34 0-0.17-0.17-0.34-0.17-0.5h-1.85v1.68h0.67v2.36h-1.35v0.5h-0.5v0.5c0.17 0.17 0.17 0.34 0.34 0.67 0 0.17 0.17 0.34 0.17 0.67v1.68c0 0.34 0 0.67-0.5 0.67v0.5h1.85v0.5h1.68c0.17-0.17 0.17-0.5 0.17-0.84 0-0.17 0.17-0.34 0.17-0.17 0.17 0 0.34 0.17 0.34 0.17s0 0.17 0.17 0.34h1.35c0.5 0 1.01 0 1.35-0.17s0.5-0.34 0.84-0.34h0.67v-0.84c0-0.17 0.17-0.34 0.17-0.34 0.34-0.5 0.84-1.01 1.01-1.51 0.17-0.17 0-0.67-0.34-0.84-0.5-0.34-0.5-0.67-0.34-1.18h0.67v-0.67h-1.18c0.17 0.5-0.17 0.67-0.67 0.67-0.5 0.17-0.67-0.17-0.67-0.67 0.5-0.17 0.5-0.5 0.5-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m59.39 494.56h-1.35v1.68h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m60.57 492.21c-0.5 0-0.67 0.17-0.5 0.5v1.85h0.5v-1.35c0-0.34 0.17-0.5 0.5-0.5h1.35v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m60.57 492.21h1.85v0.5h0.67v-0.5c0.17-0.5-0.17-0.67-0.67-0.67h-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m57.54 489.35h1.18v0.67c0.84 0 0.67 0 0.67-0.84-0.34-0.17-0.67-0.17-1.01-0.34h-1.01c0.17 0.17 0.17 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m58.04 496.25v-1.68h-1.18v0.5c0.17 0 0.34 0 0.67 0.17v1.18c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m60.06 494.56v-1.85h-0.67v1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m54.34 484.81v1.18h1.35v1.01h0.5v-1.68h-0.5c-0.5 0.17-0.84-0.17-0.67-0.67-0.17 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m24.9 505.84c0.34 0.17 0.84-0.34 0.84 0.34 0.34-0.17 0.67-0.17 1.01-0.34v-0.5c0-0.17-0.17-0.17-0.34-0.34h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34-0.34 0-0.67 0.17-0.84 0.34v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m26.41 504.99c0.17 0.17 0.34 0.17 0.34 0.34v0.5c0.34 0 0.34 0.17 0.34 0.34s0.17 0.34 0.17 0.5v-2.19q-0.17 0-0.34-0.17s-0.17 0-0.17 0.17c-0.17 0-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m25.91 507.01v0.84c0.34 0 0.34-0.17 0.34-0.34 0-0.34 0-0.5-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m25.91 506.17c-0.17 0-0.34 0-0.67 0.17v0.17c0.17 0 0.5 0.17 0.67 0.17v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m23.72 507.85c0.34-0.17 0.5-0.17 0.67-0.34v-1.18h-0.67q0.17 0.17 0.34 0.34c-0.34 0.34-0.67 0.5-1.18 0.5l-0.17 0.17c0.17 0 0.34 0.17 0.34 0.17 0.17 0.17 0.34 0.34 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m24.9 505.84v-0.67h-0.34v1.18h0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m24.9 506.51h-0.34v1.01c0.17-0.17 0.34-0.17 0.34-0.34 0.17-0.17 0-0.5 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m24.56 507.52v-1.01h-0.34v1.18c0.17 0 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m19.85 508.7c-0.17 0.17-0.17 0.34-0.34 0.5h0.67c0.17-0.17 0.17-0.34 0.34-0.34h0.84c0.17-0.17 0.17-0.34 0.34-0.34h1.01c0.34-0.17 0.5-0.34 0.84-0.5h-2.19c-0.17 0-0.17 0.17-0.34 0.17s-0.17 0.17-0.34 0.34q-0.17-0.17-0.34-0.34s0-0.17-0.17-0.34c0 0.17-0.17 0.34-0.17 0.34 0.17 0.34 0 0.5-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m22.38 508.19h1.18q0-0.17 0.17-0.34c-0.17-0.17-0.34-0.17-0.67-0.34-0.17 0-0.34-0.17-0.34-0.17h-0.17c-0.17 0.34-0.17 0.5-0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m22.38 508.7h-0.67c-0.17 0-0.17 0.17-0.34 0.34h0.67c0.17 0 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m14.81 505.84v0.67c0.34 0.17 0.5 0.34 0.67 0.34h0.5c0.17-0.34 0.67-0.17 1.01-0.17l-0.17-0.17c-0.17-0.17-0.5-0.17-0.67-0.34q0.17-0.34 0.17-0.5c0-0.34-0.17-0.67-0.17-0.84h-0.34c-0.34 0.17-0.67 0.34-0.67 0.84 0 0 0.17 0.34-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m13.29 506.51c0.17 0 0.34 0 0.34-0.17 0.34-0.34 0.67-0.5 1.18-0.5v-0.5c-0.5-0.34-0.17-0.67 0-0.84h-0.5c-0.17 0.17-0.34 0.34-0.34 0.5 0 0.5-0.34 0.34-0.67 0.34 0.17 0.17 0.17 0.34 0.17 0.34 0 0.34 0 0.5-0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m16.99 506.68q0.17 0.17 0.34 0.34c0.17 0.17 0.34 0.17 0.67 0.34h0.34c0.17-0.17 0.17-0.34 0.34-0.34h0.84v-0.84c-0.5 0.17-0.84 0.5-1.18 0.5-0.5 0-0.67-0.17-0.67-0.84h-0.34c0 0.34 0.34 0.84-0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m13.29 506.51c0-0.34 0.17-0.5 0.17-0.84 0 0-0.17-0.17-0.17-0.34v-0.34h-0.34v0.67c-0.34-0.17-0.84 0.34-1.01-0.34h-0.17v0.5c0 0.17 0.17 0.34 0.17 0.67 0.17 0 0.17-0.17 0.34-0.17 0.34-0.17 0.5-0.17 0.67 0.17h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m15.48 508.53c0 0.5 0.34 0.5 0.84 0.5-0.17-0.5 0.17-0.5 0.5-0.5 0-0.5-0.34-0.17-0.5-0.34h-0.67l-0.17 0.34q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m13.63 508.7q-0.17 0.17-0.34 0.34c0 0.17 0.17 0.34 0.17 0.34 0.17 0.17 0.34 0.17 0.5 0.34 0-0.17 0-0.34-0.17-0.67 0 0 0.17 0 0.5-0.17-0.17-0.17-0.17-0.5-0.34-0.67 0 0.17 0.17 0.5-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m16.82 507.85c0.34 0.17 0.67 0.17 1.01 0.34v-0.67c-0.17 0-0.67 0.17-0.67-0.34-0.67 0.17-0.34 0.5-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m13.63 508.7c0.5 0 0.34-0.34 0.34-0.5v-0.67c0-0.34-0.17-0.34-0.5-0.17 0 0.34 0 0.5 0.17 0.84v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m12.95 506.51c-0.17-0.34-0.34-0.34-0.67-0.17-0.17 0-0.17 0.17-0.34 0.17 0.17 0.17 0.34 0.17 0.5 0.34 0.17 0 0.34 0 0.5-0.34v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m17.67 507.52v0.67q0.17 0.17 0.34 0.34c-0.17-0.5 0-0.84 0.34-1.18h-0.34l-0.34 0.17q0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m15.48 508.36q0-0.17 0 0c0-0.34-0.17-0.5-0.34-0.67-0.34 0.34-0.34 0.5 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m17.67 507.52 0.17-0.17c-0.34 0-0.5 0-0.84-0.17 0.17 0.67 0.5 0.34 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m19.35 507.85h1.18c0-0.34 0.5-0.34 0.67-0.34 0-0.17-0.17-0.5 0.34-0.5v-0.34h-0.84c0 0.17-0.17 0.34-0.17 0.67-0.17-0.17-0.34-0.17-0.67-0.34h-0.17v0.34c-0.17 0.17-0.34 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m19.35 507.85c0.17-0.17 0.17-0.34 0.34-0.67h-1.18c-0.17 0.34-0.34 0.67-0.34 1.18 0.34-0.17 0.5-0.17 0.84-0.34 0 0 0.17 0 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m21.2 507.52c-0.34 0-0.67 0-0.67 0.34v0.17q0 0.17 0.17 0.34c0 0.17 0.17 0.17 0.34 0.34q0.17-0.17 0.34-0.34c0.17 0 0.17-0.17 0.34-0.17h0.67l-0.5-0.5c-0.34 0-0.5 0-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m16.82 508.53c-0.34 0-0.67 0-0.5 0.5h0.5c0.17 0.67 0.34 0.67 1.01 0.5-0.17-0.17-0.17-0.34-0.34-0.5-0.34-0.17-0.5-0.34-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m19.01 508.19c0.17 0.34 0.5 0.34 1.01 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m73.19 498.43c0.34 0 0.67-0.17 1.01-0.17q0.17-0.17 0.34-0.34c-0.5 0-1.01 0-1.51-0.17h-1.68c0.17 0.17 0.17 0.34 0.34 0.34h0.84c0.5 0.17 0.5 0.34 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m73.19 497.93c0.5 0 1.01 0 1.51 0.17 0.17-0.17 0.34-0.17 0.5-0.34v-0.34h-1.01c-0.34 0-0.67 0.17-0.84 0.34q-0.17 0-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m74.7 498.94c-0.17 0-0.34-0.17-0.5-0.17l-0.5 0.5h1.35l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m76.55 497.59v-0.34h-0.67c-0.17 0-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m75.04 500.28v1.18h0.5c0-0.67 0-1.18-0.17-1.68h-0.34v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m73.69 499.27 0.5-0.5c-0.84-0.34-1.51-0.17-2.19 0.5 0-0.17-0.17-0.34-0.17-0.5h-0.84c0.17 0.34 0.17 0.5 0.34 0.84 0.5 0 1.01 0.17 1.51 0.17h0.34c0.17 0 0.17-0.17 0.34-0.17 0-0.17 0.17-0.17 0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m73.02 499.78c-0.17 0.17-0.17 0.34-0.17 0.5h2.19v-0.5h-0.67c-0.17 0.17-0.84 0.34-1.35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m73.02 499.78c0.34 0.34 1.18 0.17 1.35-0.17h-1.01s-0.17 0-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m81.94 495.57v0.67h1.85v-0.84h-0.67q-0.17 0.17-0.34 0.34c-0.17-0.17-0.5-0.17-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m81.6 499.95h-0.67c0 0.17-0.17 0.5 0.34 0.5s0.34-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m81.94 495.57h0.84v-1.01h-0.84c-0.17 0.17-0.34 0.17-0.34 0.34 0.17 0.17 0.34 0.5 0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m81.94 495.57c-0.17-0.34-0.17-0.5-0.34-0.84 0-0.17 0.17-0.17 0.34-0.34 0-0.17 0-0.34-0.17-0.5h-0.5c-0.34 0-0.5 0.17-0.84 0.17l0.5 0.5h0.17v1.01h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m82.94 494.56v1.01q0.17-0.17 0.34-0.34v-0.84c-0.17 0.17-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m76.22 495.57v-0.34q-0.84 0-0.84-0.84h-0.34v0.84h-0.67v1.01h1.01v-0.5c0.34-0.17 0.67-0.17 0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m75.37 494.56q0 0.84 0.84 0.84v-0.84c0-0.34 0-0.5-0.17-0.84h-0.5c0 0.34 0 0.5-0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m76.22 493.72c0 0.34 0 0.5 0.17 0.84h0.67v-1.18c-0.17 0-0.34 0-0.5-0.17 0 0-0.17 0-0.17 0.17q-0.17 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m76.89 493.39v1.18h0.67v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m76.89 493.39h0.67v-0.67h-1.01c0 0.17 0 0.34-0.17 0.5q0.34 0 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m76.89 496.75 0.17-0.17h-0.34c-0.34-0.17 0.17-0.84-0.5-0.84v0.84c0.34 0 0.5 0 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m75.04 497.09c0-0.34 0.34-0.34 0.5-0.34-0.17 0-0.17-0.17-0.34-0.17h-1.01c-0.17 0-0.17 0.17-0.34 0.17q0 0.17 0.17 0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m76.89 496.75c-0.17 0-0.5-0.17-0.67-0.17h-0.34c-0.17 0-0.17 0.17-0.34 0.17 0.17 0.17 0.17 0.34 0.34 0.34h1.01v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m75.04 497.09h-1.01v0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m80.59 494.23c0.34 0 0.5-0.17 0.84-0.17 0-0.17-0.17-0.5-0.17-0.67h-1.35v0.34q0.17 0.17 0.34 0.34c0.17 0 0.34 0 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m80.08 491.7c-0.67-0.17-0.5 0.34-0.5 0.67v0.5h1.18v-1.01c-0.34-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m80.59 492.71h-1.18v0.5h1.85v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m76.55 493.22c0-0.17 0-0.34 0.17-0.5 0-0.17-0.17-0.5 0.34-0.5v-0.34s0-0.17-0.17-0.17c-0.34 0.17-0.5 0.34-0.84 0.5v0.84c0 0.17 0.17 0.17 0.5 0.17q-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m76.89 491.7s0 0.17 0.17 0.17c0.34 0 0.67-0.17 1.01 0.34h0.5c-0.17-0.17-0.17-0.34-0.34-0.67h-0.5c-0.34 0.17-0.67 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m17.67 498.1-0.17 0.17v1.35h-0.17l-0.5 0.5h1.18c0.17 0 0.17-0.17 0.34-0.34 0-0.17 0-0.34-0.17-0.5 0-0.17-0.17-0.34-0.17-0.34h-0.34c0.17-0.17 0.17-0.34 0.34-0.5 0 0 0-0.17-0.17-0.17 0-0.17 0-0.34-0.17-0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m16.82 499.95 0.5-0.5h0.17v-0.5h-0.67c-0.17 0-0.5 0.17-0.67 0.17 0 0.34-0.17 0.34-0.5 0.34v0.67c0.34 0 0.84 0 1.18-0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m17.67 498.1v0c0.17-0.17 0.34-0.34 0.5-0.67h-1.35v0.5c0.34 0 0.5 0 0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m16.82 498.94h0.67v-0.84h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m19.35 495.07c-0.34-0.17-0.5-0.34-0.84-0.34l-0.17-0.17h-0.84v0.5c0.17 0.5-0.34 0.67-0.5 0.84h0.17c0.17 0 0.34 0.17 0.5 0.17 0 0.17-0.17 0.34-0.17 0.5 0 0 0 0.17-0.17 0.17 0.17 0 0.34 0 0.5 0.17h0.34l0.17-0.17c-0.17-0.34 0.17-0.5 0.5-0.84 0.17-0.17 0.34-0.34 0.5-0.34 0 0 0.17 0 0.17 0.17-0.34-0.34-0.34-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m16.82 495.91c0.17-0.34 0.67-0.34 0.5-0.84h-1.18c0 0.17-0.17 0.17-0.17 0.34 0.17 0.17 0.34 0.34 0.5 0.34 0 0 0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m17.67 496.92c-0.17 0-0.34 0-0.5-0.17h-0.84c0 0.5 0.34 0.17 0.5 0.34 0.17-0.17 0.5-0.17 0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m16.66 496.75h0.34s0-0.17 0.17-0.17c0-0.17 0.17-0.34 0.17-0.5-0.17 0-0.34-0.17-0.5-0.17 0 0.34 0 0.5-0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m13.29 502.13q-0.17 0.17-0.34 0.34v0.5h0.34c0.17-0.17 0.17-0.34 0.34-0.34h0.84c0.17 0 0.17-0.17 0.34-0.17 0-0.34 0.17-0.34 0.34-0.34s0.5-0.17 0.67-0.34c0.34-0.17 0.5-0.34 0.84-0.67v-0.34h-0.5q-0.17 0-0.34 0.17c-0.17 0.34-0.5 0.5-1.01 0.5q-0.17-0.17-0.34-0.34t-0.34-0.34c0 0.17-0.17 0.17-0.17 0.34h-0.34v0.67c0 0.17-0.17 0.34-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m14.3 500.96q0.17 0.17 0.34 0.34t0.34 0.34v-1.35h-0.34c-0.17 0.17-0.34 0.5-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m15.98 495.4c0-0.17 0.17-0.17 0.17-0.34s0.17-0.34 0.17-0.5h-0.5c-0.17 0-0.17 0.17-0.34 0.17 0.17 0.17 0.34 0.34 0.5 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m15.82 495.4c-0.17-0.17-0.17-0.34-0.34-0.5h-0.34v0.84c0.34-0.17 0.5-0.34 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m14.81 500.28v0.5h0.34c0.34 0 0.5-0.17 0.84-0.17h0.67v-0.34h-1.18v-0.67q-0.17 0.17-0.34 0.34l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m17.67 496.92c-0.34 0-0.5 0.17-0.84 0.17v0.34h1.35c-0.17 0.34-0.17 0.5-0.34 0.67h0.17c0.17 0 0.34 0 0.5-0.17 0-0.17 0.17-0.17 0.17-0.34v-0.5c-0.34-0.17-0.5-0.17-0.67-0.34-0.17 0-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m13.29 502.13c0.17-0.17 0.34-0.17 0.34-0.34v-0.67c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m10.43 501.63v0.84c0 0.17 0.17 0.17 0.34 0.34v-0.84c0-0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m9.25 500.45h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m12.95 502.98v-0.5h-0.34c-0.17 0-0.17 0.17-0.34 0.17s-0.17 0.17-0.34 0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m7.07 497.93s0.17 0 0.17 0.17c0-0.17 0-0.5 0.17-0.67-0.17-0.17 0.17-0.67-0.34-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m7.57 497.26v0.84h0.67v-0.34c0.17-0.34 0-0.5-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m8.58 498.77c0.17 0 0.34 0 0.5 0.17h0.17c0-0.34 0-0.67 0.17-0.84h-0.67c0 0.17 0 0.34-0.17 0.67q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m15.14 494.73h0.34c0.17 0 0.17-0.17 0.34-0.17h0.34v-0.67s0-0.17-0.17-0.17c0 0-0.17 0-0.17-0.17h-1.01v0.17c0 0.17 0 0.5 0.17 0.67 0 0.17 0.17 0.34 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m14.81 493.55h1.01v-0.34h-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m15.14 494.73c-0.17 0-0.17-0.17-0.34-0.17v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m14.81 493.39h0.67v-0.67h-1.35c0.17 0.17 0.34 0.17 0.67 0.34v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m14.3 492.54h1.01c0-0.17 0-0.34-0.17-0.34-0.34 0-0.5 0-0.84 0.34q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m15.48 491.37v0.84c0.34 0 0.67 0 1.01-0.17v-0.34l-0.17-0.17c0-0.17-0.17-0.34-0.17-0.5-0.17 0-0.67-0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m16.15 491.03c0 0.17 0.17 0.34 0.17 0.5v-0.84c0-0.17 0.17-0.17 0.34-0.34 0.5 0 0.34-0.34 0.34-0.67h-0.84v1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m14.64 490.19v0.34h1.01v-0.67h-0.67l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m15.48 489.85v0.67h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m16.66 492.04c-0.34 0-0.67 0-1.01 0.17v0.5h0.67v0.5h0.5c0-0.34 0-0.67-0.17-1.18q0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m14.64 490.19q0.17-0.17 0.34-0.34c0.17-0.5-0.17-0.67-0.67-0.67 0 0.17-0.17 0.34-0.17 0.67 0 0.17 0.34 0.34 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m5.38 492.71v-0.17h-1.51v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m12.95 487.67c0.67 0 0.67 0.17 0.67-0.84-0.17 0-0.67-0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m14.64 486.49q-0.17 0 0 0c-0.17-0.17-0.34 0-0.34 0 0 0.34 0.17 0.67 0.17 0.84h0.5v-0.34c-0.17-0.17-0.34-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m15.48 489.85h1.51v-0.5h-0.17q-0.67 0-0.67-0.67l-0.17-0.17h-0.34s0 0.17-0.17 0.17v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m14.81 487.5h-0.5c0 0.34-0.17 0.67-0.17 1.01 0 0 0.34 0.17 0.5 0.17 0.17-0.34 0.34-0.5 0.34-0.67v-0.34s0-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.14 487.67v0.34l0.5 0.5h0.34l0.5-0.5v-0.34c-0.34 0-0.5 0.17-0.84 0.17-0.17 0-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m15.48 489.85v-1.18c-0.34 0.17-0.67 0.34-1.18 0.34 0 0-0.17 0.17-0.17 0.34 0.5-0.17 0.67 0.17 0.67 0.67 0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m9.25 498.77q-0.17 0 0 0c-0.34 0-0.5 0.17-0.67 0.17s-0.17 0.17-0.34 0.34h1.01v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m9.25 499.27h-1.01l-0.17 0.17s0 0.17 0.17 0.17h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m9.25 499.61h-1.01v0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m78.07 485.98h-1.35c0 0.34 0 0.67 0.17 1.18v3.03c0.5 0 0.67 0.17 0.67 0.67h1.18c0-0.34 0-0.67-0.67-0.67v-0.67h-0.5v-2.69h0.5v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m76.89 489.85v-0.34c-0.17-0.17-0.5-0.17-0.67-0.34v1.35c0.17 0.17 0.17 0.34 0.34 0.34h1.01v-0.5c-0.5 0.34-0.67 0-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m80.08 491.7h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m77.56 491.54h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m78.07 489.35c0.5 0 0.67-0.17 0.67-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m81.26 492.71h0.67v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m80.59 491.03v0.67h0.67v-0.5c-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m80.08 485.31h-0.5v0.84c0.17-0.17 0.34-0.17 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m79.41 486.32v-0.34h-0.67v0.67h0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m78.74 487.67h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m78.74 486.99h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m78.74 487.67v-0.67h-0.67v1.68h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m78.07 484.81v0.67h0.34c0-0.17-0.17-0.5 0.34-0.67v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m78.74 484.81c-0.5 0-0.34 0.34-0.34 0.67 0 0.17-0.17 0.67 0.34 0.67v-0.5c0-0.17 0.17-0.34 0.17-0.5q0-0.34-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m79.08 484.81c0 0.17-0.17 0.34-0.17 0.5h0.67c-0.17-0.17 0.17-0.5-0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m78.07 479.42c0-0.5 0-0.84 0.17-1.35h-0.5c0 0.5 0 1.01 0.17 1.51-0.17-0.17 0-0.17 0.17-0.17-0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m77.73 479.42c0-0.5 0-1.01-0.17-1.51h-0.34v1.35c0 0.17 0.17 0.17 0.5 0.17-0.17 0.17 0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m77.56 480.26v0.5h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m76.89 474.04v1.18h0.67c0-0.34 0.17-0.5 0.5-0.5v-1.18h-0.5c0.17 0.34-0.17 0.5-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m78.07 474.54c-0.5 0-0.67 0.17-0.5 0.5v1.18h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m78.07 476.22h-0.5v1.01h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m78.07 477.4h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m32.47 481.78h-0.67v0.84h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m32.47 481.78v0.84h0.67v-0.67s0-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m31.8 482.62v-0.84h-0.34s0 0.17-0.17 0.17c-0.17 0.34-0.17 0.67 0.5 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m31.29 481.78h0.17v-1.01h-0.34c0.17 0.34-0.17 0.67 0.17 1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m31.29 481.78c-0.5-0.34 0-0.67-0.17-1.01 0-0.17 0-0.5-0.17-0.67h-0.5s0 0.17-0.17 0.17v1.85h0.67c0.34-0.17 0.34-0.34 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m30.12 479.59c0-0.34 0-0.5-0.5-0.5-0.17 0-0.17-0.17-0.34-0.17v0.84h0.5c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m30.12 479.59s-0.17 0-0.17 0.17c-0.17 0.5 0.17 0.67 0.67 0.67 0 0 0-0.17 0.17-0.17 0-0.17-0.17-0.17-0.17-0.34-0.34-0.17-0.34-0.34-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m23.05 498.6c-0.17-0.17-0.34-0.17-0.5-0.34l-0.17 0.17c0 0.34-0.17 0.5-0.17 0.84 0 0.17 0.17 0.34 0.17 0.5h1.18v-0.67h-0.67c0.17-0.34 0.17-0.5 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m23.05 498.6v0.5h0.67c-0.17-0.5 0.17-0.5 0.67-0.5v-0.67h-0.67c-0.67-0.17-0.84 0.17-0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m22.38 498.26c0.17-0.34 0.17-0.67 0-1.01 0-0.17-0.17-0.34-0.34 0v0.5c0 0.17 0.17 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m18 496.75c0.17 0.17 0.34 0.17 0.67 0.34v0.5h1.35v-0.5c0.34-0.17 0.5-0.17 0.84-0.34-0.34 0-0.67-0.17-0.84-0.17s-0.34 0-0.5 0.17c0-0.17-0.17-0.34-0.17-0.5h-0.5c-0.34 0.17-0.67 0.34-0.84 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m20.69 496.75c-0.17 0.17-0.5 0.17-0.84 0.34v0.5s0.17 0 0.17 0.17c0.17 0 0.5 0.17 0.67 0.17 0.34-0.17 0.34-0.5 0.34-0.84 0-0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m18.68 496.25h0.5c0 0.17 0.17 0.34 0.17 0.5 0.17 0 0.34 0 0.5-0.17q0-0.67-0.67-0.67h-0.5q0 0.17 0 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m20.86 497.93c-0.17 0-0.5-0.17-0.67-0.17s-0.34 0.17-0.5 0.17h-1.18c-0.17 0-0.34 0-0.5 0.17 0 0 0 0.17 0.17 0.17h1.85c0.67 0 0.84 0.17 0.84 0.84h0.34l0.17-0.17c-0.17-0.17-0.17-0.34-0.34-0.5 0-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m22.38 498.26c-0.17-0.17-0.34-0.34-0.34-0.5 0 0.17-0.17 0.5-0.17 0.67v0.5s0.17 0 0.17 0.17h0.17c0-0.34 0.17-0.5 0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m22.04 499.11s-0.17 0-0.17-0.17c-0.17 0-0.34-0.17-0.5-0.17l-0.17 0.17v0.67c0.34 0 0.5-0.17 0.84-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m18.34 494.56 0.17 0.17c0-0.34 0-0.5 0.17-0.84v-0.67c-0.17-0.17-0.34-0.17-0.5-0.34-0.17 0.17-0.34 0.34-0.5 0.34l-0.17 0.17v0.34c0.17 0 0.67-0.17 0.67 0.34q0 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m18.68 493.55v0.34h1.35v-0.84h-0.17l-0.17 0.17q-0.17 0.17-0.34 0.34c-0.34 0.17-0.5 0-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m19.35 489.85c-0.17 0-0.34 0-0.5 0.17v0.67c0.67 0 0.34 0.34 0.5 0.67 0.34-0.17 0.34-0.5 0.34-0.67-0.34-0.34-0.34-0.5-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m19.35 491.37c0-0.17 0.17-0.67-0.5-0.67-0.17 0.17-0.17 0.5-0.34 0.67 0.34 0 0.5 0.17 0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m18 493.05c0.17 0.17 0.34 0.17 0.5 0.34 0.17 0 0.34-0.17 0.5-0.17 0-0.34 0-0.67 0.17-0.84h-0.84c-0.5 0-0.17 0.34-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m18.34 492.21h0.84v-0.67c-0.34 0-0.5-0.17-0.84-0.17-0.34 0.17-0.67 0.17-1.01 0.34v0.5c0.17 0 0.17-0.17 0.34-0.17 0.34-0.17 0.67-0.34 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m19.18 493.05c-0.17 0-0.34 0.17-0.5 0.17v0.34h0.67c0.17 0 0.17-0.17 0.34-0.34-0.17 0-0.34 0-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m16.49 488-0.5 0.5 0.17 0.17c0.5 0 0.67-0.17 0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m18.84 490.53v-0.5s-0.17 0-0.17-0.17h-1.51c0 0.17 0.17 0.67-0.34 0.67v0.17h0.67v-0.5c0.34 0.17 0.84-0.34 1.01 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m77.56 476.22v-1.18h-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m13.63 508.19c0-0.34 0-0.5-0.17-0.84-0.34 0-0.84 0.17-1.18 0.17v0.5c0.5 0.17 1.01 0.17 1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m48.12 474.54c0.17 0 0.17 0.17 0.34 0.17 0-0.17-0.17-0.5 0.34-0.5v-0.34c-0.5 0-0.17-0.34-0.34-0.67 0-0.17 0-0.34-0.17-0.34 0 0-0.17 0-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m48.12 474.54v-1.51c-0.17 0.17-0.34 0.17-0.34 0.34v1.18q0.17 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m12.95 502.98h-1.01v0.67h0.34c0-0.17 0-0.34 0.34-0.34 0.17 0 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m12.95 502.98c-0.17 0.17-0.17 0.34-0.34 0.34-0.34 0-0.34 0.17-0.34 0.34 0.17 0.17 0.34 0.17 0.5 0.34 0 0.34 0.17 0.67 0.17 1.01h0.34v-0.84c0.34 0.17 0.5 0.17 0.67 0.34v-0.34c-0.17-0.17-0.17-0.34-0.34-0.67 0.17-0.17 0.17-0.34 0.34-0.5h-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m12.11 504.49v0.84c0.5 0.17 0.67-0.17 0.67-0.67v-0.5c-0.34 0.17-0.67-0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m12.62 504.15v0.5c0.17 0.5-0.17 0.67-0.67 0.67 0.17 0.67 0.67 0.17 1.01 0.34v-0.67c0-0.34-0.17-0.67-0.17-1.01 0 0 0 0.17-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m9.25 500.96h-1.35q0.17 0.17 0.34 0.34h0.34c0.34 0 0.67 0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m8.58 501.29h-0.34v0.34c0.17-0.17 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m27.42 481.27v0.67c0 0.17 0.17 0.17 0.17 0.34 0.17 0 0.17-0.17 0.34-0.17q0.17-0.17 0.34-0.34c0-0.34-0.17-0.5-0.17-0.84-0.34 0.17-0.5 0.34-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m27.93 482.11c-0.17 0-0.17 0.17-0.34 0.17v0.67h1.18v-0.34c-0.67 0.34-0.67-0.17-0.84-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m28.77 482.95h-1.18c0 0.17-0.17 0.34-0.17 0.34h1.35v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m28.6 483.29h-1.35v0.34h1.35q0.17-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m29.27 479.59v-0.84c-0.17 0-0.5 0.17-0.67 0.17v1.68c0.67 0.17 0.34 0.67 0.17 1.01 0 0 0 0.17 0.17 0.17h0.34v-0.67c0.17-0.34 0.17-0.84 0-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m28.1 481.1c0 0.34 0.17 0.5 0.17 0.84h0.5v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m28.1 481.1v-0.34c-0.17 0-0.5-0.17-0.67-0.17v0.84c0.17-0.17 0.34-0.34 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m26.75 485.98s0 0.17 0.17 0.17h0.5l0.5-0.5h0.17v-0.5c-0.5 0-0.34-0.34-0.34-0.67h-0.34v0.34c-0.17 0.17-0.17 0.34-0.34 0.5q-0.17 0.5-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m27.42 484.81h1.35v-0.17c-0.5-0.17-0.67-0.34-0.67-0.84h-0.67v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m4.88 491.7v-0.5h-0.67v0.67c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m4.21 492.54h1.18v-0.34h-0.84c0 0.17-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m4.54 492.21h0.34v-0.5h-0.67c0.17 0.17 0.34 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m31.8 485.31c0.5 0.17 0.67-0.17 0.67-0.67h-1.18v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m33.14 486.99h-1.35c0 0.17 0.17 0.34 0.17 0.34h0.17c0.17 0 0.34 0.17 0.67 0.17h0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m31.8 485.31h-0.5v1.35h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m32.13 484.81h1.01v-0.5h-1.35c0.17 0.17 0.17 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m33.14 484.81h-0.34v0.67c0 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m31.8 486.49h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m36.17 486.49v-0.67h-1.18v1.01h0.67c-0.17-0.17 0-0.34 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m34.32 486.99h-0.5v2.19h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m33.65 488.67v-1.68h-0.67v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m34.32 486.99v1.18h0.67v-0.5c-0.17 0-0.17-0.17-0.34-0.17v-0.17h1.01v-0.34h-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m33.14 482.62h-0.67v1.01h0.34q1.01 0 1.01-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m31.8 484.3h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m38.19 486.99v-0.5h-0.67v1.01h-1.35s-0.17 0-0.17 0.17 0.17 0.34 0.17 0.5c0.17 0 0.34 0.17 0.5 0.17 0.67 0.17 1.01-0.34 1.51-0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m36.17 487.67h0.67c-0.17-0.17-0.17-0.34-0.34-0.5 0.17-0.17 0.17-0.34 0.34-0.34-0.17 0-0.5-0.17-0.67-0.17-0.5 0-0.67 0.17-0.5 0.5 0.5-0.17 0.5 0.17 0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m75.04 486.99h-0.67v0.67h-1.18v0.67h1.85v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m70.66 486.66v-0.17q-1.35 0-1.35 1.18h0.67c0-0.5 0.17-0.84 0.67-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m71.84 486.99h-1.18v0.5c0.17 0 0.5-0.17 0.5 0.34 0.17-0.17 0.5-0.17 0.67-0.34v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m70.66 487.67v-0.5h0.5c0-0.34-0.34-0.34-0.5-0.34-0.5 0.17-0.67 0.5-0.67 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m73.19 488.17v-0.67h-0.67v0.5c0.17 0.17 0.5 0.17 0.67 0.34v-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m71.84 486.99v0.5h0.67c0.17-0.34-0.17-0.5-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m76.89 487.67v-0.67h-1.35v0.67c0.17 0.17 0.34 0.17 0.34 0.17 0.5 0 0.84-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m78.74 485.98c-0.5 0-0.34-0.34-0.34-0.67h-0.34v1.35h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m69.32 487.67q0-1.01 1.35-1.18v-0.67h-1.51c-0.17-0.34-0.34-0.5-0.34-0.67v2.36c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m68.81 485.31c0.17 0.17 0.17 0.34 0.34 0.67h1.51v-0.67c-0.5 0.17-0.84-0.17-0.67-0.5h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m78.07 484.81v-0.5h-1.18c0 0.17-0.17 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m75.71 487.67v-0.67h-0.5v1.18h0.5c-0.17-0.17-0.17-0.34 0-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m9.25 499.95h-1.01c-0.67 0.17-0.17 0.5-0.34 0.84h0.67c-0.17-0.5 0.34-0.5 0.67-0.5v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m9.25 500.28c-0.34 0-0.84 0-0.67 0.5 0.17 0 0.5-0.17 0.67-0.17v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m29.44 491.03q0 0.17 0.17 0.34h0.34c0.17 0 0.34 0.17 0.34 0.34s-0.17 0.17-0.34 0.34v0.84h0.5c0-0.17 0-0.34 0.17-0.5v-1.18c-0.5-0.17-0.84-0.17-1.18-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m29.95 491.87c0.17-0.17 0.34-0.17 0.34-0.34l-0.34-0.34h-0.34c0 0.17-0.17 0.17-0.17 0.34v0.34h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m29.44 491.03h1.01v-0.5h-1.35v0.17c0.17 0.17 0.34 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m30.28 493.39v0c-0.17 0.17-0.17 0.34-0.17 0.5h1.01v-1.01c0-0.17-0.17-0.17-0.34-0.17v0.5c0 0.17-0.17 0.34-0.17 0.34s-0.17 0-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m30.28 493.89v-0.34c-0.5 0-0.67 0.34-0.67 0.84v0.67h0.34v-0.84c0-0.17 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m29.95 495.07h-0.5v0.67c0 0.17 0.17 0.34 0.17 0.67h0.34v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m30.28 493.39c0.17 0 0.34 0.17 0.34 0.17 0-0.17 0.17-0.34 0.17-0.34v-0.5h-0.34v0.34q0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m30.45 493.05v-0.34h-0.5c0 0.5 0.34 0.34 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m29.61 496.25c0-0.17-0.17-0.34-0.17-0.67-0.17 0.17-0.34 0.34-0.5 0.34v0.67c0.17 0 0.17 0.17 0.34 0.17 0.34 0 0.34-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m28.94 496.08c0.17-0.17 0.34-0.34 0.5-0.34v-0.34c-0.17 0-0.34-0.17-0.5-0.17-0.17 0.17-0.5 0.5 0 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m31.29 504.15h1.18c-0.17-0.17-0.17-0.34-0.34-0.67h-1.01q-1.18 0-1.18-1.01-0.17-0.17-0.34-0.34c-0.34-0.17-0.5-0.34-0.84-0.67v-0.34h-0.67c0 0.5-0.17 1.01 0.34 1.35h0.67c0.17 0 0.17 0.17 0.34 0.34 0.17 0.34 0.34 0.84 0.5 1.18 0.17 0 0.34 0 0.5 0.17 0.17 0.17 0.5 0.17 0.84 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m32.13 503.65c0.17 0.17 0.17 0.34 0.34 0.67h0.17c0.17 0.67 0.84 0.34 1.35 0.5v-1.68q0-0.17-0.17-0.34c-0.17-0.34-0.17-0.5 0.34-0.5h0.5q-0.17-0.17-0.34-0.34h-1.18v0.67c0.17 0 0.17 0.17 0.34 0.17 0.17 0.17 0.17 0.34 0.34 0.5h-0.67q-0.17 0.17-0.34 0.34h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m31.29 504.15c-0.34 0-0.5 0-0.84 0.17 0 0.17 0.17 0.34 0.17 0.34 0.5-0.17 0.67 0.34 1.18 0.5 0.17 0 0.34 0.17 0.5 0.17l0.17-0.17-0.67-0.67c-0.17 0-0.34-0.17-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m33.99 503.65v1.01c0.5 0 0.34 0.34 0.34 0.67h0.17l0.5-0.5c0-0.17-0.17-0.34-0.17-0.5-0.5 0-0.67-0.34-0.5-0.67h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m34.49 505.33h-0.17c0 0.17-0.17 0.17-0.17 0.34h1.51v-0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m32.47 505.33q-0.17 0 0 0v0.34h1.18c-0.17-0.17-0.34-0.17-0.67-0.34h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m30.62 506.51h0.34c0.17-0.17 0.17-0.34 0.34-0.34-0.17-0.5-0.34-1.01-0.5-1.35h-0.67v1.18c0.17 0 0.34 0 0.67-0.17-0.17 0.34-0.17 0.5-0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m27.76 506.17c0.17 0.17 0.34 0.34 0.67 0.5 0.17 0.17 0.34 0.17 0.34 0.17 0.34 0.17 0.34 0.34 0.17 0.5s-0.17 0.34-0.34 0.5c0.5 0 0.84 0.17 1.01-0.17 0-0.17 0.34 0 0.5 0 0.17-0.17 0.17-0.34 0.34-0.67h-0.84c-0.17 0-0.17-0.17-0.34-0.34v-0.5c-0.5-0.17-1.01-0.5-1.01-1.18h-0.5v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m29.27 506.51v0.5h0.84c0.17-0.17 0.17-0.34 0.34-0.5v-0.67c-0.34 0-0.5 0-0.67 0.17h-0.34c0 0.17 0 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m30.28 507.01h-0.84c0.17 0.17 0.17 0.34 0.34 0.34h0.84l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m35.67 505.33v0.34h1.85v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m27.76 506.17v-0.84h-0.34v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m56.19 500.28h1.35v-0.5h-1.85v0.67c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m55.69 500.28v-0.67h-1.35v0.5c0.5 0.17 0.84 0.17 1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m53.17 499.61h1.18v-0.67h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m51.82 497.26v1.68h0.67v-1.68h1.18v-0.5h-1.18c-0.5-0.17-0.67 0.17-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m53.17 499.61v-0.67h-0.67c-0.17 0.5 0.17 0.84 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m57.54 499.61v0.5h0.5v-0.67h1.35v-0.67h-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m59.39 498.94v1.35h0.67v-1.18c-0.17-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m60.57 500.62v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m68.14 470.5v-0.67c-0.17-0.17-0.5-0.17-0.67-0.34v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m66.79 472.69c0-0.17 0.17-0.34 0.17-0.5s0-0.34 0.17-0.5h-0.34c0 0.17-0.17 0.34-0.17 0.5v0.67c0-0.17 0.17-0.17 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m66.79 471.68h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m68.14 470.5h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m48.12 484.81q-0.17 0.17-0.17 0.34c0.34 0.17 0.84-0.17 0.84 0.34 0.17-0.17 0.34-0.17 0.5-0.34v-0.34c-0.17-0.17-0.17-0.34-0.34-0.67 0 0-0.17 0-0.17 0.17v0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m48.12 487.67v0.84c0.34-0.17 0.5-0.5 0.84-0.67 0 0-0.17 0-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m48.79 487.67s0.17 0 0.17 0.17c0 0 0.17 0 0.17 0.17l0.17-0.17v-0.67h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m48.79 486.99h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m49.3 484.97c-0.17 0.17-0.34 0.17-0.5 0.34v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m49.3 486.49v1.18h0.67v-1.68h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m48.79 484.3s0.17 0 0.17-0.17v-0.34l-0.17-0.17h-0.67v0.5c0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m48.12 483.63h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m48.79 484.3h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m49.63 481.44h-0.34v0.67c0 0.17-0.17 0.17-0.34 0.34v0.17c0.17 0 0.5 0.17 0.67 0.17v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m48.96 482.28c-0.5-0.17-1.01-0.17-1.51-0.17q0 0.17-0.17 0.34h1.35c0.17 0 0.34 0 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m47.45 482.28h1.51c-0.17-0.67-0.84-0.17-1.18-0.34l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m48.96 482.28-0.17 0.17v1.18l0.17 0.17c0.17 0 0.34-0.17 0.67-0.17h0.34v-1.18h-0.34c-0.17 0-0.5 0-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m68.14 475.05v-1.01h-0.34c-0.17 0.34 0.34 0.67-0.34 0.84v0.34c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m44.42 504.66h1.18v-1.01h-0.34c-0.67 0 0-0.67-0.5-0.84-0.17 0-0.5 0-0.67-0.17v-0.17h0.84v-0.84c-0.17-0.17-0.34-0.17-0.34-0.17-0.34 0.17-0.5 0.17-0.67 0.17-0.17 0.17-0.34 0.34-0.5 0.34 0.67 0.5-0.34 0.67-0.17 1.01h-0.67v0.17c0.5 0.34 0.5 0.67 0 1.01-0.17 0-0.34-0.17-0.67-0.17 0 0-0.17 0.17-0.17 0.34s0.17 0.17 0.34 0.34c0.17 0 0.5 0.17 0.84 0.17 0.17-0.17 0.34-0.34 0.5-0.34 0.34-0.17 0.67 0 1.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m42.06 503.14c0.17 0 0.17-0.17 0.34-0.17 0.17-0.17 0.17-0.34 0.34-0.34h-0.84c-0.5 0.17-0.84-0.17-0.67-0.67h-0.67v1.01h0.67c0.34 0 0.5 0.17 0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m38.53 504.99c0.34 0 0.5 0 0.84 0.17 0.67 0 1.18-0.17 1.51-0.84h-0.5c-0.17 0.34-0.34 0.5-0.84 0.5-0.34 0-0.67 0-1.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m42.73 502.47c-0.17 0.17-0.17 0.34-0.34 0.34q0.17 0 0.34 0.17h0.67c-0.17-0.34 0.67-0.5 0.17-1.01 0 0-0.17 0-0.17 0.17-0.17 0.34-0.34 0.34-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m42.06 503.14c-0.34 0-0.67 0-0.84-0.17v0.5s0.17 0 0.17 0.17c0.5 0.17 0.67-0.17 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m41.39 503.65s-0.17 0-0.17-0.17h-0.67v0.5h0.34c0.17 0 0.34-0.17 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m46.94 504.15v-1.68h-0.67c0 0.34 0 0.84-0.17 1.18 0.17 0.5 0.5 0.5 0.84 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m46.1 503.65c0-0.34 0-0.84 0.17-1.18v-0.5h-0.34v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m45.93 503.65v-1.68h-0.34v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m47.45 501.29h-0.5v1.35h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m35.67 505.33h1.85c0.17-0.17 0.5-0.17 0.67-0.34q-0.17-0.17-0.34-0.34c-0.17 0-0.34-0.17-0.5-0.17h-0.34c-0.34 0-0.67 0.17-1.18 0.17 0 0.17-0.17 0.5-0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m37.35 504.49c0.17 0 0.34 0.17 0.5 0.17q0.17 0.17 0.34 0.34h0.17s0.17 0 0.17-0.17c0.34 0 0.67-0.17 1.01-0.17s0.67-0.17 0.84-0.5h-2.02q-0.17 0.17-0.34 0.34h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m4.88 491.7v0.5h0.5v-0.67c-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m50.64 477.4c0-0.34 0.17-0.5 0.17-0.84 0-0.17-0.17-0.34-0.17-0.67v-0.34c-0.5 0.17-0.67-0.17-0.67-0.67v-0.5c-0.17 0.17-0.5 0.34-0.67 0.5v1.68h0.67v1.85c0.5 0.17 0.67-0.17 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m49.97 475.05c-0.17 0.5 0.17 0.67 0.67 0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m48.45 474.71c0 0.5-0.34 0.84-1.01 0.67v0.84h1.35v-1.18q0-0.17-0.34-0.34c0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m48.79 475.05v1.18h0.5v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m48.45 474.71h0.17c0-0.17 0-0.34 0.17-0.5-0.5 0-0.34 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m55.18 483.96c0.17-0.17 0-0.67 0.67-0.5 0.17 0 0.34 0 0.5-0.17 0.17 0 0.17-0.17 0.34-0.34h-2.19c0 0.34 0 0.67 0.17 1.01 0 0.17 0.17 0.17 0.5 0q-0.17 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m55.86 483.63c0 0.34 0.34 0.34 0.5 0.34s0.5 0 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m54.34 483.12h1.85v-0.5h-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m54.34 482.62h1.85v-0.5h-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m54.34 481.1c-0.34 0.17-0.67 0.34-0.84 0.5v0.17l0.17 0.17h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m69.32 484.81h1.35v-0.5c-0.17 0-0.34 0-0.67-0.17v-0.5h-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m69.32 483.12v-0.5h-0.5v1.01h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m68.81 482.62h0.5v-0.67h-1.18v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m68.14 481.95h1.18v-0.67c-0.5 0.17-0.5-0.17-0.5-0.67h-0.67v1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m38.19 486.99v0.67c0.34 0 0.5 0.17 0.84 0.17-0.17-0.34-0.17-0.67-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m39.03 488c-0.34 0-0.5-0.17-0.84-0.17-0.5 0.34-0.84 0.67-1.51 0.67-0.17 0-0.17 0.17-0.34 0.17-0.34 0-0.5 0.17-0.5 0.34v0.17h1.51c0.17-0.17 0.5-0.17 0.67-0.34h0.17l0.5-0.5c0.17-0.17 0.17-0.34 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m38.36 488.67h-0.17v0.5h0.5c0.17-0.17 0.17-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m53.67 481.95-0.17-0.17c-0.34 0-0.67 0.17-0.84 0.17l-0.17-0.17c0.17-0.17 0.34-0.5 0.5-0.67v-0.5c-0.34-0.17-0.34-0.5-0.34-0.84h-0.67v1.68h-0.5v0.5c0.17 0 0.34 0.17 0.5 0.17v0.5h0.84c0.5 0 0.67 0.17 0.5 0.5v2.19h0.5c0-0.17 0-0.34 0.17-0.5h0.67v-0.5h-0.67c-0.34-0.84-0.34-1.68-0.34-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m51.82 482.62v-0.5c-0.17 0-0.34-0.17-0.5-0.17v-0.5h-0.67v1.68h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m52.49 479.59c0 0.34 0 0.67 0.34 0.84 0.17-0.17 0.34-0.17 0.5-0.34 0.17-0.34 0.5-0.34 0.84-0.34 0-0.17 0.17-0.17 0.17-0.34v-0.67h-1.18c0 0.84-0.17 1.01-0.67 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m50.64 482.62v-1.68h-0.67v1.85c0.17-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m49.97 478.58v-1.85h-0.67v1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m52.49 479.59c0.5 0.17 0.67-0.17 0.67-0.5-0.5-0.17-0.84 0-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m52.83 480.77v0.34c0.17 0.17 0.5 0.34 0.67 0.67 0.34-0.17 0.5-0.34 0.84-0.5-0.5-0.17-1.01-0.34-1.51-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m69.32 483.63h-0.5c0.17 0.5-0.17 0.67-0.67 0.67v0.5h1.18v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m68.14 484.3c0.5 0.17 0.67-0.17 0.67-0.67h-1.35c0 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m67.3 484.97s-0.17 0 0 0q-0.17 0.17 0 0c-0.17 0.5-0.17 1.01-0.17 1.35h0.34v-1.35c0 0.34-0.17 0.17-0.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m67.13 485.14c-0.17-0.17-0.17-0.34-0.34-0.34h-0.5v0.67c0.34-0.17 0.67-0.17 0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m67.3 484.97c0 0.17 0.17 0.17 0.17 0.34h0.67v-0.67c-0.34 0.17-0.67 0-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m66.29 484.81h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m66.79 481.27c0 0.17-0.17 0.17-0.17 0.34h0.5v1.01h0.34v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m67.47 483.63h1.35v-1.01h-1.01c-0.17 0-0.17 0.17-0.34 0.17v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m65.62 481.27h0.67v-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m66.29 480.26v0.5h1.18v-1.01c-0.34 0-1.01 0.17-0.84-0.5h-0.34l-0.17 0.17c0 0.17 0.17 0.5 0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m67.47 480.77h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m66.29 484.81v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m29.27 490.53h1.35v-0.67c-0.67 0.17-0.67-0.17-0.67-0.67h-0.5v0.34c0 0.17 0 0.34-0.17 0.34v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m29.44 489.35h0.5v-0.67h-1.51c-0.17 0-0.17 0.17-0.34 0.34h1.01l0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m29.27 490.02c0-0.17 0-0.34 0.17-0.34h-0.67c-0.17 0-0.17 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m27.09 487.33v0.5h0.5s0.17 0 0.17-0.17l0.17-0.17q0-0.17 0.17-0.34c0.34-0.17 1.01 0 1.18 0.34h0.17c0-0.17 0.17-0.5 0-0.67-0.17-0.34 0-0.84-0.5-1.01-0.17 0.34-0.34 0.67-0.84 0.67s-0.84 0.17-0.84 0.67c0.17 0 0 0.17-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m28.1 487.67-0.17 0.17c0.17 0.67 0.67 0.34 1.01 0.5v0.5h0.34c0-0.34 0-0.84-0.34-1.01-0.17-0.17-0.5-0.17-0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m27.09 487.33 0.17-0.17c0-0.5 0.34-0.67 0.84-0.67s0.67-0.17 0.84-0.67h-0.34c-0.34 0.5-0.84 0.17-1.35 0.34 0 0.34-0.17 0.5-0.17 0.84v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m26.92 497.93h-1.35v0.67c0 0.17 0 0.34 0.17 0.34 0.34 0.17 1.18 0 1.35-0.5h0.5v-0.67c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m29.27 496.92c-0.17 0-0.17-0.17-0.34-0.17h-0.84c0 0.34 0.17 0.67-0.5 0.67 0 0-0.17 0.34-0.17 0.5h1.35c-0.17-0.5 0.17-0.67 0.67-0.67q0-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m24.4 497.59v0.34h1.18v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m38.7 489.35h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m57.88 488.67h0.5v-0.5h-0.84c0.17 0.17 0.17 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m57.54 489.35c0-0.17 0-0.34-0.17-0.67-0.67 0.17-0.5-0.17-0.5-0.5h-0.67v1.18h0.67v0.67c0.5 0 0.84-0.17 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m68.81 476.22v-0.67h-1.35c-0.17 0.5 0.17 0.67 0.67 0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m68.81 480.26v-1.18h-0.67v0.5c0 0.5 0.17 0.84 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m68.14 479.59v-1.35c0-0.17-0.17-0.17-0.34-0.34v0.84c0 0.17-0.17 0.17-0.34 0.34v0.67c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m66.79 478.08c0.5 0.17 0.5 0.67 0.5 1.01h0.34v-1.01s0-0.17-0.17-0.17c-0.34 0-0.5 0-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m67.47 477.91v1.01c0.17-0.17 0.34-0.17 0.34-0.34v-0.84c0 0.17-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m66.79 499.61h-1.18v0.5h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m66.29 500.28h-1.35v0.5h0.34c0.17 0 0.34-0.17 0.5-0.17 0.34-0.17 0.5-0.17 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m68.14 500.28v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m67.47 500.28v-0.67h-0.67v0.5c0.34 0 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m69.32 499.61c0-0.5 0.34-0.5 0.67-0.67v-1.18h-0.67v1.01h-0.5v0.84c0.17 0.17 0.34 0.17 0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m68.14 498.94h0.67v-1.85h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m67.47 499.61h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m69.65 500.28h1.35v-0.67h-1.68v0.34c0.17 0 0.34 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m69.65 500.28q-0.17-0.17-0.34-0.34v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m64.94 500.62v-0.5h-0.5v0.5c0.17 0.17 0.34 0 0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m48.12 491.7h-2.69c0.17 0.17 0.17 0.34 0.17 0.67h2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m46.94 492.21h-2.02v0.5h1.85c0.17-0.17 0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m46.94 490.53v0.5h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m49.13 491.7c-0.17-0.17-0.17-0.34-0.34-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m46.94 492.71h-1.85v-0.5h-0.5v1.01h2.52c-0.17-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m66.29 480.26c0-0.34-0.17-0.67-0.17-0.84h-0.5v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m68.14 479.59h-0.67v1.01h1.35v-0.5c-0.5 0.34-0.67 0-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m49.97 482.62v-1.85h-0.34v1.68q0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m55.18 483.96q-0.17 0.17 0 0c-0.17 0.34-0.17 0.5-0.17 0.67h0.84c-0.17-0.17-0.5-0.34-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m55.69 484.81h-0.67c-0.17 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m39.37 491.7c0-0.17-0.17-0.17-0.17-0.34h-1.35v1.01l0.17 0.17c0.5 0 1.01-0.17 1.51-0.17 0 0 0.17 0 0.17-0.17-0.17-0.17-0.34-0.34-0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m39.03 491.37c0.17 0 0.17-0.17 0.34-0.34v-0.5h-2.52v0.5h0.67c0.5 0 1.01-0.17 1.51 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m39.37 491.7c0 0.17 0.17 0.34 0.17 0.5 0.17 0 0.34 0 0.34 0.17v-0.5c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m40.55 492.71v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m40.55 492.71h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m37.86 492.38c-0.17-0.17-0.34-0.17-0.34-0.17h-0.67v-1.18h-1.85v0.5h0.67v0.5c0.17 0 0.34 0.17 0.5 0.17v2.19h1.35v-0.67h-0.67v-0.67c0-0.34 0.17-0.5 0.5-0.5 0.17 0 0.5 0 0.5-0.17q0.17 0.17 0 0c0.17 0.17 0 0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m36 489.01q-0.17-0.17-0.34-0.34c-0.34 0-0.5-0.17-0.5-0.34 0 0-0.17 0-0.17-0.17h-0.67v0.5c0.5-0.17 0.84 0.17 0.67 0.67 0.5-0.17 0.67 0.17 0.67 0.67h0.5v-0.5q-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m36.17 489.35v0.5h2.02v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m35 491.03v-1.68h-0.67v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "m35 489.35v0.67h0.67c0-0.5-0.17-0.84-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m36.17 491.03h0.67v-0.5c-0.5 0-0.84 0-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m38.02 492.54c-0.17 0-0.5 0.17-0.67 0.17-0.34 0-0.67 0.17-0.5 0.5v0.67h0.67c-0.17-0.5 0.17-0.67 0.67-0.67q0.17-0.17 0.34-0.34t0.17-0.34c-0.17 0.17-0.5 0.17-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m38.7 492.71c0 0.17-0.17 0.17-0.17 0.34q-0.17 0.17-0.34 0.34h1.18v-0.5c-0.34-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m39.37 492.71v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m46.94 493.39h-0.67v1.18h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m44.42 498.6v-0.67h-2.52v1.01h0.67v-0.5c0.67 0.17 1.18 0.17 1.85 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m40.55 499.11h-1.18v1.35h0.67c0-0.34 0-0.67 0.5-0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m39.37 499.61v-1.85h-0.67v1.68c0.17 0.17 0.34 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m40.55 499.11v0.5h1.35v-0.67c-0.5 0-0.84 0-1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m38.19 495.07h-0.67v1.68h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m38.19 496.75h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m38.7 497.93v-0.67h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m37.52 494.56h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m46.94 494.56v1.68h0.5v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m47.45 496.75h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m44.92 499.11h-0.5v0.67h-0.67c0 0.34 0.17 0.67 0.17 1.01l0.17 0.17c0.17-0.17 0.5-0.34 0.67-0.67 0-0.5 0.17-0.84 0.17-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m44.75 500.28c-0.17 0.17-0.5 0.34-0.67 0.67 0 0.17 0 0.34-0.17 0.5v0.34c0.17 0 0.5-0.17 0.67-0.17 0 0 0.17 0.17 0.34 0.17v-1.35c0-0.17-0.17-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m44.92 500.28v1.35h0.34c0-0.34 0.17-0.67 0.17-1.01 0 0 0-0.17-0.17-0.17 0 0-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m45.43 500.45s0 0.17 0.17 0.17c0 0 0.17 0 0.17 0.17h0.67v-0.5h-0.67c-0.17 0-0.34 0-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m51.82 497.26c0-0.5 0.17-0.67 0.67-0.67v-0.5c-0.5-0.17-1.35 0.34-1.18-0.67h-0.67v1.18h0.67v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m48.79 496.75v0.5h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m44.42 498.6h-1.85v0.5h1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m46.94 501.29v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m46.27 500.79h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m50.64 496.75v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m48.12 496.25v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m70.66 484.81h-0.67c-0.17 0.5 0.17 0.67 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m60.06 500.28h0.5v-1.68h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m61.24 498.43v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m47.45 476.9v0.67h1.01s0.17 0 0.17-0.17 0.17-0.5 0.17-0.84c-0.5 0.17-0.84 0.34-1.35 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m47.45 476.9c0.34 0 0.84-0.17 1.35-0.17 0 0.34-0.17 0.67-0.17 0.84 0.67 0.34 0.34-0.34 0.5-0.5-0.17-0.17-0.17-0.5-0.34-0.67h-0.67l-0.34 0.34q-0.17 0-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m47.45 476.22v-0.84h-0.17s0 0.17-0.17 0.17c-0.34 0.17-0.5 0.34-0.34 0.5 0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m67.47 479.08h-0.34c-0.17 0-0.34 0-0.5 0.17 0 0.67 0.5 0.5 0.84 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m65.62 479.42h0.5l0.17-0.17c0-0.17 0-0.5-0.34-0.34-0.5-0.17-0.17 0.17-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m72.85 500.12v-0.5h-0.17c-0.17 0-0.34 0.17-0.5 0.17-0.17 0.17-0.34 0.17-0.67 0.34 0.5 0.17 1.01 0.17 1.35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m73.19 498.43c-0.17-0.17-0.17-0.34-0.34-0.34h-0.84c-0.17 0-0.17-0.17-0.34-0.34h-0.34v0.34c0.17 0.17 0.17 0.34 0.34 0.34 0.5 0.17 1.01 0 1.51 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m71.17 498.26v-0.34s0-0.17-0.17-0.17-0.5 0.17-0.67 0.17v1.01c0.67 0 0.17-0.5 0.5-0.84 0 0.17 0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m70.33 498.94v-1.01h-0.34v1.18c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m46.94 490.53h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m49.13 487.83s-0.17 0-0.17-0.17c-0.34 0.17-0.5 0.5-0.84 0.67 0 0.17-0.17 0.34-0.17 0.34 0 0.34 0 0.67-0.17 1.18h0.34c0.67 0 0.84-0.34 0.84-0.84 0-0.17 0.17-0.34 0.34-0.5 0-0.17 0-0.5-0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m48.12 490.02h-0.67v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m67.13 485.14c-0.34 0.17-0.5 0.17-0.84 0.34l-0.17 0.17c0.17 0.34 0.34 0.84 0.5 1.18h0.17c0.17-0.17 0.17-0.34 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m68.14 488.67h-2.69c-0.17 0-0.34 0.17-0.5 0.34-0.17 0.34 0.17 0.34 0.5 0.34h0.34c0.34 0 0.5 0.17 0.5 0.34v1.85h-0.67v0.5c0.5 0.17 1.18-0.34 1.35 0.5h1.18c-0.17-0.5 0.34-0.5 0.67-0.5v-1.18c-0.5-0.17-1.18 0.34-1.35-0.5h-0.5v-1.18h1.35c-0.17 0-0.17-0.17-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m61.91 497.93h0.5c0-0.17 0-0.34 0.17-0.5 0.17 0 0.34 0 0.67-0.17v-2.69h-0.67v2.19h-0.5v0.67c-0.17 0.17-0.17 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m65.62 492.21h-0.67v2.36h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m62.42 494.56h0.67v-1.85h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m63.09 492.71v1.18h0.67v-1.68h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m67.47 498.94h0.67v-1.68h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m64.44 500.28h1.18v-0.5h-0.67v-0.34c0-0.17-0.17-0.17-0.34-0.17s-0.17 0.17-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m67.47 487.67h-0.67v0.5h1.35c0.17-0.5-0.17-0.67-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m67.47 497.93v-1.35h-0.67v0.5c0 0.67 0.17 1.01 0.67 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m65.62 494.56v1.18h0.67v-1.01c-0.17-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m67.47 499.61v-0.67c-0.5-0.17-0.67 0.17-0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m61.91 497.93v-0.67h-0.67v0.5c0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m68.14 488.17v0.5c0.34 0 0.84 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m66.79 496.75h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m66.29 495.57v0.5h0.5v-0.67c-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m68.14 488.17h0.67v-3.03h-0.67v0.67c0.17 0.5-0.17 0.67-0.67 0.67v1.18c0.5-0.17 0.84 0 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m67.47 486.99v-0.5h-0.34c-0.17 0.17-0.17 0.34-0.34 0.34 0.17 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m49.13 477.07c-0.17 0.17 0.34 0.84-0.5 0.5 0 0-0.17 0-0.17 0.17v0.34h0.84v-0.84c0-0.17-0.17-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m51.31 495.57c-0.17 1.01 0.67 0.5 1.18 0.67v0.5h5.05v-1.68c-0.17 0-0.34 0-0.67-0.17v-0.5c-0.34 0-0.5 0.17-0.84 0.34-0.5 0.17-1.01 0.17-1.35 0.17h-1.35q0-0.17-0.17-0.34c-0.17-0.17-0.34-0.17-0.34-0.17l-0.17 0.17c0 0.34 0 0.67-0.17 0.84-0.34 0.34-0.67 0.17-1.18 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m51.82 482.62v0.5h-1.18v2.36h-0.67v0.67h1.85c0 0.17 0.17 0.34 0.17 0.5 0.34 0.17 0.67 0 0.67-0.34v-0.67h-1.18v-1.01h1.85v-1.18c0-0.34-0.17-0.5-0.5-0.5-0.5-0.34-0.67-0.34-1.01-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m48.79 495.07v-2.86h-0.67v2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m49.13 487.83c0 0.17 0.17 0.5 0.17 0.67v1.35h0.67v-2.36h-0.67c0 0.17 0 0.34-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m49.97 487.67v2.36h0.67v-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m48.79 492.21v1.68h0.5v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m51.82 485.31h1.35v-0.5h-1.35v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m50.64 495.57v-0.5h-1.35v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m48.79 492.21h0.5c0-0.17-0.17-0.34-0.17-0.67h-1.01v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m56.87 489.85v-0.67h-0.67c0 0.67 0.17 0.84 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m49.3 493.89h-0.5v0.67c0.5 0 0.5-0.34 0.5-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m49.3 495.57v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m48.79 490.53h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m48.12 491.03h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m59.39 496.25h-1.35v1.18h0.67c0-0.17 0.17-0.34 0.17-0.67h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m60.06 494.56h-0.67v1.01h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m60.06 495.57h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m62.42 494.56v-1.85h-1.35c-0.34 0-0.5 0-0.5 0.5v1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m61.24 494.56h-1.18v1.68c0 0.17 0.17 0.5-0.34 0.5 0.17 0.17 0.17 0.34 0.34 0.67 0.17-0.17 0.34-0.17 0.5-0.34 0.17 0 0.17-0.17 0.34-0.17v-1.01c0-0.17 0.17-0.17 0.34-0.34v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m58.04 496.75v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m55.02 484.81v-0.5c-0.17 0-0.34 0-0.5-0.17l-0.17 0.17v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m24.9 505.33v0.34c0.17-0.17 0.5-0.34 0.84-0.34 0.17 0 0.17-0.17 0.34-0.34h-1.01q0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m25.24 504.99h1.35v-0.34h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m27.09 504.32q0.17 0 0.34 0.17c0.17 0 0.67 0.17 0.67-0.34v-0.5c-0.17 0-0.34 0-0.5-0.17-0.17-0.34 0-0.84-0.67-0.84 0 0.17-0.17 0.34-0.17 0.67 0.5 0 0.34 0.34 0.34 0.5h-0.67q0.17 0.17 0.34 0.34c-0.17 0.17 0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m28.1 504.15c0 0.5-0.5 0.17-0.67 0.34v0.84h0.34q0.17-0.17 0.34-0.34c0.17 0 0.34 0 0.5-0.17 0.17 0 0.5-0.17 0.67-0.17v-0.5c-0.17 0-0.34 0.17-0.67 0.34v-0.84q-0.17 0.17-0.34 0.34l-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m27.09 504.32c-0.17 0-0.34-0.17-0.5-0.17s-0.17-0.17-0.34-0.34q-0.17-0.17-0.34-0.34h-0.34v1.18h0.67c0.17 0 0.5-0.17 0.67-0.17t0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m26.92 504.49c-0.17 0-0.5 0.17-0.67 0.17h0.34s0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m22.71 507.35c0.5 0 0.84 0 1.18-0.5q-0.17-0.17-0.34-0.34h-0.84c-0.34 0-0.67 0.17-1.18 0.17 0.34 0 0.67 0.17 1.01 0.17 0.17 0.17 0.17 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m23.72 506.51h0.67v-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m22.71 507.35v-0.5c-0.34 0-0.67-0.17-1.01-0.17l-0.17 0.17v0.34h0.67c0.34 0 0.34 0.17 0.34 0.34q0-0.17 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m23.72 505.33h1.35c0-0.17 0.17-0.17 0.17-0.34v-0.34h-0.17c-0.34 0-0.5 0-0.84-0.17 0 0-0.17 0-0.17 0.17-0.17 0.17-0.34 0.5-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m24.73 505.33h-0.34v1.18h0.34c-0.17-0.34 0-0.84 0-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m21.7 507.69 0.5 0.5h0.34v-0.84c-0.34 0.17-0.67 0.17-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m14.81 504.49c-0.34 0.34-0.5 0.5 0 0.84 0.17 0 0 0.34 0 0.5 0.34 0 0.34-0.17 0.34-0.5 0-0.5 0.17-0.67 0.67-0.84v-1.18c-0.17-0.34-0.17-0.67-0.34-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m16.15 504.66c0 0.34 0.17 0.67 0.17 0.84 0.34 0.17 0.67 0.17 1.01 0.34 0.17-0.17 0.5-0.34 0.67-0.67 0-0.17 0.17-0.67-0.34-0.67-0.17 0.5-0.5 0.67-1.01 0.5v-0.67h-0.5v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m17.33 505.84c-0.34-0.17-0.67-0.17-1.01-0.34 0 0.17-0.17 0.34-0.17 0.5 0.17 0.17 0.5 0.17 0.67 0.34l0.17 0.17c0.67 0.17 0.34-0.34 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m16.15 504.66v-1.01h-0.34v1.18c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m13.96 504.49c-0.17-0.17-0.34-0.17-0.67-0.34v1.18c0.17 0 0.67 0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m13.96 504.49v0.5c0.17-0.17 0.17-0.34 0.34-0.5h0.5v-0.84h-0.34c0 0.34 0 0.67-0.5 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m19.52 507.01h0.17c0.17 0 0.34 0.17 0.67 0.34 0-0.17 0.17-0.34 0.17-0.67 0 0 0-0.17-0.17-0.17v-0.5c-0.17 0-0.34-0.17-0.67-0.17 0.17-0.17 0.34-0.17 0.34-0.17-0.17-0.34-0.17-0.67-0.17-0.84h-0.67c-0.5 0-0.34-0.34-0.34-0.5-0.17 0-0.17 0.17-0.34 0.17s-0.17 0.17-0.17 0.34v0.5c0 0.17-0.17 0.17-0.34 0.34q-0.17 0.17-0.34 0.34c0 0.5 0.17 0.84 0.67 0.84 0.34 0 0.67-0.34 1.18-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m18.34 507.35h1.18v-0.34h-0.84l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m17.67 505.84q0.17-0.17 0.34-0.34v-0.34c-0.17 0.17-0.5 0.34-0.67 0.67h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m21.7 507.69c0.34-0.17 0.5-0.17 0.84-0.34q0-0.34-0.34-0.34h-0.67c-0.5 0-0.34 0.34-0.34 0.5 0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m20.53 506.51s0 0.17 0.17 0.17h0.84l0.17-0.17c-0.17 0-0.34-0.17-0.5-0.17 0.17-0.17 0.17-0.34 0.34-0.5h-0.67c-0.17 0.34 0.17 0.67-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m71.17 497.76s0 0.17 0.17 0.17h2.02v-0.67h-0.5c-0.17 0.17-0.17 0.34-0.34 0.34-0.5 0-0.84 0-1.35 0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m73.19 497.26v0.34c0.17-0.17 0.5-0.34 0.84-0.34v-0.34q0-0.17-0.17-0.34h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m75.37 494.56c0.17-0.34 0.17-0.5 0.34-0.84 0-0.5 0-1.01-0.17-1.51h-0.5v2.19q0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m74.03 496.75c0.17 0 0.17-0.17 0.34-0.17q0-0.17 0.17-0.34v-0.67c-0.17-0.17-0.34-0.17-0.34-0.34v-0.84h-0.34v1.68c-0.17 0.34 0 0.5 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m74.36 496.25q0 0.17-0.17 0.34h1.01c0.17 0 0.17 0.17 0.34 0.17s0.17-0.17 0.34-0.17v-0.67c-0.17 0.17-0.34 0.17-0.5 0.34h-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m75.37 496.25c0.17-0.17 0.34-0.17 0.5-0.34v0.67h0.34v-0.84h-0.84v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m74.36 495.4h0.67v-0.84h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m74.36 495.4v-0.84h-0.34v0.84c0 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m75.71 492.21c0 0.5 0 1.01 0.17 1.51h0.5c0-0.17 0-0.34 0.17-0.34-0.17-0.17-0.34-0.17-0.34-0.34v-0.84h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m81.26 491.7h-0.67v1.01h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m75.71 492.21h0.34c0.34-0.17 0.5-0.34 0.84-0.5 0.34 0 0.5-0.17 0.84-0.17v-0.34h-1.18c-0.17 0-0.5 0.17-0.67 0.17-0.34 0.5-0.34 0.67-0.17 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m20.86 498.94c0-0.67-0.17-0.84-0.84-0.84h-1.85c0 0.17-0.17 0.34-0.34 0.5h1.85c0.17 0 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m18.34 499.11c0 0.17 0 0.34 0.17 0.5 0 0.17 0.17 0.34 0.17 0.5 0.34 0 0.67 0.17 1.01 0.17 0-0.17 0.17-0.5-0.34-0.5-0.17-0.17-0.34-0.17-0.34-0.34v-0.67c-0.34 0.34-0.5 0.34-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m18.68 500.12c0-0.17-0.17-0.34-0.17-0.5-0.17 0.17-0.17 0.34-0.34 0.34h-1.18v0.67c0.17 0 0.17 0.17 0.34 0.17v-0.5c0.34 0 0.84 0 1.35-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m18.34 499.11c0.17 0 0.5 0 0.67-0.17h1.01c-0.17-0.17-0.17-0.34-0.34-0.34h-1.51c0 0.17 0 0.34 0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m16.49 494.56c0 0.17-0.17 0.34-0.17 0.5h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m16.99 494.56h1.18c0-0.17-0.17-0.17-0.17-0.34h-0.67l-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m18.68 496.25v-0.34c-0.34 0.17-0.67 0.34-0.5 0.84 0-0.17 0.34-0.34 0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m14.97 502.47h1.85v-1.18c-0.34 0.17-0.5 0.5-0.84 0.67-0.17 0.17-0.5 0.17-0.67 0.34-0.17 0-0.5-0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m15.14 500.62h-0.34v0.84c0.5 0 0.84-0.17 1.01-0.5 0 0 0.17 0 0.34-0.17v-0.5h-0.17c-0.34 0.34-0.5 0.34-0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m13.29 502.98h0.67c-0.17 0.17-0.17 0.34-0.34 0.5h0.84v-0.84h-0.84c0 0.17-0.17 0.34-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m16.82 501.29v1.18c0.17-0.17 0.34-0.17 0.34-0.34v-1.18h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m16.82 500.96h0.34v-0.34c-0.17 0-0.17-0.17-0.34-0.17h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m14.47 502.64v0.84h0.34v-1.01c0 0.17-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m16.49 494.56h0.34v-0.5h-0.5v0.67q0-0.17 0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m15.82 494.56c-0.17 0-0.17 0.17-0.34 0.17 0.17 0 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m15.14 500.62c0.34 0 0.5-0.17 0.84-0.17-0.34 0.17-0.5 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m18.34 497.93h1.18c0.17 0 0.34-0.17 0.5-0.17 0 0-0.17 0-0.17-0.17h-1.35q0 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m17.5 493.55 0.17-0.17s-0.17 0-0.17-0.17h-1.51v0.34s0.17 0 0.17 0.17c0.34 0 0.84 0 1.35-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m17.5 493.55c-0.5 0-0.84 0-1.35 0.17 0 0 0 0.17 0.17 0.17h1.18c-0.17 0-0.17-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m15.82 493.39h0.34v-0.5h-0.67v0.5h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m16.82 490.69v-0.17c-0.17 0.17-0.34 0.17-0.34 0.34v0.84l0.17 0.17h0.17v-0.67q0-0.34 0-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m16.82 491.7q-0.17 0 0 0c-0.17 0.17-0.17 0.34-0.17 0.34l0.17 0.17h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m17.33 492.21h-0.67v1.18h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m75.71 487.67v1.85h0.67c0.17 0.17 0.5 0.17 0.67 0.34v-2.02c-0.34 0-0.5 0.17-1.01 0.17l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m78.07 488.67v-2.19h-0.5v2.69h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m76.89 489.85c-0.17 0.5 0.17 0.67 0.67 0.67 0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m75.71 491.7c0.17-0.17 0.5-0.17 0.67-0.17h1.18v-0.34h-1.01c-0.17 0-0.17-0.17-0.34-0.34h-1.18v0.34c0.67-0.34 0.67 0.17 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m75.04 490.69h1.18v-1.35h-0.67l-0.17 0.17q0 0.17 0.17 0.34 0.5 0.84-0.5 0.84v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m79.41 485.31h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m78.07 486.49v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m31.8 483.63h0.67v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m31.8 483.63v-1.01c-0.5 0.17-0.5-0.17-0.5-0.67h-0.67v1.85h0.67c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m30.62 483.12v-1.85h-0.67v1.35c-0.34-0.17-0.34-0.34-0.5-0.34v0.84h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m29.27 479.59v1.68h0.5v-0.67h0.67v-0.5c-0.5 0.17-0.67-0.17-0.67-0.67 0 0.17-0.17 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m30.62 480.77h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m22.04 499.11c-0.17 0.17-0.5 0.5-0.84 0.5v0.34c0 0.5 0.5 0.34 0.67 0.34s0.34-0.17 0.5-0.17l0.17-0.17v-0.34c0-0.17-0.17-0.34-0.17-0.5h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m22.38 499.61v0.34h1.18c0.17-0.17 0.5-0.17 0.67-0.34 0 0 0.17 0 0.17-0.17s-0.17-0.34-0.17-0.5h-0.67v0.67h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m24.9 497.93h-0.67v1.18c0.5 0 0.67-0.17 0.67-0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m24.4 498.94v-0.5c-0.34 0-0.84 0-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m20.86 498.94h-0.17v0.5h0.5v-0.67c-0.17 0.17-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m17.33 492.21v1.01s0.17 0 0.17 0.17c0.17-0.17 0.34-0.34 0.5-0.34 0.17-0.34-0.34-0.67 0.34-0.84 0-0.5-0.34-0.34-0.67-0.17 0 0-0.17 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m17.33 493.89h-0.67v0.5h0.34q0.17-0.17 0.34-0.34h0.67c0-0.34-0.34 0-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m16.82 491.7h0.67c0.34-0.17 0.67-0.17 1.01-0.34 0.17-0.17 0.17-0.5 0.34-0.67v-0.17h-0.34c-0.34 0-0.67 0.17-1.01 0.17 0 0.5-0.34 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m17.33 490.69c0.34 0 0.67-0.17 1.01-0.17-0.17-0.5-0.67-0.17-1.01-0.34 0.17 0.17 0.17 0.34 0 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m16.82 491.03c0.17 0 0.67 0.17 0.67-0.34h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m14.64 503.65h-0.84c0.17 0.17 0.17 0.34 0.34 0.67 0.5 0 0.5-0.34 0.5-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m28.6 481.78h-0.5q-0.17 0.17-0.34 0.34c0.17 0.34 0.17 0.84 0.84 0.67 0.17-0.34 0.17-0.67 0-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m28.6 481.78v1.35c0.17-0.17 0.34-0.17 0.34-0.34v-0.84s0-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m28.94 481.95v0.84c0 0.17-0.17 0.17-0.34 0.34v0.67h0.67v-1.85h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m28.1 483.63c0 0.5 0.17 0.84 0.67 0.84v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m29.27 481.95v0.34q0.17 0.17 0.5 0.34v-1.35h-0.5c0.17 0.34 0 0.5 0 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m28.77 481.78h0.17c0-0.34 0.34-0.84-0.17-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m27.42 486.32c0.5 0 1.01 0.17 1.35-0.34v-0.34c-0.17-0.17-0.5-0.17-0.67-0.34v0.5h-0.17l-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m28.43 484.81h-0.67c0 0.17-0.17 0.5 0.34 0.67 0-0.34 0.17-0.5 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m28.77 483.63v1.01c0.17 0 0.34 0.17 0.5 0.17l0.17-0.17v-1.18c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m29.27 484.81c-0.17 0-0.34-0.17-0.5-0.17h-0.34c-0.17 0.17-0.17 0.34-0.34 0.5 0.17 0.17 0.5 0.17 0.67 0.34 0-0.5 0.5-0.17 0.67-0.34-0.17 0-0.17-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m31.29 486.49v-0.67c-0.34 0-0.67 0.17-0.67-0.34s0.34-0.17 0.67-0.34v-0.67h-1.35c0 0.34-0.17 0.5-0.17 0.84 0.17 0.34 0.17 0.5 0.34 0.84 0.17 0 0.17 0.17 0.34 0.17h0.34c0 0.17 0.17 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m31.8 483.63h-0.5v1.18h0.84c-0.17-0.17-0.17-0.34-0.34-0.5v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m31.8 486.99h-0.5v1.18h-0.67v0.5h1.18v-0.17c0-0.34 0.17-0.67 0.17-1.18 0 0-0.17-0.17-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m32.81 487.67c-0.17 0-0.34-0.17-0.67-0.17v1.01h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m32.13 488.51v-1.01h-0.17c0 0.34-0.17 0.67-0.17 1.18q0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m32.81 487.67v0.84h0.34v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m31.13 485.31c-0.17 0-0.67-0.17-0.67 0.34s0.34 0.34 0.67 0.34v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m31.29 486.49h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m34.32 490.53v-1.18h-0.5v0.84c0 0.17 0 0.34 0.17 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m33.65 488.67h-0.67v0.67h0.67c0.17-0.17 0.17-0.34 0-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m34.32 489.35h0.67c0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m33.14 489.35v-0.84h-0.34l-0.17 0.17c-0.17 0.34-0.34 0.5 0.17 0.67q0 0.17 0.34 0-0.17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m36.17 487.67c0-0.34 0-0.67-0.5-0.67v0.67l0.17 0.17s0.17 0 0.34-0.17c-0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m35.84 487.83-0.17-0.17h-0.67v0.5s0.17 0 0.17 0.17c0.17-0.17 0.5-0.34 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m35 487.67h0.67v-0.34h-1.01v0.17s0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m35.84 487.83c-0.17 0.17-0.5 0.34-0.67 0.5 0 0.34 0.17 0.5 0.5 0.34v-0.5h0.5c0-0.17-0.17-0.34-0.17-0.5 0 0.17-0.17 0.17-0.17 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m36.17 488.17h-0.5v0.5c0.17 0 0.17 0.17 0.34 0.17 0-0.34 0-0.5 0.5-0.34 0.17 0 0.17-0.17 0.34-0.17-0.34 0-0.5 0-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m73.19 488.17v0.5h1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m74.36 488.17v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m70.66 487.67h-1.35v0.5c0.17 0 0.34 0 0.67 0.17v1.01c0.17 0 0.34-0.17 0.67-0.17 0-0.17 0.17-0.34 0.17-0.34v-0.17c0-0.17-0.17-0.17-0.17-0.34v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m72.51 487.67h-0.67c-0.17 0.17-0.5 0.17-0.67 0.34v0.34h1.35v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m71.17 488.17v-0.34c0-0.34-0.34-0.34-0.5-0.34v0.67c0 0.17 0.17 0.17 0.17 0.34 0.17 0 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m73.19 488.67v-0.17c-0.17-0.17-0.5-0.17-0.67-0.34v0.34c0.5 0.34 0.34 0.67 0.34 1.01v1.18c0 0.17-0.17 0.17-0.34 0.34v0.34h0.67v-2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m69.99 489.35v-1.01c-0.17 0-0.34 0-0.67-0.17v-0.5h-0.5v0.67c0.17 0.5-0.34 0.5-0.67 0.5v0.67h1.18c0.34-0.17 0.5-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m68.14 485.31h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m75.04 488.17v0.5h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m30.45 492.71h0.34c0.17 0 0.34 0.17 0.34 0.17v1.01h-0.67v1.18h0.67c0-0.17 0-0.34 0.17-0.5h0.5v-2.36c-0.17 0-0.34-0.17-0.5-0.17v-1.18h-0.34v0.84c0 0.17-0.17 0.17-0.34 0.34 0 0.34-0.17 0.5-0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m30.62 492.21c0.17-0.17 0.34-0.17 0.34-0.34v-0.84h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m30.62 491.03h0.67v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m30.62 495.07v-1.18h-0.34v0.84c0 0.17-0.17 0.17-0.34 0.34v1.68h0.67v-0.5-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m29.95 495.07c0.17-0.17 0.34-0.17 0.34-0.34v-0.84c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m30.62 496.75h-0.67v-0.5h-0.34c0 0.34 0 0.5-0.34 0.67 0 0 0 0.17 0.17 0.17h0.84c0.17 0 0.17 0.17 0.34 0.34h0.67c-0.17-0.17-0.17-0.34-0.34-0.67h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m28.1 504.15q0.17-0.17 0.34-0.34t0.34-0.34c0.17-0.17 0.34-0.17 0.67-0.34v0.84h0.5c-0.17-0.34-0.34-0.84-0.5-1.18h-0.67c-0.17 0-0.17-0.17-0.34-0.34-0.17 0-0.5-0.17-0.67-0.17-0.17-0.17-0.34-0.17-0.34-0.34v-0.67h-0.5v-0.67l0.17-0.17c0.17 0 0.17 0.17 0.34 0.17v0.34h1.01v-0.84h-1.51c-0.17 0.17-0.34 0.17-0.34 0.34v0.84c0.5 0.34 0.17 0.67 0.17 1.18 0.67 0 0.67 0.5 0.67 0.84 0.17 0 0.34 0 0.5 0.17 0.17 0.34 0.17 0.5 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m29.95 502.47q0 1.01 1.18 1.01h1.01q0.17-0.17 0.34-0.34v-0.34h-1.85v-0.5c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m28.77 501.29v0.34c0.17 0.17 0.5 0.34 0.84 0.67h0.34l0.5-0.5c0.17-0.17 0.17-0.34 0.34-0.67h-0.84v-0.67c-0.34 0-0.34 0.17-0.34 0.34s-0.17 0.34-0.17 0.34c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m29.95 504.15h-0.5v0.5c0 0.5 0.17 0.84 0.17 1.35h0.34v-1.18h0.67c0-0.17-0.17-0.34-0.17-0.34-0.17-0.17-0.34-0.34-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m28.43 500.45v0.84h0.34v-1.35h0.17c0.17-0.17 0.34-0.34 0.5-0.34h-1.01v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m27.76 502.47c0.17 0 0.5 0.17 0.67 0.17-0.5-0.34-0.34-0.84-0.34-1.35h-0.34v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m29.95 502.13h-0.34q0.17 0.17 0.34 0.34h0.67v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m28.43 502.64q0.17 0.17 0.34 0.34h0.67c-0.17-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m33.14 501.97h1.18v-0.5h-2.69c0 0.17 0 0.34-0.17 0.67h1.01c0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m34.66 502.13s-0.17 0 0 0c-0.17 0.34-0.34 0.5-0.34 0.84q0.17 0 0.34 0.17h0.67c0-0.17 0.17-0.34 0.17-0.5-0.17-0.17-0.5-0.34-0.84-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m32.47 502.98v0.34h1.35c-0.17-0.17-0.17-0.34-0.34-0.5-0.17 0-0.17-0.17-0.34-0.17s-0.5 0.17-0.67 0.17v0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m34.66 502.13c0.17 0 0.17-0.17 0.34-0.17v-0.67h-0.67v0.5c0.17 0.17 0.17 0.34 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m32.47 502.64c0.17 0 0.5-0.17 0.67-0.17v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m34.32 502.98c0-0.34 0.17-0.5 0.17-0.84h-0.34c-0.5 0-0.5 0.17-0.34 0.5 0 0 0 0.17 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m34.32 502.98h-0.34v0.67h0.34c0.34 0 0.34-0.34 0.34-0.5-0.17 0-0.34-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m33.14 503.31h-0.67q-0.17 0.17-0.34 0.34h0.67c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m33.14 502.47c0.17 0 0.17 0.17 0.34 0.17-0.17 0-0.34 0-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m34.66 503.14c0 0.17 0 0.5-0.34 0.5 0 0.34 0 0.67 0.5 0.67l0.67-0.67h0.17c-0.17-0.17-0.17-0.5-0.34-0.67-0.17 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m35.67 505.33c0.17-0.17 0.17-0.34 0.34-0.5h-0.34c-0.17 0-0.34 0-0.5 0.17l-0.5 0.5c0.17-0.17 0.5-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m35 504.83c0.17 0 0.34 0 0.5-0.17 0.17-0.5-0.34-0.5-0.67-0.5l-0.17 0.17c0.34 0.17 0.34 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m29.61 506c0-0.5-0.17-0.84-0.17-1.35-0.17 0-0.5 0.17-0.67 0.17s-0.34 0-0.5 0.17c-0.17 0-0.17 0.17-0.34 0.34h0.5c0.17 0.67 0.5 1.01 1.01 1.18 0-0.17 0-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m57.54 499.61v-0.67h-1.35v-0.5h-0.5v0.5h-1.35v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m52.49 498.94h1.18v-0.5h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m53.67 498.43v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m52.49 498.43h1.18c-0.17-0.5 0.17-0.67 0.67-0.67v-0.5h-1.85v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m53.67 497.26h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m57.54 498.94h0.5v-0.5c0.17-0.17 0.17-0.34 0.34-0.67h-0.84v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m58.04 498.43v0.5h1.35v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m59.39 498.6v0.5h0.67v-0.5c-0.17-0.17-0.5-0.17-0.67 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m49.63 483.63c-0.17 0-0.34 0.17-0.67 0.17v0.34c0.17 0.17 0.17 0.34 0.34 0.67h0.34v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m49.63 484.81h-0.34v0.67h0.67v-0.67h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m49.97 485.31h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m49.97 484.81v0.67h0.67v-2.36h-0.67v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m49.97 484.81v-1.01h-0.34v1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m49.97 483.12h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m45.26 501.63h-0.34v0.84h-0.84v0.17c0.17 0 0.5 0 0.67 0.17 0.34 0.17-0.17 0.84 0.5 0.84v-1.68-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m45.26 501.97v1.68h0.34v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m43.91 501.63v-0.34h-0.84c0 0.34 0.17 0.5 0.17 0.84 0 0 0.17 0 0.17-0.17 0.17-0.17 0.34-0.17 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m43.24 502.13c0-0.34-0.17-0.5-0.17-0.84v-0.67h0.84c0-0.34-0.17-0.67-0.17-1.01h-1.18v-0.67h-0.67v0.67h-0.67v0.67q1.35 0 1.35 1.18v1.18h0.17c0.34-0.17 0.5-0.17 0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m40.55 501.97h1.35v-0.5h-1.85v0.67c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m41.89 501.29v1.18h0.67v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m40.55 501.97h-0.5v1.01h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m41.89 502.47v-0.67h-0.67c-0.17 0.67 0.17 0.84 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m40.55 503.65h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m40.04 504.15h0.5v-0.5c-0.5-0.17-0.5 0.17-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m46.94 502.47v-0.67h-0.67v0.5c0.17 0.17 0.34 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m45.59 501.97h0.67v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m46.27 501.29v0.67h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m35 504.15c0.34 0 0.84 0 0.67 0.5h0.34c0.34 0 0.67-0.17 1.18-0.17 0-0.17-0.17-0.34-0.17-0.67v-0.84h-0.67v-0.5h-0.67c0 0.17-0.17 0.34-0.17 0.5 0.17 0.17 0.17 0.5 0.34 0.67h-0.17c-0.34 0.34-0.5 0.34-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m36.85 503.82c0 0.17 0.17 0.34 0.17 0.67h1.01c0.17 0 0.17-0.17 0.34-0.34 0-0.17-0.17-0.17-0.17-0.34h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m40.04 504.15c0-0.34 0-0.67 0.5-0.67v-0.5h-1.18v1.35c0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m39.37 504.15v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m38.7 504.15v-0.67h-0.5v0.34c0 0.17 0.17 0.17 0.17 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m49.13 477.07h0.17v-0.84h-0.5c0 0.34 0.17 0.5 0.34 0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m54.34 484.3 0.17-0.17c0-0.34 0-0.67-0.17-1.01v-1.18h-0.67v2.19c0.34 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m53.5 481.61c-0.17-0.17-0.5-0.34-0.67-0.67-0.17 0.17-0.34 0.5-0.5 0.67l0.17 0.17c0.34 0.17 0.67 0 1.01-0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m68.14 480.77h-0.67v0.67c0.17 0.17 0.34 0.17 0.34 0.34v0.84h0.34v-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m36.17 489.35h1.35v-0.34h-1.51q0 0.17 0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m37.52 489.01v0.34h0.67v-0.5c-0.34 0-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m51.82 484.81h1.35v-0.5h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m68.14 485.98v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m68.14 485.98h-0.67v0.67c0.67 0 0.84-0.17 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m67.8 482.62v-0.84c0-0.17-0.17-0.17-0.34-0.34v1.35c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m30.62 490.53h0.67v-1.35h-1.35c0 0.34 0 0.67 0.67 0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m29.95 489.35h0.67v-1.18h-0.67v0.5 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m29.95 488.67v-1.18h-0.84c0.34 0.34 0.34 0.67 0.34 1.01 0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m29.61 487.67h0.34v-1.35c-0.17-0.34-0.17-0.5-0.34-0.84-0.17 0-0.17-0.17-0.34-0.17s-0.67-0.17-0.67 0.34v0.34h0.34c0.5 0.17 0.34 0.67 0.5 1.01 0.17 0.17 0.17 0.34 0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m28.94 487.67h0.34c-0.17-0.17-0.84-0.5-1.18-0.34 0 0-0.17 0.17-0.17 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m24.9 497.93v0.5c0.17 0.5-0.17 0.67-0.67 0.67 0 0.17 0.17 0.34 0.17 0.5l0.17 0.17c0.5 0 0.17 0.34 0.34 0.67 0.5 0 0.84 0.34 0.84 0.67 0 0.17 0.17 0.17 0.34 0.34v-0.5c0-0.5 0.17-0.67 0.67-0.5 0-0.34-0.17-0.67 0.34-0.67 0 0 0.17-0.17 0.17-0.34v-0.84h-0.5c-0.17 0.34-1.01 0.67-1.35 0.5 0 0-0.17-0.17-0.17-0.34v-0.67c0.17-0.17-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m28.77 497.93h-1.35v0.67h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m29.44 497.26c-0.5 0-0.84 0.17-0.67 0.67 0.5 0 0.67 0 0.67 0.5v0.17c0.34 0 0.5-0.17 0.84-0.17v-0.34h-0.84c0.17-0.34 0.34-0.67 0.5-0.84h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m29.44 497.26h1.18c-0.17-0.17-0.17-0.34-0.34-0.34h-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m68.81 497.93v1.18h0.5v-1.01c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m69.32 497.93h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m69.32 497.93v-1.68c0.17 0 0.34 0 0.67-0.17v-0.5h-0.67v-1.01h-1.18c-0.5 0.17-0.67-0.17-0.67-0.67-0.5-0.17-0.67 0.17-0.67 0.67v0.5c0.5-0.17 0.67 0.17 0.67 0.67 0.5-0.17 0.84 0.17 0.67 0.67 0.5-0.17 0.67 0.17 0.67 0.67v1.18c0.17-0.34 0.34-0.34 0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m68.81 497.26v-0.5c0-0.5-0.17-0.67-0.67-0.67v1.18h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m48.12 493.89v-1.68h-1.18v1.18h0.5c0 0.17 0 0.34 0.17 0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m39.37 492.71h0.67v-0.5c-0.17 0-0.34 0-0.34-0.17 0 0-0.17 0-0.17 0.17-0.17 0.17-0.17 0.34-0.34 0.34h-1.01c0.17 0 0.5 0.17 0.67 0.17h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m39.03 491.37c-0.34-0.5-1.01-0.17-1.51-0.34v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m38.02 492.54h1.01c0.17 0 0.17-0.17 0.34-0.34-0.5 0.17-1.01 0.17-1.35 0.34-0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m37.86 491.37h-0.34v0.84c0.17 0 0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m37.52 492.21v-1.18h-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m36.17 493.39v-1.01c-0.17 0-0.34-0.17-0.5-0.17v-0.5h-0.67v0.67c0 0.5-0.17 0.5-0.67 0.34v-0.5h-1.18v0.5c-0.67-0.17-0.67 0.17-0.67 0.67h1.35 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m36.17 493.39h-2.36v0.34h0.84c0.17 0 0.17 0.17 0.34 0.34 0.5 0 0.67 0.17 0.67 0.67h0.5v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m36.17 494.56h-0.5v0.5q0.17 0.17 0.34 0.34s0.17 0 0.17 0.17h0.5c0-0.17 0.17-0.34 0.17-0.34v-0.5c-0.34-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m35 491.03h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m34.32 490.53h-0.5v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m48.12 493.89h-0.67c0-0.17 0-0.34-0.17-0.5h-0.5v1.18h1.18c0.17-0.17 0.17-0.5 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m40.04 501.29h0.5v-0.5h-0.5v-0.5h-1.35c0.17 0.17 0.17 0.34 0.34 0.5 0.5 0 0.34 0.34 0.34 0.67 0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m41.22 500.28v-0.67h-0.67c-0.5-0.17-0.5 0.17-0.5 0.67h1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m38.7 500.28h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m38.7 497.93h-0.5v1.18h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m38.7 498.94h-0.5v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m36.85 495.07c0 0.17-0.17 0.34-0.17 0.34s0 0.17 0.17 0.17q0.17 0.17 0.34 0.34t0.34 0.34v-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m37.52 496.25q-0.17-0.17-0.34-0.34t-0.34-0.34v0.67c0.17 0.17 0.17 0.34 0.34 0.5 0.17 0 0.34 0 0.34-0.17v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m38.19 497.93v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m37.52 497.59v-1.01c-0.17 0-0.34 0-0.34 0.17v0.34c0 0.17-0.17 0.5 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m48.12 494.56h-0.67v1.68h0.67c-0.17-0.5 0.17-0.67 0.67-0.67v-0.5h-0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m43.91 500.79h-0.84v0.67h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m44.42 499.11h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m45.59 501.97v-1.18s-0.17 0-0.17-0.17c0 0.34-0.17 0.67-0.17 1.01v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m45.59 500.79v0.5h0.67v-0.67c-0.34 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m50.64 495.57h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m48.79 495.57c-0.5 0-0.84 0.17-0.67 0.67h0.67v0.5h0.5v-1.18h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m49.3 496.25v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m43.74 499.61v-0.67h-1.18v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m60.57 498.43v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m61.24 497.93v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m69.99 497.26v0.67h0.34c0.17 0 0.5-0.17 0.67-0.17 0 0 0.17 0 0.17-0.17v-0.34h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m48.12 490.53h0.67v-0.5h0.5v-1.35c-0.17 0.17-0.34 0.34-0.34 0.5 0 0.5-0.34 0.84-0.84 0.84v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m65.62 494.56h0.67q0-1.18 1.18-1.18h0.67v-0.5h-1.18c-0.17-0.67-0.84-0.34-1.35-0.5v2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m69.32 489.35h-1.85v0.5c0.17 0 0.34 0 0.5 0.17 0 0.17 0 0.34 0.17 0.5h1.18v-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m68.81 490.53h-0.67c0-0.17 0-0.34-0.17-0.5-0.17 0-0.34 0-0.5-0.17v-0.5h-0.67v1.18h0.5c0.17 0.84 0.84 0.34 1.35 0.5 0.17-0.17 0.17-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m68.81 490.53v1.68h0.5v0.5h0.67v-1.01h-0.67v-1.01c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m68.81 492.21c-0.34 0-0.84 0-0.67 0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m62.42 494.56h-0.5v2.19h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m61.24 497.26h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m68.14 497.26v-1.18h-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m66.79 495.07v-0.5h-0.5v1.01h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m66.79 495.57v0.67h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m54.34 496.75v0.67h2.52v-0.5c-0.84-0.17-1.68-0.17-2.52-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m56.87 496.75v0.5h0.67v-0.67c-0.17 0.17-0.5 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m51.82 484.81v-0.5h-0.5v1.01h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m49.3 496.25h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m57.54 497.93h1.85v-1.35h-0.5c0 0.17-0.17 0.34-0.17 0.67h-1.18v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m57.54 497.26h0.5v-0.67h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m59.73 496.75c0.5 0 0.34-0.34 0.34-0.5h-0.67v0.5h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m61.91 496.25v-1.68h-0.67v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m61.24 497.26v-0.67h-0.34c-0.17 0-0.17 0.17-0.34 0.17-0.17 0.17-0.34 0.17-0.5 0.34v0.5h0.5v-0.5c0.34 0.17 0.5 0.17 0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m60.9 496.75h0.34v-1.35c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m59.73 496.75h-0.34v0.67h0.67c-0.17-0.34-0.17-0.5-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m24.9 504.66h0.5v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m26.75 502.64c0-0.34 0.34-0.84-0.17-1.18h-0.34v1.35h-0.67v0.67h0.34c0.17-0.17 0.5-0.17 0.67-0.34 0 0 0-0.17 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m26.41 503.31c-0.17 0.17-0.5 0.17-0.67 0.34q0.17 0.17 0.34 0.34h0.67c0-0.34 0.34-0.67-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m29.44 504.15v-0.84c-0.34 0.17-0.5 0.17-0.67 0.34v0.84c0.17-0.17 0.34-0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m25.57 503.65v-0.67c-0.67-0.17-0.5 0.34-0.5 0.67v0.67h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m21.54 505.84c-0.17 0.17-0.17 0.34-0.34 0.5 0.17 0 0.34 0.17 0.5 0.17 0.34 0 0.67-0.17 1.18-0.17 0-0.34 0.17-0.5 0.17-0.84-0.17 0-0.5 0.17-0.5-0.34h-0.67c-0.17 0.34 0.17 0.67-0.34 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m23.05 505.67c0 0.34-0.17 0.5-0.17 0.84h0.84v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m23.05 505.67h0.67v-0.34c-0.34 0-0.67-0.17-1.01-0.17l-0.17 0.17c-0.17 0.34 0.17 0.17 0.5 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m22.71 505.16c0.34 0 0.67 0.17 1.01 0.17 0.17-0.17 0.17-0.34 0.34-0.5-0.84 0-0.84-0.17-0.5-0.67-0.17 0-0.34-0.17-0.5-0.17v0.84s-0.17 0-0.34 0.34v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m23.55 503.99q-0.34 0.67 0.5 0.84s0.17 0 0.17-0.17v-0.34h-0.17c-0.17-0.17-0.34-0.34-0.5-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m24.23 504.15v0.34c0.34 0 0.5 0 0.84 0.17v-0.5h-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m16.49 502.47h-0.84c0.17 0.34 0.17 0.67 0.34 1.18h0.34l0.17-0.17c0.34-0.34 0.67-0.17 1.01-0.17 0-0.34-0.17-0.34-0.34-0.34h-0.84c0-0.17 0-0.34 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m16.32 503.48v0c-0.17 0.34-0.17 0.67-0.17 1.01h0.5v0.67c0.5 0.17 0.84 0 1.01-0.5-0.17-0.17-0.34-0.17-0.34-0.34v-0.84h-0.34c-0.17 0.17-0.34 0.34-0.5 0.67h-0.17c0.17-0.17 0.17-0.34 0-0.67v0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m18 505.33v0.34c0.17-0.17 0.34-0.17 0.34-0.34v-0.5c-0.17 0-0.17-0.17-0.34-0.17h-0.34v0.17c0.67-0.17 0.34 0.34 0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m18 504.49c0.17 0 0.17 0.17 0.34 0.17 0-0.17 0.17-0.17 0.17-0.34q0.17-0.17 0.34-0.17c0.34-0.17 0.67-0.17 1.01-0.34 0-0.17 0-0.34 0.17-0.5 0-0.17-0.17-0.17-0.17-0.34-0.17-0.17-0.5-0.17-0.5-0.34-0.17-0.34-0.17-0.67-0.17-0.84h-0.5c-0.17-0.84 0-1.18 0.84-1.18 0-0.17 0.17-0.17 0.17-0.34-0.34 0-0.67-0.17-1.01-0.17-0.17 0.17-0.17 0.34-0.34 0.34h-0.67v0.17c-0.17 0.17-0.34 0.34-0.5 0.34v1.18c0 0.17-0.17 0.17-0.34 0.34h-0.34c0 0.17-0.17 0.17-0.34 0.5h0.84c0.17 0 0.5 0 0.34 0.34v0.34h0.34c0.17 0.17 0.34 0.17 0.34 0.34 0.17 0.17 0 0.34 0 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m19.85 504.66c0 0.34 0.17 0.5 0.17 0.84 0 0-0.17 0-0.34 0.17 0.34 0.17 0.5 0.17 0.67 0.17s0.17 0 0.34-0.17v-1.35h-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m20.02 504.49h0.34c0-0.17 0.17-0.5-0.34-0.67-0.34 0.17-0.67 0.17-1.01 0.34 0 0.17-0.17 0.5 0.34 0.5v-0.5c0.34 0 0.5-0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m20.02 504.49c0-0.5-0.34-0.34-0.67-0.34v0.5h0.67q-0.17 0 0-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m20.86 505.84q-0.17 0-0.34 0.17v0.5c0.5 0 0.17-0.34 0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m19.85 503.82c0.5 0 0.34 0.34 0.34 0.67h0.5v1.35h0.34v-0.84c0-0.17 0-0.5-0.17-0.67 0-0.17-0.17-0.17-0.17-0.34 0-0.5-0.34-0.67-0.84-0.67 0.17 0.17 0.17 0.34 0 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m21.2 504.99v0.84h0.34v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m71.17 497.26v0.34h1.01c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m72.51 497.26s0.17 0 0 0h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m74.03 496.75c0-0.17-0.17-0.34-0.17-0.5v-2.86h-0.5v3.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m75.04 493.89v-1.68h-0.67c0.17 0.5-0.34 0.5-0.67 0.5v0.67h0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m75.71 491.7c0-0.34 0-0.67-0.5-0.67v1.18h0.5c-0.17-0.17-0.17-0.34 0-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m75.04 493.89h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m74.36 494.56v-1.01h-0.67v1.18h0.34c0.17-0.17 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m19.85 498.94h-0.34v0.34c0.17 0.34 0.5 0.67 0.34 1.18 0.17 0 0.5-0.17 0.67-0.17 0-0.17 0.17-0.17 0.17-0.34h-0.5v-0.84s-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m20.19 499.11v0.84h0.84v-0.34h-0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m19.85 500.45c0.17-0.5-0.17-0.67-0.34-1.18-0.5 0-0.34 0.34-0.34 0.67 0.5 0 0.34 0.34 0.34 0.5h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m19.35 499.95c0-0.17-0.17-0.5 0.34-0.67v-0.34h-0.67v0.67c0 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m17.16 500.96c0.17-0.17 0.34-0.34 0.5-0.34v-0.17h0.67c0.17 0 0.17-0.17 0.34-0.34h-1.51v0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m75.54 488.67h-0.5v0.67h0.5l0.17-0.17c-0.17 0-0.17-0.17-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m75.04 490.69v-0.17h-0.67c-0.17 0.5 0.17 0.5 0.67 0.5v-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m75.54 489.52h-0.5c-0.17 0-0.17 0.17-0.34 0.17 0.17 0.34 0.17 0.67 0.34 0.84q1.01 0 0.5-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m29.27 483.63v1.18h0.5v-0.5c0-0.5 0.17-0.67 0.67-0.67v-0.67h-1.18c0.17 0.34 0 0.5 0 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m31.29 484.81v-1.18h-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m22.38 499.95c-0.17 0-0.34 0.17-0.5 0.17q-0.17 0.17-0.34 0.34c-0.17 0-0.17 0.17-0.34 0.17 0.17 0.17 0.5 0.17 0.67 0.34 0-0.5 0.5-0.17 0.67-0.34v-0.5q-0.17 0-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m21.2 500.79c0.17 0 0.17-0.17 0.34-0.17q0.17-0.17 0.34-0.34c-0.17 0-0.67 0.17-0.67-0.34h-0.34c0 0.17-0.17 0.17-0.17 0.34v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m22.38 499.95s0 0.17 0.17 0.17h1.18v-0.34c-0.5 0.17-0.84 0.17-1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m23.72 499.95v0.84c0.17 0 0.5-0.17 0.67-0.17v-0.84c-0.34 0-0.5 0-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m24.4 499.61v0.84h0.34v-0.84l-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m29.95 484.81h-0.5l-0.17 0.17c0 0.17 0.17 0.34 0.17 0.5 0.17 0 0.17 0.17 0.34 0.17 0-0.34 0-0.67 0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m30.62 484.81v-1.18c-0.5-0.17-0.67 0.17-0.67 0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m29.95 486.32v2.02h0.34v-1.68q-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m30.28 486.49v1.68h0.34v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m32.64 489.52c-0.34-0.17-0.34-0.5-0.17-0.67l0.17-0.17h-1.01v1.35c0.17 0 0.17 0.17 0.34 0.17l0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m30.62 486.99v1.18h0.67v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m31.8 489.85v-1.18h-0.5v1.35c0.17-0.17 0.34-0.17 0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m31.29 489.35v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m33.82 491.03v-0.5c0-0.17 0-0.34-0.17-0.34 0 0-0.17 0-0.17 0.17q-0.17 0.17-0.34 0.34h-0.67v1.18h0.34v-0.67c0.34-0.17 0.67-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m33.48 490.19s0.17 0 0.17-0.17v-0.17c-0.17-0.17-0.5-0.34-0.67-0.5h-0.34c-0.17 0.17-0.34 0.5-0.5 0.67h0.17c0.34 0.17 0.67 0.17 1.18 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m32.98 489.52c0.17 0.17 0.5 0.34 0.67 0.5v-0.67c-0.17 0-0.34 0-0.67 0.17q0-0.17 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m73.19 488.67v1.18h0.17v-0.67h1.01v-0.67c-0.34 0.17-0.67 0.17-1.18 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m74.36 488.67v1.01h0.34c0.17 0 0.17-0.17 0.34-0.17v-0.67c-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m72.85 489.68c0-0.34 0.17-0.67-0.34-1.01v-0.34h-1.35c-0.17 0.17-0.17 0.34-0.34 0.34v0.17c0.34 0 0.67-0.17 1.01-0.17v0.5q0.17 0 0.34 0.17c0.34 0 0.5 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m70.66 489.18c-0.17 0-0.34 0.17-0.67 0.17v1.35h0.67c0-0.34 0.17-0.67 0.17-1.01v-0.17c0-0.17-0.17-0.34-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m70.66 489.18 0.17 0.17h0.67c0.17 0 0.17-0.17 0.34-0.34v-0.5c-0.34 0-0.67 0.17-1.01 0.17 0 0.17-0.17 0.34-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m73.19 491.37h-0.67c0 0.5-0.5 0.17-0.67 0.34v0.5h1.35v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m71.84 489.01c-0.17 0.17-0.17 0.34-0.34 0.34h-0.67v0.17c0.17 0 0.17 0.17 0.34 0.17q0.17 0.17 0.34 0.34h1.35v-0.34c-0.17-0.17-0.5-0.34-0.67-0.5 0 0-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m73.19 491.37v0.34h0.5v-1.01c-0.5 0-0.17-0.34-0.34-0.67h-0.17v1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m71.84 490.02h-0.34v1.18c0.17 0.17 0.17 0.34 0.34 0.34h0.67v-0.34c-0.5 0.17-0.67 0-0.67-0.5v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m72.85 489.85h-0.34v1.01c0.17-0.17 0.34-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m69.99 489.85v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m32.47 493.39c0-0.34 0-0.67 0.67-0.67v-0.5c-0.5 0-0.84-0.17-0.67-0.67h-1.18v0.5c0.17 0 0.34 0.17 0.5 0.17v1.68h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m30.62 495.07v1.18h1.01v0.5h0.17v-1.35c0-0.17 0.17-0.17 0.34-0.34h0.34v-0.5h-1.18c0 0.17 0 0.34-0.17 0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m31.8 494.56h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m31.29 491.7h0.5v-0.67h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m31.29 491.03h0.5c0-0.34 0-0.67 0.34-0.84-0.17 0-0.17-0.17-0.34-0.17h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m31.63 496.75v-0.5h-1.01v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m31.63 496.75h-0.67c0.17 0.17 0.17 0.34 0.34 0.67h2.19c-0.17-0.17-0.17-0.34-0.34-0.34h-0.84c-0.17 0-0.17-0.17-0.34-0.34h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m31.46 497.26h-0.67v1.18h0.67v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m30.96 498.6v-1.18h-0.34v1.35c0-0.17 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m26.25 501.63h0.34v-0.84c0-0.17 0.17-0.17 0.34-0.34v-0.34c-0.5 0-0.67 0-0.67 0.5v0.5q0 0.34 0 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m26.75 500.28v0.34h1.18v-0.84l-0.5 0.5v0.17c0-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m27.42 501.29v-0.34c0-0.17-0.17-0.17-0.34-0.17l-0.17 0.17v0.67h0.5q0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m27.42 501.29v1.01c0 0.17 0.17 0.17 0.34 0.34v-1.18c-0.17-0.17-0.34-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m28.1 499.61v0.84h0.34v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m32.47 502.64v-0.84h-1.01c-0.17 0.5-0.5 0.17-0.84 0.34v0.34h1.18v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m31.8 502.98v-0.5h-1.18v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m29.27 501.29c0-0.17 0.17-0.34 0.17-0.34 0-0.17 0-0.34 0.34-0.34-0.17-0.5 0.17-0.67 0.67-0.67v-1.01h-0.67c0 0.17-0.17 0.17-0.17 0.34 0 0 0 0.17-0.17 0.17 0 0.67 0 1.18-0.17 1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m29.27 501.29c0-0.67 0.17-1.18 0.17-1.85 0 0-0.17 0-0.17 0.17-0.17 0.17-0.34 0.34-0.5 0.34h-0.17v1.35h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m29.95 500.45v0.67h1.35c0.17-0.5-0.34-0.34-0.67-0.5v-0.5c-0.34 0.17-0.5 0.34-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m31.29 501.13h-0.5c-0.17 0.17-0.17 0.34-0.34 0.67 0.34 0 0.67 0.17 1.01 0.17 0-0.17 0-0.34 0.17-0.67-0.17 0-0.34-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m31.46 501.97c-0.34 0-0.67-0.17-1.01-0.17l-0.5 0.5h0.67c0.17-0.17 0.67 0.17 0.84-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m29.44 499.61s0.17 0 0.17-0.17c0 0 0-0.17 0.17-0.17h-1.01c-0.17 0-0.17 0.17-0.34 0.34h1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m34.32 501.29h0.67c-0.17-0.5 0.17-0.67 0.67-0.67h0.5v-0.17c-0.17 0-0.17-0.17-0.34-0.17-0.34 0.34-1.18 0.34-1.68 0-0.5 0-0.67-0.17-0.5-0.67-0.17 0-0.34 0-0.5-0.17v1.68c0.34 0.17 0.67 0.17 1.18 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m33.14 501.29v-0.67h-1.35v-0.5h-1.18v0.5c0.34 0.17 0.84 0 0.67 0.5 0.17 0 0.17 0.17 0.34 0.17h1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m35.5 502.64v0c0.17-0.34 0.17-0.5 0.17-0.67-0.17 0-0.5 0-0.67 0.17l-0.17 0.17c0.17 0 0.5 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m35 501.97c0.17 0 0.5 0 0.67-0.17 0.17 0 0.34-0.17 0.5-0.17 0-0.17 0-0.34 0.17-0.34-0.5 0.17-0.5-0.17-0.5-0.67-0.5-0.17-0.84 0.17-0.67 0.67-0.17 0.17-0.17 0.5-0.17 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m57.54 498.94v-1.01h-0.67c0.17 0.5-0.17 0.67-0.67 0.67v0.5c0.5-0.17 0.84-0.17 1.35-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m56.19 498.6c0.5 0 0.84-0.17 0.67-0.67h-1.18v0.5c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m54.34 498.43v0.5h1.35v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m54.34 497.93c-0.5 0-0.67 0.17-0.67 0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m55.69 497.93h1.85v-0.5h-3.2v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m59.39 497.93h-1.01c-0.17 0.17-0.17 0.34-0.34 0.67h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m59.39 497.93v0.67h0.67v-0.5c-0.17-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m41.22 500.28h-1.18v0.5h1.18c0.5 0 0.67 0.17 0.67 0.67h0.67q0-1.18-1.35-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m40.04 501.29h-0.67c0.17 0.5-0.17 0.67-0.67 0.67v0.67h1.35v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m41.89 501.29c0.17-0.5 0-0.67-0.67-0.67h-0.67v0.5c0.5 0.17 0.84 0.17 1.35 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m40.04 502.47h-1.35v0.5h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m38.19 503.82v-0.34h-1.35v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m36.85 503.65h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m36 501.63c-0.17 0-0.34 0.17-0.5 0.17v0.67h0.5v-0.67c0.17 0 0 0 0-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m36.17 502.47v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m39.37 502.98h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m38.7 503.65v-1.85h-0.5v1.68c0.17 0.17 0.34 0.17 0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m26.25 501.63v-0.34c-0.17-0.17-0.34-0.17-0.34-0.34 0-0.5-0.34-0.67-0.84-0.67v1.18h0.5v1.68h0.67v-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m26.75 500.28h0.84v-0.17l0.5-0.5c-0.17-0.5 0.17-0.67 0.67-0.67v-0.5h-1.35v0.84c0 0.17 0 0.34-0.17 0.34-0.5 0-0.34 0.34-0.5 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m24.9 500.45v-0.34c-0.17-0.17 0.17-0.67-0.34-0.67v0.84c0.17 0.17 0.34 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m28.77 498.43v0.5h0.67v-0.5c0.17-0.5-0.17-0.67-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m30.28 497.26h-0.34c-0.17 0.34-0.34 0.5-0.5 0.84h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m30.28 497.26v1.18h0.34v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m29.44 498.77v0.34c0 0.17 0.17 0.17 0.17 0.34h0.17c0-0.17 0.17-0.17 0.17-0.34 0.17-0.17 0.17-0.34 0.34-0.5-0.34 0-0.67 0-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m69.99 495.57v0.5c-0.17 0-0.34 0-0.67 0.17v1.01h0.67c-0.17-0.5 0.17-0.67 0.67-0.67v-0.5h1.18v-0.67c0-0.17 0-0.34-0.17-0.5-0.17 0-0.34 0.17-0.5 0.17-0.17 0.17-0.17 0.34-0.34 0.34-0.17 0.17-0.5 0.17-0.84 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m66.29 494.56h0.5c0-0.5 0.17-0.67 0.67-0.67v-0.5q-1.18-0.17-1.18 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m69.32 494.56v1.01h0.67c0-0.17-0.17-0.5 0.34-0.5 0.17-0.17 0.17-0.34 0.34-0.5h-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m66.79 495.57h0.67c0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m67.47 495.57v0.67h0.67c0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m67.47 493.89c-0.17 0.5 0.17 0.67 0.67 0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m68.14 493.89v0.67h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m68.81 493.89v0.67h0.5v-0.5c-0.17-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m32.47 491.7c-0.17 0.5 0.17 0.67 0.67 0.67h1.18v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m32.47 493.39v0.67h1.35v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m34.32 491.7v1.18c0.5 0.17 0.67 0 0.67-0.34v-0.67c-0.34-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m33.82 493.55v0.34h1.18c-0.17-0.17-0.17-0.34-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m35.67 494.56c0-0.5-0.17-0.67-0.67-0.67v0.34c0.17 0.17 0.34 0.17 0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m36.17 495.4s-0.17 0-0.17-0.17c-0.5 0-1.18-0.17-1.68 0.34-0.17 0.34-0.17 0.5-0.34 0.84 0.5 0 0.84-0.17 1.18-0.17s0.84-0.17 1.01 0.5v-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m34.32 495.57c0.5-0.5 1.01-0.34 1.68-0.34q-0.17-0.17-0.34-0.34c-0.5 0.17-0.84-0.17-0.67-0.67v-0.5h-0.67c0.17 0.17 0.17 0.34 0.34 0.5-0.34 0.34-0.67 0.67-0.67 1.18q0.17 0.17 0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m36.17 495.4v0.5c0.17 0.17 0.34 0.34 0.5 0.34v-0.67s0-0.17-0.17-0.17h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m35 494.23v0.17c-0.17 0.5 0.17 0.67 0.67 0.67v-0.5c-0.34-0.17-0.5-0.17-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m33.82 491.7h0.5v-0.67h-0.5c-0.17 0.17 0 0.34 0 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m36.17 500.45q0 0.17 0 0v0.17h1.35c0.34 0 0.67-0.17 0.67 0.34 0.17-0.34 0.5-0.34 0.84-0.34-0.17-0.17-0.17-0.34-0.34-0.5-0.5 0.17-0.5-0.17-0.5-0.5h-1.35l-0.17 0.17v0.17c0.17 0.17 0.17 0.34 0.34 0.5-0.17 0-0.34 0.17-0.67 0.17 0-0.17-0.17-0.17-0.17-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m39.03 500.62c-0.34 0-0.67 0-0.84 0.34v0.34c0.17 0 0.34-0.17 0.5-0.17s0.5 0.17 0.67 0.17c-0.17-0.17 0.17-0.5-0.34-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m38.19 499.61c0 0.34 0 0.67 0.5 0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m38.19 498.94v-0.5h-0.67c-0.17 0.17-0.17 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m37.52 498.6h0.67v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m38.19 498.94h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m36.68 496.25c-0.17-0.17-0.34-0.34-0.5-0.34v0.67c-0.17-0.5-0.67-0.5-1.01-0.5s-0.67 0.17-1.18 0.17c0.17-0.17 0.17-0.5 0.34-0.84h-0.34c-0.17-0.17-0.17-0.34-0.34-0.5h-0.5v1.68h0.67v1.51c0.17 0.17 0.34 0.34 0.5 0.34 0-0.17 0.17-0.5 0-0.5-0.5-0.34-0.17-0.84-0.34-1.35 0.34 0 0.67-0.17 0.67 0.34 0.17-0.17 0.34-0.17 0.67-0.34 0.17 0.34 0.17 0.67 0.34 1.01q0.17 0 0.34-0.17c0.17 0 0.34-0.17 0.5-0.17v0.5c0 0.17-0.17 0.34-0.17 0.67h0.67c0.34-0.17 0.17-0.34 0.17-0.5-0.17-0.34-0.17-0.5 0.17-0.84v-0.34c-0.34-0.17-0.5-0.34-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m37.01 497.09c-0.34 0.17-0.34 0.5-0.17 0.84 0.17 0.17 0.17 0.5-0.17 0.5v0.5h0.34c0.17-0.17 0.17-0.34 0.34-0.5v-1.01c-0.34 0.17-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m70.66 496.75c-0.5-0.17-0.67 0.17-0.67 0.67h1.18v-0.67h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m67.47 493.89h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m68.81 492.71h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m69.99 489.85h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m69.99 492.71h-0.67v0.5h0.67c0.5-0.17 0.84 0.17 0.67 0.67v0.5h1.18v-1.18c-0.5 0.17-0.67-0.17-0.67-0.67v-0.5h-0.5c0.17 0.67-0.17 0.67-0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m69.99 490.53h-0.67v1.01h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m69.99 492.71c0.34 0 0.84 0 0.67-0.5v-0.67h-0.67v1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m68.81 492.21v0.5h0.5v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m61.24 496.25v0.5h0.67v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m59.39 497.93h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m25.57 502.98v-1.68h-0.5c0.17 0.5-0.17 0.67-0.67 0.67v1.85h0.67c-0.17-0.5-0.17-0.84 0.5-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m24.9 503.65h-0.67c0 0.17-0.17 0.34-0.17 0.5h1.01c-0.17-0.17-0.17-0.34-0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m22.71 505.16v0c0.17-0.17 0-0.34 0-0.5h-1.18v0.5q0.17 0.17 0.34 0.34h0.67q0-0.34 0.17-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m21.87 505.33q-0.17-0.17-0.34-0.34v0.84c0.5 0 0.17-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m21.54 504.99v-0.5h1.18v0.5c0-0.17 0.17-0.34 0.17-0.34v-0.84c-0.17 0-0.34 0-0.5-0.17h-0.67v0.67c-0.17-0.17-0.34-0.34-0.5-0.34-0.17 0.17-0.17 0.34-0.17 0.5s0 0.5 0.17 0.67c0-0.17 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m22.54 503.65c0.17 0 0.34 0 0.5 0.17 0.17 0 0.34 0.17 0.5 0.17h0.17v-0.84h-1.18v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m23.72 502.98v0.84c0.17 0.17 0.34 0.17 0.5 0.34 0-0.17 0.17-0.34 0.17-0.5v-0.67h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m17.33 503.65v-0.34c-0.34 0-0.84-0.17-1.01 0.17l0.17 0.17h0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m17.67 503.65h-0.34v0.84c0 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m17.16 503.65h-0.67v0.5h0.17l0.5-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m17.67 503.65v0.84h0.34v-0.67s-0.17-0.17-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m21.03 504.32c0-0.17 0.17-0.34 0.17-0.5 0.17 0.17 0.34 0.17 0.5 0.34v-1.01c-0.17 0-0.67 0.17-0.67-0.34h-1.18s-0.17 0-0.17 0.17 0.17 0.17 0.17 0.34c0.5 0 0.84 0.17 0.84 0.67 0.17 0.17 0.34 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m20.53 500.79v-0.5c-0.17 0-0.5 0.17-0.67 0.17h-0.34c0 0.17-0.17 0.17-0.17 0.34v0.5c0.34 0 0.67 0 1.18 0.17v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m19.52 501.13v-0.5c-0.84 0-1.01 0.34-0.84 1.18h0.5v-0.34c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m19.85 503.14v0c0.17-0.17 0.17-0.34 0.17-0.34-0.34 0-0.34-0.17-0.34-0.5s-0.17-0.34-0.34-0.34c0 0.34 0 0.67 0.17 0.84-0.17 0.17 0.17 0.17 0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m71.84 495.57v1.85h0.67v-1.68c-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m71.84 497.26v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m72.51 495.57v1.01h0.67v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m72.51 492.21h-0.67v1.18c0.5-0.17 0.67 0.17 0.67 0.67v0.5h0.67v-1.18h0.5v-0.67h-1.18v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m73.19 494.56h-0.67v1.18h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m73.69 490.53v1.01c0.5 0 0.67 0.17 0.67 0.67h0.67v-1.18c-0.34 0-0.84 0-0.67-0.5v-0.5c-0.5-0.17-0.67 0-0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m74.36 492.21c0.17-0.5-0.17-0.67-0.67-0.67v1.18c0.5 0 0.84 0 0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m74.36 490.02v0.5h0.67c-0.17-0.34-0.17-0.67-0.34-0.84h-0.34v0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m20.53 500.79v1.18h0.17c0-0.34 0.17-0.5 0.5-0.34h0.84q-0.17-0.17-0.34-0.34c-0.17-0.17-0.5-0.17-0.67-0.34 0-0.17-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m23.05 500.28h-0.5v1.18c0.17 0.17 0.34 0.34 0.5 0.34q0.17-0.17 0.34-0.34c-0.5-0.17-0.67-0.5-0.34-1.18-0.17 0.17 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m22.38 501.29v-0.67c-0.17 0-0.67-0.17-0.67 0.34q0.17 0.17 0.34 0.34h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m23.05 500.28q0 0.17-0.17 0.34c-0.34 0.5-0.17 0.67 0.34 1.01q0.17 0 0.34-0.17c0-0.17 0.17-0.34 0.17-0.5v-0.5c-0.34-0.17-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m23.72 500.79c0 0.17-0.17 0.34-0.17 0.5h0.84c0-0.34 0.17-0.5 0.34-0.84h-0.34c-0.34 0.17-0.5 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m33.82 491.7v-0.67h-1.01v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m32.13 490.19c-0.34 0.17-0.34 0.5-0.34 0.84h0.67v-0.5c-0.17 0-0.17-0.17-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m32.47 491.03h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m32.13 490.19c0 0.17 0.17 0.17 0.17 0.34h0.67c0.17 0 0.17-0.17 0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m74.36 490.02v-0.67h-1.01v0.67c0 0.17-0.17 0.5 0.34 0.67 0-0.67 0.17-0.84 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m69.99 491.7h0.67v-1.18h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m71.17 489.68c-0.17 0-0.17-0.17-0.34-0.17 0 0.34-0.17 0.67-0.17 1.01h0.5v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m73.69 492.71v-0.5h-1.18v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m72.51 491.37h-0.67c-0.17 0-0.17-0.17-0.34-0.34h-0.34v0.67h0.67c0.34-0.17 0.67 0.17 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m71.84 491.7h-0.67v0.67h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m73.19 492.21h0.5v-0.67h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m72.51 491.03v-1.01h-0.67v0.5c0 0.5 0.17 0.67 0.67 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m71.17 491.03h0.34v-1.18q-0.17-0.17-0.34-0.34v1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m32.47 495.07h-0.34v0.84c0 0.17-0.17 0.17-0.34 0.34v0.5h0.67v-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m31.8 496.25c0.17-0.17 0.34-0.17 0.34-0.34v-0.84c-0.17 0.17-0.34 0.17-0.34 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m32.47 494.56v0.5h0.67c0.17-0.17 0.17-0.34 0.34-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "m32.47 494.56h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m32.47 497.26h-0.67v1.51h0.5c0-0.17 0.17-0.17 0.17-0.34v-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m32.47 496.75h-0.67q0.17 0.17 0.34 0.34h0.84c0.17 0 0.17 0.17 0.34 0.34v0.5h0.34v-1.18h-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m31.8 498.77v-1.51h-0.17v1.18h-0.67c-0.17 0-0.17 0.17-0.34 0.17v0.34h0.5c0.17 0 0.34-0.17 0.34-0.17h0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m33.48 497.93v-0.5h-1.01v0.67c0.34-0.17 0.67-0.17 1.01-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m30.62 498.94v-0.5h-0.34c-0.17 0.17-0.17 0.34-0.34 0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m29.61 499.27c0-0.17-0.17-0.17-0.17-0.34h-0.67c-0.5 0-0.84 0.17-0.67 0.67h0.34c0.17-0.17 0.17-0.34 0.34-0.34h0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m30.62 500.28h0.67v-0.34h-0.67c-0.5 0-0.67 0.17-0.67 0.67 0.17-0.17 0.34-0.34 0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m30.62 499.95h0.67c0-0.34-0.17-0.5-0.17-0.84-0.17 0-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m30.62 499.27c0.17 0 0.34-0.17 0.5-0.17v-0.17h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m31.8 498.77h-0.17c0 0.5 0.17 0.84 0.17 1.35v0.5h1.35v-1.01c0.17 0 0.34 0 0.5 0.17q0.17-0.17 0.34-0.34c0-0.17-0.17-0.34-0.17-0.34-0.5 0-1.01 0.17-1.51-0.17q-0.34-0.17-0.5-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "m36.17 500.45h0.34c0.17 0 0.34-0.17 0.67-0.17-0.17-0.17-0.17-0.34-0.34-0.5v-0.17h-0.5c-0.17 0-0.17 0.17-0.34 0.17s-0.34-0.17-0.67-0.17h-1.01v0.67c0.5 0 1.01 0 1.51 0.17q0.17 0 0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m34.32 500.28v-0.67s0-0.17-0.17-0.17h-0.17q-0.17 0.17-0.34 0.34c0 0.34 0.17 0.5 0.67 0.5-0.17 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m34.32 500.28s-0.17 0 0 0c0.34 0.34 1.18 0.34 1.51 0.17-0.5-0.17-1.01-0.17-1.51-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m35.67 500.79c0 0.34 0 0.67 0.5 0.67v-0.67c-0.17-0.17-0.34 0-0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m31.8 500.28c0-0.5-0.17-0.84-0.17-1.35-0.17 0-0.34 0.17-0.34 0.17v0.17c0 0.34 0.17 0.5 0.17 0.84v0.34c0-0.17 0.17-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m36 501.63s0 0.17 0.17 0.17h0.67v-0.67h-0.67c0 0.34-0.17 0.5-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m55.69 497.93h-1.35v0.67h1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m39.37 501.29c-0.17 0-0.5-0.17-0.67-0.17v0.84c0.5 0 0.67-0.17 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m38.19 503.65v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m36.85 502.47v0.5h0.67v-0.5c0-0.5-0.17-0.67-0.67-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m36.85 502.47v-0.5h-0.67v0.67c0.17-0.17 0.34-0.17 0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "m36.85 501.97c0.5 0 0.67 0 0.67 0.5v0.5h0.67v-1.85c-0.5 0.17-0.67-0.17-0.67-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m38.19 501.29v0.67h0.5v-0.84c-0.17 0-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m24.73 500.45c-0.17 0.17-0.5 0.5-0.34 0.84h0.67v-0.84h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m71.84 494.56h-1.18c-0.17 0.17-0.17 0.34-0.34 0.5q0.17 0.17 0.34 0.34h0.5c0.17 0 0.34-0.17 0.5-0.17l0.17-0.17v-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m71.17 496.75h0.67v-0.5h-1.18v0.5h0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m71.17 495.4h-0.5c-0.17 0-0.17-0.17-0.34-0.34-0.5 0-0.34 0.34-0.34 0.5h0.84c0.17 0 0.34-0.17 0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m71.84 495.07c-0.17 0.34 0 0.5 0 0.67h0.67v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m69.32 493.89v0.5h0.67v-0.67c-0.17 0.17-0.34 0.17-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m69.99 493.89v0.67h0.67v-0.5c-0.17-0.17-0.34-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m68.81 493.39h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m68.81 493.39v0.67h0.5v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "m33.14 493.89v0.5h0.34c0.5 0 0.17-0.34 0.34-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m33.82 493.89c-0.17 0.17 0.17 0.5-0.34 0.5-0.17 0.17-0.17 0.34-0.34 0.5h0.5c0.17 0.17 0.34 0.34 0.34 0.5-0.17-0.5 0.34-0.84 0.67-1.18-0.17-0.17-0.17-0.34-0.34-0.5-0.17 0.17-0.34 0.17-0.5 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m36.34 499.78h0.5l0.17-0.17v-0.5h-0.67c-0.17 0.17-0.17 0.34 0 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m36.85 498.94v0.5h0.67v-0.67h-0.34c-0.17 0.17-0.34 0.17-0.34 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m37.52 500.79c-0.17 0.5 0.17 0.67 0.67 0.5v-0.34c0-0.5-0.5-0.17-0.67-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m36.85 501.29v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m36.17 498.6c0-0.17 0.17-0.34 0.17-0.67v-0.5c-0.17 0-0.34 0.17-0.5 0.17s-0.17 0-0.34 0.17c-0.17 0.34-0.34 0.34-0.67 0.17-0.34-0.17-0.5-0.5-0.34-0.84 0-0.5-0.34-0.34-0.67-0.34 0.17 0.5-0.34 0.84 0.34 1.35 0.17 0 0 0.34 0 0.5v0.17c0.34 0.17 0.67 0.17 1.01 0.34 0-0.17 0.17-0.17 0.17-0.34 0.34-0.17 0.67-0.17 0.84-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "m34.66 497.09c-0.17 0.34 0 0.5 0.34 0.84 0.34 0.17 0.5 0.17 0.67-0.17-0.17-0.34-0.17-0.67-0.34-1.01-0.34 0.17-0.5 0.17-0.67 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m33.48 497.93h-1.01v0.67h1.35v-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "m35.5 498.77c0 0.17-0.17 0.17-0.17 0.34h1.51v-0.5h-0.67c-0.17 0-0.5 0-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "m32.81 496.75h0.34v-1.68h-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m33.82 498.26v0.84c0 0.17 0.17 0.34 0.17 0.34h0.17v-0.84l-0.34-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m68.81 493.39h0.5v-0.5h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m72.51 494.56v-0.5c0-0.5-0.17-0.67-0.67-0.67v1.18h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m69.99 493.89h0.67c0.17-0.5-0.17-0.67-0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m69.99 493.89v-0.67h-0.67v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "m71.84 493.39v-0.67h-0.67c0 0.5 0.17 0.67 0.67 0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m71.17 492.71h0.67v-0.5h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "m71.17 492.21v-0.67h-0.5v0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m24.23 501.29h-0.84q-0.17 0-0.34 0.17t-0.34 0.34s0 0.17-0.17 0.17c0 0.17 0.17 0.17 0.17 0.34h1.35v-0.34c0.34-0.34 0.34-0.5 0.17-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m24.23 502.13h-1.35v0.34h0.67v0.5h0.67v-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m24.4 501.29v0.67c0.5 0 0.67-0.17 0.67-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m21.87 503.31v0.34h0.67v-0.5c-0.17 0-0.34 0-0.34 0.17-0.34-0.17-0.34 0-0.34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m23.72 502.98v-0.5h-0.67v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "m23.05 502.98v-0.5h-0.5v0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m21.87 503.31 0.17-0.17c-0.17-0.34-0.17-0.5-0.34-0.84 0.5-0.17 0.67-0.34 1.01-0.5 0 0 0-0.17 0.17-0.17-0.17-0.17-0.34-0.34-0.5-0.34h-0.34c0 0.34-0.17 0.34-0.34 0.34-0.34 0-0.5 0.17-0.84 0.17 0 0.34 0.17 0.84 0.17 1.18 0.17 0.5 0.5 0.34 0.84 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "m19.85 502.64v0.34h0.67v-1.01h-0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m20.53 501.97v1.01h0.5c0-0.34-0.17-0.84-0.17-1.18l-0.17-0.17h-0.17q0 0.17 0 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "m20.53 501.63v-0.34c-0.34 0-0.67 0-1.18-0.17-0.17 0.17-0.17 0.34-0.34 0.34 0.67 0.17 1.18 0.17 1.51 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m20.53 501.63h-1.35v0.34c0.34 0 0.5 0 0.34 0.34 0 0.17 0 0.5 0.34 0.5v-0.84h0.67q0-0.17 0-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m72.51 494.56h-0.67v0.5h0.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m20.86 501.63q0 0.17 0 0c0.34 0 0.67 0 0.84-0.17 0.17 0 0.5 0 0.34-0.34h-0.84c-0.34 0.17-0.5 0.34-0.34 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m70.66 491.7h0.5v-1.18h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m32.81 496.75v-1.68h-0.34v1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "m33.82 498.94v-0.5h-1.35c0 0.17-0.17 0.17-0.17 0.34 0.34 0.5 0.84 0.17 1.51 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "m34.15 498.77v0.67s0 0.17 0.17 0.17h1.01c0.17 0 0.34 0.17 0.67 0.17 0 0 0.17 0 0.34-0.17 0-0.17 0-0.5-0.17-0.67h-0.84c-0.5 0-0.84-0.17-1.18-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "m35.5 498.77c0.17 0 0.5-0.17 0.67-0.17-0.17 0-0.5 0-0.67 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "m22.71 501.97c-0.34 0.17-0.67 0.17-1.01 0.5 0 0.17 0.17 0.5 0.34 0.84 0.17 0 0.34 0 0.34-0.17v-0.5h0.5v-0.34c0-0.17 0-0.34-0.17-0.34z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st140",
    x: 42.06,
    y: 493.89,
    width: 2.52,
    height: 0.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "538.22 627.81 864.95 620.75 865.62 650.36 538.89 657.59",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m585.49 634.88c-0.34 0.84-0.5 1.68-0.5 2.52 0 2.02 0.34 3.36 1.18 4.04 1.01 1.18 3.36 1.68 6.73 1.51 2.02 0 3.36 0 4.04 0.34 0.5 0.17 0.84 0.5 0.84 1.18 0 0.5-0.17 1.01-0.34 1.18-0.34 0.34-0.5 0.34-0.5 0.34 0 0.17 0.17 0.17 0.34 0.17 0.67 0 1.01-0.67 1.01-1.85 0-1.35-0.34-1.85-1.01-1.85-1.18 0-2.86 0-4.71-0.17-2.52-0.17-4.04-0.34-4.37-0.67-1.01-0.67-1.51-1.35-2.02-1.85-0.34-0.67-0.5-1.51-0.5-2.69s0.17-2.19 0.34-2.86l0.34-0.5c-0.17 0.34-0.5 0.5-0.84 1.18zm0 11.78c0-0.17-0.17-0.17-0.34-0.17s-0.17 0.17-0.17 0.34c0 1.01 0.17 1.51 0.34 1.51s0.17-0.34 0.17-1.01zm7.74-13.8c-2.86 0-4.88 0.34-5.72 1.01s-1.18 2.02-1.18 4.04c0 1.51 0.5 2.36 1.35 2.86 1.01 0.5 2.52 0.84 4.88 0.67 2.19 0 3.53 0 4.04 0.17 1.51 0.34 2.19 1.35 2.19 2.86 0 1.35-0.34 2.19-1.01 2.69-0.84 0.5-2.19 1.01-4.54 1.01-2.86 0-4.54-0.17-4.88-0.67-0.17-0.17-0.34-0.67-0.84-1.51-0.34-0.5-0.5-0.84-1.01-0.84-0.84 0-1.01 0.34-1.01 1.01 0 0.5 0.34 0.5 0.67 0.17 0.34 0.17 0.5 0.5 0.67 1.18 0.34 0.67 0.67 1.01 1.35 1.35 1.01 0.34 2.52 0.67 4.88 0.5 2.19 0 4.04-0.34 4.88-0.84 1.51-0.67 2.19-2.02 2.19-3.87 0-2.02-0.84-3.36-2.19-3.87-0.84-0.34-2.19-0.5-4.21-0.34h-4.04c-1.35-0.34-2.02-1.35-2.19-3.03 0-1.51 0.5-2.36 1.68-2.86 0.5-0.17 1.68-0.34 3.7-0.34 2.19 0 3.7 0.17 4.54 0.5 0.67 0.34 1.01 1.01 1.01 2.02 0 0.5 0.17 1.01 0.5 1.01 0.67 0 1.01-0.34 1.01-1.35 0-2.52-2.36-3.53-6.73-3.53zm7.74 10.43c0-0.17-0.17-0.17 0 0-0.34-0.17-0.34 0-0.34 0.17 0.17 2.19-0.17 3.7-0.84 4.71-1.01 1.51-3.2 2.19-6.56 2.19-2.86 0-4.71-0.34-5.89-1.01-0.17-0.17-0.34-0.17-0.34 0-0.17 0.17 0 0.17 0.17 0.34 1.01 0.67 2.02 1.01 3.36 1.35 0.67 0.17 2.02 0.17 4.04 0.17 1.68 0 3.2-0.34 4.37-1.18 1.51-1.01 2.36-2.69 2.36-4.88-0.17-1.01-0.17-1.51-0.34-1.85zm-8.75 3.87c-0.67 0-1.51-0.17-2.19-0.34-1.01-0.34-1.51-0.5-1.51-1.01q-0.17-0.17-0.34-0.17c-0.17 0-0.17 0.17 0 0.34 0.34 0.67 1.01 1.18 2.02 1.35s1.51 0.34 1.51 0.34c0 0.17 0.67 0.17 2.19 0.17 1.35 0 2.02-0.17 2.02-0.34 0-0.34-0.34-0.34-1.01-0.34 1.51-0.17 0.5-0.17-2.69 0zm-4.2-9.76c0 1.01 0.34 1.51 0.67 1.51 0.17 0 0.34-0.17 0.34-0.34s-0.17-0.34-0.34-0.34c-0.17-0.17-0.34-0.34-0.34-1.01s0.5-1.01 1.68-1.35c0.5-0.17 1.51-0.17 3.03-0.34 1.51 0 2.69 0.17 3.36 0.5 0.34 0.17 0.67 0.5 0.84 1.01 0.17 0.34 0.34 0.5 0.34 0.5 0.34-0.17 0.34-0.5 0-1.35-0.34-1.01-1.85-1.51-4.71-1.51-2.36 0-3.36 0.17-3.36 0.17-0.34 0-0.67 0-0.67 0.34 0 0.17 0.17 0.17 0.34 0.34 0.17 0 0.34 0.17 0.34 0.17 0-0.17-0.34 0-0.84 0.34s-0.67 0.67-0.67 1.35zm2.69 2.19c1.51 0.17 3.03 0.17 4.71 0.34 1.85 0 3.2 0.34 4.21 1.01q0.17 0.17 0.34 0t0-0.34c-1.51-1.18-4.54-1.68-9.09-1.51q-0.34 0-0.34 0.17c-0.34 0.34-0.17 0.34 0.17 0.34zm15.98-6.73c-0.17 0-0.34 2.69-0.17 7.91s0.34 7.91 0.34 7.74c0.17 0 0.17-0.34 0.17-1.18 0 0.67 0-1.51-0.17-6.56v-5.05c0-1.18 0-1.85-0.17-2.19 0.34-0.67 0.17-0.67 0-0.67zm13.29-0.17c0-0.34-0.34-0.67-1.18-0.84h-1.85c-3.36 0.17-5.89 0.17-7.74 0.34-1.18 0-1.85 0.34-1.68 0.84 0 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.34 0.34 0.34 0.67l0.34 13.46c-0.67 0.5-1.01 0.84-1.01 1.01s0.17 0.17 0.17 0.17c0.34 0 0.67 0.34 0.84 0.5q0.17 0.34 0.34 0.34c0.17 0 0.17-0.17 0.34-0.34 0-0.17 0.17-0.34 0.17-0.5l9.42-0.34c0.34 0 0.84 0.17 1.01 0.34q0.34 0.34 0.5 0.34c0.5 0 0.84-0.34 0.84-1.18 0-0.34-0.34-0.67-1.01-0.67l-9.59 0.34c-0.34 0-0.5 0-0.84-0.17-0.17-0.17-0.34-0.34-0.17-0.5 0.17-0.34 0.17-1.01 0.17-2.19 0-1.01 0.17-1.68 0.34-2.19v-0.17l-0.34-0.34c-0.17-0.17-0.34-0.34-0.34-0.5 0-0.5 0.17-0.67 0.5-0.84 0.17 0 0.34 0 0.34 0.17 0.17 0.17 0.17 0.34 0.34 0.34s0.34 0 0.34-0.17c0.17-0.17 0.34-0.17 0.34-0.17l4.37-0.17h2.19c0.5 0 0.84-0.34 0.84-0.84 0-0.34-0.67-0.67-2.19-0.5-0.34 0-1.18 0.17-2.86 0.34-1.51 0.17-2.86 0.34-3.87 0.34-0.34 0-0.5-0.17-0.5-0.67v-2.19c0-0.34 0-1.01-0.17-1.68-0.17-0.84-0.17-1.35-0.17-1.51 0-0.5 0.17-0.84 0.5-0.84s0.34 0 0.5 0.17c0.17 0.17 0.34 0.17 0.34 0.17l0.67-0.34 7.4-0.17h1.18c0.34 0.34 0.5 0 0.5-0.17zm-11.44 17.16c0 0.34 0.34 0.34 0.67 0.34 1.01-0.17 1.68-0.17 1.85-0.17 0.5 0 1.35 0 2.36 0.17s2.19 0.17 2.86 0.17c2.19 0 3.36-0.17 3.36-0.34 0-0.34-3.2-0.34-9.42-0.34-1.01-0.34-1.68-0.17-1.68 0.17zm10.1-8.41c0-0.17-0.17 0-0.5 0-0.5 0.17-1.01 0.34-1.18 0.34l-5.55 0.17q-0.34 0-0.34-0.17c0-0.17-0.17-0.17-0.34-0.17s-0.17 0.17-0.34 0.34c0 0.17-0.17 0.34-0.34 0.34s-0.34 0-0.34-0.17c0 0.34 0 1.01-0.17 1.35l0.17 2.19c0 0.17 0.17 0.34 0.34 0.34s0.34-0.17 0.34-0.34v-3.03c0.34-0.17 1.01-0.17 2.02-0.17h4.21c1.35 0 2.02-0.34 2.02-1.01zm-8.41-5.55q0-0.34-0.17-0.34c-0.34 0-0.34 0.17-0.34 0.5 0 1.01 0.17 1.68 0.34 2.19 0.17 0 0.34 0 0.34-0.17l-0.17-2.19zm0.5-0.84 7.4-0.17c1.01 0 1.68-0.34 2.19-0.84 0.34-0.34 0.34-0.5-0.17-0.34-0.5 0.34-1.18 0.67-2.02 0.67 0.34-0.17 0.34-0.34 0-0.34h-7.57c-0.34 0-0.34 0.17-0.34 0.5 0 0.34 0 0.5 0.5 0.5zm-0.17 3.53c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.34 0.34 0.67 0.34h2.69c2.52 0 3.7-0.17 3.7-0.34h-0.34l-5.38 0.34c-0.34 0-0.5 0-0.67-0.17q-0.17-0.5-0.34-0.5zm0.67 7.74c-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.5 0.34c0.67 0 2.02-0.17 3.87-0.17 2.02-0.17 2.86-0.17 3.03-0.17 0.34 0 1.01 0 1.51 0.17q0.34 0 0.34-0.17c0-0.34-0.34-0.34-1.01-0.34h-7.91zm22.72-12.62c1.51-0.17 3.2-0.34 4.88-0.34 0.5 0 0.84-0.34 0.84-0.34 0-0.67-0.84-1.01-2.19-1.01l-10.77 0.34c-1.01 0-1.51 0.34-1.51 1.18 0 0.34 0.34 0.34 1.01 0.34 0.34 0 1.85 0 4.71-0.17 0.17-0.17 0.34-0.34 1.01-0.34 0.5 0 0.67 0 0.67 0.17q0 0.34-0.17 0.34s-0.17 0-0.34-0.17c-0.17 0-0.34-0.17-0.34-0.17-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.34 0.34c0.17 0.17 0.17 0.34 0.17 0.67s-0.17 0.34-0.17 0.67l-0.17 5.89 0.17 5.89c0 0.34-0.17 0.5-0.34 1.01-0.17 0.34-0.34 0.5-0.34 0.5q0 0.17 0.17 0.34l0.5 0.5c0.17 0.17 0.34 0.34 0.67 0.34 0.67 0 1.01-0.34 1.01-0.84l-0.34-12.45q0-0.34 0.17-0.5c0.17-0.17 0.17-0.34 0.17-0.67 0-0.84-0.17-1.35-0.34-1.51-0.17-0.17 0-0.17 0.17-0.34s0.34-0.17 0.34-0.17c0.17-0.17 0.17 0 0.34 0.17zm-4.54 1.01c0.34 0 0.34-0.17 0.67-0.34v-0.34c-1.01 0-2.36 0-4.04 0.17-0.34 0-0.5 0.17-0.5 0.34s0.17 0.17 0.34 0.34zm1.34 14.47c0.34 0 0.34-0.67 0.34-1.85l-0.17-9.76c0-1.51-0.34-2.36-0.5-2.36s-0.34 0.17-0.34 0.5 0 0.34 0.17 0.34c0.17 0.17 0.17 0.34 0.17 0.5v3.87c0 2.52 0 4.37 0.17 5.72-0.17 1.85 0 3.03 0.17 3.03zm3.03-11.27c0 0.34 0.17 0.34 0.34 0.34s0.17-0.17 0.34-0.34v-1.85c0-0.67 0.17-1.01 0.34-1.01 0.84 0 1.68-0.17 2.52-0.34 1.01 0 1.68-0.34 2.02-0.34 0.17-0.17 0.34-0.17 0.34-0.34l-0.17-0.17q-0.17 0-0.34 0.17c-0.17 0-0.34 0.17-0.5 0.34-0.17 0-0.34 0-0.34-0.17v-0.34c0-0.17-0.17-0.17-0.34 0-0.34 0.17-1.01 0.34-1.68 0.34h-1.68c-0.17 0-0.17 0.17-0.17 0.17-0.34 0-0.5 0-0.5 0.17-0.34 0.34-0.34 1.01-0.34 2.02 0.17 0.5 0.17 0.84 0.17 1.35zm0.17 3.03c-0.17 0-0.17 0.5-0.17 1.68 0 1.01 0.17 1.51 0.34 1.51s0.17-0.5 0.17-1.51c-0.17-1.18-0.17-1.68-0.34-1.68zm18.17-7.57c1.51-0.17 3.2-0.34 4.88-0.34 0.5 0 0.84-0.34 0.84-0.34 0-0.67-0.84-1.01-2.19-1.01l-10.77 0.34c-1.01 0-1.51 0.34-1.51 1.18 0 0.34 0.34 0.34 1.01 0.34 0.34 0 1.85 0 4.71-0.17 0.17-0.17 0.34-0.34 1.01-0.34 0.5 0 0.67 0 0.67 0.17q0 0.34-0.17 0.34s-0.17 0-0.34-0.17c-0.17 0-0.34-0.17-0.34-0.17-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.34 0.34c0.17 0.17 0.17 0.34 0.17 0.67s-0.17 0.34-0.17 0.67l-0.17 5.89 0.17 5.89c0 0.34-0.17 0.5-0.34 1.01-0.17 0.34-0.34 0.5-0.34 0.5q0 0.17 0.17 0.34l0.5 0.5c0.17 0.17 0.34 0.34 0.67 0.34 0.67 0 1.01-0.34 1.01-0.84l-0.34-12.45q0-0.34 0.17-0.5c0.17-0.17 0.17-0.34 0.17-0.67 0-0.84-0.17-1.35-0.34-1.51-0.17-0.17 0-0.17 0.17-0.34s0.34-0.17 0.34-0.17c0.17-0.34 0.34-0.17 0.34 0.17zm-4.38 1.01c0.34 0 0.34-0.17 0.67-0.34v-0.34c-1.01 0-2.36 0-4.04 0.17-0.34 0-0.5 0.17-0.5 0.34s0.17 0.17 0.34 0.34zm1.35 14.3c0.34 0 0.34-0.67 0.34-1.85l-0.17-9.76c0-1.51-0.34-2.36-0.5-2.36s-0.34 0.17-0.34 0.5 0 0.34 0.17 0.34c0.17 0.17 0.17 0.34 0.17 0.5v3.87c0 2.52 0 4.37 0.17 5.72-0.17 2.02 0 3.03 0.17 3.03zm3.03-11.11c0 0.34 0.17 0.34 0.34 0.34s0.17-0.17 0.34-0.34v-1.85c0-0.67 0.17-1.01 0.34-1.01 0.84 0 1.68-0.17 2.52-0.34 1.01 0 1.68-0.34 2.02-0.34 0.17-0.17 0.34-0.17 0.34-0.34l-0.17-0.17q-0.17 0-0.34 0.17c-0.17 0-0.34 0.17-0.5 0.34-0.17 0-0.34 0-0.34-0.17v-0.34c0-0.17-0.17-0.17-0.34 0-0.34 0.17-1.01 0.34-1.68 0.34h-1.68c-0.17 0-0.17 0.17-0.17 0.17-0.34 0-0.5 0-0.5 0.17-0.34 0.34-0.34 1.01-0.34 2.02 0 0.34 0 0.84 0.17 1.35zm0.17 2.86c-0.17 0-0.17 0.5-0.17 1.68 0 1.01 0.17 1.51 0.34 1.51s0.17-0.5 0.17-1.51c-0.17-1.18-0.34-1.68-0.34-1.68zm11.1-8.91c-0.17 0-0.34 2.69-0.17 7.91s0.34 7.91 0.34 7.74c0.17 0 0.17-0.34 0.17-1.18 0 0.67 0-1.51-0.17-6.56v-5.05c0-1.18 0-1.85-0.17-2.19 0.17-0.5 0-0.67 0-0.67zm13.12 0c0-0.34-0.34-0.67-1.18-0.84h-1.85c-3.36 0.17-5.89 0.17-7.74 0.34-1.18 0-1.85 0.34-1.68 0.84 0 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.34 0.34 0.34 0.67l0.34 13.46c-0.67 0.5-1.01 0.84-1.01 1.01s0.17 0.17 0.17 0.17c0.34 0 0.67 0.34 0.84 0.5q0.17 0.34 0.34 0.34c0.17 0 0.17-0.17 0.34-0.34 0-0.17 0.17-0.34 0.17-0.5l9.42-0.34c0.34 0 0.84 0.17 1.01 0.34q0.34 0.34 0.5 0.34c0.5 0 0.84-0.34 0.84-1.18 0-0.34-0.34-0.67-1.01-0.67l-9.59 0.34c-0.34 0-0.5 0-0.84-0.17-0.17-0.17-0.34-0.34-0.17-0.5 0.17-0.34 0.17-1.01 0.17-2.19 0-1.01 0.17-1.68 0.34-2.19v-0.17l-0.34-0.34c-0.17-0.17-0.34-0.34-0.34-0.5 0-0.5 0.17-0.67 0.5-0.84 0.17 0 0.34 0 0.34 0.17 0.17 0.17 0.17 0.34 0.34 0.34s0.34 0 0.34-0.17c0.17-0.17 0.34-0.17 0.34-0.17l4.37-0.17h2.19c0.5 0 0.84-0.34 0.84-0.84 0-0.34-0.67-0.67-2.19-0.5-0.34 0-1.18 0.17-2.86 0.34s-2.86 0.34-3.87 0.34c-0.34 0-0.5-0.17-0.5-0.67v-2.19c0-0.34 0-1.01-0.17-1.68-0.17-0.84-0.17-1.35-0.17-1.51 0-0.5 0.17-0.84 0.5-0.84s0.34 0 0.5 0.17c0.17 0.17 0.34 0.17 0.34 0.17l0.67-0.34 7.4-0.17h1.18c0.5 0.17 0.5 0 0.5-0.17zm-11.44 16.99c0 0.34 0.34 0.34 0.67 0.34 1.01-0.17 1.68-0.17 1.85-0.17 0.5 0 1.35 0 2.36 0.17s2.19 0.17 2.86 0.17c2.19 0 3.36-0.17 3.36-0.34 0-0.34-3.2-0.34-9.42-0.34-1.01-0.17-1.68 0-1.68 0.17zm10.1-8.25c0-0.17-0.17 0-0.5 0-0.5 0.17-1.01 0.34-1.18 0.34l-5.55 0.17q-0.34 0-0.34-0.17c0-0.17-0.17-0.17-0.34-0.17s-0.17 0.17-0.34 0.34c0 0.17-0.17 0.34-0.34 0.34s-0.34 0-0.34-0.17c0 0.34 0 1.01-0.17 1.35l0.17 2.19c0 0.17 0.17 0.34 0.34 0.34s0.34-0.17 0.34-0.34v-3.03c0.34-0.17 1.01-0.17 2.02-0.17h4.21c1.35 0 2.02-0.34 2.02-1.01zm-8.58-5.55q0-0.34-0.17-0.34c-0.34 0-0.34 0.17-0.34 0.5 0 1.01 0.17 1.68 0.34 2.19 0.17 0 0.34 0 0.34-0.17l-0.17-2.19zm0.67-0.84 7.4-0.17c1.01 0 1.68-0.34 2.19-0.84 0.34-0.34 0.34-0.5-0.17-0.34-0.5 0.34-1.18 0.67-2.02 0.67 0.34-0.17 0.34-0.34 0-0.34h-7.57c-0.34 0-0.34 0.17-0.34 0.5-0.17 0.34 0.17 0.5 0.5 0.5zm0 3.53c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.34 0.34 0.67 0.34h2.69c2.52 0 3.7-0.17 3.7-0.34h-0.34l-5.38 0.34c-0.34 0-0.5 0-0.67-0.17l-0.34-0.5zm0.51 7.74c-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.5 0.34c0.67 0 2.02-0.17 3.87-0.17 2.02-0.17 2.86-0.17 3.03-0.17 0.34 0 1.01 0 1.51 0.17q0.34 0 0.34-0.17c0-0.34-0.34-0.34-1.01-0.34h-7.91zm28.77-7.9 0.34 9.25c0 0.17 0 0.34-0.17 0.34-0.17 0.17-0.17 0.34-0.17 0.5 0 0.67 0.34 1.01 1.01 1.01 0.34 0 0.5-0.34 0.67-0.67s0.17-0.84 0-1.01l-0.34-14.64c0-1.01-0.34-1.51-1.35-1.51-0.67 0-1.01 0.17-1.01 0.5-0.17 0.34-0.17 0.67-0.17 0.84l-3.36 8.08c0 1.01-0.34 1.51-0.84 1.68-0.34 0-0.5-0.17-1.01-0.5-0.34-0.34-0.34-0.5-0.34-0.5 0.34 0 0.34-0.17 0.17-0.5l-4.37-8.75c-0.34-0.5-0.67-0.67-1.18-0.67-1.01 0-1.51 0.34-1.51 0.84 0 0.17 0.17 0.17 0.34 0.34 0.17 0 0.34 0.17 0.34 0.34l0.34 9.59-0.34 0.5 0.17 4.37c0 0.34-0.17 0.5-0.67 0.5-0.17 0-0.34-0.17-0.34-0.34 0-0.34-0.17-0.34-0.34-0.34s-0.17 0.34 0 0.67c0.17 0.67 0.67 1.01 1.68 1.01 0.5 0 0.84-0.34 0.84-0.84l-0.34-12.95c0-0.17 0-0.34 0.17-0.34s0.17-0.17 0.17-0.34 0-0.34-0.17-0.34c-0.17-0.17-0.17-0.34-0.17-0.5q0-0.34 0.17-0.34c0.34 0 0.34 0.17 0.67 0.5 0.84 1.68 1.35 2.52 1.35 2.69-0.34-0.17-0.67-0.17-1.01 0 0 0.34 0.17 0.5 0.5 0.5s0.67 0.17 0.84 0.5l3.36 6.39-0.34 0.34c0.5 0.34 1.01 0.34 1.18 0.34 0.67 0 1.01-0.5 1.18-1.68l3.7-9.25c0.17-0.34 0.34-0.5 0.5-0.5s0.34 0.34 0.34 0.67l-0.5 4.21zm-14.47-5.72c-0.17 0-0.17 0.17-0.17 0.34q0 0.34 0.17 0.34c0.17 0 0.34-0.17 0.34-0.34-0.17-0.17-0.17-0.34-0.34-0.34zm0.5 12.95-0.17-11.44c0-0.34-0.17-0.34-0.34-0.34s-0.17 0.17-0.17 0.34l0.17 11.44c0 0.34 0.17 0.34 0.34 0.34 0 0 0.17 0 0.17-0.34zm2.02 4.04c0-0.17-0.17-0.17-0.34-0.17h-0.5s-0.17 0-0.5-0.17c-0.17 0-0.34 0-0.34 0.17 0 0.34 0.34 0.34 0.67 0.34 0.67 0.17 0.84 0 1.01-0.17zm5.22-4.21c-0.34-0.34-1.18-1.68-2.36-4.04-1.01-2.19-1.68-3.2-1.68-3.2q-0.17 0-0.17 0.17c0 0.34 1.01 2.19 2.69 5.89 0.34 1.01 0.84 1.51 1.51 1.18zm0.33-6.39-2.86-5.38c0-0.17-0.17-0.17-0.34-0.17 0 0.17-0.17 0.17-0.17 0.34l2.86 5.38c0.17 0.34 0.34 0.34 0.34 0.34 0.17 0 0.17-0.17 0.17-0.5zm4.04-6.23-1.85 4.37c-1.01 2.19-1.51 3.36-1.51 3.53s0 0.17 0.17 0.17 0.34-0.34 0.67-1.01c0.34-0.84 0.67-1.68 1.01-2.52 0.67-1.35 1.18-2.86 1.85-4.54v-0.34zm0.34 6.4-1.01 2.36-0.17 1.35c-0.34 1.01-1.01 1.85-1.85 2.52 0.17 0.17 0.34 0.17 0.34 0.17 0.34 0 1.01-0.34 1.35-1.01s0.67-1.51 0.84-2.36c0-0.34 0.34-1.01 0.84-2.36v-0.34q-0.17-0.5-0.34-0.34 0-0.17 0 0zm1.01-0.17-0.17 1.85c0 0.17 0 0.34-0.17 0.34q-0.17 0.17-0.17 0.34c0.17 3.7 0.17 5.89 0.34 6.56 0 0.17 0 0.34 0.17 0.34 0.34 0 0.34-0.17 0.34-0.5v-7.23c0.17-1.01 0.17-1.68-0.34-1.68zm3.02 8.58q0 0.34 0.17 0.34c0.34 0 0.34-0.34 0.34-0.67 0-2.52-0.17-4.54-0.17-5.72v-1.51c0-4.04-0.17-5.72-0.17-5.38 0-0.5-0.17-1.01-0.34-1.51 0-0.17-0.17-0.17-0.34 0s-0.17 0.34-0.17 0.5l0.67 13.96zm4.88-14.47c-0.17 0-0.17 0.84-0.17 2.52s0.17 2.52 0.34 2.52 0.34-0.84 0.34-2.52c-0.34-1.68-0.34-2.52-0.5-2.52zm0.68-1.01c0 0.34 0.17 0.5 0.34 0.5-0.17 0 0 0 0.34-0.17 0.17 0 0.17 0.17 0.17 0.34l0.34 14.13c0 0.34-0.17 0.34-0.34 0.34s-0.34 0.34-0.34 0.34c0 0.34 0.17 0.34 0.34 0.5 0.34 0.17 0.67 0.17 0.67 0.34 0.34 0.17 0.34 0 0.34-0.34q0-0.17 0.17-0.17h1.01l6.9-0.17c3.53-0.17 5.38-1.68 5.38-4.88 0-1.35-0.34-2.19-0.84-2.86-0.5-0.5-0.84-0.84-0.84-1.01s0.17-0.5 0.34-1.18 0.34-1.51 0.34-2.86c0-2.69-1.18-4.04-3.53-4.04l-7.23 0.17c-2.69 0.5-3.53 0.67-3.53 1.01zm0.84-1.35c-0.17 0-0.17 0.17-0.17 0.34s0 0.34 0.17 0.34h2.69c0.17 0 0.34-0.17 0.34-0.34s0-0.34-0.17-0.34zm1.18 2.02c0.17 0 0.34 0 0.34 0.17 0.17 0.17 0.34 0.17 0.5 0.17s0.34 0 0.34-0.17q0.17-0.17 0.34-0.17c0.34 0 2.52 0 6.9-0.17 0.67 0 1.18 0.34 1.68 1.01 0.5 0.5 0.84 1.35 0.67 2.19 0 2.19-0.5 3.36-1.51 3.36-2.36 0-5.55 0.17-9.42 0.34l-0.17-4.04c0-0.34 0-0.67 0.17-0.84s0.17-0.17 0.17-0.34c0-0.34-0.17-0.34-0.34-0.34 0 0-0.17 0-0.17 0.17q-0.17 0.17-0.34 0.17c-0.17 0-0.17-0.17-0.17-0.34 0-0.34 0-0.5 0.17-0.84 0.5-0.34 0.67-0.34 0.84-0.34zm0 7.74c0.17-0.34 1.01-0.34 2.86-0.5-1.85 0.17 0.17 0 6.23-0.17 1.85 0 2.86 1.01 2.86 3.2 0 2.36-1.01 3.53-3.36 3.7l-6.56 0.17c-1.18 0-1.85-0.34-1.85-1.01-0.17-3.2-0.17-5.05-0.17-5.38zm0.67 8.08c-0.17 0-0.17 0.17-0.17 0.34s0 0.34 0.17 0.34h1.85c0.17 0 0.34-0.17 0.34-0.34s0-0.34-0.17-0.34zm0-14.13c-0.34 0-0.34 0.67-0.34 1.85 0 1.35 0.17 2.02 0.34 2.02 0.34 0 0.34-1.01 0.34-3.2-0.17-0.5-0.34-0.67-0.34-0.67zm0 6.89c-0.17 0-0.17 0.84-0.17 2.19 0 1.68 0.17 2.52 0.34 2.52 0.34 0 0.34-1.01 0.34-3.2 0-1.18-0.17-1.68-0.5-1.51zm0.5-7.57c0 0.34 0.17 0.34 0.34 0.34 0.34 0 1.01 0 2.19-0.17 1.01-0.17 1.85-0.17 2.36-0.17 1.51 0 2.52 0.17 3.03 0.5 0.34 0.34 0.5 0.84 0.5 1.51 0 1.18-0.34 1.85-1.18 1.85 0 0-1.35 0-4.04 0.17-2.19 0-3.2 0.17-3.2 0.34s0.34 0.34 0.67 0.34h3.36c2.02 0 3.2-0.17 3.36-0.34 1.01-0.67 1.51-1.51 1.51-2.69 0-0.67-0.34-1.18-1.01-1.51-0.34-0.34-0.5-0.34-1.01-0.84-0.34 0-1.51-0.17-3.36 0-2.52 0.17-3.53 0.34-3.53 0.67zm3.37 12.45c3.36-0.17 5.22-0.34 5.22-1.01q0-0.17-0.17-0.17c-0.17 0-0.34 0-0.67 0.17-0.34 0.17-0.67 0.17-1.01 0.17l-5.38 0.17c-0.34 0-0.5 0-0.5-0.17s-0.17-0.17-0.34-0.17c-0.34 0-0.5 0.17-0.5 0.34 0 0.67 1.35 0.84 3.36 0.67zm-2.86-5.21c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.5 0.34l7.91-0.17c0.34 0 0.5-0.17 0.5-0.34 0-0.34-0.34-0.34-0.67-0.34l-7.91 0.17zm1.51-10.6c-0.17 0-0.17 0.17-0.17 0.34s0 0.34 0.17 0.34h2.36c0.17 0 0.34-0.17 0.34-0.34s0-0.34-0.17-0.34h-2.52zm0.51 18.34c-0.17 0-0.17 0.17-0.17 0.34s0 0.34 0.17 0.34h2.36c0.17 0 0.34-0.17 0.34-0.34s0-0.34-0.17-0.34h-2.52zm7.4-5.89c0-0.84-0.17-1.35-0.17-1.51-0.17-0.17-0.34-0.17-0.34 0-0.17 0.17-0.17 0.34-0.17 0.5v1.51c0 0.34-0.17 0.5-0.34 0.84s-0.34 0.5-0.34 0.67 0 0.17 0.17 0.17c0.84-0.17 1.18-0.84 1.18-2.19zm0.5-11.11q-0.17-0.17-0.34 0c-0.17 0.17 0 0.34 0.17 0.34 0.84 0.67 1.18 1.85 1.18 3.36 0 1.18-0.17 2.19-0.34 2.69-0.34 0.5-0.34 1.01-0.34 1.01 0 0.17 0.34 0.34 0.84 1.01s0.84 1.51 0.84 2.52c0 1.51-0.34 2.86-0.84 4.04q-0.17 0.34 0 0.34c0.17 0.17 0.34 0 0.34-0.34 0.84-1.01 1.18-2.52 1.01-4.21 0-1.01-0.34-1.85-0.67-2.52-0.34-0.5-0.67-0.84-0.67-1.01 0-0.34 0.17-0.67 0.34-1.01 0.17-0.5 0.34-1.18 0.34-2.19-0.34-1.85-0.84-3.03-1.85-4.04zm17.33-0.84-7.23 0.17c-1.68 0-2.52 0.17-2.69 0.34 0 0.34 0 0.67 0.34 0.67 0 0 0.17 0 0.17-0.17q0.17-0.17 0.17 0v0.34c0 3.7 0 8.58-0.17 14.81l-1.01 0.17c-0.17 0-0.34 0.17-0.34 0.34s0.17 0.34 0.34 0.34h0.84c0 0.67 0.34 1.01 0.67 1.01s0.84-0.34 1.01-0.5c-0.34-2.02-0.34-3.7-0.34-5.38 0-1.51 0.17-2.19 0.34-2.19 0.67 0.17 1.18 0.17 1.51 0.17l6.9-0.17c1.35 0 2.02 0.67 2.19 2.02 0.17 3.2 0 4.88-0.34 5.22-0.17 0-0.17 0.17-0.17 0.17 0 0.17 0.17 0.34 0.34 0.34 0.34 0.17 0.5 0.17 0.67 0.17 0.5-0.34 0.84-1.01 0.84-2.02 0 0 0-1.35-0.17-3.7 0-0.5-0.17-1.18-0.5-1.51-0.34-0.5-0.67-0.84-1.01-1.01 1.01-1.35 1.51-2.86 1.51-4.54 0.17-3.53-1.18-5.05-3.87-5.05zm-10.09 1.18c0.17 0 0.34 3.7 0.34 10.94 0 2.19 0 3.36-0.34 3.36-0.17 0-0.34-1.51-0.34-4.54-0.17-6.56 0-9.76 0.34-9.76zm1.85 0.34c2.86 0 5.89 0 8.41-0.17 0.5 0 1.01 0.34 1.51 0.84s0.84 1.18 0.84 2.02c0 2.86-0.34 4.21-1.35 4.21-3.7-0.17-6.39-0.17-8.24 0.17-0.17 0-0.34 0.17-0.34 0.34s0 0.17-0.17 0.17c-0.34 0-0.5 0-0.84-0.17 0.17-2.36 0.17-4.71 0.17-7.4zm0.67 2.18c0 2.52 0 3.87 0.17 4.04s1.18 0.17 3.2 0.17 3.03-0.17 3.03-0.34-0.84-0.17-2.52-0.17c-1.85 0-3.03 0-3.36-0.17 0.17-1.01 0.17-2.19 0.17-3.03s-0.17-1.18-0.34-1.01c-0.17-0.17-0.34 0-0.34 0.5zm0.51 7.41c-0.17 0.34-0.17 1.51-0.17 3.2 0 1.51 0.17 2.36 0.34 2.52 0.34 0 0.34-1.35 0.34-3.87-0.17-1.01-0.34-1.68-0.5-1.85zm8.41-3.87c0.5-0.5 0.84-1.51 0.67-2.69 0-1.35-0.34-2.19-1.01-2.36-0.84-0.34-3.36-0.5-7.4-0.17-0.5 0-0.84 0.17-0.84 0.34 0 0.34 0.34 0.34 0.84 0.34h1.51c0.84 0 1.35-0.17 1.51-0.17h1.18c0.5 0 1.01-0.17 1.01-0.17 1.51 0 2.36 0.84 2.36 2.36 0 1.01 0 1.68-0.34 2.02q-0.17 0.34-0.17 0.5 0.5 0.17 0.67 0zm-7.91 3.36 0.34 0.67 6.23 0.34c1.01 0 1.51-0.17 1.51-0.67 0-0.17-0.17-0.34-0.34-0.17zm8.75 0.84q0-0.34-0.17-0.34c-0.34 0-0.34 0.34-0.34 1.01v3.36c0 0.84 0 1.35 0.17 1.35 0.34 0 0.34-0.67 0.34-1.85 0.17-1.51 0.17-2.52 0-3.53zm2.36-2.52c0.5-1.01 0.84-2.02 0.84-3.36 0-0.84-0.17-1.51-0.34-2.19 0-0.17-0.17-0.34-0.17-0.34l-0.17-0.17v0.34c0.34 2.36 0.17 4.21-0.5 5.55-0.17 0.17-0.17 0.34 0 0.34q0.17 0 0.34-0.17zm0.5 2.02c-0.34 0-0.34 0.67-0.34 1.85s0.17 1.85 0.34 1.85 0.17-0.67 0-1.85zm6.06-11.11c-0.17 0-0.34 2.69-0.17 7.91s0.34 7.91 0.34 7.74c0.17 0 0.17-0.34 0.17-1.18 0 0.67 0-1.51-0.17-6.56v-5.05c0-1.18 0-1.85-0.17-2.19zm13.12 0c0-0.34-0.34-0.67-1.18-0.84h-1.85c-3.36 0.17-5.89 0.17-7.74 0.34-1.18 0-1.85 0.34-1.68 0.84 0 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.34 0.34 0.34 0.67l0.34 13.46c-0.67 0.5-1.01 0.84-1.01 1.01s0.17 0.17 0.17 0.17c0.34 0 0.67 0.34 0.84 0.5q0.17 0.34 0.34 0.34c0.17 0 0.17-0.17 0.34-0.34 0-0.17 0.17-0.34 0.17-0.5l9.42-0.34c0.34 0 0.84 0.17 1.01 0.34q0.34 0.34 0.5 0.34c0.5 0 0.84-0.34 0.84-1.18 0-0.34-0.34-0.67-1.01-0.67l-9.59 0.34c-0.34 0-0.5 0-0.84-0.17-0.17-0.17-0.34-0.34-0.17-0.5 0.17-0.34 0.17-1.01 0.17-2.19 0-1.01 0.17-1.68 0.34-2.19v-0.17l-0.34-0.34c-0.17-0.17-0.34-0.34-0.34-0.5 0-0.5 0.17-0.67 0.5-0.84 0.17 0 0.34 0 0.34 0.17 0.17 0.17 0.17 0.34 0.34 0.34s0.34 0 0.34-0.17c0.17-0.17 0.34-0.17 0.34-0.17l4.37-0.17h2.19c0.5 0 0.84-0.34 0.84-0.84 0-0.34-0.67-0.67-2.19-0.5-0.34 0-1.18 0.17-2.86 0.34s-2.86 0.34-3.87 0.34c-0.34 0-0.5-0.17-0.5-0.67v-2.19c0-0.34 0-1.01-0.17-1.68-0.17-0.84-0.17-1.35-0.17-1.51 0-0.5 0.17-0.84 0.5-0.84s0.34 0 0.5 0.17c0.17 0.17 0.34 0.17 0.34 0.17 0.17 0 0.34-0.17 0.67-0.34l7.4-0.17h1.18c0.5 0.34 0.5 0 0.5-0.17zm-11.27 17c0 0.34 0.34 0.34 0.67 0.34 1.01-0.17 1.68-0.17 1.85-0.17 0.5 0 1.35 0 2.36 0.17s2.19 0.17 2.86 0.17c2.19 0 3.36-0.17 3.36-0.34 0-0.34-3.2-0.34-9.42-0.34-1.18-0.17-1.68 0-1.68 0.17zm10.09-8.25c0-0.17-0.17 0-0.5 0-0.5 0.17-1.01 0.34-1.18 0.34l-5.55 0.17q-0.34 0-0.34-0.17c0-0.17-0.17-0.17-0.34-0.17s-0.17 0.17-0.34 0.34c0 0.17-0.17 0.34-0.34 0.34s-0.34 0-0.34-0.17c0 0.34 0 1.01-0.17 1.35l0.17 2.19c0 0.17 0.17 0.34 0.34 0.34s0.34-0.17 0.34-0.34v-3.03c0.34-0.17 1.01-0.17 2.02-0.17h4.21c1.18 0 2.02-0.34 2.02-1.01zm-8.58-5.55q0-0.34-0.17-0.34c-0.34 0-0.34 0.17-0.34 0.5 0 1.01 0.17 1.68 0.34 2.19 0.17 0 0.34 0 0.34-0.17l-0.17-2.19zm0.51-0.84 7.4-0.17c1.01 0 1.68-0.34 2.19-0.84 0.34-0.34 0.34-0.5-0.17-0.34-0.5 0.34-1.18 0.67-2.02 0.67 0.34-0.17 0.34-0.34 0-0.34h-7.4c-0.34 0-0.34 0.17-0.34 0.5-0.17 0.34 0 0.5 0.34 0.5zm0 3.53c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.34 0.34 0.67 0.34h2.69c2.52 0 3.7-0.17 3.7-0.34h-0.34l-5.38 0.34c-0.34 0-0.5 0-0.67-0.17l-0.34-0.5zm0.67 7.74c-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.5 0.34c0.67 0 2.02-0.17 3.87-0.17 2.02-0.17 2.86-0.17 3.03-0.17 0.34 0 1.01 0 1.51 0.17q0.34 0 0.34-0.17c0-0.34-0.34-0.34-1.01-0.34h-7.91zm24.56 1.52c0.34 0 0.5-1.01 0.34-3.36 0-1.51 0.5-2.69 1.68-3.7 0.34-0.34 1.85-0.67 4.71-1.01 2.69-0.34 4.04-0.84 4.54-1.35 0.34-0.5 0.34-1.68 0.17-3.36 0-0.34-0.17-0.34-0.34-0.34-0.17 0.17-0.34 0.34-0.17 0.5 0 1.35-0.17 2.19-0.34 2.86-0.34 0.5-2.36 1.01-6.39 1.51-3.03 0.34-4.54 2.19-4.54 5.38 0.17 1.85 0.17 2.86 0.34 2.86zm0-10.43c0.17 0 0.17-0.34 0.17-0.67 0.17-0.84 0.17-1.18 0.17-1.35 0-0.34 0.17-0.67 0.34-1.51 0.34-0.67 0.34-1.01 0.34-1.18-0.34-0.17-0.5 0.17-1.01 1.01-0.34 0.67-0.5 1.51-0.5 2.36 0.34 0.84 0.34 1.35 0.5 1.35zm0.51-0.34c0 0.67 0.34 1.01 1.01 1.01 0.5 0 0.84-0.34 0.84-1.18 0-1.51-0.17-2.02-0.17-1.18 0-0.5 0.34-1.01 0.84-1.85 0.34-0.34 1.68-0.67 4.21-0.67 2.02 0 3.36 0 3.7 0.34 1.01 0.34 1.35 1.18 1.35 2.69 0 1.85-0.34 3.03-1.18 3.53s-2.52 0.84-4.88 1.01c-2.19 0.34-3.53 0.5-4.04 1.01-0.84 0.84-1.18 2.86-1.18 5.89-0.5 0.34-0.84 0.5-0.84 1.01s0.34 0.84 1.01 0.84c0.34 0 0.5-0.34 0.84-0.84h9.76c0.5 0 1.01 0 1.01 0.17 0.34 0 0.5 0.17 0.84 0.17s0.5-0.34 0.5-1.01c0-0.34-0.17-0.67-0.5-0.67l-10.26 0.34c-0.84 0-1.18-0.17-1.18-0.5 0-1.85 0.34-3.2 1.01-4.21 0.34-0.34 1.35-0.67 3.36-0.84 2.36-0.17 4.04-0.67 5.55-1.18 1.18-0.5 1.68-2.02 1.51-4.54 0-1.51-0.34-2.86-1.01-3.36-1.01-0.84-2.69-1.18-5.38-1.18-2.86 0-4.54 0.5-5.22 1.35-1.01 0.84-1.51 2.19-1.51 3.87zm1.85 11.94c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34 2.69 0.17 5.22 0.17 7.91 0 2.02-0.17 2.86-0.34 2.86-0.34 0-0.34-0.67-0.34-1.85-0.34zm-0.17-10.43c0 0.17 0.17 0.34 0.34 0.17 0.5 0 1.01-0.5 1.01-1.51 0-1.51 0.34-2.19 1.01-2.52 0.5-0.17 2.36-0.34 5.55-0.34 0.17 0 0.34-0.17 0.17-0.34 0-0.34-0.17-0.34-0.34-0.34l-4.21 0.17c-2.02 0.17-2.86 1.35-2.86 3.7 0 0.34-0.17 0.5-0.34 0.67-0.34 0.17-0.5 0.34-0.34 0.34zm9.25-7.57s0.17 0.17 0.67 0.34c0.5 0.34 1.01 0.84 1.35 1.35 0.5 1.01 0.84 2.19 0.84 3.53 0 2.69-0.67 4.21-2.19 4.88-1.01 0.34-2.52 0.84-4.54 1.01-1.68 0.34-2.86 0.5-3.53 1.01-0.34 0.17-0.34 0.34-0.67 1.01-0.34 0.5-0.34 0.84-0.34 1.01s0 0.34 0.17 0.34c0.34 0.17 0.5-0.34 1.01-1.51 0.17-0.5 1.51-1.01 3.7-1.18 2.69-0.34 4.21-0.67 5.05-1.35 0.67-0.5 1.18-1.01 1.51-1.51 0.34-1.01 0.67-2.19 0.67-3.87s-0.5-3.03-1.51-4.04c-0.84-0.84-1.35-1.18-2.02-1.18l-0.17 0.17zm-7.4 14.81c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34l8.75-0.17c0.34 0 0.67-0.17 0.67-0.34 0-0.34-0.34-0.34-0.67-0.34zm17.67-11.95c-0.34-0.17-0.34 0.34-0.5 1.01-0.34 1.18-0.34 3.03-0.34 5.55 0.17 3.2 0.34 5.22 0.84 5.89 1.01 2.02 3.36 2.86 7.23 2.86 1.18 0 2.19-0.17 3.2-0.34 1.01-0.34 1.51-0.5 1.51-0.84 0-0.17-0.17-0.17-0.17-0.17 0.34 0 0 0.17-1.01 0.34-1.01 0.34-2.19 0.5-4.04 0.5-2.19 0-3.7-0.34-4.88-1.01-1.18-0.84-1.85-1.85-1.85-3.2l-0.17-4.37v-4.04c0-0.84 0.17-1.35 0.34-1.85 0-0.17 0-0.34-0.17-0.34q0.17 0 0 0zm8.24-2.52-4.21 0.17c-1.68 0-2.86 1.01-3.36 2.69-0.17 0.84-0.34 2.36-0.34 4.71 0 2.86 0.17 4.54 0.17 4.88 0.34 1.51 0.84 2.69 1.68 3.36 1.01 0.84 2.86 1.18 5.22 1.01 2.19 0 3.53-0.34 4.21-1.01 1.01-1.01 1.51-2.86 1.35-5.55l-0.17-5.05c0-1.85-0.34-3.2-1.01-4.04-0.5-0.84-1.68-1.18-3.53-1.18zm-1.51 1.34c1.85 0 3.2 0.17 3.7 0.5 1.01 0.5 1.51 1.68 1.51 3.53l-0.17 5.55c0 1.68-0.17 2.86-0.34 3.2-0.5 1.01-1.85 1.51-4.21 1.51-1.68 0-3.03-0.17-3.87-0.67-1.01-0.5-1.51-1.68-1.51-3.36l-0.17-6.23c0-1.85 0.34-3.03 1.01-3.36 0.5-0.5 1.68-0.67 4.04-0.67zm-4.38 8.58q0 0.17 0 0c0.34 0 0.34-0.17 0.34-0.34 0.17-2.19 0.34-4.04 0.34-5.38 0.17-0.84 0.34-1.35 1.01-1.51 0.17 0 1.01-0.17 2.36-0.17h2.69c0.67 0.17 1.01 0.67 1.18 1.51 0.34 1.01 0.34 2.52 0.34 5.05 0 2.02 0 3.36-0.34 3.87-0.34 0.84-1.18 1.35-2.52 1.35-1.18 0-2.19 0-2.86-0.17-0.84-0.17-1.01-0.17-1.01-0.17q-0.17 0-0.34 0.17c-0.17 0.34 1.18 0.5 3.87 0.34 1.35 0 2.19-0.34 2.69-0.5 0.34-0.34 0.84-1.18 0.84-2.69v-6.56c0-2.19-1.51-3.36-4.37-3.2-1.85 0-3.2 0.34-3.7 1.01-0.34 0.34-0.5 1.18-0.5 2.36v5.05zm17.16 5.73c0.34 0 0.5-1.01 0.34-3.36 0-1.51 0.5-2.69 1.68-3.7 0.34-0.34 1.85-0.67 4.71-1.01 2.69-0.34 4.04-0.84 4.54-1.35 0.34-0.5 0.34-1.68 0.17-3.36 0-0.34-0.17-0.34-0.34-0.34-0.17 0.17-0.34 0.34-0.17 0.5 0 1.35-0.17 2.19-0.34 2.86-0.34 0.5-2.36 1.01-6.39 1.51-3.03 0.34-4.54 2.19-4.54 5.38 0 1.85 0.17 2.86 0.34 2.86zm0-10.44c0.17 0 0.17-0.34 0.17-0.67 0.17-0.84 0.17-1.18 0.17-1.35 0-0.34 0.17-0.67 0.34-1.51 0.34-0.67 0.34-1.01 0.34-1.18v-0.17c-0.34-0.17-0.5 0.17-1.01 1.01-0.34 0.67-0.5 1.51-0.5 2.36 0.17 0.84 0.17 1.51 0.5 1.51zm0.51-0.33c0 0.67 0.34 1.01 1.01 1.01 0.5 0 0.84-0.34 0.84-1.18 0-1.51-0.17-2.02-0.17-1.18 0-0.5 0.34-1.01 0.84-1.85 0.34-0.34 1.68-0.67 4.21-0.67 2.02 0 3.36 0 3.7 0.34 1.01 0.34 1.35 1.18 1.35 2.69 0 1.85-0.34 3.03-1.18 3.53s-2.52 0.84-4.88 1.01c-2.19 0.34-3.53 0.5-4.04 1.01-0.84 0.84-1.18 2.86-1.18 5.89-0.5 0.34-0.84 0.5-0.84 1.01s0.34 0.84 1.01 0.84c0.34 0 0.5-0.34 0.84-0.84h9.76c0.5 0 1.01 0 1.01 0.17 0.34 0 0.5 0.17 0.84 0.17s0.5-0.34 0.5-1.01c0-0.34-0.17-0.67-0.5-0.67l-10.26 0.34c-0.84 0-1.18-0.17-1.18-0.5 0-1.85 0.34-3.2 1.01-4.21 0.34-0.34 1.35-0.67 3.36-0.84 2.36-0.17 4.04-0.67 5.55-1.18 1.18-0.5 1.68-2.02 1.51-4.54 0-1.51-0.34-2.86-1.01-3.36-1.01-0.84-2.69-1.18-5.38-1.18-2.86 0-4.54 0.5-5.22 1.35-1.18 0.84-1.51 2.36-1.51 3.87zm1.85 11.77c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34 2.69 0.17 5.22 0.17 7.91 0 2.02-0.17 2.86-0.34 2.86-0.34 0-0.34-0.67-0.34-1.85-0.34-3.7 0.34-6.73 0.17-8.92 0zm-0.34-10.26c0 0.17 0.17 0.34 0.34 0.17 0.5 0 1.01-0.5 1.01-1.51 0-1.51 0.34-2.19 1.01-2.52 0.5-0.17 2.36-0.34 5.55-0.34 0.17 0 0.34-0.17 0.17-0.34 0-0.34-0.17-0.34-0.34-0.34l-4.21 0.17c-2.02 0.17-2.86 1.35-2.86 3.7 0 0.34-0.17 0.5-0.34 0.67-0.34 0.17-0.5 0.34-0.34 0.34zm9.26-7.57s0.17 0.17 0.67 0.34c0.5 0.34 1.01 0.84 1.35 1.35 0.5 1.01 0.84 2.19 0.84 3.53 0 2.69-0.67 4.21-2.19 4.88-1.01 0.34-2.52 0.84-4.54 1.01-1.68 0.34-2.86 0.5-3.53 1.01-0.34 0.17-0.34 0.34-0.67 1.01-0.34 0.5-0.34 0.84-0.34 1.01s0 0.34 0.17 0.34c0.34 0.17 0.5-0.34 1.01-1.51 0.17-0.5 1.51-1.01 3.7-1.18 2.69-0.34 4.21-0.67 5.05-1.35 0.67-0.5 1.18-1.01 1.51-1.51 0.34-1.01 0.67-2.19 0.67-3.87s-0.5-3.03-1.51-4.04c-0.84-0.84-1.35-1.18-2.02-1.18 0 0.17-0.17 0.17-0.17 0.17zm-7.41 14.64c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34l8.75-0.17c0.34 0 0.67-0.17 0.67-0.34 0-0.34-0.34-0.34-0.67-0.34zm23.73-10.1c0 0.17 0.84 0.17 2.36 0.17s2.52 0.34 3.36 0.84c1.01 0.84 1.51 2.52 1.51 5.38 0.17 4.21-1.68 6.39-5.38 6.56h-1.85c-2.52 0-4.37-0.34-5.38-1.01-0.84-0.5-1.35-1.18-1.51-2.19-0.17-0.84-0.34-1.18-0.34-1.18-0.17 0-0.34 0.34-0.34 0.67 0 1.01 0.34 1.85 1.01 2.52 1.01 1.18 3.2 1.68 6.06 1.51 3.2-0.17 5.38-0.5 6.06-1.18 1.18-1.01 1.85-3.2 1.68-6.56 0-2.19-0.5-3.7-1.35-4.71-1.01-1.01-2.36-1.51-4.37-1.51-0.84 0.34-1.51 0.5-1.51 0.67zm-6.73-2.86c0.17 0 0.17-0.34 0-0.67 0-0.34 0.17-0.84 0.34-1.01 0.34-0.34 0.67-0.34 1.18-0.34 0.34 0 0.67-0.17 0.67-0.17 0-0.34-0.34-0.34-0.84-0.34-1.18 0-1.85 0.5-1.85 1.35 0.17 0.84 0.34 1.18 0.5 1.18zm0 7.57c0.17 0 0.17-2.19 0-6.9 0-0.17-0.17-0.34-0.34-0.34s-0.34 0.17-0.34 0.34l0.17 5.89c0.34 0.67 0.34 1.01 0.5 1.01zm13.46 1.52c0-2.19-0.34-3.53-1.18-4.21-1.01-0.84-2.86-1.01-5.55-1.01-1.51 0-2.36 0.17-2.86 0.34-0.67 0.17-1.35 0.5-2.02 1.18 0.17-1.01 0.34-2.19 0.17-3.36v-0.34c0-1.01 0.17-1.51 0.34-1.68 0.34-0.17 0.84-0.34 1.51-0.34h6.73c1.01 0 1.51 0 1.51 0.34v0.17h0.34c0.67 0 1.01-0.34 0.84-1.18 0-0.67-0.84-0.84-2.36-0.67-1.85 0-4.71 0.17-8.58 0.34-1.01 0-1.51 0.17-1.51 0.34-0.17 0.34-0.17 2.02 0 5.38 0 0 0 0.5 0.17 1.35v1.01l-0.67 0.34c0 0.17 0 0.34 0.34 0.84 0.34 0.34 0.34 0.5 0.84 0.5 0.34 0 0.67-0.34 0.84-0.67 0.17-0.5 0.34-1.01 0.84-1.18 0.84-0.34 2.02-0.67 3.87-0.67 2.19 0 3.7 0.17 4.37 0.67s1.01 1.51 1.01 3.36c0 2.19-0.34 3.36-1.01 4.04-0.67 0.5-2.19 1.01-4.37 1.01-3.2 0.17-4.71-0.5-4.88-1.68 0-0.34 0-0.84-0.17-1.18s-0.34-0.34-0.67-0.34c-0.84 0-1.01 0.34-1.01 1.01 0.17 1.51 1.01 2.69 2.36 3.03 1.01 0.34 2.69 0.34 4.88 0.34s3.7-0.34 4.21-0.84 1.01-1.01 1.01-1.18c0.5-2.02 0.67-3.36 0.67-5.05zm-12.79 0.67c0 0.17 0.34 0.17 0.67 0.17s0.67 0.17 1.01 0.34c0.17 0.34 0.34 0.5 0.34 0.84v1.01c0.17 1.01 1.35 1.51 3.53 1.35l2.86-0.17c1.35 0 2.19-0.67 2.52-1.68 0-0.34 0.17-1.01 0.17-2.19s0-1.85-0.34-2.19c0-0.17-0.34-0.34-0.5-0.34 0-0.67-0.34-1.01-0.67-1.01 0.17 0-1.01 0-3.36 0.17h-2.36c-0.67 0.17-1.01 0.34-1.01 0.5-0.34 1.01-0.5 1.35-0.84 1.51-0.34 0-0.84 0.17-1.18 0.34 0 0.34 0.17 0.34 0.67 0.34s1.01-0.34 1.35-0.84c0.34-0.67 0.5-1.01 0.67-1.01 0.34-0.17 1.51-0.34 3.7-0.34 1.68 0 2.86 0 3.03 0.34 0.17 0.17 0.17 1.01 0.34 2.19 0 2.02 0.17 2.52 0.17 1.68 0 0.67-0.17 1.01-0.34 1.18-0.34 0.34-1.01 0.34-1.85 0.5h-4.04c-0.84 0-1.18-0.67-1.35-2.19 0-0.67-0.5-1.01-1.35-1.01-1.51 0.17-1.85 0.34-1.85 0.5zm12.95-9.42h-0.34l-0.34 0.17c-0.17 0-0.34-0.17-0.5-0.34-2.86 0.17-5.22 0.34-7.07 0.34h-1.85c-0.34 0.17-0.34 0.34-0.34 0.34-0.17 0.34-0.17 1.01-0.17 1.85 0 0.17 0.17 0.34 0.34 0.34s0.34 0 0.34-0.17l0.34-1.51c0-0.34 1.18-0.34 3.36-0.34h5.05c0.5 0 1.01-0.17 1.35-0.34-0.17 0-0.17-0.17-0.17-0.34zm-8.58 2.36c-1.01 0-1.51 0.17-1.51 0.34s0.5 0.17 1.51 0.17 1.35-0.17 1.35-0.34-0.34-0.17-1.35-0.17zm-289.21 17.83c0.34 0 0.34-2.36 0-7.23-0.17-3.36-0.34-5.05-0.34-5.05-0.17 0-0.34 0.5-0.34 1.51 0 0.34 0.17 3.53 0.34 9.59 0 0.84 0.17 1.18 0.34 1.18zm0-12.96c0.17 0.17 0.34 0 0.34-0.34l0.67-1.01c0.34-0.34 0.5-0.5 1.01-0.67 0.34-0.17 0.34-0.34 0.34-0.34 0-0.17-0.17-0.17-0.34-0.17-0.34 0-0.84 0.34-1.35 1.01-0.67 1.01-0.84 1.35-0.67 1.51zm0.84 1.69v3.87c0 1.18 0 2.86 0.17 4.37 0 1.51 0.34 2.69 1.35 3.36s2.52 1.01 4.71 1.01c1.85 0 3.2-0.34 3.87-0.5 1.51-0.67 2.19-2.19 2.19-4.54 0-1.85-0.34-3.2-1.01-3.87-1.01-1.01-2.86-1.51-5.72-1.51-0.67 0-1.51 0.17-2.19 0.34-0.34 0.17-0.84 0-1.18-0.17v0.5q0 0.17-0.34 0.34c-0.17 0.17-0.34 0.17-0.5 0.17-0.34 0-0.34-0.17-0.34-0.34 0-0.34-0.17-0.67-0.34-1.01h0.17c0.17 0 0.34 0 0.34 0.17v0.34q0 0.17 0.17 0.17c0.34 0 0.5-0.17 0.34-0.34-0.34-0.67-0.5-1.35-0.5-2.19 0-0.5 0.17-1.01 0.34-1.35 0.67-1.01 2.36-1.51 5.22-1.51s4.21 0.67 4.54 2.19c0.84 0.34 1.18 0 1.18-0.84s-0.5-1.51-1.51-2.02-2.36-0.84-4.04-0.84c-2.36 0-4.04 0.34-4.88 0.84-1.51 0.67-2.02 1.85-2.02 3.36zm1.18 5.38c0-1.01 1.51-1.51 4.54-1.51 1.68 0 2.86 0 3.53 0.17 1.01 0.17 1.51 0.67 1.51 1.35 0.17 1.01 0.34 1.85 0.34 2.52 0 2.19-0.67 3.36-2.02 3.36l-5.55 0.17c-0.5 0-1.01-0.17-1.51-0.5s-0.67-0.67-0.67-1.01l-0.17-4.54zm0.5 3.03c0 1.18 0.5 2.02 1.51 2.19 0.5 0.17 1.85 0.34 4.04 0.17 1.35 0 2.19-0.17 2.36-0.34 0.67-0.34 1.01-1.35 1.01-2.86 0-1.18-0.34-2.02-0.5-2.36-0.5-0.5-1.68-0.84-3.53-0.67-2.19 0-3.53 0.34-4.04 1.01-0.67 0.34-0.84 1.18-0.84 2.86zm0.34 4.88c0 0.17 0.5 0.34 1.51 0.5s2.19 0.34 3.36 0.34c2.52 0 4.37-0.5 5.38-1.51s1.51-2.36 1.51-4.54c0-2.52-0.5-4.37-1.35-5.38-0.84-1.01-2.52-1.35-4.88-1.35h-4.37c-0.34 0-0.5-0.5-0.5-1.51s1.35-1.35 4.04-1.35c1.35 0 2.19 0.17 2.86 0.34 0.34 0.17 0.5 0.34 0.5 0.67s0.17 0.34 0.34 0.34 0.34-0.34 0.17-0.84c-0.17-1.01-1.51-1.35-4.04-1.18-3.03 0.17-4.54 1.01-4.54 2.69 0 1.01 0.84 1.51 2.36 1.51 0.34 0 0.67 0 1.01-0.17 0.5 0 0.84-0.17 1.01-0.17 1.68 0 2.86 0 3.7 0.34 0.34 0.17 1.01 0.34 1.85 1.01 0.84 0.5 1.18 2.02 1.18 4.54 0 1.68-0.34 3.03-1.01 3.87-1.01 1.18-2.86 1.85-5.38 2.02-1.18 0-2.36 0-3.36-0.17s-1.51-0.34-1.35-0.34c0.17 0.17 0 0.34 0 0.34zm0.34-7.07c0.17-0.67 1.35-1.01 3.53-1.01h2.36c1.01 0.17 1.51 0.67 1.51 1.35 0 0.34 0 0.5 0.17 1.01 0 1.01 0 1.51-0.34 1.85-0.34 0.5-1.51 1.01-3.36 1.01-2.19 0-3.36-0.17-3.53-0.34-0.34-0.34-0.34-1.01-0.34-1.85-0.17-0.84-0.17-1.51 0-2.02zm10.6-8.75c0-0.34-0.34-0.84-0.84-1.18-0.5-0.5-1.01-0.67-1.35-0.67q-0.17 0-0.34 0.17 0 0.17 0.34 0.34c0.34 0.17 0.67 0.34 1.01 0.67 0.84 0.84 1.01 1.18 1.01 1.18s0.17-0.17 0.17-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m453.59 685.52 6.39 9.25h-10.43l-5.38-7.91h-3.03v7.91h-9.59v-35.84h16.15c7.23 0 12.95 4.88 12.95 10.94v5.72c0 4.37-2.86 8.08-7.07 9.93zm-2.52-15.48c0-1.51-1.51-3.03-3.53-3.03h-6.56v11.61h6.56c2.02 0 3.53-1.35 3.53-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m478.49 667.01v6.06h10.43v6.56h-10.43v7.07h14.64v7.91h-24.06v-35.84h24.06v7.91l-14.64 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m521.22 670.38v-3.36h-10.09v19.68h10.09v-5.05h-3.7v-6.73h13.29v13.29c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.37 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.36-6.56 7.91-6.56h13.46c4.37 0 7.91 3.03 7.91 6.56v4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m558.74 670.38v-3.36h-10.09v19.68h10.09v-5.05h-3.7v-6.73h13.29v13.29c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.37 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.36-6.56 7.91-6.56h13.46c4.37 0 7.91 3.03 7.91 6.56v4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m586.17 659.11v35.84h-9.59v-35.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m627.89 694.94h-9.59l-1.35-4.04h-11.78l-1.35 4.04h-9.59l11.44-35.84h10.6l11.61 35.84zm-12.79-10.6-3.7-11.95-3.87 11.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m684.93 670.04v13.8c0 6.06-5.89 10.94-12.95 10.94h-15.98v-35.84h15.98c7.23 0.17 12.95 5.05 12.95 11.1zm-9.43 0c0-1.51-1.51-3.03-3.53-3.03h-6.56v19.68h6.56c2.02 0 3.53-1.35 3.53-3.03v-13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m702.93 659.11v35.84h-9.59v-35.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m752.22 659.11c4.37 0 7.91 3.03 7.91 6.56v4.71h-9.59v-3.36h-10.09v19.68h10.09v-3.2h9.59v4.71c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.21 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.53-6.56 7.91-6.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m800.85 694.94h-9.59l-1.35-4.04h-11.78l-1.35 4.04h-9.59l11.44-35.84h10.6l11.61 35.84zm-12.79-10.6-3.7-11.95-3.87 11.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m826.42 669.71v-2.69h-10.09v6.23h11.78c4.37 0 7.91 3.03 7.91 6.56v8.41c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.37 0-7.91-3.03-7.91-6.56v-4.04h9.59v2.86h10.09v-5.38h-11.78c-4.37 0-7.91-2.86-7.91-6.56v-9.09c0-3.53 3.36-6.56 7.91-6.56h13.46c4.37 0 7.91 3.03 7.91 6.56v4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m853.84 667.01v6.06h10.43v6.56h-10.43v7.07h14.64v7.91h-24.06v-35.84h24.06v7.91l-14.64 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m898.93 685.52 6.39 9.25h-10.43l-5.38-7.91h-2.86v7.91h-9.59v-35.84h15.98c7.23 0 12.95 4.88 12.95 10.94v5.72c0 4.37-3.03 8.08-7.07 9.93zm-2.52-15.48c0-1.51-1.51-3.03-3.53-3.03h-6.56v11.61h6.56c2.02 0 3.53-1.35 3.53-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m937.29 659.11v7.91h-7.57v27.93h-9.59v-27.93h-7.57v-7.91h24.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "m972.29 694.94h-9.59l-1.35-4.04h-11.78l-1.35 4.04h-9.59l11.44-35.84h10.6l11.61 35.84zm-12.96-10.6-3.7-11.95-3.87 11.95z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "66.46 622.26 332.79 627.65 332.28 657.42 65.78 652.04",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m76.55 644.64c0.34 0 0.5-1.01 0.5-3.2 0-1.35 0.67-2.52 1.85-3.36 0.34-0.34 2.02-0.5 4.71-0.84s4.21-0.5 4.71-1.01c0.34-0.5 0.5-1.51 0.34-3.2 0-0.17-0.17-0.34-0.34-0.34s-0.34 0.34-0.34 0.5c0 1.35-0.34 2.19-0.5 2.69-0.34 0.5-2.52 0.84-6.56 1.01-3.2 0.34-4.71 1.85-4.71 4.88 0.17 1.85 0.17 2.86 0.34 2.86zm0.34-10.1c0.17 0 0.17-0.34 0.34-0.67 0.17-0.84 0.17-1.18 0.17-1.18 0-0.34 0.34-0.67 0.5-1.35s0.5-1.01 0.5-1.18v-0.17c-0.34-0.17-0.5 0.17-1.01 0.84-0.34 0.67-0.67 1.51-0.67 2.19-0.17 1.01 0 1.51 0.17 1.51zm0.67-0.16c0 0.5 0.34 1.01 1.01 1.01 0.5 0 0.84-0.34 1.01-1.18 0-1.51 0-1.85-0.17-1.18 0-0.34 0.34-1.01 1.01-1.68 0.34-0.34 1.68-0.5 4.37-0.5 2.19 0 3.36 0.17 3.87 0.34 1.01 0.34 1.35 1.18 1.18 2.52 0 1.85-0.5 2.86-1.35 3.36-1.01 0.34-2.52 0.67-5.05 0.84-2.19 0.17-3.7 0.34-4.04 0.84-1.01 0.67-1.35 2.52-1.51 5.55-0.67 0.34-1.01 0.5-1.01 0.84 0 0.5 0.34 0.84 1.01 0.84 0.34 0 0.5-0.34 0.84-0.84l9.93 0.34c0.5 0 1.01 0 1.01 0.17 0.34 0.17 0.5 0.17 0.84 0.17s0.5-0.34 0.5-0.84c0-0.34-0.17-0.5-0.5-0.67l-10.43-0.34c-0.84 0-1.18-0.17-1.18-0.5 0-1.68 0.34-3.03 1.18-4.04 0.34-0.34 1.51-0.5 3.36-0.67 2.36-0.17 4.21-0.34 5.72-1.01 1.18-0.5 1.85-1.85 1.85-4.21 0-1.51-0.34-2.69-1.01-3.36-1.01-0.84-2.86-1.35-5.38-1.35-2.86 0-4.71 0.34-5.38 1.01-1.18 1.68-1.68 2.86-1.68 4.54zm1.35 11.44c-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.34 0.34c2.69 0.34 5.38 0.34 7.91 0.34 2.02 0 3.03-0.17 3.03-0.34s-0.67-0.34-1.85-0.34c-3.87 0-6.9-0.17-9.09-0.34zm0.17-9.93c0 0.17 0.17 0.34 0.34 0.34 0.5 0 1.01-0.5 1.01-1.51 0-1.35 0.34-2.19 1.18-2.36 0.5-0.17 2.36-0.17 5.72-0.17 0.17 0 0.34-0.17 0.34-0.34s-0.17-0.34-0.34-0.34h-4.21c-2.02 0-3.03 1.18-3.03 3.36 0 0.34-0.17 0.5-0.34 0.67-0.67 0.17-0.67 0.34-0.67 0.34zm9.75-6.9s0.17 0.17 0.67 0.34c0.5 0.34 1.01 0.84 1.35 1.35 0.5 1.01 0.84 2.19 0.67 3.36 0 2.52-1.01 4.04-2.52 4.71-1.01 0.34-2.69 0.67-4.71 0.84-1.68 0.17-2.86 0.34-3.7 0.84-0.34 0.17-0.5 0.34-0.67 0.84-0.34 0.34-0.34 0.84-0.34 1.01s0 0.34 0.17 0.34c0.34 0.17 0.67-0.34 1.01-1.51 0.34-0.34 1.51-0.84 3.87-1.01 2.69-0.17 4.37-0.5 5.22-1.01s1.35-1.01 1.51-1.51c0.5-0.84 0.84-2.02 0.84-3.53s-0.34-2.86-1.35-4.04c-0.67-0.67-1.35-1.01-2.02-1.01 0.17 0 0 0 0 0zm-8.24 13.8c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34l9.09 0.17c0.34 0 0.67-0.17 0.67-0.34s-0.34-0.34-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m96.24 632.02c0.34 0.67 0.67 1.01 1.18 1.01 0.34 0 0.67-0.17 1.01-0.34 0.34-0.34 0.84-0.5 1.01-1.01v-0.34c0-0.34 0.34-0.5 1.01-0.5 0.34 0 0.5 0 0.5 0.17v0.5c0 0.5-0.17 0.84-0.34 0.84s-0.17-0.17-0.17-0.5 0-0.5-0.17-0.5-0.17 0.17-0.34 0.34c-0.17 0.34-0.17 0.5-0.34 0.84 0 0.17 0 0.34 0.17 0.5q0.17 0.34 0.17 0.5l-0.34 9.76c0 0.34-0.17 0.5-0.34 0.67-0.17 0-0.34 0.34-0.34 0.84 0 0.84 0.34 1.18 1.01 1.18s1.01-0.34 1.01-0.67l0.34-14.81c0-0.67-0.5-1.01-1.68-1.01-0.84 0-1.68 0.34-2.52 0.84-0.17 0.84-0.5 1.18-0.84 1.68zm2.86 1.35 0.17 0.5-0.34 9.93q0 0.34 0.34 0.34c0.17 0 0.34 0 0.34-0.17l0.34-9.93c-0.17-0.5-0.34-0.67-0.84-0.67zm3.36 7.06c-0.17 0-0.17 0.34-0.17 0.84 0 0.67 0 1.01 0.17 1.01s0.34-0.34 0.34-1.01c0-0.5 0-0.84-0.34-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m125.51 629.83c0-0.17-0.34-0.34-1.01-0.34-1.68 0.17-2.86 0.5-3.53 1.01-1.35 1.01-2.02 3.2-2.19 6.56s0 5.89 0.34 6.9c0.17 0.34 0.5 1.01 1.18 1.68 0.67 0.67 1.51 1.18 2.86 1.35 0.84 0.17 2.19 0.17 4.04 0.34 2.86 0 4.71 0 5.89-0.34 1.01-0.34 1.51-0.84 2.02-1.68v-0.34s0-0.17-0.17-0.17-0.17 0.17-0.34 0.34c-0.34 0.67-1.01 1.01-1.51 1.18-1.01 0.34-3.03 0.5-5.89 0.34h-3.36c-1.51-0.17-2.69-0.5-3.36-1.01-1.01-0.84-1.51-3.03-1.51-6.56v-2.69c0.17-4.37 1.85-6.56 5.22-6.39 1.18 0 1.35 0 1.35-0.17zm7.91 11.11v2.19c0 0.5-0.17 1.01-0.34 1.18-0.34 0.34-2.19 0.5-5.38 0.5-2.69 0-4.21-0.34-5.05-0.84s-1.01-2.86-1.01-7.07c0-2.52 0.34-4.04 1.01-4.71s2.36-1.01 5.38-0.84c2.52 0 4.04 0.34 4.71 0.84 0.34 0.34 0.67 1.18 0.67 2.69 0 0.5 0.34 1.01 1.01 1.01s1.01-0.34 1.01-1.18c0-1.68-0.34-2.86-1.18-3.36-1.01-0.5-3.03-1.01-6.23-1.01-3.36-0.17-5.55 0.34-6.56 1.18-0.67 0.67-1.01 2.69-1.01 6.23-0.17 4.04 0.34 6.39 1.18 7.23 1.01 0.84 2.86 1.18 6.23 1.35 3.2 0 5.05-0.17 5.89-0.5 1.01-0.5 1.51-1.85 1.51-4.04v-1.51c0-0.5-0.34-0.84-0.67-0.84l-5.05-0.17c-0.5 0-0.84 0.34-0.84 0.84s0.34 0.84 0.84 0.84h3.87zm-0.84-6.4c0.17 0 0.34-0.34 0.34-0.84 0-1.01-1.68-1.35-5.22-1.51-2.19 0-3.7 0.17-4.37 0.67s-1.01 1.51-1.01 2.86c-0.17 3.7 0 5.55 0.34 5.55 0.17 0 0.17-1.51 0.34-4.88 0-1.85 0.34-2.86 0.84-3.36 0.34-0.34 1.85-0.34 4.04-0.34 2.86 0 4.21 0.34 4.54 1.01v0.34c0 0.34 0 0.5 0.17 0.5zm-9.09 9.26c0 0.5 1.51 0.84 4.54 1.01 2.69 0 3.87-0.17 3.87-0.67 0-0.17-0.34-0.17-0.67 0-1.01 0.17-2.19 0.17-3.87 0.17-1.01 0-1.85-0.17-2.69-0.34-0.67-0.17-1.18-0.17-1.18-0.17zm10.1-7.24c0 0.17 0.34 0.34 0.84 0.34s0.84 0 0.84-0.17-0.34-0.17-1.01-0.17c-0.5-0.34-0.67-0.17-0.67 0zm1.85-4.37c-0.17 0.17-0.17 0.34 0 0.34s0.17 0.34 0.17 0.5c0 0.34 0 0.67 0.17 0.67s0.34-0.17 0.34-0.5c0-0.84-0.17-1.01-0.67-1.01 0.17-0.17 0 0 0 0zm0.67 8.24c0-0.84 0-1.01-0.34-1.01-0.17 0-0.34 0.34-0.34 1.01 0 1.01 0 1.35 0.34 1.35 0.17 0 0.34-0.34 0.34-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m141.66 635.22c0 0.34 0.17 0.34 0.34 0.34 0.34 0 0.34-0.17 0.34-0.34v-1.01c0.17-0.34 0-0.34-0.17-0.34-0.17 0.17-0.34 0.67-0.5 1.35zm0 11.27c0 0.17 0.17 0.17 0.34 0.17s0.34-0.17 0.17-0.17c-0.17-0.17-0.17-0.34-0.17-0.67s0-0.67 0.17-1.51c0.17-0.67 0.17-1.18 0.17-1.51s0-0.67-0.17-1.01c0-2.86 0.17-4.54 0-5.22 0-0.34-0.17-0.34-0.34-0.34q-0.17 0.17-0.34 0.34l0.17 9.93zm2.53-15.98c-0.34-0.17-0.5-0.17-0.5 0l-0.67 0.5c-0.34 0.17-0.34 0.5 0 1.18v6.39 3.36 2.19c0 1.01-0.34 1.51-0.5 1.68v0.17c0 0.34 0.17 0.5 0.34 0.84 0.34 0.34 0.67 0.34 1.01 0.34 0.5 0 0.67-0.34 0.67-1.01-0.17-5.05 0-7.91 0.17-8.24 0-1.35 0.17-3.53 0.17-6.56 0-0.34-0.17-0.5-0.34-0.67l-0.34-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m151.25 642.79c-0.17 1.51 0.5 2.86 1.51 3.87 0.17 0.17 0.34 0.17 0.34 0 0.17-0.17 0-0.34-0.34-0.34-0.84-0.84-1.35-1.68-1.18-3.2l0.17-8.24q0-0.34-0.17-0.34c-0.17 0-0.34 0.17-0.34 0.34v7.91zm0.68-10.77c-0.17 0-0.17 0.17-0.34 0.34v0.84c0 0.34 0.17 0.34 0.34 0.34 0.34 0 0.5-0.17 0.17-0.5-0.17-0.17-0.17-0.34-0.17-0.67 0.17-0.17 0.17-0.34 0-0.34zm8.07 13.46c-1.85 0-3.2-0.17-4.04-0.5-1.18-0.34-1.68-1.01-1.68-2.19l0.17-9.25h0.34v-1.85c0-0.5-0.34-0.84-1.01-0.84-0.84 0-1.18 0.34-1.18 1.01 0 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.34 0.34 0.34 0.5l-0.17 9.09c0 1.85 0.34 3.2 1.35 3.87s2.86 1.01 5.89 1.01c2.36 0 4.04 0 4.71-0.34 1.51-0.34 2.19-1.68 2.19-3.7l0.17-5.38 0.34-0.17 0.17-4.21c0.17 0.17 0.34 0 0.34-0.34 0-1.01-0.34-1.35-1.01-1.51-0.34 0-0.5 0.17-0.84 0.34s-0.34 0.5-0.34 0.67 0.17 0.34 0.34 0.34c0.34 0.17 0.34 0.34 0.34 0.84 0 0.34-0.17 1.51-0.34 3.36s-0.17 2.86-0.17 3.2c0 2.69-0.34 4.21-0.67 4.71-1.01 0.84-2.69 1.01-5.55 1.01zm-6.22 1.35c-0.34 0.34 0.34 0.67 1.51 1.01 1.18 0.34 1.68 0.34 1.68-0.17 0-0.34-0.34-0.34-0.67-0.34-0.67 0-1.18-0.17-1.68-0.34s-0.84-0.34-0.67-0.34c0 0-0.17 0-0.17 0.17zm1.34-13.13c-0.17 0-0.17 0.67-0.17 2.02 0 0.34 0 1.01-0.17 2.36 0 1.35-0.17 2.19-0.17 2.52s0 1.01-0.17 1.68v0.84c0 0.17 0.17 0.17 0.34 0.34 0.34 0 0.34-0.84 0.34-2.52 0-0.34 0-1.18 0.17-2.69v-2.69c0.17-1.18 0.17-1.85-0.17-1.85zm0.34-1.68c-0.34 0-0.34 0.34-0.34 0.84q0 0.34 0.17 0.34c0.34 0 0.34-0.17 0.34-0.34-0.17-0.67-0.17-0.84-0.17-0.84zm3.7 15.81c-1.01 0-1.51 0-1.51 0.17s0.34 0.34 1.35 0.34c1.01 0.17 1.51 0 1.51-0.34 0-0.17-0.17-0.34-0.34-0.34-0.34 0.17-0.67 0.17-1.01 0.17zm2.86 0c0 0.17 0.34 0.34 0.67 0.34 1.68 0 3.2-0.5 4.37-1.68 0.67-0.67 1.01-1.85 1.01-3.36 0-0.84-0.17-1.18-0.34-1.18s-0.17 0.5-0.17 1.51-0.34 1.85-0.67 2.19c-0.67 0.84-1.35 1.35-2.19 1.51-0.5 0.17-1.18 0.34-2.02 0.34-0.34 0.17-0.67 0.17-0.67 0.34zm2.86-14.97-0.34 9.09c0 0.5-0.17 1.18-0.34 2.02q0 0.17 0.17 0.34c0.5 0.34 0.84-0.5 1.01-2.36l0.17-9.09q0-0.34-0.34-0.34c-0.34 0-0.34 0.17-0.34 0.34zm3.37-0.17c-0.17 0-0.34 1.18-0.34 3.53 0 0.67-0.17 2.19-0.17 4.04 0 0.5 0 0.84 0.17 0.84 0.34 0 0.34-1.18 0.34-3.7 0.17-3.2 0.17-4.71 0-4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m179.85 630.84c0-0.17-0.34-0.34-1.01-0.34-1.68 0.17-2.86 0.5-3.53 1.01-1.35 1.01-2.02 3.2-2.19 6.56s0 5.89 0.34 6.9c0.17 0.34 0.5 1.01 1.18 1.68 0.67 0.67 1.51 1.18 2.86 1.35 0.84 0.17 2.19 0.17 4.04 0.34 2.86 0 4.71 0 5.89-0.34 1.01-0.34 1.51-0.84 2.02-1.68v-0.34q0-0.17-0.17-0.17c-0.17 0-0.17 0.17-0.34 0.34-0.34 0.67-1.01 1.01-1.51 1.18-1.01 0.34-3.03 0.5-5.89 0.34h-3.36c-1.51-0.17-2.69-0.5-3.36-1.01-1.01-0.84-1.51-3.03-1.51-6.56v-2.69c0.17-4.37 1.85-6.56 5.22-6.39 1.01 0.17 1.35 0 1.35-0.17zm7.91 11.27v2.19c0 0.5-0.17 1.01-0.34 1.18-0.34 0.34-2.19 0.5-5.38 0.5-2.69 0-4.21-0.34-5.05-0.84s-1.01-2.86-1.01-7.07c0-2.52 0.34-4.04 1.01-4.71s2.36-1.01 5.38-0.84c2.52 0 4.04 0.34 4.71 0.84 0.34 0.34 0.67 1.18 0.67 2.69 0 0.5 0.34 1.01 1.01 1.01s1.01-0.34 1.01-1.18c0-1.68-0.34-2.86-1.18-3.36-1.01-0.5-3.03-1.01-6.23-1.01-3.36-0.17-5.55 0.34-6.56 1.18-0.67 0.67-1.01 2.69-1.01 6.23-0.17 4.04 0.34 6.39 1.18 7.23 1.01 0.84 2.86 1.18 6.23 1.35 3.2 0 5.05-0.17 5.89-0.5 1.01-0.5 1.51-1.85 1.51-4.04v-1.51c0-0.5-0.34-0.84-0.67-0.84l-4.88-0.34c-0.5 0-0.84 0.34-0.84 0.84s0.34 0.84 0.84 0.84l3.7 0.17zm-0.84-6.56c0.17 0 0.34-0.34 0.34-0.84 0-1.01-1.68-1.35-5.22-1.51-2.19 0-3.7 0.17-4.37 0.67s-1.01 1.51-1.01 2.86c-0.17 3.7 0 5.55 0.34 5.55 0.17 0 0.17-1.51 0.34-4.88 0-1.85 0.34-2.86 0.84-3.36 0.34-0.34 1.85-0.34 4.04-0.34 2.86 0 4.21 0.34 4.54 1.01v0.34q0 0.5 0.17 0.5zm-9.08 9.42c0 0.5 1.51 0.84 4.54 1.01 2.69 0 3.87-0.17 3.87-0.67 0-0.17-0.34-0.17-0.67 0-1.01 0.17-2.19 0.17-3.87 0.17-1.01 0-1.85-0.17-2.69-0.34-0.84-0.34-1.18-0.34-1.18-0.17q0-0.17 0 0zm9.92-7.4c0 0.17 0.34 0.34 0.84 0.34s0.84 0 0.84-0.17-0.34-0.17-1.01-0.17c-0.34-0.17-0.67-0.17-0.67 0zm2.02-4.37c-0.17 0.17-0.17 0.34 0 0.34 0.17 0.17 0.17 0.34 0.17 0.5 0 0.34 0 0.67 0.17 0.67s0.34-0.17 0.34-0.5c0-0.67-0.34-1.01-0.67-1.01q0.17 0 0 0zm0.67 8.41c0-0.84 0-1.01-0.34-1.01-0.17 0-0.34 0.34-0.34 1.01 0 1.01 0 1.35 0.34 1.35 0.17 0 0.17-0.5 0.34-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m196.17 648.68c0.34-0.34 0.67-0.67 0.67-1.51 0.17-0.5 0-1.01-0.17-1.51l0.34-11.95c0-0.5 0.34-0.84 0.5-0.84 0.34 0 0.84 0.17 1.18 0.5s0.5 0.5 0.34 0.67c-0.17 0.17-0.34 0.17-0.5 0q-0.34 0-0.34 0.34c0 0.34 0.17 0.5 0.5 0.5q0.34 0 0.5 0.17l7.23 11.27q0.17 0.34 0 0.34c-0.17 0-0.34 0.17-0.34 0.17 0 0.17 0.17 0.34 0.34 0.34 0.34 0.17 0.5 0.34 0.84 0.34 1.01 0 2.02-0.17 2.36-0.5l0.34-0.34-0.34-0.34c-0.17-0.17-0.34-0.17-0.34-0.34l0.5-11.44c0-0.34 0.17-0.5 0.17-0.84l-0.34-0.17v-0.17c0-0.17 0.17-0.34 0.34-0.67s0.34-0.5 0.34-0.5c0-0.67-0.34-1.01-0.84-1.01-0.34 0-0.5 0.17-0.84 0.34-0.34 0.34-0.34 0.5-0.34 0.84 0 0.17 0.17 0.34 0.34 0.34s0.34 0.34 0.34 0.5l-0.17 8.41c0 1.85-0.17 2.86-0.17 3.03 0 0.5-0.34 0.84-0.5 0.67-0.67 0-1.01-0.17-1.01-0.34-0.17-0.34-0.17-0.5-0.34-1.01-3.2-4.71-5.72-8.92-7.91-12.79-0.17-0.17-0.34-0.34-0.5-0.34l-2.02-0.17c-0.84 0-1.18 0.34-1.18 1.01 0 0.17 0.17 0.34 0.34 0.34 0.17 0.17 0.34 0.5 0.17 1.35-0.17 1.85-0.17 3.7-0.34 5.55l-0.34 6.73c0 0.5-0.17 0.84-0.34 0.84-0.34 0-0.34-0.17-0.34-0.34 0 0 0-0.84 0.17-2.02v-2.19c0-0.34 0-0.5-0.34-0.5-0.17 0-0.34 0-0.34 0.34l-0.17 4.88c0 0.67 0.34 1.01 0.84 1.01l1.68 1.01zm-1.34-16.32c-0.17 0-0.34 0.34-0.34 1.01 0-0.17 0 1.18-0.17 3.87 0 0.84 0 1.85-0.17 2.86v1.51c0 0.34 0.17 0.34 0.34 0.34s0.34-1.51 0.34-4.88c0 0.34 0-0.84 0.17-3.7 0-0.67 0-1.01-0.17-1.01zm2.86 3.02c-0.17 0-0.34 0.5-0.34 1.51v5.55c0 3.2 0 4.71 0.17 4.71s0.34 0 0.34-0.17v-4.21c0-1.51 0.17-2.52 0.17-3.36 0-0.67 0-1.35-0.17-2.02-0.17-1.35-0.17-2.02-0.17-2.02zm8.07 12.62c0.17 0 0.17-0.17 0.17-0.34 0-0.34-0.34-0.84-1.18-1.85v-0.5c-0.84-1.01-2.19-3.03-3.87-6.06-1.35-2.19-2.19-3.36-2.36-3.36s0.17 0.5 0.67 1.18c0.5 0.84 0.84 1.18 0.67 1.18s0.84 1.68 2.86 4.88c1.68 3.36 2.69 4.88 3.03 4.88zm-4.54-13.79q-0.17 0 0 0c-0.17 0.34 0 0.84 0.5 1.51 0.34 0.5 1.01 1.51 1.85 3.03 0.34 0.67 0.84 1.35 1.18 1.85l0.84 0.84c0.17-0.17 0-0.67-0.34-1.35l-4.04-5.89zm5.55 9.25-0.5-1.01q-0.17-0.17-0.34-0.17c-0.17 0-0.34 0.17-0.17 0.17l0.5 1.01q0.17 0.17 0.5 0 0 0.17 0 0zm3.7 3.87c-0.84 1.01-1.51 1.35-2.36 1.35-0.34 0-0.5 0-1.01-0.17q-0.34 0-0.34 0.17c0 0.34 0.34 0.34 1.35 0.5 0.84 0 1.51-0.17 2.02-0.67 0.34-0.34 0.5-0.5 0.5-1.01l-0.17-0.17zm-2.69-3.2c0.17 0 0.17-0.5 0.17-1.68v-7.23c0-1.51 0-2.52-0.17-2.52-0.34 0-0.34 0.84-0.34 2.36 0-0.84 0 0-0.17 2.36-0.17 1.68-0.17 3.2 0 4.21 0.17 1.85 0.34 2.52 0.5 2.52zm-0.33 0.51c0 0.67 0.17 1.01 0.5 1.01 0.17 0 0.17-0.17 0.17-0.5s0-0.67-0.17-0.67c-0.34-0.17-0.34 0-0.5 0.17zm3.53-0.67 0.34-10.09q-0.17-0.17-0.34-0.34c-0.17 0-0.34 0.17-0.34 0.34l-0.34 9.09-0.17 0.34v3.03c0 0.17 0 0.34 0.34 0.34 0.17 0.17 0.34 0 0.34-0.17l0.17-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m215.52 643.63c0 0.17 0.17 0.17 0.34 0.17s0.17-0.17 0.17-0.34c-0.17-1.51-0.17-2.86-0.17-4.04 0.17-3.36 0.67-5.38 1.51-5.89 0.34-0.17 0.34-0.34 0.17-0.34-0.17-0.17-0.34-0.17-0.5 0.17-1.01 1.18-1.51 3.2-1.68 6.23-0.17 1.85 0 3.2 0.17 4.04zm0.84 2.02q-0.17 0 0 0c-0.17 0.34 0 0.5 0.17 0.84q0.34 0.34 0.5 0.34c-0.5-0.84-0.67-1.18-0.67-1.18zm15.15-4.88c0.17-3.36-0.34-5.55-1.01-6.56-1.01-1.18-2.86-1.85-6.06-2.02-2.86 0-4.71 0.17-5.55 0.67-1.18 1.01-1.85 3.03-1.85 6.56-0.17 3.36 0.17 5.55 0.67 6.39 0.84 1.35 3.03 2.02 6.56 2.19 2.86 0 4.71-0.34 5.38-1.01 1.18-1.01 1.68-3.03 1.85-6.23zm-1.18-0.51c0 3.03-0.34 4.71-0.67 5.38-0.67 1.01-2.52 1.51-5.38 1.35-2.36 0-4.04-0.34-4.71-1.01-1.01-0.84-1.35-2.52-1.35-5.22 0.17-3.53 0.34-5.72 1.01-6.39 0.5-0.67 2.36-1.01 5.38-0.84 2.86 0 4.71 0.67 5.38 1.68 0.17 0.67 0.34 2.19 0.34 5.05zm-5.89-5.88h-2.69c-2.02 0-3.03 1.68-3.03 5.38 0 1.85 0.17 2.86 0.34 3.03 0.17 0 0.34 0 0.34-0.17-0.17-0.5-0.17-1.51-0.17-2.86 0.17-1.35 0.34-2.36 0.34-3.2 0.34-0.84 1.01-1.35 2.19-1.51h2.86c1.51 0 2.36 0.17 2.86 0.34 0.34 0.34 0.67 0 0.67-0.34 0-0.5-1.18-0.5-3.7-0.67zm-4.88 13.79q-0.34-0.17-0.5 0c0 0.17 0 0.34 0.34 0.34 1.35 0.5 2.86 0.84 4.88 1.01 4.21 0.17 6.56-1.01 7.23-2.86v-0.34q-0.17 0-0.34 0.17c-1.01 1.68-3.2 2.69-6.9 2.52-2.02-0.17-3.53-0.5-4.71-0.84zm3.2-2.19c-0.34 0-0.5 0-0.5 0.17s0.17 0.34 0.5 0.34 0.5 0 0.5-0.17q0-0.34-0.5-0.34zm6.05-9.92c-0.17-0.17-0.34-0.17-0.34 0s0 0.34 0.17 0.34c0.17 0.17 0.17 0.5 0.17 1.18l-0.17 5.89c0 1.51-1.18 2.36-3.53 2.19-0.17 0-0.34 0-0.34 0.17 0 0 0 0.17 0.17 0.17 0.34 0.17 1.01 0.17 1.51 0 1.35-0.34 2.19-0.67 2.36-1.35 0.17-0.34 0.34-0.84 0.34-1.51l0.17-5.89c0.17-0.5-0.17-0.84-0.5-1.18zm3.87 2.18q0-0.34-0.17-0.34c-0.17 0-0.34 0.17-0.34 0.34 0 2.69-0.17 4.54-0.34 5.55 0 0.17 0 0.34 0.17 0.34s0.17 0 0.34-0.17c0.17-0.5 0.17-2.52 0.34-5.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m246.82 648c0.34 0 0.5-1.01 0.5-3.2 0-1.35 0.67-2.52 1.85-3.36 0.34-0.34 2.02-0.5 4.71-0.84s4.21-0.5 4.71-1.01c0.34-0.5 0.5-1.51 0.34-3.2 0-0.17-0.17-0.34-0.34-0.34s-0.34 0.34-0.34 0.5c0 1.35-0.34 2.19-0.5 2.69-0.34 0.5-2.52 0.84-6.56 1.01-3.2 0.34-4.71 1.85-4.71 4.88 0 2.02 0.17 2.86 0.34 2.86zm0.16-9.92c0.17 0 0.17-0.34 0.34-0.67 0.17-0.84 0.17-1.18 0.17-1.18 0-0.34 0.34-0.67 0.5-1.35 0.34-0.67 0.5-1.01 0.5-1.18v-0.17c-0.34-0.17-0.5 0.17-1.01 0.84-0.34 0.67-0.67 1.51-0.67 2.19 0.17 1.01 0.17 1.51 0.17 1.51zm0.68-0.34c0 0.5 0.34 1.01 1.01 1.01 0.5 0 0.84-0.34 1.01-1.18 0-1.51 0-1.85-0.17-1.18 0-0.34 0.34-1.01 1.01-1.68 0.34-0.34 1.68-0.5 4.37-0.5 2.19 0 3.36 0.17 3.87 0.34 1.01 0.34 1.35 1.18 1.18 2.52 0 1.85-0.5 2.86-1.35 3.36-1.01 0.34-2.52 0.67-5.05 0.84-2.19 0.17-3.7 0.34-4.04 0.84-1.01 0.67-1.35 2.52-1.51 5.55-0.67 0.34-1.01 0.5-1.01 0.84 0 0.5 0.34 0.84 1.01 0.84 0.34 0 0.5-0.34 0.84-0.84l9.93 0.34c0.5 0 1.01 0 1.01 0.17 0.34 0.17 0.5 0.17 0.84 0.17s0.5-0.34 0.5-0.84c0-0.34-0.17-0.5-0.5-0.67l-10.43-0.34c-0.84 0-1.18-0.17-1.18-0.5 0-1.68 0.34-3.03 1.18-4.04 0.34-0.34 1.51-0.5 3.36-0.67 2.36-0.17 4.21-0.34 5.72-1.01 1.18-0.5 1.85-1.85 1.85-4.21 0-1.51-0.34-2.69-1.01-3.36-1.01-0.84-2.86-1.35-5.38-1.35-2.86 0-4.71 0.34-5.38 1.01-1.01 1.68-1.68 3.03-1.68 4.54zm1.51 11.44c-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.34 0.34c2.69 0.34 5.38 0.34 7.91 0.34 2.02 0 3.03-0.17 3.03-0.34s-0.67-0.34-1.85-0.34c-3.87 0.17-6.73 0-9.09-0.34zm0-9.76c0 0.17 0.17 0.34 0.34 0.34 0.5 0 1.01-0.5 1.01-1.51 0-1.35 0.34-2.19 1.18-2.36 0.5-0.17 2.36-0.17 5.72-0.17 0.17 0 0.34-0.17 0.34-0.34s-0.17-0.34-0.34-0.34h-4.21c-2.02 0-3.03 1.18-3.03 3.36 0 0.34-0.17 0.5-0.34 0.67-0.5 0-0.67 0.17-0.67 0.34zm9.76-6.9s0.17 0.17 0.67 0.34c0.5 0.34 1.01 0.84 1.35 1.35 0.5 1.01 0.84 2.19 0.67 3.36 0 2.52-1.01 4.04-2.52 4.71-1.01 0.34-2.69 0.67-4.71 0.84-1.68 0.17-2.86 0.34-3.7 0.84-0.34 0.17-0.5 0.34-0.67 0.84-0.34 0.34-0.34 0.84-0.34 1.01s0 0.34 0.17 0.34c0.34 0.17 0.67-0.34 1.01-1.51 0.34-0.34 1.51-0.84 3.87-1.01 2.69-0.17 4.37-0.5 5.22-1.01s1.35-1.01 1.51-1.51c0.5-0.84 0.84-2.02 0.84-3.53s-0.34-2.86-1.35-4.04c-0.67-0.84-1.35-1.18-2.02-1.01q0.17 0 0 0zm-8.08 13.63c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34l9.09 0.17c0.34 0 0.67-0.17 0.67-0.34s-0.34-0.34-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m269.53 635.55c-0.34-0.17-0.34 0.34-0.67 1.01-0.34 1.01-0.5 2.86-0.5 5.38 0 3.03 0.17 4.88 0.5 5.72 1.01 1.85 3.36 2.86 7.23 2.86 1.18 0 2.36 0 3.36-0.34s1.51-0.34 1.51-0.84l-0.17-0.17c0.34 0 0 0.17-1.01 0.34-1.01 0.34-2.36 0.34-4.04 0.34-2.19 0-3.7-0.5-5.05-1.35-1.18-0.84-1.85-1.85-1.85-3.03l0.17-4.04c0-1.51 0.17-2.86 0.34-4.04 0.17-0.67 0.34-1.35 0.34-1.68 0 0 0-0.17-0.17-0.17 0.17 0.17 0.17 0 0 0zm8.41-2.02-4.37-0.17c-1.85 0-3.03 0.84-3.53 2.36-0.34 0.84-0.34 2.19-0.34 4.71 0 2.86-0.17 4.37 0 4.71 0.17 1.51 0.67 2.52 1.51 3.2 1.01 0.84 2.86 1.18 5.38 1.35 2.19 0 3.53-0.34 4.37-1.01 1.01-0.84 1.51-2.69 1.51-5.38l0.17-4.71c0-1.85-0.34-3.03-1.01-4.04-0.67-0.5-1.85-1.01-3.7-1.01zm-1.51 1.18c2.02 0 3.2 0.34 3.87 0.67 1.01 0.5 1.51 1.68 1.35 3.36l-0.34 5.38c-0.17 1.68-0.34 2.69-0.5 3.03-0.5 1.01-2.02 1.35-4.37 1.18-1.68 0-3.03-0.34-3.87-0.84-1.01-0.67-1.51-1.68-1.51-3.36l0.17-5.89c0-1.68 0.34-2.86 1.01-3.2 0.5-0.17 1.85-0.34 4.21-0.34zm-4.88 8.08q0 0.17 0 0c0.34 0 0.34-0.17 0.34-0.34 0.17-2.19 0.34-4.04 0.5-5.22 0.17-0.84 0.34-1.18 1.01-1.35h2.52c1.51 0 2.52 0.17 2.69 0.17 0.67 0.17 1.01 0.67 1.18 1.51s0.34 2.36 0.17 4.71c0 1.85-0.34 3.2-0.5 3.7-0.34 0.84-1.35 1.18-2.69 1.01-1.18 0-2.19-0.17-2.86-0.34s-1.01-0.17-1.01-0.17q-0.17 0-0.34 0.17c-0.17 0.34 1.18 0.5 3.87 0.5 1.35 0 2.19-0.17 2.86-0.34 0.5-0.34 0.84-1.18 1.01-2.36 0.17-0.84 0.17-2.86 0.34-6.23 0-2.19-1.35-3.2-4.21-3.2-2.02 0-3.2 0.34-3.87 0.84-0.34 0.34-0.67 1.01-0.67 2.19-0.34 2.52-0.34 4.04-0.34 4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m288.71 648.84c0.34 0 0.5-1.01 0.5-3.2 0-1.35 0.67-2.52 1.85-3.36 0.34-0.34 2.02-0.5 4.71-0.84s4.21-0.5 4.71-1.01c0.34-0.5 0.5-1.51 0.34-3.2 0-0.17-0.17-0.34-0.34-0.34s-0.34 0.34-0.34 0.5c0 1.35-0.34 2.19-0.5 2.69-0.34 0.5-2.52 0.84-6.56 1.01-3.2 0.34-4.71 1.85-4.71 4.88 0.17 2.02 0.17 2.86 0.34 2.86zm0.34-9.92c0.17 0 0.17-0.34 0.34-0.67 0.17-0.84 0.17-1.18 0.17-1.18 0-0.34 0.34-0.67 0.5-1.35 0.34-0.67 0.5-1.01 0.5-1.18v-0.17c-0.34-0.17-0.5 0.17-1.01 0.84-0.34 0.67-0.67 1.51-0.67 2.19 0 1.01 0 1.51 0.17 1.51zm0.67-0.34c0 0.5 0.34 1.01 1.01 1.01 0.5 0 0.84-0.34 1.01-1.18 0-1.51 0-1.85-0.17-1.18 0-0.34 0.34-1.01 1.01-1.68 0.34-0.34 1.68-0.5 4.37-0.5 2.19 0 3.36 0.17 3.87 0.34 1.01 0.34 1.35 1.18 1.18 2.52 0 1.85-0.5 2.86-1.35 3.36-1.01 0.34-2.52 0.67-5.05 0.84-2.19 0.17-3.7 0.34-4.04 0.84-1.01 0.67-1.35 2.52-1.51 5.55-0.67 0.34-1.01 0.5-1.01 0.84 0 0.5 0.34 0.84 1.01 0.84 0.34 0 0.5-0.34 0.84-0.84l9.93 0.34c0.5 0 1.01 0 1.01 0.17 0.34 0.17 0.5 0.17 0.84 0.17s0.5-0.34 0.5-0.84c0-0.34-0.17-0.5-0.5-0.67l-10.43-0.34c-0.84 0-1.18-0.17-1.18-0.5 0-1.68 0.34-3.03 1.18-4.04 0.34-0.34 1.51-0.5 3.36-0.67 2.36-0.17 4.21-0.34 5.72-1.01 1.18-0.5 1.85-1.85 1.85-4.21 0-1.51-0.34-2.69-1.01-3.36-1.01-0.84-2.86-1.35-5.38-1.35-2.86 0-4.71 0.34-5.38 1.01-1.01 1.85-1.68 3.03-1.68 4.54zm1.34 11.61c-0.34 0-0.34 0.17-0.34 0.34s0.17 0.34 0.34 0.34c2.69 0.34 5.38 0.34 7.91 0.34 2.02 0 3.03-0.17 3.03-0.34s-0.67-0.34-1.85-0.34c-3.7-0.17-6.73-0.17-9.09-0.34zm0.17-9.93c0 0.17 0.17 0.34 0.34 0.34 0.5 0 1.01-0.5 1.01-1.51 0-1.35 0.34-2.19 1.18-2.36 0.5-0.17 2.36-0.17 5.72-0.17 0.17 0 0.34-0.17 0.34-0.34s-0.17-0.34-0.34-0.34h-4.21c-2.02 0-3.03 1.18-3.03 3.36 0 0.34-0.17 0.5-0.34 0.67-0.67 0-0.67 0.17-0.67 0.34zm9.76-6.89s0.17 0.17 0.67 0.34c0.5 0.34 1.01 0.84 1.35 1.35 0.5 1.01 0.84 2.19 0.67 3.36 0 2.52-1.01 4.04-2.52 4.71-1.01 0.34-2.69 0.67-4.71 0.84-1.68 0.17-2.86 0.34-3.7 0.84-0.34 0.17-0.5 0.34-0.67 0.84-0.34 0.34-0.34 0.84-0.34 1.01s0 0.34 0.17 0.34c0.34 0.17 0.67-0.34 1.01-1.51 0.34-0.34 1.51-0.84 3.87-1.01 2.69-0.17 4.37-0.5 5.22-1.01s1.35-1.01 1.51-1.51c0.5-0.84 0.84-2.02 0.84-3.53s-0.34-2.86-1.35-4.04c-0.67-0.84-1.35-1.18-2.02-1.01zm-8.24 13.79c-0.34 0-0.34 0.17-0.34 0.34 0 0.34 0.17 0.34 0.34 0.34l9.09 0.17c0.34 0 0.67-0.17 0.67-0.34s-0.34-0.34-0.67-0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m317.48 638.41c0 0.17 0.84 0.17 2.36 0.34 1.51 0.17 2.52 0.34 3.36 1.01 1.01 0.84 1.51 2.52 1.51 5.38-0.17 4.04-2.02 6.06-5.72 5.89h-1.85c-2.52 0-4.37-0.5-5.55-1.18-0.84-0.5-1.18-1.18-1.35-2.19-0.17-0.84-0.34-1.18-0.34-1.18-0.17 0-0.34 0.34-0.34 0.67 0 1.01 0.34 1.85 1.01 2.52 1.01 1.18 3.2 1.68 6.06 1.85 3.36 0 5.38-0.34 6.39-0.84 1.35-0.84 2.02-2.86 2.19-6.23 0-2.19-0.34-3.53-1.18-4.54s-2.19-1.51-4.37-1.51c-1.51-0.34-2.19-0.17-2.19 0zm-6.73-3.03c0.17 0 0.17-0.17 0-0.5 0-0.34 0.17-0.67 0.34-1.01 0.34-0.34 0.67-0.34 1.18-0.34 0.34 0 0.67-0.17 0.67-0.17 0-0.17-0.34-0.34-0.84-0.34-1.18 0-1.85 0.34-1.85 1.18s0.17 1.18 0.5 1.18zm-0.34 7.24c0.17 0 0.34-2.19 0.34-6.56 0-0.17 0-0.34-0.34-0.34-0.17 0-0.34 0.17-0.34 0.34l-0.17 5.72c0.17 0.5 0.34 0.84 0.5 0.84zm13.63 2.02c0-2.19-0.34-3.36-1.01-4.04-0.84-0.84-2.86-1.18-5.72-1.18-1.51 0-2.52 0-2.86 0.17-0.67 0.17-1.35 0.5-2.19 1.01 0.17-1.01 0.34-2.02 0.34-3.36v-0.17c0-1.01 0.17-1.51 0.34-1.51 0.34-0.17 0.84-0.34 1.51-0.17 3.7 0.17 5.89 0.34 6.9 0.34s1.68 0.17 1.68 0.34v0.17h0.34c0.67 0 1.01-0.34 1.01-1.01 0-0.5-0.84-0.84-2.36-0.84-2.02 0-4.88-0.17-8.75-0.17-1.01 0-1.51 0.17-1.51 0.17-0.17 0.34-0.34 1.85-0.34 5.05 0 0 0 0.34 0.17 1.35 0 0.5 0 0.84-0.17 0.84l-0.67 0.17c-0.17 0.17 0 0.34 0.17 0.84 0.34 0.34 0.34 0.5 0.67 0.5s0.67-0.17 0.84-0.5c0.17-0.5 0.5-1.01 1.01-1.18 0.84-0.34 2.19-0.5 4.04-0.5 2.36 0 3.87 0.34 4.54 0.84s1.01 1.51 1.01 3.2c0 2.02-0.34 3.2-1.18 3.7s-2.19 0.84-4.54 0.67c-3.36 0-4.88-0.67-4.88-1.85v-1.18c0-0.34-0.34-0.34-0.67-0.34-0.84 0-1.01 0.34-1.01 1.01 0.17 1.51 0.84 2.69 2.19 3.03 1.01 0.34 2.69 0.5 5.05 0.5 2.19 0 3.7-0.17 4.37-0.67 0.5-0.34 1.01-0.84 1.01-1.01 0.34-1.35 0.67-2.69 0.67-4.21zm-12.95 0c0 0.17 0.34 0.17 0.67 0.17s0.67 0.17 1.01 0.34c0.17 0.34 0.34 0.5 0.34 0.84v1.01c0.17 1.01 1.35 1.35 3.53 1.51h2.86c1.35 0 2.19-0.5 2.69-1.51 0.17-0.34 0.17-1.01 0.34-2.19 0-1.01 0-1.85-0.17-2.19 0-0.17-0.34-0.34-0.5-0.34 0-0.5-0.34-1.01-0.67-1.01 0.17 0-1.01 0-3.36-0.17h-2.52c-0.67 0-1.01 0.34-1.18 0.5-0.34 0.84-0.67 1.35-1.01 1.35s-0.84 0-1.35 0.34c-0.17 0.34 0.17 0.34 0.67 0.34s1.01-0.34 1.35-0.67c0.34-0.67 0.67-1.01 0.67-1.01 0.34-0.17 1.51-0.34 3.87-0.17 1.68 0 2.86 0.17 3.03 0.34s0.17 0.84 0.17 2.19v1.68c0 0.5-0.34 1.01-0.5 1.01-0.34 0.34-1.01 0.34-2.02 0.34h-2.19c-1.35 0-2.02-0.17-1.85-0.17-0.84 0-1.18-0.67-1.35-2.19 0-0.67-0.5-1.01-1.35-1.01-1.01 0.5-1.18 0.5-1.18 0.67zm13.46-8.25h-0.34q-0.34 0.17-0.5 0.17c-0.17 0-0.34-0.17-0.5-0.34-2.86 0-5.38 0-7.23-0.17-1.18-0.17-1.68-0.17-1.85 0-0.34 0.17-0.34 0.34-0.5 0.34-0.17 0.34-0.34 1.01-0.34 1.85q0 0.17 0.34 0.34c0.17 0 0.34 0 0.34-0.17l0.34-1.51c0-0.34 1.18-0.34 3.36-0.17l5.05 0.34c0.5 0 1.01 0 1.35-0.17 0.5-0.34 0.67-0.34 0.5-0.5zm-8.75 1.69c-1.01 0-1.51 0.17-1.51 0.34s0.5 0.34 1.51 0.34 1.51 0 1.51-0.17c-0.17-0.34-0.67-0.5-1.51-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m53.5 659.11c4.37 0 7.91 3.03 7.91 6.56v4.71h-9.59v-3.2h-9.93v19.68h10.09v-3.2h9.59v4.71c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.21 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.53-6.56 7.91-6.56l13.29-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m102.29 694.78h-9.59l-1.35-4.04h-11.78l-1.35 4.04h-9.59l11.44-35.84h10.6l11.61 35.84zm-12.95-10.44-3.7-11.95-3.87 11.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m149.74 659.11v35.84h-9.59v-21.87l-5.72 12.28h-8.58l-5.72-12.28v21.87h-9.59v-35.84h11.61l7.91 16.82 7.91-16.82h11.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m187.26 670.21v5.72c0 5.89-5.89 10.94-12.95 10.94h-6.56v7.91h-9.59v-35.84h15.98c7.23 0.17 13.12 5.22 13.12 11.27zm-9.59 0c0-1.51-1.51-3.03-3.53-3.03h-6.56v11.61h6.56c2.02 0 3.53-1.35 3.53-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m224.78 665.67v22.54c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.37 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.36-6.56 7.91-6.56h13.46c4.54 0 7.91 3.03 7.91 6.56zm-9.59 1.51h-10.09v19.68h10.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m264.82 659.11-11.44 35.84h-10.6l-11.44-35.84h9.59l7.23 22.54 7.23-22.54h9.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m300.65 665.67v22.54c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.37 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.36-6.56 7.91-6.56h13.46c4.54 0 7.91 3.03 7.91 6.56zm-9.59 1.51h-10.09v19.68h10.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m309.07 659.11h9.59v27.76h10.26v7.91h-19.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m366.27 665.67v22.54c0 3.53-3.36 6.56-7.91 6.56h-13.46c-4.37 0-7.91-3.03-7.91-6.56v-22.54c0-3.53 3.36-6.56 7.91-6.56h13.46c4.54 0 7.91 3.03 7.91 6.56zm-9.42 1.51h-10.09v19.68h10.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m83.11 709.92-2.19-3.36h-2.36v3.36h-2.19v-8.41h5.72c0.84 0 1.01 0 1.51 0.17 1.01 0.34 1.68 1.35 1.68 2.36 0 0.34 0 0.67-0.34 1.01-0.34 1.01-1.01 1.18-2.02 1.35l2.52 3.53h-2.36zm-0.33-6.4c-0.34-0.34-0.84-0.34-1.18-0.34h-3.36v2.19h3.87c0.34 0 0.84-0.34 0.84-1.01 0-0.34 0-0.84-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m97.41 707.9c-0.17 0.34-0.34 0.67-1.01 1.01-0.67 0.67-1.85 1.35-3.87 1.35-0.5 0-2.19 0-3.36-1.01-1.51-1.18-1.51-2.86-1.51-3.53 0-1.01 0.34-1.68 0.67-2.52 0.17-0.34 0.34-0.34 0.5-0.67q0.34-0.34 0.67-0.5c0.5-0.34 1.68-1.01 3.36-1.01 0.5 0 2.19 0 3.36 1.01 0.67 0.5 1.01 1.01 1.35 1.35 0 0.17 0.17 0.34 0.17 0.34l-2.19 0.34c-0.17-0.34-0.34-0.5-0.84-1.01-0.34-0.17-0.84-0.5-1.68-0.5-0.34 0-0.84 0-1.35 0.34-1.01 0.34-1.68 1.51-1.68 2.69 0 0.5 0.17 1.18 0.5 1.68l0.5 0.5c0.34 0.34 1.01 0.67 2.02 0.67 1.18 0 1.85-0.5 2.19-1.01 0.17-0.17 0.34-0.34 0.34-0.67h2.19c-0.17 0.84-0.17 1.01-0.34 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m102.29 703.02v2.19h5.38v1.51h-5.38v3.36h-2.19v-8.41h7.91v1.51l-5.72-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m123.49 709.92-0.67-1.51h-4.37l-0.67 1.51h-2.19l4.04-8.41h2.19l4.04 8.41h-2.36zm-2.86-6.4-1.51 3.36h2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m135.1 709.92-2.19-3.36h-2.36v3.36h-2.19v-8.41h5.89c0.84 0 1.01 0 1.51 0.17 1.01 0.34 1.68 1.35 1.68 2.36 0 0.34 0 0.67-0.34 1.01-0.34 1.01-1.01 1.18-2.02 1.35l2.52 3.53h-2.52zm-0.17-6.4c-0.34-0.34-0.84-0.34-1.18-0.34h-3.36v2.19h3.87c0.34 0 0.84-0.34 0.84-1.01 0-0.34 0-0.84-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m139.98 709.92v-8.41h7.91v1.51h-5.89v1.85h5.72v1.51h-5.55v2.02h5.89v1.51h-8.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m158.15 709.92-5.38-5.89v5.89h-2.02v-8.41h2.19l5.22 5.89v-5.89h2.02v8.41h-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m170.94 709.92-0.67-1.51h-4.37l-0.67 1.51h-2.19l4.04-8.41h2.19l4.04 8.41h-2.36zm-2.86-6.4-1.51 3.36h2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m181.2 707.06v-1.51h4.04v1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m200.55 709.92-2.19-3.36h-2.36v3.36h-2.19v-8.41h5.89c0.84 0 1.01 0 1.51 0.17 1.01 0.34 1.68 1.35 1.68 2.36 0 0.34 0 0.67-0.34 1.01-0.34 1.01-1.01 1.18-2.02 1.35l2.52 3.53h-2.52zm-0.17-6.4c-0.34-0.34-0.84-0.34-1.18-0.34h-3.36v2.19h3.87c0.34 0 0.84-0.34 0.84-1.01 0-0.34 0-0.84-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m205.43 709.92v-8.41h7.91v1.51h-5.89v1.85h5.55v1.51h-5.55v2.02h5.89v1.51h-7.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m224.61 709.92v-1.01q-0.17 0.17-0.34 0.34c-0.34 0.34-1.01 0.84-2.19 1.01h-1.01c-1.85 0-2.86-0.5-3.36-1.01-0.5-0.34-1.35-1.01-1.51-2.52 0-0.17-0.17-0.67-0.17-1.01 0-1.51 0.84-2.52 1.18-2.86s0.5-0.5 0.84-0.67c1.01-0.67 2.19-0.84 3.36-0.84 0.5 0 2.86 0 4.21 1.51 0.34 0.34 0.34 0.5 0.5 0.84l-2.36 0.34-0.5-0.5c-0.5-0.5-1.35-0.67-2.19-0.67-1.01 0-2.19 0.34-2.69 1.35-0.17 0.34-0.34 0.84-0.34 1.68 0 0.17 0 0.67 0.34 1.18 0.67 1.68 2.52 1.68 3.03 1.68 1.01 0 2.02-0.34 2.69-1.01 0.34-0.34 0.34-0.5 0.34-0.67h-2.69v-1.51h4.54v4.54l-1.68-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m237.73 709.92v-1.01q-0.17 0.17-0.34 0.34c-0.34 0.34-1.01 0.84-2.19 1.01h-1.01c-1.85 0-2.86-0.5-3.36-1.01-0.5-0.34-1.35-1.01-1.51-2.52 0-0.17-0.17-0.67-0.17-1.01 0-1.51 0.84-2.52 1.18-2.86s0.5-0.5 0.84-0.67c1.01-0.67 2.19-0.84 3.36-0.84 0.5 0 2.86 0 4.21 1.51 0.34 0.34 0.34 0.5 0.5 0.84l-2.36 0.34-0.5-0.5c-0.5-0.5-1.35-0.67-2.19-0.67-1.01 0-2.19 0.34-2.69 1.35-0.17 0.34-0.34 0.84-0.34 1.68 0 0.17 0 0.67 0.34 1.18 0.67 1.68 2.52 1.68 3.03 1.68 1.01 0 2.02-0.34 2.69-1.01 0.34-0.34 0.34-0.5 0.34-0.67h-2.86v-1.51h4.54v4.54l-1.51-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m242.44 709.92v-8.41h2.19v8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m257.75 706.72c-0.17 0.5-0.34 1.85-1.68 2.69-0.5 0.34-1.68 1.01-3.36 1.01-2.52 0-3.87-1.01-4.54-1.85-0.34-0.34-0.84-1.35-0.84-2.69 0-2.02 1.01-2.86 1.51-3.36 1.01-0.67 2.19-1.01 3.36-1.01 1.01 0 2.36 0.17 3.36 0.67 0.17 0.17 0.34 0.17 0.67 0.34s0.5 0.34 0.67 0.67c0.34 0.34 1.01 1.35 1.01 2.86-0.17-0.17-0.17 0.17-0.17 0.67zm-2.86-3.03c-0.5-0.67-1.51-1.01-2.36-1.01-0.17 0-0.67 0-1.18 0.34-1.51 0.67-1.68 2.19-1.68 2.86 0 0.17 0 0.67 0.34 1.18 0 0.17 0.17 0.34 0.34 0.5 0 0.17 0.34 0.34 0.34 0.5 0.34 0.34 1.01 0.67 2.02 0.67 0.17 0 0.67 0 1.18-0.34 1.68-0.67 1.85-2.19 1.85-2.86 0 0-0.17-1.01-0.84-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m266.67 709.92v-8.41h7.91v1.51h-5.72v1.85h5.55v1.51h-5.55v2.02h5.89v1.51h-8.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m287.03 709.92v-6.56l-2.86 6.56h-2.02l-2.86-6.56v6.56h-2.02v-8.41h3.03l2.69 6.23 2.69-6.23h3.03v8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m292.41 709.92v-8.41h2.19v8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m297.79 709.92v-8.41h2.19v6.9h4.71v1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m307.22 709.92v-8.41h2.19v8.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m320 709.92-0.67-1.51h-4.37l-0.67 1.51h-2.19l4.04-8.41h2.19l4.04 8.41h-2.36zm-2.86-6.4-1.51 3.36h2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m672.81 707.9c-0.17 0.34-0.34 0.67-1.01 1.01-0.67 0.67-1.85 1.35-3.87 1.35-0.5 0-2.19 0-3.36-1.01-1.51-1.18-1.51-2.86-1.51-3.53 0-1.01 0.34-1.68 0.67-2.52 0.17-0.34 0.34-0.34 0.5-0.67s0.34-0.34 0.67-0.5c0.5-0.34 1.68-1.01 3.36-1.01 0.5 0 2.19 0 3.36 1.01 0.67 0.5 1.01 1.01 1.35 1.35 0 0.17 0.17 0.34 0.17 0.34l-2.19 0.34c-0.17-0.34-0.34-0.5-0.84-1.01-0.34-0.17-0.84-0.5-1.68-0.5-0.34 0-0.84 0-1.35 0.34-1.01 0.34-1.68 1.51-1.68 2.69 0 0.5 0.17 1.18 0.5 1.68l0.5 0.5c0.34 0.34 1.01 0.67 2.02 0.67 1.18 0 1.85-0.5 2.19-1.01 0.17-0.17 0.34-0.34 0.34-0.67h2.19c-0.34 0.84-0.34 1.01-0.34 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m682.74 709.92-0.67-1.51h-4.37l-0.67 1.51h-2.19l4.04-8.41h2.19l4.04 8.41h-2.36zm-3.03-6.23-1.51 3.36h2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m693.84 703.69c-0.17-0.17-0.17-0.34-0.17-0.34-0.5-0.67-1.51-0.84-2.19-0.84h-0.67c-0.17 0-1.18 0.17-1.18 1.01 0 0.34 0.34 0.67 0.67 0.84 0.67 0.17 2.19 0.34 2.86 0.5 0.67 0.17 1.01 0.17 1.18 0.34 0.5 0.17 1.68 0.67 1.68 2.19 0 0.84-0.34 2.02-2.02 2.52-0.5 0.17-1.01 0.34-1.51 0.34h-1.01c-1.51 0-2.36-0.34-2.86-0.67-0.17 0-0.34-0.17-0.5-0.34-0.5-0.34-0.84-1.01-1.01-1.01-0.17-0.17-0.17-0.34-0.34-0.34l2.02-0.5c0.5 1.01 1.85 1.35 2.86 1.35 0.17 0 1.18 0 1.68-0.34 0.17-0.17 0.34-0.34 0.34-0.84 0-0.34-0.17-0.34-0.34-0.5-0.34-0.34-0.84-0.34-1.51-0.34-1.51-0.34-2.36-0.34-3.03-0.67-0.34-0.17-1.35-0.84-1.35-2.02s0.67-1.68 1.01-1.85c0.5-0.34 1.51-0.84 2.86-0.84 1.51 0 2.19 0.34 2.86 0.5 0.34 0.17 0.67 0.34 1.01 0.67q0.34 0.34 0.5 0.84l-1.85 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m698.55 709.92v-8.41h7.91v1.51h-5.89v1.85h5.55v1.51h-5.55v2.02h5.89v1.51h-7.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m716.56 709.92-2.19-3.36h-2.36v3.36h-2.19v-8.41h5.89c0.84 0 1.01 0 1.51 0.17 1.01 0.34 1.68 1.35 1.68 2.36 0 0.34 0 0.67-0.34 1.01-0.34 1.01-1.01 1.18-2.02 1.35l2.52 3.53h-2.52zm-0.34-6.4c-0.34-0.34-0.84-0.34-1.18-0.34h-3.36v2.19h3.87c0.34 0 0.84-0.34 0.84-1.01 0-0.34 0-0.67-0.17-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m725.81 703.02v6.9h-2.19v-6.9h-3.2v-1.51h8.41v1.51h-3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m737.42 709.92-0.67-1.51h-4.37l-0.67 1.51h-2.19l4.04-8.41h2.19l4.04 8.41h-2.36zm-2.69-6.23-1.51 3.36h2.86z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "77.73 313.2 913.57 262.89 923.33 423.23 87.49 473.53",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m129.04 336.58c-1.01 0-0.67 15.48 1.18 46.27 1.85 30.62 3.2 45.76 4.21 45.76 0.84 0 0.34-15.31-1.51-45.93-0.5-7.4-1.01-17.5-1.51-30.28-0.34-6.9-0.84-11.27-1.18-13.12-0.17-1.85-0.5-2.86-1.18-2.69zm15.82 4.21c-0.34-4.21-3.2-6.23-8.92-5.89-4.21 0.34-5.22 3.36-2.86 9.42 1.01 2.36 1.35 4.37 1.35 6.06-0.34 3.7-0.5 6.23-0.5 7.74l4.88 51.48c0.34 5.72 0.5 11.27 0.67 16.82 0.5 4.54 2.19 6.56 5.22 6.06 1.18 0 4.54-0.17 9.76-0.34 7.4-0.17 15.82-0.67 25.57-1.18 9.59-0.5 15.82-0.5 18.17 0 2.52 0.5 3.36 0.84 2.86 0.84 2.52-0.17 3.53-2.52 3.2-6.9-0.17-3.03-1.68-4.54-4.54-4.37-8.75 0.34-16.49 0.67-22.88 1.01-10.6 0.67-18.17 1.51-22.54 2.36-4.37 1.01-7.07 1.51-7.91 1.51-2.52 0.17-2.86-2.36-1.01-7.23 0.17 0.17 0.5 0.34 0.67 0.34 2.36 0 2.02-26.08-1.18-77.73zm-1.68 97.58c0.17 1.35 1.51 2.02 4.37 1.51 7.91-1.01 11.78-1.68 11.61-1.68 3.53-0.17 7.91-0.17 13.12 0.17 5.38 0.34 8.75 0.34 10.43 0.34 13.46-0.84 20.19-1.85 20.02-3.03 0-0.84-2.69-1.01-8.08-0.67l-40.38 1.18c-7.4 0.34-11.27 1.01-11.1 2.19zm8.91-48.62c0-0.84-0.5-1.18-1.35-1.18-1.01 0.34-1.51 0.84-1.51 1.68l1.35 21.03c0 1.01 0.67 1.51 1.85 1.35 1.18-0.34 1.68-0.84 1.35-1.85-0.34-2.86-1.01-9.93-1.68-21.03zm3.54 26.41c0.17 1.35 4.21 1.85 12.28 1.35 17.5-1.01 27.59-1.18 29.95-0.5 3.87 1.18 5.89 1.01 5.72-0.34-0.17-1.85-2.19-2.69-6.23-2.69-27.93 0.67-41.72 1.35-41.72 2.19zm80.25-56.36c0.17 1.68 0.84 2.36 2.02 2.36 1.35-0.17 1.85-0.67 1.18-1.68-0.5-1.68-0.67-3.36-0.34-5.55 0.34-1.51 0-2.19-0.67-2.19-1.68 0.34-2.36 2.69-2.19 7.07zm5.22 70.49c0 0.84 0.5 1.01 1.51 0.84 1.01-0.34 1.35-0.67 0.84-1.35-0.5-1.01-0.67-2.36-0.84-3.87-0.17-1.68 0-4.54 0.17-8.75 0.34-4.21 0.34-7.4 0.17-9.59-0.17-2.52-0.5-4.54-1.01-6.06-1.01-17.67-1.85-28.27-2.19-31.8-0.34-1.85-0.84-2.69-1.68-2.69-0.34 0.67-0.67 1.35-1.18 1.85l4.21 61.41zm6.05-100.61c-1.68-0.34-2.86-0.17-3.2 0.17l-3.2 3.87c-1.18 1.35-1.01 3.7 0.5 7.4l0.84 14.13c0.17 2.02 0.84 10.77 2.02 26.41s1.85 22.38 1.68 20.36c1.01 16.32 1.35 20.69 1.18 13.46 0.17 5.72-0.5 9.42-2.02 11.1-0.17 0.17-0.34 0.67-0.17 1.18 0.17 1.68 1.01 3.36 2.69 5.05s3.7 2.52 5.89 2.36c2.86-0.17 4.04-2.52 3.53-6.9-2.86-31.29-3.87-48.45-3.03-51.31-0.5-8.41-1.35-22.04-2.52-41.22-0.17-1.68-0.84-3.03-2.02-4.37-1.18-1.35-2.02-1.85-2.19-1.68zm81.26-6.39c0-1.18-1.85-1.51-5.55-0.84-10.26 1.85-16.99 4.37-20.02 7.57-7.07 6.9-10.09 20.69-8.92 41.39 1.35 21.87 3.03 36.17 5.38 42.9 1.01 2.52 3.53 5.89 7.57 9.76s9.76 6.23 17.5 7.07c4.37 0.34 12.45 0.17 24.23-0.5 16.66-1.01 28.1-2.69 33.99-5.05 5.22-2.02 8.92-5.72 10.94-11.44 0.17-0.67 0.17-1.35 0.17-2.19 0-0.67-0.34-0.84-0.67-0.5-0.34 0-1.01 0.84-1.68 2.19-2.02 4.21-4.54 7.07-7.74 8.41-5.72 2.52-17.16 4.37-34.32 5.38-11.61 0.67-18 1.01-19.01 1.18-8.58-0.34-15.48-2.02-20.53-5.22-6.56-4.37-10.6-17.83-11.95-40.72 0-1.18-0.34-3.7-0.67-7.23-0.17-3.7-0.34-6.56-0.5-8.92-1.68-26.92 7.4-40.88 27.26-42.06 3.03-0.17 4.71-0.5 4.54-1.18zm51.15 65.28c0.34 4.54 0.5 9.09 0.84 13.8 0.17 3.2-0.5 5.89-2.02 7.74-2.02 2.52-12.45 4.37-30.96 5.55-15.14 0.84-24.9 0-29.61-2.52s-7.74-16.99-9.42-43.24c-1.01-15.65 0.17-25.57 3.53-29.61s13.8-6.73 31.46-7.74c14.64-0.84 23.89-0.17 27.59 2.36 2.69 1.85 4.37 7.4 5.05 16.49 0.17 3.7 2.02 5.38 5.55 5.22 3.7-0.17 5.38-3.03 5.05-8.24-0.67-10.6-3.36-17.16-8.24-19.68-5.89-3.2-18-4.21-36.51-3.03-19.68 1.18-31.97 4.54-37.01 10.26-3.7 4.04-4.71 17.16-3.53 39.2 1.51 24.73 5.05 39.2 10.6 43.74s17.83 6.23 36.85 5.22c18.34-1.18 29.61-3.03 33.65-6.06 5.38-3.53 7.57-12.45 6.73-26.41-0.34-6.39-0.5-9.25-0.5-8.92-0.34-3.03-1.85-4.54-4.21-4.37l-29.11 1.68c-3.03 0.17-4.54 2.02-4.21 5.38 0.17 3.2 1.85 4.88 4.88 4.54l23.55-1.35zm-8.24-40.04c1.01 0 1.51-1.68 1.18-4.71-0.34-5.55-10.6-7.57-30.79-6.39-12.95 0.84-21.37 2.86-24.9 6.06-3.53 3.36-5.05 9.59-4.54 18.68 1.35 23.22 2.86 34.83 4.54 34.66 0.34 0 0-10.09-1.18-30.28-0.67-11.44 0.5-18.34 3.36-20.69 2.36-2.02 10.26-3.36 23.89-4.21 16.15-1.01 25.07 0.17 26.92 3.36 0.17 0.34 0.34 1.18 0.17 2.52 0.17 0.84 0.67 1.18 1.35 1.01zm-47.95 62.42c0.17 3.2 9.09 4.37 26.58 3.36 15.14-0.84 22.54-2.86 22.38-5.72 0-0.67-1.35-0.67-4.04 0-5.89 1.18-13.29 2.02-22.21 2.52-5.89 0.34-11.1 0.34-15.82-0.17-4.54-0.5-6.73-0.67-6.39-0.67-0.34 0.17-0.5 0.34-0.5 0.67zm54.51-50.81c0 0.84 1.68 1.18 4.88 1.01s4.71-0.67 4.71-1.51c0-0.67-1.68-0.84-5.05-0.67-3.03 0.17-4.54 0.67-4.54 1.18zm9.42-27.76c-0.5 0.84-0.67 1.68-0.17 2.52 0.67 1.18 1.01 2.19 1.18 3.03 0.17 2.86 0.67 4.21 1.51 3.87 1.01 0 1.51-1.18 1.35-3.53-0.34-4.21-1.35-6.39-3.2-6.23-0.34 0-0.5 0-0.67 0.34zm7.4 52.15c-0.34-4.54-0.84-6.9-2.02-6.73-1.01 0-1.35 2.36-1.18 6.9 0.34 5.38 1.01 8.08 2.02 8.08 1.18-0.17 1.51-2.86 1.18-8.24zm50.65-49.8c-8.24 25.24-16.49 50.98-24.73 77.22 0.17 2.02 0.67 3.2 1.51 3.53 1.01 0.34 1.51-0.17 1.68-1.51 0-1.35 0.34-3.36 0.67-6.06 11.27-33.14 19.18-57.37 23.89-72.51 0.67-2.36 0.34-3.36-0.84-3.36-1.01 0.17-1.68 1.01-2.19 2.69zm32.3-9.76c-1.68-4.21-5.72-6.06-12.28-5.72-6.39 0.34-10.09 2.69-11.61 7.07-5.38 19.01-14.64 48.12-27.93 87.49-0.34 1.18-0.5 2.36-0.34 3.36 0.17 3.87 1.85 5.72 4.88 5.55 2.69-0.17 4.37-1.68 4.88-4.54l3.7-16.15c0.5-2.52 3.53-3.87 9.25-4.21l40.72-2.52c4.54-0.34 7.23 0.84 8.24 3.53l5.05 13.8c1.51 3.87 3.36 5.55 5.89 5.55 4.54-0.34 5.55-3.36 3.2-9.42zm-32.47 77.23c-1.01 0-2.36 2.19-3.7 6.23-1.51 4.04-2.19 7.07-2.02 9.25 0 0.67 0.17 1.01 0.34 1.18 1.01 0.34 2.36-1.51 3.87-5.72 1.35-3.53 3.03-5.72 4.88-6.39 1.18-0.5 5.89-1.01 14.3-1.51 12.28-0.67 20.86-1.01 26.08-1.01 1.68 0.17 2.69 1.85 3.2 5.38 0.5 3.36 1.68 5.05 3.53 5.05 1.68-0.17 2.02-2.19 1.18-6.23-0.84-3.7-1.85-6.06-3.03-7.23-1.18-1.18-3.7-1.68-7.57-1.35l-41.05 2.36zm20.52-76.39c2.52-0.17 4.37 1.01 5.89 3.7 1.51 2.52 2.02 4.04 1.68 4.54-0.17 0.5-0.5 0.67-0.84 0.67-0.17 0-0.84-0.67-1.85-2.02s-1.85-2.02-2.36-2.02c-1.68 0.17-1.68 1.68-0.34 4.88 0.5 1.01 1.51 1.85 3.03 2.36 1.51 0.67 2.52 1.51 3.03 2.36l13.63 31.97c0.34 1.68 0.67 4.04 1.01 7.23 0.34 1.35 1.01 2.02 2.02 2.02 0.34 0 0.5-0.67 0.5-1.85s0.17-1.85 0.5-1.85l1.85 9.09c-28.1 2.02-45.09 3.2-50.98 3.03 4.37-12.79 8.24-25.91 11.78-39.37 2.19-8.58 3.53-12.79 4.21-12.79s0.84 0.5 0.67 1.51 0.34 1.51 1.35 1.51c0.84 0 1.51-1.18 2.19-3.53 0.67-2.36 0.67-3.36-0.17-3.36-0.67 0-1.01 0.34-1.01 1.18 0 0.67-0.5 1.18-1.35 1.18-0.34 0-0.67-0.34-0.67-1.18-0.17-1.85 0.5-3.87 1.68-5.89 0.84-2.19 2.52-3.36 4.54-3.36zm-2.35 21.54c0.67-2.02 0.17-3.03-1.35-3.03-0.67 0-1.01 0.67-1.35 1.85-5.89 18-8.75 28.27-8.58 30.96 0 0.67 0.34 1.01 0.67 1.18 0.84 0.17 2.52-4.21 5.38-13.12 1.68-5.89 3.53-11.78 5.22-17.83zm-11.61-24.73c-0.84 0-1.51 0.67-2.02 2.02-0.5 1.51-0.34 2.19 0.5 2.19s1.51-0.84 2.02-2.19c0.34-1.51 0.34-2.02-0.5-2.02zm23.05 58.71c-7.74 0.67-11.61 1.68-11.44 3.2 0 0.67 5.22 0.67 15.65 0 1.01 0 1.51-0.5 1.51-1.35-0.17-1.68-2.02-2.36-5.72-1.85zm-4.88-36.17 10.6 29.78c0 0.17 0.34 1.68 0.84 4.21 0.34 1.35 0.84 2.02 1.68 2.02s1.01-0.84 0.5-2.52c-0.67-1.35-0.84-2.02-0.5-2.19 2.02-0.17 2.52-1.18 1.35-3.2-1.35-1.51-3.36-5.89-6.23-13.12s-4.71-12.28-5.22-15.31c-0.34-1.68-1.01-2.36-2.02-2.36-1.18 0.17-1.51 1.01-1.01 2.69zm11.44-18.51 4.21 9.93c0.5 1.01 1.35 1.35 2.52 1.01 1.01-0.34 1.35-1.01 0.84-2.19l-3.87-8.92c-0.5-1.18-1.35-1.68-2.52-1.68-1.18 0.17-1.68 0.84-1.18 1.85zm10.77 15.65c-0.5-1.35-1.18-1.85-2.19-1.35-1.01 0.34-1.35 1.18-0.84 2.52 1.01 2.86 8.75 22.21 23.22 58.38l2.36 7.23c0.67 2.02 1.51 3.03 2.36 2.86 1.85-0.17 1.85-2.69 0.17-7.91-7.07-17.33-15.48-37.86-25.07-61.75zm44.92-19.01c-0.84 0-0.84 5.05-0.34 14.97 0.67 10.26 1.35 15.31 2.19 15.14 1.01 0 1.18-5.22 0.67-15.31-0.67-9.93-1.51-14.81-2.52-14.81zm3.36-5.72c0.17 2.02 0.67 3.03 1.68 3.03-0.67 0 0-0.17 1.85-0.67 0.34-0.17 0.67 0.34 0.67 1.85l5.05 83.45c0 1.18-0.84 2.02-2.69 2.52-1.85 0.34-2.69 1.35-2.52 2.69 0.17 1.68 0.84 2.52 2.36 2.86 2.52 0.5 3.87 0.84 4.37 1.35 1.51 1.01 2.19 0.34 2.02-1.85 0-0.67 0.17-1.01 0.5-1.01 1.68-0.17 3.36-0.17 5.22-0.34l41.22-2.52c21.2-1.35 31.13-11.44 30.12-30.28-0.5-7.74-2.36-13.12-5.72-15.98-3.36-3.03-5.05-4.71-5.05-5.38s0.67-2.86 2.36-6.9c1.68-4.04 2.19-9.76 1.68-17.33-1.01-15.82-8.41-23.39-22.21-22.54l-42.73 2.52c-12.28 0.5-18.34 2.19-18.17 4.54zm4.21-9.42c-0.67 0-0.84 0.5-0.84 1.35 0 1.01 0.34 1.51 1.01 1.51l16.15-1.01c0.84 0 1.18-0.5 1.18-1.68 0-0.84-0.34-1.18-1.01-1.18zm8.08 11.77c1.01 0 1.68 0.17 2.19 0.67 0.5 0.5 1.51 0.67 3.36 0.5 0.84 0 1.51-0.34 2.02-1.01 0.5-0.67 1.01-1.01 1.51-1.01 1.68 0.17 15.14-0.67 40.72-2.19 3.7-0.17 7.07 1.35 10.09 4.71s4.71 7.74 4.71 13.12c0.17 13.12-2.52 19.85-8.24 20.36-14.3 0.67-32.98 2.02-55.86 4.21l-1.51-23.89c-0.17-2.52 0-4.04 0.67-4.71s0.84-1.18 0.84-1.51c0-1.18-0.5-1.85-1.35-1.68-0.17 0-0.5 0.34-0.84 0.84s-0.84 0.84-1.18 0.84-0.67-0.5-0.67-1.51c-0.17-1.35 0.17-3.03 1.01-4.88 0.67-1.85 1.51-2.86 2.52-2.86zm1.85 46.78c0.34-1.68 5.89-2.86 16.49-3.7-11.27 0.84 1.01 0.17 36.85-1.85 10.77-0.67 16.49 5.38 17.33 18 0.84 14.3-5.38 21.87-18.84 22.54l-39.71 2.36c-7.07 0.5-10.77-1.51-11.1-5.72-1.18-19.52-1.51-29.95-1.01-31.63zm5.72 47.78c-0.67 0-0.84 0.5-0.84 1.35 0 1.01 0.34 1.51 1.01 1.51l11.27-0.67c0.84 0 1.18-0.5 1.18-1.68 0-0.84-0.34-1.18-1.01-1.18zm-3.54-84.12c-1.18 0-1.51 3.87-0.84 11.44 0.67 7.74 1.35 11.61 2.19 11.44 1.18 0 1.51-6.39 0.67-19.01-0.17-2.52-0.84-3.87-2.02-3.87zm2.53 40.38c-0.84 0-1.01 4.37-0.5 13.29 0.67 10.26 1.35 15.31 2.52 15.14 1.18 0 1.51-6.56 0.67-19.35-0.5-6.23-1.35-9.09-2.69-9.09zm0.33-44.76c0.17 1.35 0.5 2.19 1.35 2.02 2.02 0 6.23-0.34 12.62-1.01 6.39-0.84 11.27-1.35 14.47-1.51 9.09-0.5 15.31 0.17 18.51 2.19 2.19 1.35 3.36 4.37 3.53 8.92 0.34 6.9-1.85 10.77-6.9 11.44-0.17 0-8.08 0.5-23.89 1.51-12.45 0.67-18.68 1.68-18.51 3.03 0 0.84 1.35 1.51 4.04 1.85 2.02 0 8.75-0.17 19.85-0.84 11.95-0.67 18.68-1.35 19.85-2.19 6.23-4.21 9.25-9.76 8.75-16.49-0.17-4.04-2.36-7.07-6.39-9.09-1.35-1.18-3.53-2.52-6.73-4.21-1.85-0.34-8.58-0.17-20.19 0.67-13.63 0.84-20.53 2.02-20.36 3.7zm23.73 73.69c20.36-1.18 30.45-3.36 30.28-6.39 0-0.67-0.34-0.84-1.01-0.84s-1.85 0.5-3.87 1.18c-2.02 0.67-3.7 1.18-5.22 1.18l-31.8 2.19c-1.85 0.17-2.86 0-3.03-0.5-0.17-0.34-0.84-0.5-1.85-0.5-2.19 0.17-3.36 0.84-3.2 2.36 0 1.68 6.56 2.02 19.68 1.35zm-18.68-30.45c-1.68 0.17-2.36 0.84-2.36 2.02 0.17 1.35 1.01 2.02 2.86 2.02l47.11-2.86c2.02-0.17 3.03-0.84 2.86-2.36 0-1.18-1.35-1.68-3.7-1.68zm6.23-63.6c-0.67 0-0.84 0.5-0.84 1.35s0.34 1.18 1.01 1.18l14.13-0.84c0.84 0 1.18-0.5 1.18-1.35s-0.34-1.18-1.01-1.18zm7.57 109.03c-0.67 0-0.84 0.5-0.84 1.35 0 1.01 0.34 1.51 1.01 1.51l14.13-0.84c0.84 0 1.18-0.5 1.18-1.68 0-0.84-0.34-1.18-1.01-1.18zm42.9-36.68c-0.34-5.05-0.84-7.91-1.51-8.58-0.67-0.5-1.35-0.5-2.19 0.17-0.5 0.67-0.84 1.51-0.67 2.86l0.5 8.58c0.17 1.35-0.34 3.2-1.35 5.22s-1.51 3.2-1.51 3.53 0.34 0.67 1.01 0.5c4.21-0.17 6.06-4.21 5.72-12.28zm0.17-66.46c-0.67-0.5-1.01-0.5-1.18 0-0.34 0.67-0.17 1.35 0.67 2.19 4.71 4.04 7.4 10.6 7.91 19.68 0.5 7.4-0.17 12.62-1.85 15.98s-2.52 5.22-2.36 5.72c0 0.67 1.51 2.69 4.71 6.23 3.03 3.53 4.88 8.41 5.22 14.64 0.5 9.09-0.84 17.16-4.04 23.89-1.01 1.35-1.01 2.19-0.17 2.52 0.67 0.34 1.35-0.17 2.36-1.68 4.37-6.56 6.23-15.14 5.55-25.41-0.34-6.56-1.85-11.27-4.37-14.47s-3.87-5.05-3.87-5.55c-0.17-1.68 0.34-3.87 1.35-6.73s1.18-7.23 0.84-13.46c-0.67-9.93-4.21-17.83-10.77-23.55zm43.41 68.14c0.34 9.76 4.04 17.33 11.1 22.71 0.84 0.84 1.51 0.67 2.19-0.17 0.34-0.67-0.17-1.51-1.35-2.69-5.38-4.21-8.24-10.43-8.75-18.84l-3.03-51.31c-0.17-1.68-0.5-2.19-1.01-1.85-0.84 0.5-1.18 1.18-1.18 2.19l2.02 49.97zm-1.52-66.96c-0.67 0-1.01 1.01-1.01 2.86-0.17 1.68 0 3.36 0.34 5.22 0.5 1.85 1.18 2.69 2.02 2.69 2.52-0.17 2.69-1.18 0.67-3.03-0.84-0.84-1.18-2.19-1.18-4.37 0-2.36-0.34-3.36-0.84-3.36zm52.83 80.42c-10.94 0.67-18.84 0.34-23.72-1.01-7.07-1.85-10.77-6.06-11.1-12.45l-3.53-57.71h1.18l-0.67-11.61c-0.17-3.53-2.02-5.05-5.55-4.88-4.71 0.34-6.9 2.52-6.73 6.56 0 1.01 0.5 1.85 1.51 2.52s1.51 1.68 1.51 2.86l3.36 55.86c0.67 11.78 4.04 19.52 9.93 23.05s17.83 4.71 35.5 3.7c14.13-0.84 23.05-2.19 26.75-4.04 7.91-3.53 11.61-11.61 10.77-23.89l-2.02-33.99 1.51-1.35-1.51-26.25c1.01 0.34 1.51-0.34 1.35-1.85-0.34-5.72-2.69-8.41-6.9-8.24-1.35 0.17-3.03 1.01-4.54 2.69-1.68 1.68-2.36 3.2-2.36 4.37 0 0.67 0.84 1.18 2.36 1.85s2.36 2.19 2.52 4.88c0.17 2.02 0.34 8.92 0.5 20.86 0.17 11.78 0.34 18.51 0.5 20.19 1.01 16.66 0.5 26.41-1.35 29.27-2.69 4.71-12.45 7.57-29.27 8.58zm-35.16 11.11c-1.35 2.19 2.02 3.87 9.76 5.22 6.9 1.18 10.09 0.67 10.09-1.51-0.17-1.35-1.51-2.02-4.37-1.85-3.7 0.17-7.07-0.17-10.09-1.01-3.03-1.01-4.37-1.35-4.21-1.51-0.34 0-0.84 0.17-1.18 0.67zm1.51-81.94c-0.34 0-0.34 4.21 0.17 12.62 0.17 1.35 0.34 6.39 0.5 14.81 0.34 8.41 0.5 13.8 0.67 15.98s0.17 5.89 0.34 10.77c0.17 2.69 0.34 4.37 0.67 5.22 0.17 0.84 0.67 1.18 1.35 1.18 1.18 0 1.51-5.38 0.84-15.98-0.17-1.68-0.34-7.07-0.67-16.15-0.5-9.09-0.84-14.64-1.01-16.49-0.5-8.24-1.35-12.11-2.86-11.95zm0.34-11.1c-1.18 0-1.68 1.68-1.51 5.05 0.17 1.68 0.5 2.36 1.01 2.36 1.18 0 1.85-0.84 1.68-2.52-0.17-3.36-0.67-4.88-1.18-4.88zm29.61 96.06c-5.55 0.17-8.24 0.67-8.24 1.35 0 1.18 2.69 1.85 8.08 2.02 5.89 0 8.92-0.67 8.75-2.36 0-1.01-0.84-1.51-2.52-1.35-2.02 0-4.04 0.17-6.06 0.34zm16.82-1.01c0 1.18 1.51 1.68 4.37 1.51 10.26-0.67 18.34-4.71 24.4-12.45 3.87-4.71 5.38-11.61 4.88-20.86-0.34-4.88-1.18-7.23-2.52-7.23-0.34 0-0.5 3.03-0.34 8.92 0.17 6.73-0.67 11.61-2.52 14.64-3.2 4.88-7.23 8.58-11.95 10.77-3.03 1.18-6.9 2.19-11.44 2.86-3.36 0.67-4.88 1.18-4.88 1.85zm8.75-93.71 2.52 56.87c0.17 3.2-0.34 7.57-1.68 12.95 0 0.67 0.34 1.01 1.01 1.18 3.36 1.51 4.71-3.53 4.04-14.97l-3.36-55.86c-0.17-1.68-0.5-2.36-1.35-2.36-0.84 0-1.18 0.67-1.18 2.19zm20.02-2.86c-0.84 0-0.84 7.57 0.17 22.38 0.34 4.54 0.5 12.79 0.84 25.07 0.17 3.53 0.67 5.22 1.51 5.05 1.18 0 1.35-7.91 0.34-23.55-1.01-19.35-2.02-28.94-2.86-28.94zm36.51-10.43c-1.01 0-0.67 15.48 1.18 46.27s3.2 46.1 4.37 46.1c0.84 0 1.01-2.36 0.84-6.73 0.17 4.04-0.5-9.09-2.36-39.37-0.5-7.4-1.01-17.5-1.51-30.28-0.34-6.9-0.84-11.27-1.18-13.12-0.17-2.02-0.67-2.86-1.35-2.86zm78.4-3.03c-0.17-2.69-2.69-4.21-7.57-4.21 1.01 0-2.69 0.17-10.94 0.67-20.19 1.18-35.33 2.36-45.43 3.36-7.07 0.67-10.6 2.36-10.43 4.88 0 0.84 0.5 1.68 1.51 2.36 1.01 0.84 1.51 2.19 1.68 4.21l4.88 79.75c-3.53 3.2-5.22 5.22-5.22 5.89 0.17 0.34 0.5 0.5 1.01 0.5 2.52 0.34 4.04 1.18 4.71 2.86 0.67 1.51 1.18 2.36 1.35 2.36 0.67 0 1.01-0.67 1.35-1.85s0.5-2.19 0.84-2.86l56.19-3.36c2.52-0.17 4.37 0.34 5.89 1.68 1.51 1.18 2.52 1.85 2.86 1.85 3.03-0.17 4.37-2.69 4.21-7.23-0.17-2.69-2.02-3.87-5.72-3.7l-56.53 3.36c-2.02 0.34-3.53 0-4.54-0.84s-1.35-1.85-1.01-2.86c0.5-1.51 0.67-5.72 0.34-12.62-0.17-6.39 0.17-10.43 1.01-12.28 0.17-0.17 0.17-0.5 0.17-1.01 0-0.17-0.5-0.67-1.68-1.51-1.01-0.67-1.68-1.85-1.68-3.2-0.17-2.86 0.84-4.37 3.03-4.54 1.01 0 1.68 0.34 2.19 1.18s0.84 1.18 1.35 1.18c0.67 0 1.35-0.34 2.19-0.67 0.84-0.5 1.68-0.67 2.52-0.84l26.08-1.68c9.09-0.5 13.29-0.84 12.79-0.84 3.03-0.34 4.37-2.02 4.21-4.88-0.17-2.52-4.37-3.36-12.45-2.86-1.18 0-6.73 0.67-16.49 1.85s-17.33 2.02-22.88 2.36c-2.19 0.17-3.36-1.01-3.53-3.53 0-0.34 0-1.68 0.17-3.7s0.17-5.38-0.17-9.76c-0.17-1.85-0.5-5.22-1.01-9.93-0.67-4.71-0.84-7.57-1.01-8.41-0.17-3.2 0.67-4.88 2.69-5.05 1.18 0 2.36 0.17 3.36 0.84s1.85 1.01 2.52 0.84c1.01 0 2.36-0.5 3.87-1.51l44.75-2.52c0.67 0 2.02-0.17 4.21-0.34 1.68 0.17 2.69 0 3.36-0.17 0.67-0.5 1.01-1.68 1.01-3.2zm-63.76 103.64c0 1.18 1.51 1.68 4.37 1.35 6.56-1.01 10.26-1.51 11.27-1.51 2.86-0.17 7.57 0 14.3 0.34s12.62 0.5 17.67 0.17c13.29-0.84 19.85-1.85 19.68-3.36-0.17-1.35-18.84-1.18-56.36 0.67-7.4 0.34-10.94 1.18-10.94 2.36zm58.04-51.65c0-0.34-1.01-0.17-3.03 0.5-2.86 1.18-5.05 1.85-6.9 2.02l-33.31 2.02c-1.35 0.17-2.19-0.17-2.52-0.67-0.17-0.5-0.67-0.67-1.35-0.67-0.34 0-0.84 0.67-1.18 1.68-0.34 1.18-0.84 1.68-1.68 1.85-0.67 0-1.35-0.17-2.19-0.5 0 2.69-0.17 5.22-0.17 7.74l1.51 13.8c0 1.01 0.5 1.68 1.35 1.68 1.01 0.17 1.51-0.5 1.35-1.85l-0.84-18c2.19-0.67 6.06-1.35 11.61-1.68 3.7-0.17 8.58-0.34 14.81-0.5 6.23-0.17 9.59-0.34 10.26-0.34 8.41-0.67 12.45-3.03 12.28-7.07zm-51.65-30.96c-0.17-1.68-0.5-2.36-1.01-2.36-1.18 0-1.85 1.18-1.68 3.53 0.34 6.39 1.01 10.6 2.02 12.79 0.67 0.17 1.18-0.17 1.85-1.01zm3.03-5.04 44.08-2.36c6.06-0.34 10.43-2.02 13.12-5.05 1.68-2.02 1.51-2.86-0.84-2.69-3.36 2.52-7.4 3.87-11.95 4.37 1.35-1.18 1.35-1.68-0.17-1.51l-45.26 2.19c-1.85 0.17-2.69 1.18-2.52 3.2 0.17 1.35 1.35 2.02 3.53 1.85zm0.17 21.19c-1.18 0-1.85 0.67-1.68 1.68 0.17 1.35 1.51 2.19 4.04 2.19 5.22-0.34 10.43-0.67 15.65-1.01 14.81-0.67 22.21-1.85 22.21-3.53-0.17-0.17-1.01-0.17-2.19-0.17l-32.47 2.69c-1.85 0.17-3.2-0.17-4.04-0.84s-1.35-1.01-1.51-1.01zm5.55 45.94c-1.68 0.17-2.36 0.5-2.36 1.35 0 1.01 1.01 1.51 2.86 1.35 3.87-0.17 11.61-0.84 23.22-2.02s17.67-1.68 18.34-1.68c2.52-0.17 5.38 0.17 8.58 0.67 1.68 0.34 2.52 0 2.36-1.01-0.17-1.35-2.19-2.02-6.23-1.85l-46.77 3.2z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    transform: "translate(-.003736 -262.89)",
    points: "250.35 443.75 748.86 429.79 750.71 495.74 252.2 509.71",
    fill: "url(#c)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.003736 -262.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m282.65 454.69c-0.34 0-0.5 6.39-0.17 19.01 0.34 12.62 0.67 18.84 1.18 18.84 0.34 0 0.34-6.23 0-18.84-0.17-3.03-0.17-7.23-0.17-12.45 0-2.86-0.17-4.71-0.34-5.38 0-0.84-0.17-1.18-0.5-1.18zm6.56 1.85c0-1.68-1.18-2.52-3.53-2.52-1.68 0-2.19 1.35-1.35 3.87 0.34 1.01 0.5 1.85 0.5 2.52-0.17 1.51-0.34 2.52-0.34 3.2l1.35 21.2c0 2.36 0.17 4.71 0 6.9 0.17 1.85 0.84 2.69 2.02 2.52h4.04c3.03 0 6.56 0 10.43-0.17 4.04-0.17 6.56 0 7.57 0.17 1.01 0.34 1.35 0.34 1.18 0.34 1.01 0 1.51-1.01 1.51-2.86 0-1.18-0.67-1.85-1.85-1.85-3.53 0-6.73 0-9.42 0.17-4.37 0.17-7.4 0.34-9.25 0.67s-2.86 0.5-3.2 0.5c-1.01 0-1.18-1.01-0.34-3.03 0.17 0 0.17 0.17 0.34 0.17 0.67 0.17 0.84-10.43 0.34-31.8zm-2.02 40.04c0 0.5 0.67 0.84 1.85 0.67 3.2-0.34 4.88-0.5 4.71-0.5 1.35 0 3.2 0 5.38 0.17s3.53 0.34 4.21 0.34c5.55-0.17 8.24-0.5 8.24-1.01 0-0.34-1.18-0.5-3.36-0.34h-16.66c-2.86 0-4.37 0.34-4.37 0.67zm4.38-19.85c0-0.34-0.17-0.5-0.5-0.5-0.34 0.17-0.67 0.34-0.67 0.67l0.17 8.75c0 0.5 0.34 0.67 0.84 0.67 0.5-0.17 0.67-0.34 0.67-0.84-0.34-1.18-0.5-4.04-0.5-8.75zm1.01 10.94c0 0.5 1.68 0.84 5.05 0.67 7.23-0.17 11.27-0.17 12.28 0.17 1.68 0.5 2.36 0.5 2.36 0 0-0.67-0.84-1.18-2.52-1.18-11.44 0-17.16 0-17.16 0.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m334.64 460.24c-3.7 10.26-7.4 20.69-11.27 31.46 0 0.84 0.17 1.35 0.5 1.51 0.5 0.17 0.67 0 0.67-0.5s0.17-1.35 0.34-2.52c5.05-13.46 8.58-23.39 10.77-29.44 0.34-1.01 0.17-1.35-0.34-1.35-0.17-0.17-0.34 0.17-0.67 0.84zm13.46-3.53c-0.67-1.68-2.36-2.52-5.05-2.52-2.52 0-4.21 1.01-4.88 2.86-2.52 7.74-6.73 19.52-12.62 35.67-0.17 0.5-0.17 1.01-0.17 1.35 0 1.51 0.67 2.36 2.02 2.36 1.01 0 1.85-0.67 2.02-1.85l1.68-6.56c0.17-1.01 1.51-1.51 3.87-1.68l16.66-0.5c1.85 0 3.03 0.5 3.36 1.51l1.85 5.72c0.5 1.51 1.35 2.36 2.36 2.36 1.85 0 2.36-1.35 1.35-3.87l-12.45-34.83zm-14.47 31.29c-0.34 0-1.01 0.84-1.68 2.52s-1.01 2.86-1.01 3.7c0 0.17 0 0.34 0.17 0.5 0.5 0.17 1.01-0.67 1.68-2.36 0.67-1.51 1.35-2.36 2.02-2.52 0.5-0.17 2.52-0.34 5.89-0.34 5.05-0.17 8.58-0.17 10.77 0 0.67 0 1.01 0.84 1.18 2.19s0.67 2.19 1.35 2.02c0.67 0 0.84-0.84 0.5-2.52-0.34-1.51-0.67-2.52-1.18-3.03s-1.51-0.67-3.03-0.67l-16.66 0.5zm9.59-31.12c1.01 0 1.85 0.5 2.36 1.51 0.5 1.01 0.84 1.68 0.67 1.85 0 0.17-0.17 0.34-0.34 0.34s-0.34-0.34-0.67-0.84-0.67-0.84-1.01-0.84c-0.67 0-0.67 0.67-0.17 2.02 0.17 0.34 0.5 0.84 1.18 1.01 0.67 0.34 1.01 0.67 1.18 1.01l5.22 13.29c0.17 0.67 0.17 1.68 0.34 3.03 0.17 0.5 0.34 0.84 0.84 0.84 0.17 0 0.17-0.34 0.17-0.84s0-0.84 0.17-0.84l0.67 3.7c-11.61 0.5-18.51 0.67-21.03 0.67 2.02-5.22 3.7-10.43 5.38-15.98 1.01-3.53 1.68-5.22 1.85-5.22s0.34 0.17 0.34 0.67 0.17 0.67 0.5 0.67 0.67-0.5 1.01-1.35c0.34-1.01 0.34-1.35 0-1.35-0.17 0-0.34 0.17-0.5 0.5 0 0.34-0.17 0.5-0.5 0.5-0.17 0-0.34-0.17-0.34-0.5 0-0.67 0.17-1.51 0.67-2.36 0.5-1.01 1.18-1.51 2.02-1.51zm-1.35 8.75c0.34-0.84 0.17-1.35-0.5-1.18-0.17 0-0.5 0.34-0.67 0.84-2.69 7.23-4.04 11.44-3.87 12.62 0 0.17 0.17 0.34 0.34 0.5 0.34 0 1.18-1.68 2.36-5.38 0.84-2.52 1.68-4.88 2.36-7.4zm-4.37-10.27c-0.34 0-0.67 0.34-0.84 0.84-0.17 0.67-0.17 0.84 0.17 0.84s0.67-0.34 0.84-0.84c0.17-0.67 0.17-0.84-0.17-0.84zm8.75 24.4c-3.2 0.17-4.71 0.5-4.71 1.18 0 0.17 2.19 0.34 6.39 0.17 0.34 0 0.67-0.17 0.67-0.5-0.17-0.67-0.84-1.01-2.36-0.84zm-1.68-14.98 4.04 12.28c0 0.17 0.17 0.67 0.34 1.68 0.17 0.5 0.34 0.84 0.67 0.84s0.34-0.34 0.17-1.01c-0.34-0.5-0.34-0.84-0.17-0.84 0.84 0 1.01-0.5 0.67-1.35-0.5-0.67-1.35-2.52-2.36-5.55s-1.68-5.05-2.02-6.39c-0.17-0.67-0.34-1.01-0.84-1.01-0.5 0.34-0.67 0.67-0.5 1.35zm5.04-7.4 1.68 4.04c0.17 0.34 0.5 0.5 1.01 0.5 0.34-0.17 0.5-0.34 0.34-0.84l-1.51-3.7c-0.17-0.5-0.5-0.67-1.01-0.67-0.5 0-0.67 0.34-0.5 0.67zm4.21 6.56c-0.17-0.5-0.5-0.84-0.84-0.67s-0.5 0.5-0.34 1.01c0.34 1.18 3.36 9.25 8.75 24.23l0.84 3.03c0.34 0.84 0.5 1.18 0.84 1.18 0.67 0 0.84-1.18 0.17-3.2-2.69-7.07-5.89-15.65-9.42-25.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m401.43 495.24c1.01-0.67 1.51-1.85 1.51-3.7 0.17-1.51 0-2.69-0.67-3.7l-0.84-30.62c0-1.35 0.34-2.19 1.35-2.19s2.02 0.34 2.86 1.01 1.18 1.35 1.01 1.68c-0.17 0.34-0.67 0.34-1.35 0.17-0.67-0.17-1.01 0.17-1.01 0.84 0 0.84 0.5 1.35 1.35 1.35h0.17c0.5 0 1.01 0.17 1.18 0.34l18.34 28.1c0.34 0.5 0.34 1.01 0.17 1.18-0.34 0.17-0.5 0.34-0.5 0.5 0 0.34 0.34 0.67 1.18 1.18 0.67 0.34 1.35 0.67 2.02 0.5 2.69 0 4.54-0.67 5.72-1.85 0.34-0.5 0.67-0.67 0.67-0.84s-0.17-0.34-0.5-0.5c-0.34-0.17-0.5-0.34-0.5-0.67l-0.17-29.11c0-0.5 0.17-1.18 0.17-1.85l-0.84-0.34c-0.17 0-0.17-0.17-0.17-0.17 0-0.17 0.17-0.84 0.5-1.68 0.34-0.84 0.5-1.35 0.5-1.51 0-1.68-0.67-2.69-2.02-2.52-0.67 0-1.35 0.34-1.85 1.01s-0.84 1.35-0.84 2.02c0 0.5 0.17 0.84 0.67 0.84 0.5 0.17 0.67 0.67 0.67 1.35l0.67 21.87c0.17 4.71 0.17 7.4 0.17 7.91 0 1.18-0.5 1.85-1.18 1.85-1.51 0-2.36-0.34-2.69-1.01-0.34-0.67-0.5-1.51-0.67-2.19-8.08-11.27-14.81-22.04-20.19-31.97-0.34-0.5-0.67-0.67-1.35-0.67h-4.71c-1.85 0-2.69 0.84-2.69 2.69 0 0.34 0.34 0.67 1.01 1.01 0.34 0.17 0.5 1.35 0.67 3.2 0 4.71 0.17 9.59 0.17 14.13l0.17 17.5c0 1.18-0.17 1.85-0.67 1.85-0.67 0-1.01-0.34-1.01-1.01v-5.22c-0.17-3.36-0.17-5.38-0.17-5.89 0-0.67-0.17-1.18-0.5-1.35-0.5 0-0.67 0.17-0.67 0.67l0.34 12.62c0 1.68 0.67 2.69 2.02 2.69l2.52 0.5zm-5.04-41.56c-0.34 0-0.67 0.84-0.5 2.36 0-0.34 0 2.86 0.34 9.93 0 2.19 0.17 4.71 0.17 7.57 0 2.02 0.17 3.2 0.17 3.7 0.17 0.67 0.34 1.18 0.5 1.18 0.34 0 0.5-4.21 0.34-12.45v-9.59c-0.34-1.85-0.5-2.69-1.01-2.69zm7.23 7.57c-0.34 0-0.67 1.18-0.84 3.7 0 1.68 0 4.37 0.34 7.74 0.17 4.04 0.34 6.23 0.34 6.39 0.17 8.08 0.5 12.11 0.84 12.11s0.67 0 0.67-0.34v-2.86c-0.17-2.36-0.34-5.05-0.34-7.74 0-3.53-0.17-6.56-0.17-8.92-0.17-1.51-0.34-3.36-0.5-5.22-0.17-3.2-0.17-4.88-0.34-4.88zm20.36 31.13c0.17-0.17 0.34-0.34 0.34-0.67 0-0.5-1.01-2.19-3.2-4.71v-1.35c-2.02-2.69-5.38-7.74-9.93-15.14-3.53-5.72-5.55-8.41-6.06-8.08-0.17 0.17 0.34 1.18 1.68 3.03 1.35 1.85 1.85 2.86 1.68 3.03s2.19 4.21 7.4 12.11c5.05 8.08 7.74 11.95 8.08 11.78zm-12.28-34.49c-0.17 0-0.34 0.17-0.34 0.5 0 0.5 0.5 1.85 1.68 3.53 0.84 1.35 2.36 3.87 4.88 7.74 1.01 1.51 2.02 3.2 3.03 4.71l2.02 1.85c0.34-0.5-0.17-1.68-1.18-3.36zm14.47 22.88-1.35-2.52c-0.17-0.34-0.5-0.5-0.84-0.34-0.34 0.17-0.5 0.34-0.34 0.5l1.35 2.52c0.17 0.34 0.5 0.5 0.84 0.34 0.34 0 0.5-0.17 0.34-0.5zm9.25 9.42c-1.85 2.36-3.7 3.53-5.55 3.53-0.5 0-1.35-0.17-2.36-0.34-0.67 0-0.84 0-0.84 0.34 0 0.67 1.01 1.18 3.2 1.01 1.85 0 3.36-0.67 4.54-1.68 0.84-0.84 1.35-1.51 1.35-2.36 0-0.34-0.17-0.5-0.34-0.5zm-6.56-7.91c0.34 0 0.34-1.51 0.17-4.37-0.34-6.23-0.67-12.28-0.84-18.51-0.17-4.21-0.34-6.23-0.5-6.23-0.5 0-0.67 2.19-0.5 6.23v6.23c0 4.54 0.17 8.24 0.5 10.94 0.17 3.7 0.5 5.72 1.18 5.72zm-0.84 1.68c0 1.51 0.5 2.36 1.35 2.36 0.17 0 0.34-0.5 0.34-1.51s-0.17-1.51-0.5-1.68c-0.67-0.17-1.18 0-1.18 0.84zm8.24-2.69-0.67-25.74c-0.17-0.17-0.34-0.5-0.5-0.67-0.34 0.17-0.5 0.34-0.5 0.84l0.34 23.39-0.34 1.01 0.17 7.74c0 0.34 0.17 0.5 0.5 0.67 0.5 0.17 0.67 0 0.67-0.5l0.34-6.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m447.2 480.26c0.17 0.17 0.34 0.34 0.67 0.34 0.17-0.17 0.34-0.34 0.34-0.67-0.5-3.7-0.84-7.07-0.84-10.09 0-8.75 1.01-13.8 3.03-15.48 0.5-0.5 0.67-0.67 0.17-0.84-0.34-0.17-0.67-0.17-1.18 0.34-2.36 3.2-3.53 8.41-3.36 15.98 0.34 4.71 0.67 8.08 1.18 10.43zm2.18 4.71c-0.17 0-0.17 0.17-0.17 0.34 0 0.5 0.34 1.18 0.84 1.85s1.01 0.84 1.18 0.5c-1.18-1.85-1.68-2.69-1.85-2.69zm35.84-14.3c-0.17-8.58-1.35-14.3-3.36-16.82-2.36-3.03-7.23-4.37-14.64-4.21-7.07 0.17-11.44 1.01-13.12 2.52-2.86 2.36-4.04 8.08-3.87 17.16 0.17 8.75 1.01 14.13 2.36 15.98 2.19 3.36 7.4 4.88 16.15 4.54 6.73-0.17 10.94-1.18 12.95-2.86 2.52-2.52 3.7-7.91 3.53-16.32zm-2.86-1.18c0.17 7.74-0.17 12.28-1.01 13.8-1.51 2.52-5.72 3.87-12.95 4.21-5.89 0.17-9.76-0.5-11.44-2.02-2.36-2.02-3.53-6.39-3.7-13.29-0.34-9.25 0.17-14.64 1.51-16.32 1.18-1.68 5.55-2.69 13.12-2.86 6.9-0.17 11.1 1.01 12.95 3.87 0.67 1.51 1.18 5.72 1.51 12.62zm-14.64-14.13-6.73 0.17c-4.71 0.17-7.07 4.71-6.73 13.8 0.17 4.71 0.5 7.4 1.01 7.74 0.34 0 0.5-0.17 0.67-0.5-0.5-1.35-0.67-3.87-0.5-7.23 0-3.36 0.34-6.06 0.67-8.24 0.34-2.19 2.02-3.53 4.88-4.04 0.34-0.17 2.69-0.17 7.07-0.34 3.36-0.17 5.72 0.17 6.9 0.67 1.01 0.5 1.51 0 1.51-1.18-0.17-0.67-3.03-1.01-8.75-0.84zm-10.43 35.84c-0.67-0.17-1.01-0.17-1.18 0 0 0.34 0.17 0.5 0.67 0.67 3.2 1.18 7.23 1.85 11.95 1.68 10.09-0.34 15.65-3.03 16.82-8.24 0-0.5 0-0.67-0.17-0.67-0.34 0-0.5 0-0.67 0.34-2.02 4.54-7.4 7.07-16.32 7.23-4.37 0.17-8.24-0.17-11.1-1.01zm7.57-6.39c-0.84 0-1.18 0.17-1.18 0.34 0 0.34 0.5 0.5 1.35 0.5s1.35-0.17 1.35-0.5c-0.17-0.17-0.67-0.34-1.51-0.34zm13.29-25.58c-0.5-0.17-0.67-0.17-0.67 0 0 0.34 0 0.5 0.34 1.01 0.34 0.34 0.5 1.35 0.5 3.03l0.34 15.31c0.17 4.04-2.69 6.06-8.41 6.23-0.34 0-0.5 0.17-0.67 0.34 0 0.17 0 0.34 0.34 0.34 1.18 0.17 2.36 0.17 3.87-0.17 3.03-0.84 5.05-2.02 5.72-3.87 0.34-0.67 0.5-2.02 0.34-4.04l-0.5-15.14c0.17-1.51-0.34-2.52-1.18-3.03zm9.26 4.71c0-0.67-0.17-1.01-0.34-1.01-0.34 0.17-0.5 0.5-0.5 1.01 0.17 6.56 0.17 11.44 0 14.3 0 0.34 0.17 0.67 0.34 0.67s0.34-0.17 0.5-0.5c0.34-1.01 0.34-5.89 0-14.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m517.35 453.01c4.04-0.34 7.91-0.5 11.95-0.84 1.35-0.17 2.02-0.5 2.02-1.18 0-1.85-1.85-2.69-5.38-2.52l-26.25 0.67c-2.36 0-3.7 1.01-3.53 2.86 0 0.67 0.84 1.01 2.52 1.01 0.5 0 4.37-0.17 11.61-0.34 0.17-0.5 1.01-0.67 2.19-0.84s1.68 0 1.85 0.5c0 0.5 0 0.84-0.17 0.84s-0.34 0-0.67-0.17c-0.34-0.17-0.67-0.17-1.01-0.17-0.5 0.17-0.84 0.34-1.01 0.84 0 0.34 0.34 0.67 1.01 0.67 0.34 0.17 0.5 0.67 0.34 1.51 0 0.5-0.17 1.01-0.34 1.51l-0.17 14.3 0.34 14.64c0 0.67-0.17 1.35-0.5 2.19-0.34 0.84-0.67 1.35-0.5 1.51 0 0.17 0.17 0.34 0.34 0.5 0.34 0.17 0.67 0.67 1.18 1.35 0.34 0.34 0.84 0.67 1.68 0.5 1.51 0 2.19-0.67 2.19-2.02l-1.18-30.45c0-0.5 0-1.01 0.34-1.35 0.17-0.34 0.34-1.01 0.34-1.68 0-2.02-0.34-3.36-0.67-3.7-0.17-0.17-0.17-0.34 0.17-0.67 0.34-0.34 0.67-0.34 1.18-0.34-0.34 0 0 0.17 0.17 0.84zm-11.1 2.69c0.5 0 1.01-0.17 1.51-0.67 0-0.34 0.17-0.5 0.17-0.67-2.36 0-5.72 0.17-10.09 0.5-0.67 0.17-1.18 0.34-1.18 0.5s0.17 0.34 0.67 0.5l8.92-0.17zm3.7 34.99c0.5 0 0.67-1.51 0.67-4.37l-0.34-23.89c-0.17-3.87-0.5-5.72-1.35-5.72-0.34 0-0.67 0.34-0.67 1.18 0 0.5 0.17 0.84 0.34 1.01s0.34 0.67 0.34 1.18v9.25c0 6.06 0.17 10.77 0.34 14.13 0 4.71 0.17 7.23 0.67 7.23zm7.24-27.08c0.17 0.67 0.34 0.84 0.67 0.67 0.17-0.17 0.34-0.34 0.5-0.84 0-1.35 0.17-2.86 0.17-4.54 0-1.51 0.34-2.36 1.01-2.52 2.02-0.17 4.21-0.34 6.23-0.5 2.36-0.17 4.04-0.5 5.05-1.18 0.34-0.34 0.5-0.5 0.67-0.5-0.17 0-0.17-0.17-0.34-0.17s-0.34 0-0.67 0.17c-0.34 0.17-0.84 0.34-1.35 0.67-0.34 0.17-0.5 0-0.5-0.17s0-0.5 0.17-0.84c0-0.17-0.17-0.34-0.5-0.17-1.01 0.5-2.36 0.67-4.21 0.67-2.36 0-3.7 0.17-4.21 0.17-0.17 0.17-0.34 0.17-0.34 0.34s0 0.17-0.17 0.17c-0.84 0-1.35 0.17-1.35 0.34-0.67 0.67-1.01 2.19-0.84 4.88-0.34 0.84-0.17 2.02 0 3.36zm0.5 6.89c-0.34 0-0.5 1.35-0.34 4.21 0 2.69 0.34 4.04 0.67 4.04s0.5-1.35 0.34-4.04c-0.17-2.86-0.34-4.21-0.67-4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m561.94 451.66c4.04-0.34 7.91-0.5 11.95-0.84 1.35-0.17 2.02-0.5 2.02-1.18 0-1.85-1.85-2.69-5.38-2.52l-26.25 0.67c-2.36 0-3.7 1.01-3.53 2.86 0 0.67 0.84 1.01 2.52 1.01 0.5 0 4.37-0.17 11.61-0.34 0.17-0.5 1.01-0.67 2.19-0.84s1.68 0 1.85 0.5c0 0.5 0 0.84-0.17 0.84s-0.34 0-0.67-0.17c-0.34-0.17-0.67-0.17-1.01-0.17-0.5 0.17-0.84 0.34-1.01 0.84 0 0.34 0.34 0.67 1.01 0.67 0.34 0.17 0.5 0.67 0.34 1.51 0 0.5-0.17 1.01-0.34 1.51l-0.17 14.3 0.34 14.64c0 0.67-0.17 1.35-0.5 2.19-0.34 0.84-0.67 1.35-0.5 1.51 0 0.17 0.17 0.34 0.34 0.5 0.34 0.17 0.67 0.67 1.18 1.35 0.34 0.34 0.84 0.67 1.68 0.5 1.51 0 2.19-0.67 2.19-2.02l-1.18-30.45c0-0.5 0-1.01 0.34-1.35 0.17-0.34 0.34-1.01 0.34-1.68 0-2.02-0.34-3.36-0.67-3.7-0.17-0.17-0.17-0.34 0.17-0.67 0.34-0.34 0.67-0.34 1.18-0.34-0.17 0 0 0.34 0.17 0.84zm-10.94 2.86c0.5 0 1.01-0.17 1.51-0.67 0-0.34 0.17-0.5 0.17-0.67-2.36 0-5.72 0.17-10.09 0.5-0.67 0.17-1.18 0.34-1.18 0.5s0.17 0.34 0.67 0.5l8.92-0.17zm3.54 34.83c0.5 0 0.67-1.51 0.67-4.37l-0.34-23.89c-0.17-3.87-0.5-5.72-1.35-5.72-0.34 0-0.67 0.34-0.67 1.18 0 0.5 0.17 0.84 0.34 1.01s0.34 0.67 0.34 1.18v9.25c0 6.06 0.17 10.77 0.34 14.13 0 4.88 0.34 7.23 0.67 7.23zm7.23-27.09c0.17 0.67 0.34 0.84 0.67 0.67 0.17-0.17 0.34-0.34 0.5-0.84 0-1.35 0.17-2.86 0.17-4.54 0-1.51 0.34-2.36 1.01-2.52 2.02-0.17 4.21-0.34 6.23-0.5 2.36-0.17 4.04-0.5 5.05-1.18 0.34-0.34 0.5-0.5 0.67-0.5-0.17 0-0.17-0.17-0.34-0.17s-0.34 0-0.67 0.17c-0.34 0.17-0.84 0.34-1.35 0.67-0.34 0.17-0.5 0-0.5-0.17s0-0.5 0.17-0.84c0-0.17-0.17-0.34-0.5-0.17-1.01 0.5-2.36 0.67-4.21 0.67-2.36 0-3.7 0.17-4.21 0.17-0.17 0.17-0.34 0.17-0.34 0.34s0 0.17-0.17 0.17c-0.84 0-1.35 0.17-1.35 0.34-0.67 0.67-1.01 2.19-0.84 4.88-0.17 0.84-0.17 2.02 0 3.36zm0.51 7.07c-0.34 0-0.5 1.35-0.34 4.21 0 2.69 0.34 4.04 0.67 4.04s0.5-1.35 0.34-4.04c-0.17-2.86-0.34-4.21-0.67-4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m589.19 447.12c-0.5 0-0.5 6.39-0.17 19.01 0.34 12.62 0.67 19.01 1.18 19.01 0.34 0 0.5-1.01 0.5-2.86 0 1.68-0.17-3.7-0.5-16.15-0.17-3.03-0.17-7.23-0.17-12.45 0-2.86-0.17-4.71-0.34-5.38 0-0.84-0.17-1.18-0.5-1.18zm32.31-0.17c0-1.18-1.01-1.68-3.03-1.85 0.34 0-1.01 0-4.54 0.17-8.24 0.17-14.47 0.5-18.68 0.84-2.86 0.17-4.37 0.84-4.37 1.85 0 0.34 0.17 0.67 0.67 1.01 0.34 0.34 0.67 0.84 0.67 1.68l0.84 32.81c-1.51 1.35-2.19 2.02-2.19 2.36q0.17 0.17 0.34 0.17c1.01 0.17 1.68 0.5 1.85 1.18 0.34 0.67 0.5 1.01 0.5 1.01 0.17 0 0.5-0.17 0.5-0.67 0.17-0.5 0.17-0.84 0.34-1.18l23.22-0.67c1.01 0 1.85 0.17 2.36 0.67 0.67 0.5 1.01 0.84 1.18 0.84 1.18 0 1.85-1.01 1.85-3.03 0-1.01-0.84-1.68-2.36-1.51l-23.22 0.67c-0.84 0.17-1.51 0-1.85-0.34s-0.5-0.84-0.34-1.18c0.17-0.67 0.34-2.36 0.34-5.22 0-2.52 0.17-4.21 0.5-5.05 0 0 0.17-0.17 0.17-0.34 0 0-0.17-0.34-0.67-0.67-0.5-0.34-0.67-0.84-0.67-1.35 0-1.18 0.34-1.85 1.35-1.85 0.34 0 0.67 0.17 0.84 0.5 0.17 0.34 0.34 0.5 0.5 0.5s0.5-0.17 1.01-0.34c0.34-0.17 0.67-0.34 1.01-0.34l10.77-0.34c3.7-0.17 5.05-0.84 4.88-0.84 1.18-0.17 2.36-0.17 2.19-1.35 0-1.01-1.68-1.51-5.05-1.35-0.5 0-2.69 0.17-6.73 0.5-4.04 0.34-7.23 0.5-9.42 0.67-0.84 0-1.35-0.5-1.35-1.51 0-0.17 0-0.67 0.17-1.51s0.17-2.19 0-4.04c0-0.67-0.17-2.19-0.34-4.04-0.17-2.02-0.34-3.2-0.34-3.53 0-1.35 0.34-2.02 1.18-2.02 0.5 0 1.01 0.17 1.35 0.34 0.5 0.34 0.84 0.34 1.01 0.34 0.34 0 1.01-0.17 1.68-0.5l18.34-0.5h3.03c0.34 0 0.5-0.34 0.5-1.01zm-27.59 41.72c0 0.5 0.67 0.67 1.85 0.5 2.69-0.34 4.21-0.5 4.71-0.5 1.18 0 3.2 0 5.89 0.34s5.22 0.34 7.23 0.34c5.38-0.17 8.24-0.5 8.08-1.18 0-0.5-7.74-0.67-23.22-0.5-3.03 0.17-4.54 0.5-4.54 1.01zm24.56-20.52c0-0.17-0.5-0.17-1.18 0.17-1.18 0.5-2.19 0.67-2.86 0.67l-13.63 0.34c-0.5 0-1.01 0-1.01-0.34-0.17-0.17-0.34-0.34-0.5-0.34s-0.34 0.17-0.5 0.67c-0.17 0.5-0.34 0.67-0.67 0.67-0.17 0-0.5 0-0.84-0.17 0 1.01-0.17 2.19-0.17 3.2l0.34 5.72c0 0.5 0.17 0.67 0.5 0.67s0.67-0.17 0.67-0.84v-7.4c0.84-0.34 2.52-0.5 4.71-0.5h10.26c3.2 0.17 4.88-0.84 4.88-2.52zm-20.86-13.29c0-0.67-0.17-1.01-0.34-1.01-0.5 0-0.67 0.5-0.67 1.35 0 2.52 0.34 4.37 0.67 5.22 0.34 0 0.5 0 0.67-0.34l-0.34-5.22zm1.34-2.02 18.17-0.34c2.52 0 4.37-0.67 5.55-1.85 0.67-0.84 0.67-1.18-0.34-1.18-1.35 1.01-3.03 1.51-5.05 1.68 0.5-0.5 0.5-0.67 0-0.67l-18.68 0.34c-0.67 0-1.18 0.5-1.18 1.35 0.17 0.34 0.67 0.67 1.51 0.67zm-0.17 8.58c-0.5 0-0.67 0.17-0.67 0.67s0.5 0.84 1.68 1.01c2.19 0 4.37-0.17 6.39-0.17 6.06-0.17 9.25-0.5 9.09-1.18-0.17 0-0.34-0.17-0.84-0.17l-13.29 0.67c-0.67 0-1.35-0.17-1.68-0.34-0.5-0.34-0.67-0.5-0.67-0.5zm1.52 19.01c-0.67 0-1.01 0.17-1.01 0.5 0 0.5 0.34 0.67 1.18 0.67 1.51 0 4.71-0.17 9.59-0.5 4.71-0.34 7.23-0.5 7.57-0.5 1.01 0 2.19 0.17 3.53 0.34 0.67 0.17 1.01 0 1.01-0.34 0-0.5-0.84-0.84-2.52-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m659.69 447.12c-0.34 0-0.5 0.17-0.67 0.5 0 0.17 0 0.67 0.17 1.01 0.17 0.5 0.17 0.67 0.17 0.84 0 0.5 0 1.85-0.34 4.21-0.17 2.36-0.34 4.21-0.17 5.55 0 1.01 0.17 4.37 0.5 9.76 0.34 5.38 0.5 8.92 0.5 10.6 0 0.17 0.17 0.34 0.5 0.17 0.17-0.17 0.34-0.17 0.34-0.34l-0.84-28.6c0-0.84 0-1.51 0.17-1.51 0.17-0.17 0.17-0.5 0.17-1.01 0.34-0.84 0-1.18-0.5-1.18zm25.74-3.03-21.87 0.67c-1.68 0-2.69 0.5-2.52 1.51-0.17 1.01 0 1.35 0.34 1.35s0.67-0.34 0.67-0.84c0-0.34 0.17-0.34 0.34-0.34s0.34 0.34 0.34 0.84l1.01 34.66c0 0.5-0.17 0.84-0.84 1.01-0.5 0.17-0.84 0.5-0.84 0.84s0.17 0.67 0.67 1.18 1.01 0.67 1.51 0.67 0.84-0.17 0.84-0.67c0-0.34-0.34-0.5-1.01-0.5s-0.84-0.17-0.84-0.67c0-0.34 0.17-0.5 0.67-0.5 0.34 0 0.5 0.17 0.5 0.34s0.34 0.5 1.01 0.67c1.01 0.17 2.86 0.34 5.72 0.17 8.41-0.17 13.96-0.67 16.32-1.18 6.56-1.68 9.76-6.39 9.59-14.3l-0.34-14.3c-0.17-3.2-1.18-5.72-3.03-7.74-2.19-2.02-4.88-3.03-8.24-2.86zm-21.87-1.68c-0.17 0-0.34 0.17-0.34 0.5s0.17 0.5 0.34 0.5h2.69c0.34 0 0.5-0.17 0.5-0.5s-0.17-0.5-0.34-0.5h-2.86zm1.51 5.55c0.17-0.5 0.67-0.67 1.35-0.5h2.19l16.99-0.5c5.38-0.17 8.08 2.69 8.24 8.41l0.34 14.47c0.17 3.2-0.67 5.89-2.19 7.91-1.51 2.19-3.7 3.2-6.73 3.36l-14.3 0.34c-0.5 0-1.01-0.17-1.51-0.34-0.34-0.17-0.5-0.17-0.67 0l-0.67 0.67c-0.17 0.17-0.34 0.34-0.67 0.34-0.17 0-0.67-0.67-2.02-2.02 0-0.34 0.34-0.67 0.67-0.84l-0.84-27.59-0.5-1.68c0-0.67 0.17-1.35 0.34-2.02zm11.11 38.36c-6.39 0.17-9.59 0.5-9.59 1.18 0 0.17 3.2 0.17 9.59 0 3.87-0.17 5.89-0.34 5.89-0.84 0-0.34-2.02-0.5-5.89-0.34zm-8.41-25.74c-0.5 0-0.67 2.36-0.5 6.73 0.17 6.06 0.5 9.25 1.01 9.09 0.34 0 0.34-3.03 0.17-9.25-0.17-4.37-0.34-6.56-0.67-6.56zm0-8.75c-0.5 0-0.67 1.01-0.67 2.86 0 1.51 0.34 2.19 0.84 2.19 0.17 0 0.34-0.84 0.34-2.36-0.17-1.68-0.17-2.69-0.5-2.69zm1.68-1.51c-0.17 0 2.19-0.17 7.4-0.5 4.21-0.17 6.9-0.34 7.74-0.17 4.04 0.34 6.23 4.71 6.56 12.95 0.17 5.72-0.34 9.76-1.68 11.95-1.18 2.19-3.36 3.36-6.06 3.36-0.67 0-1.01 0.17-1.01 0.5s0.34 0.5 0.84 0.5c4.54-0.17 7.4-2.19 8.58-6.23 0.67-2.02 0.84-5.72 0.67-11.27-0.34-9.09-3.2-13.46-9.09-13.29l-14.64 0.84c0 0.17 0 0.34-0.17 0.67v0.34c0 0.34 0.34 0.34 0.84 0.34zm0.33 28.26c-0.34 0-0.5 0.17-0.5 0.34 0.17 0.34 0.34 0.5 0.5 0.5l10.43 0.17c0.17-0.17 0.34-0.34 0.5-0.67-0.17-0.34-0.5-0.67-1.01-0.67l-9.93 0.34zm1.69-36.34c-0.17 0-0.34 0.17-0.34 0.5s0.17 0.5 0.34 0.5l4.71-0.17c0.34 0 0.5-0.17 0.5-0.5s-0.17-0.5-0.34-0.5l-4.88 0.17zm25.57 7.74c0.34 0.84 0.5 1.85 0.84 2.69 0.34 1.85 0.5 5.89 0.67 12.11 0.17 6.73-0.67 11.95-2.69 15.31-1.35 2.19-3.36 3.7-5.72 4.71-2.02 0.67-3.03 1.18-3.03 1.51 0 0.17 0.5 0.34 1.35 0.34 2.69 0 5.05-1.51 7.23-4.04 3.03-3.87 4.54-9.76 4.21-17.67-0.17-7.57-0.84-12.62-2.02-14.81-0.17-0.34-0.34-0.67-0.67-0.67-0.34-0.17-0.34 0-0.17 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "m712.35 454.69c0 0.67 0.34 1.01 0.84 1.01s0.67-0.17 0.5-0.67c-0.17-0.67-0.17-1.35 0-2.19 0.17-0.67 0-0.84-0.34-0.84-0.84 0-1.18 1.01-1.01 2.69zm1.18 29.11c0 0.34 0.17 0.5 0.67 0.34 0.34-0.17 0.5-0.34 0.34-0.5-0.17-0.34-0.34-1.01-0.34-1.68s0-1.85 0.17-3.53 0.17-3.03 0.17-4.04-0.17-1.85-0.34-2.52c-0.17-7.23-0.34-11.61-0.5-13.12-0.17-0.67-0.34-1.18-0.67-1.18-0.17 0.34-0.34 0.5-0.5 0.84l1.01 25.41zm3.7-41.22c-0.67-0.17-1.18-0.17-1.35 0l-1.35 1.51c-0.5 0.5-0.5 1.51 0.17 3.03l0.17 5.72c0 0.84 0.17 4.54 0.5 10.94 0.34 6.39 0.5 9.25 0.5 8.41 0.17 6.73 0.34 8.58 0.34 5.55 0 2.36-0.34 3.87-1.01 4.54 0 0.17-0.17 0.34-0.17 0.5 0 0.67 0.34 1.35 1.01 2.19 0.67 0.67 1.51 1.01 2.36 1.01 1.18 0 1.68-1.01 1.51-2.86-0.84-12.95-1.01-19.85-0.67-21.2-0.17-3.36-0.34-9.09-0.5-16.99 0-0.67-0.34-1.35-0.84-1.85-0.17-0.34-0.5-0.67-0.67-0.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigaAppTestataReCa2);
export default __webpack_public_path__ + "static/media/LIGA_APP_testata_RE_CA_2.6fb93413daece0c0e3f8ffee24f3f893.svg";
export { ForwardRef as ReactComponent };